var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from5, except, desc) => {
  if (from5 && typeof from5 === "object" || typeof from5 === "function") {
    for (let key of __getOwnPropNames(from5))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from5[key], enumerable: !(desc = __getOwnPropDesc(from5, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/index.js
var require_es_errors = __commonJS({
  "../../node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/index.js"(exports, module) {
    "use strict";
    module.exports = Error;
  }
});

// ../../node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/eval.js
var require_eval = __commonJS({
  "../../node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/eval.js"(exports, module) {
    "use strict";
    module.exports = EvalError;
  }
});

// ../../node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/range.js
var require_range = __commonJS({
  "../../node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/range.js"(exports, module) {
    "use strict";
    module.exports = RangeError;
  }
});

// ../../node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/ref.js
var require_ref = __commonJS({
  "../../node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/ref.js"(exports, module) {
    "use strict";
    module.exports = ReferenceError;
  }
});

// ../../node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/syntax.js
var require_syntax = __commonJS({
  "../../node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/syntax.js"(exports, module) {
    "use strict";
    module.exports = SyntaxError;
  }
});

// ../../node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/type.js
var require_type = __commonJS({
  "../../node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/type.js"(exports, module) {
    "use strict";
    module.exports = TypeError;
  }
});

// ../../node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/uri.js
var require_uri = __commonJS({
  "../../node_modules/.pnpm/es-errors@1.3.0/node_modules/es-errors/uri.js"(exports, module) {
    "use strict";
    module.exports = URIError;
  }
});

// ../../node_modules/.pnpm/has-symbols@1.0.3/node_modules/has-symbols/shams.js
var require_shams = __commonJS({
  "../../node_modules/.pnpm/has-symbols@1.0.3/node_modules/has-symbols/shams.js"(exports, module) {
    "use strict";
    module.exports = function hasSymbols() {
      if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
        return false;
      }
      if (typeof Symbol.iterator === "symbol") {
        return true;
      }
      var obj = {};
      var sym = Symbol("test");
      var symObj = Object(sym);
      if (typeof sym === "string") {
        return false;
      }
      if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
        return false;
      }
      if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
        return false;
      }
      var symVal = 42;
      obj[sym] = symVal;
      for (sym in obj) {
        return false;
      }
      if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
        return false;
      }
      if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
        return false;
      }
      var syms = Object.getOwnPropertySymbols(obj);
      if (syms.length !== 1 || syms[0] !== sym) {
        return false;
      }
      if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
        return false;
      }
      if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) {
          return false;
        }
      }
      return true;
    };
  }
});

// ../../node_modules/.pnpm/has-symbols@1.0.3/node_modules/has-symbols/index.js
var require_has_symbols = __commonJS({
  "../../node_modules/.pnpm/has-symbols@1.0.3/node_modules/has-symbols/index.js"(exports, module) {
    "use strict";
    var origSymbol = typeof Symbol !== "undefined" && Symbol;
    var hasSymbolSham = require_shams();
    module.exports = function hasNativeSymbols() {
      if (typeof origSymbol !== "function") {
        return false;
      }
      if (typeof Symbol !== "function") {
        return false;
      }
      if (typeof origSymbol("foo") !== "symbol") {
        return false;
      }
      if (typeof Symbol("bar") !== "symbol") {
        return false;
      }
      return hasSymbolSham();
    };
  }
});

// ../../node_modules/.pnpm/has-proto@1.0.3/node_modules/has-proto/index.js
var require_has_proto = __commonJS({
  "../../node_modules/.pnpm/has-proto@1.0.3/node_modules/has-proto/index.js"(exports, module) {
    "use strict";
    var test = {
      __proto__: null,
      foo: {}
    };
    var $Object = Object;
    module.exports = function hasProto() {
      return { __proto__: test }.foo === test.foo && !(test instanceof $Object);
    };
  }
});

// ../../node_modules/.pnpm/function-bind@1.1.2/node_modules/function-bind/implementation.js
var require_implementation = __commonJS({
  "../../node_modules/.pnpm/function-bind@1.1.2/node_modules/function-bind/implementation.js"(exports, module) {
    "use strict";
    var ERROR_MESSAGE2 = "Function.prototype.bind called on incompatible ";
    var toStr = Object.prototype.toString;
    var max = Math.max;
    var funcType = "[object Function]";
    var concatty = function concatty2(a, b) {
      var arr = [];
      for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
      }
      for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
      }
      return arr;
    };
    var slicy = function slicy2(arrLike, offset) {
      var arr = [];
      for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
      }
      return arr;
    };
    var joiny = function(arr, joiner) {
      var str = "";
      for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
          str += joiner;
        }
      }
      return str;
    };
    module.exports = function bind(that) {
      var target = this;
      if (typeof target !== "function" || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE2 + target);
      }
      var args = slicy(arguments, 1);
      var bound;
      var binder = function() {
        if (this instanceof bound) {
          var result = target.apply(
            this,
            concatty(args, arguments)
          );
          if (Object(result) === result) {
            return result;
          }
          return this;
        }
        return target.apply(
          that,
          concatty(args, arguments)
        );
      };
      var boundLength = max(0, target.length - args.length);
      var boundArgs = [];
      for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = "$" + i;
      }
      bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
      if (target.prototype) {
        var Empty = function Empty2() {
        };
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
      }
      return bound;
    };
  }
});

// ../../node_modules/.pnpm/function-bind@1.1.2/node_modules/function-bind/index.js
var require_function_bind = __commonJS({
  "../../node_modules/.pnpm/function-bind@1.1.2/node_modules/function-bind/index.js"(exports, module) {
    "use strict";
    var implementation = require_implementation();
    module.exports = Function.prototype.bind || implementation;
  }
});

// ../../node_modules/.pnpm/hasown@2.0.2/node_modules/hasown/index.js
var require_hasown = __commonJS({
  "../../node_modules/.pnpm/hasown@2.0.2/node_modules/hasown/index.js"(exports, module) {
    "use strict";
    var call = Function.prototype.call;
    var $hasOwn = Object.prototype.hasOwnProperty;
    var bind = require_function_bind();
    module.exports = bind.call(call, $hasOwn);
  }
});

// ../../node_modules/.pnpm/get-intrinsic@1.2.4/node_modules/get-intrinsic/index.js
var require_get_intrinsic = __commonJS({
  "../../node_modules/.pnpm/get-intrinsic@1.2.4/node_modules/get-intrinsic/index.js"(exports, module) {
    "use strict";
    var undefined2;
    var $Error = require_es_errors();
    var $EvalError = require_eval();
    var $RangeError = require_range();
    var $ReferenceError = require_ref();
    var $SyntaxError = require_syntax();
    var $TypeError = require_type();
    var $URIError = require_uri();
    var $Function = Function;
    var getEvalledConstructor = function(expressionSyntax) {
      try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
      } catch (e) {
      }
    };
    var $gOPD = Object.getOwnPropertyDescriptor;
    if ($gOPD) {
      try {
        $gOPD({}, "");
      } catch (e) {
        $gOPD = null;
      }
    }
    var throwTypeError = function() {
      throw new $TypeError();
    };
    var ThrowTypeError = $gOPD ? function() {
      try {
        arguments.callee;
        return throwTypeError;
      } catch (calleeThrows) {
        try {
          return $gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
          return throwTypeError;
        }
      }
    }() : throwTypeError;
    var hasSymbols = require_has_symbols()();
    var hasProto = require_has_proto()();
    var getProto = Object.getPrototypeOf || (hasProto ? function(x) {
      return x.__proto__;
    } : null);
    var needsEval = {};
    var TypedArray = typeof Uint8Array === "undefined" || !getProto ? undefined2 : getProto(Uint8Array);
    var INTRINSICS = {
      __proto__: null,
      "%AggregateError%": typeof AggregateError === "undefined" ? undefined2 : AggregateError,
      "%Array%": Array,
      "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined2 : ArrayBuffer,
      "%ArrayIteratorPrototype%": hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined2,
      "%AsyncFromSyncIteratorPrototype%": undefined2,
      "%AsyncFunction%": needsEval,
      "%AsyncGenerator%": needsEval,
      "%AsyncGeneratorFunction%": needsEval,
      "%AsyncIteratorPrototype%": needsEval,
      "%Atomics%": typeof Atomics === "undefined" ? undefined2 : Atomics,
      "%BigInt%": typeof BigInt === "undefined" ? undefined2 : BigInt,
      "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined2 : BigInt64Array,
      "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined2 : BigUint64Array,
      "%Boolean%": Boolean,
      "%DataView%": typeof DataView === "undefined" ? undefined2 : DataView,
      "%Date%": Date,
      "%decodeURI%": decodeURI,
      "%decodeURIComponent%": decodeURIComponent,
      "%encodeURI%": encodeURI,
      "%encodeURIComponent%": encodeURIComponent,
      "%Error%": $Error,
      "%eval%": eval,
      // eslint-disable-line no-eval
      "%EvalError%": $EvalError,
      "%Float32Array%": typeof Float32Array === "undefined" ? undefined2 : Float32Array,
      "%Float64Array%": typeof Float64Array === "undefined" ? undefined2 : Float64Array,
      "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined2 : FinalizationRegistry,
      "%Function%": $Function,
      "%GeneratorFunction%": needsEval,
      "%Int8Array%": typeof Int8Array === "undefined" ? undefined2 : Int8Array,
      "%Int16Array%": typeof Int16Array === "undefined" ? undefined2 : Int16Array,
      "%Int32Array%": typeof Int32Array === "undefined" ? undefined2 : Int32Array,
      "%isFinite%": isFinite,
      "%isNaN%": isNaN,
      "%IteratorPrototype%": hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined2,
      "%JSON%": typeof JSON === "object" ? JSON : undefined2,
      "%Map%": typeof Map === "undefined" ? undefined2 : Map,
      "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols || !getProto ? undefined2 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
      "%Math%": Math,
      "%Number%": Number,
      "%Object%": Object,
      "%parseFloat%": parseFloat,
      "%parseInt%": parseInt,
      "%Promise%": typeof Promise === "undefined" ? undefined2 : Promise,
      "%Proxy%": typeof Proxy === "undefined" ? undefined2 : Proxy,
      "%RangeError%": $RangeError,
      "%ReferenceError%": $ReferenceError,
      "%Reflect%": typeof Reflect === "undefined" ? undefined2 : Reflect,
      "%RegExp%": RegExp,
      "%Set%": typeof Set === "undefined" ? undefined2 : Set,
      "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols || !getProto ? undefined2 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
      "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined2 : SharedArrayBuffer,
      "%String%": String,
      "%StringIteratorPrototype%": hasSymbols && getProto ? getProto(""[Symbol.iterator]()) : undefined2,
      "%Symbol%": hasSymbols ? Symbol : undefined2,
      "%SyntaxError%": $SyntaxError,
      "%ThrowTypeError%": ThrowTypeError,
      "%TypedArray%": TypedArray,
      "%TypeError%": $TypeError,
      "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined2 : Uint8Array,
      "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined2 : Uint8ClampedArray,
      "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined2 : Uint16Array,
      "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined2 : Uint32Array,
      "%URIError%": $URIError,
      "%WeakMap%": typeof WeakMap === "undefined" ? undefined2 : WeakMap,
      "%WeakRef%": typeof WeakRef === "undefined" ? undefined2 : WeakRef,
      "%WeakSet%": typeof WeakSet === "undefined" ? undefined2 : WeakSet
    };
    if (getProto) {
      try {
        null.error;
      } catch (e) {
        errorProto = getProto(getProto(e));
        INTRINSICS["%Error.prototype%"] = errorProto;
      }
    }
    var errorProto;
    var doEval = function doEval2(name) {
      var value;
      if (name === "%AsyncFunction%") {
        value = getEvalledConstructor("async function () {}");
      } else if (name === "%GeneratorFunction%") {
        value = getEvalledConstructor("function* () {}");
      } else if (name === "%AsyncGeneratorFunction%") {
        value = getEvalledConstructor("async function* () {}");
      } else if (name === "%AsyncGenerator%") {
        var fn = doEval2("%AsyncGeneratorFunction%");
        if (fn) {
          value = fn.prototype;
        }
      } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval2("%AsyncGenerator%");
        if (gen && getProto) {
          value = getProto(gen.prototype);
        }
      }
      INTRINSICS[name] = value;
      return value;
    };
    var LEGACY_ALIASES = {
      __proto__: null,
      "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
      "%ArrayPrototype%": ["Array", "prototype"],
      "%ArrayProto_entries%": ["Array", "prototype", "entries"],
      "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
      "%ArrayProto_keys%": ["Array", "prototype", "keys"],
      "%ArrayProto_values%": ["Array", "prototype", "values"],
      "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
      "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
      "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
      "%BooleanPrototype%": ["Boolean", "prototype"],
      "%DataViewPrototype%": ["DataView", "prototype"],
      "%DatePrototype%": ["Date", "prototype"],
      "%ErrorPrototype%": ["Error", "prototype"],
      "%EvalErrorPrototype%": ["EvalError", "prototype"],
      "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
      "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
      "%FunctionPrototype%": ["Function", "prototype"],
      "%Generator%": ["GeneratorFunction", "prototype"],
      "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
      "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
      "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
      "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
      "%JSONParse%": ["JSON", "parse"],
      "%JSONStringify%": ["JSON", "stringify"],
      "%MapPrototype%": ["Map", "prototype"],
      "%NumberPrototype%": ["Number", "prototype"],
      "%ObjectPrototype%": ["Object", "prototype"],
      "%ObjProto_toString%": ["Object", "prototype", "toString"],
      "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
      "%PromisePrototype%": ["Promise", "prototype"],
      "%PromiseProto_then%": ["Promise", "prototype", "then"],
      "%Promise_all%": ["Promise", "all"],
      "%Promise_reject%": ["Promise", "reject"],
      "%Promise_resolve%": ["Promise", "resolve"],
      "%RangeErrorPrototype%": ["RangeError", "prototype"],
      "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
      "%RegExpPrototype%": ["RegExp", "prototype"],
      "%SetPrototype%": ["Set", "prototype"],
      "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
      "%StringPrototype%": ["String", "prototype"],
      "%SymbolPrototype%": ["Symbol", "prototype"],
      "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
      "%TypedArrayPrototype%": ["TypedArray", "prototype"],
      "%TypeErrorPrototype%": ["TypeError", "prototype"],
      "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
      "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
      "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
      "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
      "%URIErrorPrototype%": ["URIError", "prototype"],
      "%WeakMapPrototype%": ["WeakMap", "prototype"],
      "%WeakSetPrototype%": ["WeakSet", "prototype"]
    };
    var bind = require_function_bind();
    var hasOwn = require_hasown();
    var $concat = bind.call(Function.call, Array.prototype.concat);
    var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
    var $replace = bind.call(Function.call, String.prototype.replace);
    var $strSlice = bind.call(Function.call, String.prototype.slice);
    var $exec = bind.call(Function.call, RegExp.prototype.exec);
    var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
    var reEscapeChar = /\\(\\)?/g;
    var stringToPath = function stringToPath2(string) {
      var first3 = $strSlice(string, 0, 1);
      var last2 = $strSlice(string, -1);
      if (first3 === "%" && last2 !== "%") {
        throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
      } else if (last2 === "%" && first3 !== "%") {
        throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
      }
      var result = [];
      $replace(string, rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match;
      });
      return result;
    };
    var getBaseIntrinsic = function getBaseIntrinsic2(name, allowMissing) {
      var intrinsicName = name;
      var alias;
      if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
      }
      if (hasOwn(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) {
          value = doEval(intrinsicName);
        }
        if (typeof value === "undefined" && !allowMissing) {
          throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        }
        return {
          alias,
          name: intrinsicName,
          value
        };
      }
      throw new $SyntaxError("intrinsic " + name + " does not exist!");
    };
    module.exports = function GetIntrinsic(name, allowMissing) {
      if (typeof name !== "string" || name.length === 0) {
        throw new $TypeError("intrinsic name must be a non-empty string");
      }
      if (arguments.length > 1 && typeof allowMissing !== "boolean") {
        throw new $TypeError('"allowMissing" argument must be a boolean');
      }
      if ($exec(/^%?[^%]*%?$/, name) === null) {
        throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
      }
      var parts = stringToPath(name);
      var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
      var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
      var intrinsicRealName = intrinsic.name;
      var value = intrinsic.value;
      var skipFurtherCaching = false;
      var alias = intrinsic.alias;
      if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([0, 1], alias));
      }
      for (var i = 1, isOwn = true; i < parts.length; i += 1) {
        var part = parts[i];
        var first3 = $strSlice(part, 0, 1);
        var last2 = $strSlice(part, -1);
        if ((first3 === '"' || first3 === "'" || first3 === "`" || (last2 === '"' || last2 === "'" || last2 === "`")) && first3 !== last2) {
          throw new $SyntaxError("property names with quotes must have matching quotes");
        }
        if (part === "constructor" || !isOwn) {
          skipFurtherCaching = true;
        }
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn(INTRINSICS, intrinsicRealName)) {
          value = INTRINSICS[intrinsicRealName];
        } else if (value != null) {
          if (!(part in value)) {
            if (!allowMissing) {
              throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
            }
            return void 0;
          }
          if ($gOPD && i + 1 >= parts.length) {
            var desc = $gOPD(value, part);
            isOwn = !!desc;
            if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
              value = desc.get;
            } else {
              value = value[part];
            }
          } else {
            isOwn = hasOwn(value, part);
            value = value[part];
          }
          if (isOwn && !skipFurtherCaching) {
            INTRINSICS[intrinsicRealName] = value;
          }
        }
      }
      return value;
    };
  }
});

// ../../node_modules/.pnpm/es-define-property@1.0.0/node_modules/es-define-property/index.js
var require_es_define_property = __commonJS({
  "../../node_modules/.pnpm/es-define-property@1.0.0/node_modules/es-define-property/index.js"(exports, module) {
    "use strict";
    var GetIntrinsic = require_get_intrinsic();
    var $defineProperty = GetIntrinsic("%Object.defineProperty%", true) || false;
    if ($defineProperty) {
      try {
        $defineProperty({}, "a", { value: 1 });
      } catch (e) {
        $defineProperty = false;
      }
    }
    module.exports = $defineProperty;
  }
});

// ../../node_modules/.pnpm/gopd@1.0.1/node_modules/gopd/index.js
var require_gopd = __commonJS({
  "../../node_modules/.pnpm/gopd@1.0.1/node_modules/gopd/index.js"(exports, module) {
    "use strict";
    var GetIntrinsic = require_get_intrinsic();
    var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
    if ($gOPD) {
      try {
        $gOPD([], "length");
      } catch (e) {
        $gOPD = null;
      }
    }
    module.exports = $gOPD;
  }
});

// ../../node_modules/.pnpm/define-data-property@1.1.4/node_modules/define-data-property/index.js
var require_define_data_property = __commonJS({
  "../../node_modules/.pnpm/define-data-property@1.1.4/node_modules/define-data-property/index.js"(exports, module) {
    "use strict";
    var $defineProperty = require_es_define_property();
    var $SyntaxError = require_syntax();
    var $TypeError = require_type();
    var gopd = require_gopd();
    module.exports = function defineDataProperty(obj, property, value) {
      if (!obj || typeof obj !== "object" && typeof obj !== "function") {
        throw new $TypeError("`obj` must be an object or a function`");
      }
      if (typeof property !== "string" && typeof property !== "symbol") {
        throw new $TypeError("`property` must be a string or a symbol`");
      }
      if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) {
        throw new $TypeError("`nonEnumerable`, if provided, must be a boolean or null");
      }
      if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) {
        throw new $TypeError("`nonWritable`, if provided, must be a boolean or null");
      }
      if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) {
        throw new $TypeError("`nonConfigurable`, if provided, must be a boolean or null");
      }
      if (arguments.length > 6 && typeof arguments[6] !== "boolean") {
        throw new $TypeError("`loose`, if provided, must be a boolean");
      }
      var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
      var nonWritable = arguments.length > 4 ? arguments[4] : null;
      var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
      var loose = arguments.length > 6 ? arguments[6] : false;
      var desc = !!gopd && gopd(obj, property);
      if ($defineProperty) {
        $defineProperty(obj, property, {
          configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
          enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
          value,
          writable: nonWritable === null && desc ? desc.writable : !nonWritable
        });
      } else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) {
        obj[property] = value;
      } else {
        throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
      }
    };
  }
});

// ../../node_modules/.pnpm/has-property-descriptors@1.0.2/node_modules/has-property-descriptors/index.js
var require_has_property_descriptors = __commonJS({
  "../../node_modules/.pnpm/has-property-descriptors@1.0.2/node_modules/has-property-descriptors/index.js"(exports, module) {
    "use strict";
    var $defineProperty = require_es_define_property();
    var hasPropertyDescriptors = function hasPropertyDescriptors2() {
      return !!$defineProperty;
    };
    hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
      if (!$defineProperty) {
        return null;
      }
      try {
        return $defineProperty([], "length", { value: 1 }).length !== 1;
      } catch (e) {
        return true;
      }
    };
    module.exports = hasPropertyDescriptors;
  }
});

// ../../node_modules/.pnpm/set-function-length@1.2.2/node_modules/set-function-length/index.js
var require_set_function_length = __commonJS({
  "../../node_modules/.pnpm/set-function-length@1.2.2/node_modules/set-function-length/index.js"(exports, module) {
    "use strict";
    var GetIntrinsic = require_get_intrinsic();
    var define = require_define_data_property();
    var hasDescriptors = require_has_property_descriptors()();
    var gOPD = require_gopd();
    var $TypeError = require_type();
    var $floor = GetIntrinsic("%Math.floor%");
    module.exports = function setFunctionLength(fn, length) {
      if (typeof fn !== "function") {
        throw new $TypeError("`fn` is not a function");
      }
      if (typeof length !== "number" || length < 0 || length > 4294967295 || $floor(length) !== length) {
        throw new $TypeError("`length` must be a positive 32-bit integer");
      }
      var loose = arguments.length > 2 && !!arguments[2];
      var functionLengthIsConfigurable = true;
      var functionLengthIsWritable = true;
      if ("length" in fn && gOPD) {
        var desc = gOPD(fn, "length");
        if (desc && !desc.configurable) {
          functionLengthIsConfigurable = false;
        }
        if (desc && !desc.writable) {
          functionLengthIsWritable = false;
        }
      }
      if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if (hasDescriptors) {
          define(
            /** @type {Parameters<define>[0]} */
            fn,
            "length",
            length,
            true,
            true
          );
        } else {
          define(
            /** @type {Parameters<define>[0]} */
            fn,
            "length",
            length
          );
        }
      }
      return fn;
    };
  }
});

// ../../node_modules/.pnpm/call-bind@1.0.7/node_modules/call-bind/index.js
var require_call_bind = __commonJS({
  "../../node_modules/.pnpm/call-bind@1.0.7/node_modules/call-bind/index.js"(exports, module) {
    "use strict";
    var bind = require_function_bind();
    var GetIntrinsic = require_get_intrinsic();
    var setFunctionLength = require_set_function_length();
    var $TypeError = require_type();
    var $apply = GetIntrinsic("%Function.prototype.apply%");
    var $call = GetIntrinsic("%Function.prototype.call%");
    var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
    var $defineProperty = require_es_define_property();
    var $max = GetIntrinsic("%Math.max%");
    module.exports = function callBind(originalFunction) {
      if (typeof originalFunction !== "function") {
        throw new $TypeError("a function is required");
      }
      var func = $reflectApply(bind, $call, arguments);
      return setFunctionLength(
        func,
        1 + $max(0, originalFunction.length - (arguments.length - 1)),
        true
      );
    };
    var applyBind = function applyBind2() {
      return $reflectApply(bind, $apply, arguments);
    };
    if ($defineProperty) {
      $defineProperty(module.exports, "apply", { value: applyBind });
    } else {
      module.exports.apply = applyBind;
    }
  }
});

// ../../node_modules/.pnpm/call-bind@1.0.7/node_modules/call-bind/callBound.js
var require_callBound = __commonJS({
  "../../node_modules/.pnpm/call-bind@1.0.7/node_modules/call-bind/callBound.js"(exports, module) {
    "use strict";
    var GetIntrinsic = require_get_intrinsic();
    var callBind = require_call_bind();
    var $indexOf = callBind(GetIntrinsic("String.prototype.indexOf"));
    module.exports = function callBoundIntrinsic(name, allowMissing) {
      var intrinsic = GetIntrinsic(name, !!allowMissing);
      if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) {
        return callBind(intrinsic);
      }
      return intrinsic;
    };
  }
});

// (disabled):../../node_modules/.pnpm/object-inspect@1.13.2/node_modules/object-inspect/util.inspect
var require_util = __commonJS({
  "(disabled):../../node_modules/.pnpm/object-inspect@1.13.2/node_modules/object-inspect/util.inspect"() {
  }
});

// ../../node_modules/.pnpm/object-inspect@1.13.2/node_modules/object-inspect/index.js
var require_object_inspect = __commonJS({
  "../../node_modules/.pnpm/object-inspect@1.13.2/node_modules/object-inspect/index.js"(exports, module) {
    var hasMap = typeof Map === "function" && Map.prototype;
    var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
    var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === "function" ? mapSizeDescriptor.get : null;
    var mapForEach = hasMap && Map.prototype.forEach;
    var hasSet = typeof Set === "function" && Set.prototype;
    var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
    var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === "function" ? setSizeDescriptor.get : null;
    var setForEach = hasSet && Set.prototype.forEach;
    var hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
    var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
    var hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
    var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
    var hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
    var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
    var booleanValueOf = Boolean.prototype.valueOf;
    var objectToString = Object.prototype.toString;
    var functionToString = Function.prototype.toString;
    var $match = String.prototype.match;
    var $slice = String.prototype.slice;
    var $replace = String.prototype.replace;
    var $toUpperCase = String.prototype.toUpperCase;
    var $toLowerCase = String.prototype.toLowerCase;
    var $test = RegExp.prototype.test;
    var $concat = Array.prototype.concat;
    var $join = Array.prototype.join;
    var $arrSlice = Array.prototype.slice;
    var $floor = Math.floor;
    var bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
    var gOPS = Object.getOwnPropertySymbols;
    var symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
    var hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
    var toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(O) {
      return O.__proto__;
    } : null);
    function addNumericSeparator(num, str) {
      if (num === Infinity || num === -Infinity || num !== num || num && num > -1e3 && num < 1e3 || $test.call(/e/, str)) {
        return str;
      }
      var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
      if (typeof num === "number") {
        var int = num < 0 ? -$floor(-num) : $floor(num);
        if (int !== num) {
          var intStr = String(int);
          var dec = $slice.call(str, intStr.length + 1);
          return $replace.call(intStr, sepRegex, "$&_") + "." + $replace.call($replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
      }
      return $replace.call(str, sepRegex, "$&_");
    }
    var utilInspect = require_util();
    var inspectCustom = utilInspect.custom;
    var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
    module.exports = function inspect_(obj, options, depth, seen) {
      var opts = options || {};
      if (has2(opts, "quoteStyle") && (opts.quoteStyle !== "single" && opts.quoteStyle !== "double")) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
      }
      if (has2(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
      }
      var customInspect = has2(opts, "customInspect") ? opts.customInspect : true;
      if (typeof customInspect !== "boolean" && customInspect !== "symbol") {
        throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
      }
      if (has2(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
      }
      if (has2(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
      }
      var numericSeparator = opts.numericSeparator;
      if (typeof obj === "undefined") {
        return "undefined";
      }
      if (obj === null) {
        return "null";
      }
      if (typeof obj === "boolean") {
        return obj ? "true" : "false";
      }
      if (typeof obj === "string") {
        return inspectString(obj, opts);
      }
      if (typeof obj === "number") {
        if (obj === 0) {
          return Infinity / obj > 0 ? "0" : "-0";
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
      }
      if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
      }
      var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
      if (typeof depth === "undefined") {
        depth = 0;
      }
      if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") {
        return isArray2(obj) ? "[Array]" : "[Object]";
      }
      var indent = getIndent(opts, depth);
      if (typeof seen === "undefined") {
        seen = [];
      } else if (indexOf(seen, obj) >= 0) {
        return "[Circular]";
      }
      function inspect(value, from5, noIndent) {
        if (from5) {
          seen = $arrSlice.call(seen);
          seen.push(from5);
        }
        if (noIndent) {
          var newOpts = {
            depth: opts.depth
          };
          if (has2(opts, "quoteStyle")) {
            newOpts.quoteStyle = opts.quoteStyle;
          }
          return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
      }
      if (typeof obj === "function" && !isRegExp(obj)) {
        var name = nameOf(obj);
        var keys4 = arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys4.length > 0 ? " { " + $join.call(keys4, ", ") + " }" : "");
      }
      if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
        return typeof obj === "object" && !hasShammedSymbols ? markBoxed(symString) : symString;
      }
      if (isElement(obj)) {
        var s = "<" + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
          s += " " + attrs[i].name + "=" + wrapQuotes(quote(attrs[i].value), "double", opts);
        }
        s += ">";
        if (obj.childNodes && obj.childNodes.length) {
          s += "...";
        }
        s += "</" + $toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
      }
      if (isArray2(obj)) {
        if (obj.length === 0) {
          return "[]";
        }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
          return "[" + indentedJoin(xs, indent) + "]";
        }
        return "[ " + $join.call(xs, ", ") + " ]";
      }
      if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !isEnumerable.call(obj, "cause")) {
          return "{ [" + String(obj) + "] " + $join.call($concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        }
        if (parts.length === 0) {
          return "[" + String(obj) + "]";
        }
        return "{ [" + String(obj) + "] " + $join.call(parts, ", ") + " }";
      }
      if (typeof obj === "object" && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === "function" && utilInspect) {
          return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== "symbol" && typeof obj.inspect === "function") {
          return obj.inspect();
        }
      }
      if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
          mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
          });
        }
        return collectionOf("Map", mapSize.call(obj), mapParts, indent);
      }
      if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
          setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
          });
        }
        return collectionOf("Set", setSize.call(obj), setParts, indent);
      }
      if (isWeakMap(obj)) {
        return weakCollectionOf("WeakMap");
      }
      if (isWeakSet(obj)) {
        return weakCollectionOf("WeakSet");
      }
      if (isWeakRef(obj)) {
        return weakCollectionOf("WeakRef");
      }
      if (isNumber2(obj)) {
        return markBoxed(inspect(Number(obj)));
      }
      if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
      }
      if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
      }
      if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
      }
      if (typeof window !== "undefined" && obj === window) {
        return "{ [object Window] }";
      }
      if (typeof globalThis !== "undefined" && obj === globalThis || typeof global !== "undefined" && obj === global) {
        return "{ [object globalThis] }";
      }
      if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $join.call($concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) {
          return tag + "{}";
        }
        if (indent) {
          return tag + "{" + indentedJoin(ys, indent) + "}";
        }
        return tag + "{ " + $join.call(ys, ", ") + " }";
      }
      return String(obj);
    };
    function wrapQuotes(s, defaultStyle, opts) {
      var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
      return quoteChar + s + quoteChar;
    }
    function quote(s) {
      return $replace.call(String(s), /"/g, "&quot;");
    }
    function isArray2(obj) {
      return toStr(obj) === "[object Array]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isDate(obj) {
      return toStr(obj) === "[object Date]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isRegExp(obj) {
      return toStr(obj) === "[object RegExp]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isError(obj) {
      return toStr(obj) === "[object Error]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isString(obj) {
      return toStr(obj) === "[object String]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isNumber2(obj) {
      return toStr(obj) === "[object Number]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isBoolean(obj) {
      return toStr(obj) === "[object Boolean]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isSymbol(obj) {
      if (hasShammedSymbols) {
        return obj && typeof obj === "object" && obj instanceof Symbol;
      }
      if (typeof obj === "symbol") {
        return true;
      }
      if (!obj || typeof obj !== "object" || !symToString) {
        return false;
      }
      try {
        symToString.call(obj);
        return true;
      } catch (e) {
      }
      return false;
    }
    function isBigInt(obj) {
      if (!obj || typeof obj !== "object" || !bigIntValueOf) {
        return false;
      }
      try {
        bigIntValueOf.call(obj);
        return true;
      } catch (e) {
      }
      return false;
    }
    var hasOwn = Object.prototype.hasOwnProperty || function(key) {
      return key in this;
    };
    function has2(obj, key) {
      return hasOwn.call(obj, key);
    }
    function toStr(obj) {
      return objectToString.call(obj);
    }
    function nameOf(f) {
      if (f.name) {
        return f.name;
      }
      var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
      if (m) {
        return m[1];
      }
      return null;
    }
    function indexOf(xs, x) {
      if (xs.indexOf) {
        return xs.indexOf(x);
      }
      for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) {
          return i;
        }
      }
      return -1;
    }
    function isMap(x) {
      if (!mapSize || !x || typeof x !== "object") {
        return false;
      }
      try {
        mapSize.call(x);
        try {
          setSize.call(x);
        } catch (s) {
          return true;
        }
        return x instanceof Map;
      } catch (e) {
      }
      return false;
    }
    function isWeakMap(x) {
      if (!weakMapHas || !x || typeof x !== "object") {
        return false;
      }
      try {
        weakMapHas.call(x, weakMapHas);
        try {
          weakSetHas.call(x, weakSetHas);
        } catch (s) {
          return true;
        }
        return x instanceof WeakMap;
      } catch (e) {
      }
      return false;
    }
    function isWeakRef(x) {
      if (!weakRefDeref || !x || typeof x !== "object") {
        return false;
      }
      try {
        weakRefDeref.call(x);
        return true;
      } catch (e) {
      }
      return false;
    }
    function isSet(x) {
      if (!setSize || !x || typeof x !== "object") {
        return false;
      }
      try {
        setSize.call(x);
        try {
          mapSize.call(x);
        } catch (m) {
          return true;
        }
        return x instanceof Set;
      } catch (e) {
      }
      return false;
    }
    function isWeakSet(x) {
      if (!weakSetHas || !x || typeof x !== "object") {
        return false;
      }
      try {
        weakSetHas.call(x, weakSetHas);
        try {
          weakMapHas.call(x, weakMapHas);
        } catch (s) {
          return true;
        }
        return x instanceof WeakSet;
      } catch (e) {
      }
      return false;
    }
    function isElement(x) {
      if (!x || typeof x !== "object") {
        return false;
      }
      if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) {
        return true;
      }
      return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
    }
    function inspectString(str, opts) {
      if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
      }
      var s = $replace.call($replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, lowbyte);
      return wrapQuotes(s, "single", opts);
    }
    function lowbyte(c) {
      var n = c.charCodeAt(0);
      var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
      }[n];
      if (x) {
        return "\\" + x;
      }
      return "\\x" + (n < 16 ? "0" : "") + $toUpperCase.call(n.toString(16));
    }
    function markBoxed(str) {
      return "Object(" + str + ")";
    }
    function weakCollectionOf(type) {
      return type + " { ? }";
    }
    function collectionOf(type, size3, entries, indent) {
      var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ", ");
      return type + " (" + size3 + ") {" + joinedEntries + "}";
    }
    function singleLineValues(xs) {
      for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], "\n") >= 0) {
          return false;
        }
      }
      return true;
    }
    function getIndent(opts, depth) {
      var baseIndent;
      if (opts.indent === "	") {
        baseIndent = "	";
      } else if (typeof opts.indent === "number" && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), " ");
      } else {
        return null;
      }
      return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
      };
    }
    function indentedJoin(xs, indent) {
      if (xs.length === 0) {
        return "";
      }
      var lineJoiner = "\n" + indent.prev + indent.base;
      return lineJoiner + $join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
    }
    function arrObjKeys(obj, inspect) {
      var isArr = isArray2(obj);
      var xs = [];
      if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
          xs[i] = has2(obj, i) ? inspect(obj[i], obj) : "";
        }
      }
      var syms = typeof gOPS === "function" ? gOPS(obj) : [];
      var symMap;
      if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
          symMap["$" + syms[k]] = syms[k];
        }
      }
      for (var key in obj) {
        if (!has2(obj, key)) {
          continue;
        }
        if (isArr && String(Number(key)) === key && key < obj.length) {
          continue;
        }
        if (hasShammedSymbols && symMap["$" + key] instanceof Symbol) {
          continue;
        } else if ($test.call(/[^\w$]/, key)) {
          xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        } else {
          xs.push(key + ": " + inspect(obj[key], obj));
        }
      }
      if (typeof gOPS === "function") {
        for (var j = 0; j < syms.length; j++) {
          if (isEnumerable.call(obj, syms[j])) {
            xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
          }
        }
      }
      return xs;
    }
  }
});

// ../../node_modules/.pnpm/side-channel@1.0.6/node_modules/side-channel/index.js
var require_side_channel = __commonJS({
  "../../node_modules/.pnpm/side-channel@1.0.6/node_modules/side-channel/index.js"(exports, module) {
    "use strict";
    var GetIntrinsic = require_get_intrinsic();
    var callBound = require_callBound();
    var inspect = require_object_inspect();
    var $TypeError = require_type();
    var $WeakMap = GetIntrinsic("%WeakMap%", true);
    var $Map = GetIntrinsic("%Map%", true);
    var $weakMapGet = callBound("WeakMap.prototype.get", true);
    var $weakMapSet = callBound("WeakMap.prototype.set", true);
    var $weakMapHas = callBound("WeakMap.prototype.has", true);
    var $mapGet = callBound("Map.prototype.get", true);
    var $mapSet = callBound("Map.prototype.set", true);
    var $mapHas = callBound("Map.prototype.has", true);
    var listGetNode = function(list, key) {
      var prev = list;
      var curr;
      for (; (curr = prev.next) !== null; prev = curr) {
        if (curr.key === key) {
          prev.next = curr.next;
          curr.next = /** @type {NonNullable<typeof list.next>} */
          list.next;
          list.next = curr;
          return curr;
        }
      }
    };
    var listGet = function(objects, key) {
      var node = listGetNode(objects, key);
      return node && node.value;
    };
    var listSet = function(objects, key, value) {
      var node = listGetNode(objects, key);
      if (node) {
        node.value = value;
      } else {
        objects.next = /** @type {import('.').ListNode<typeof value>} */
        {
          // eslint-disable-line no-param-reassign, no-extra-parens
          key,
          next: objects.next,
          value
        };
      }
    };
    var listHas = function(objects, key) {
      return !!listGetNode(objects, key);
    };
    module.exports = function getSideChannel() {
      var $wm;
      var $m;
      var $o;
      var channel = {
        assert: function(key) {
          if (!channel.has(key)) {
            throw new $TypeError("Side channel does not contain " + inspect(key));
          }
        },
        get: function(key) {
          if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
            if ($wm) {
              return $weakMapGet($wm, key);
            }
          } else if ($Map) {
            if ($m) {
              return $mapGet($m, key);
            }
          } else {
            if ($o) {
              return listGet($o, key);
            }
          }
        },
        has: function(key) {
          if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
            if ($wm) {
              return $weakMapHas($wm, key);
            }
          } else if ($Map) {
            if ($m) {
              return $mapHas($m, key);
            }
          } else {
            if ($o) {
              return listHas($o, key);
            }
          }
          return false;
        },
        set: function(key, value) {
          if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
            if (!$wm) {
              $wm = new $WeakMap();
            }
            $weakMapSet($wm, key, value);
          } else if ($Map) {
            if (!$m) {
              $m = new $Map();
            }
            $mapSet($m, key, value);
          } else {
            if (!$o) {
              $o = { key: {}, next: null };
            }
            listSet($o, key, value);
          }
        }
      };
      return channel;
    };
  }
});

// ../../node_modules/.pnpm/qs@6.10.1/node_modules/qs/lib/formats.js
var require_formats = __commonJS({
  "../../node_modules/.pnpm/qs@6.10.1/node_modules/qs/lib/formats.js"(exports, module) {
    "use strict";
    var replace3 = String.prototype.replace;
    var percentTwenties = /%20/g;
    var Format = {
      RFC1738: "RFC1738",
      RFC3986: "RFC3986"
    };
    module.exports = {
      "default": Format.RFC3986,
      formatters: {
        RFC1738: function(value) {
          return replace3.call(value, percentTwenties, "+");
        },
        RFC3986: function(value) {
          return String(value);
        }
      },
      RFC1738: Format.RFC1738,
      RFC3986: Format.RFC3986
    };
  }
});

// ../../node_modules/.pnpm/qs@6.10.1/node_modules/qs/lib/utils.js
var require_utils = __commonJS({
  "../../node_modules/.pnpm/qs@6.10.1/node_modules/qs/lib/utils.js"(exports, module) {
    "use strict";
    var formats = require_formats();
    var has2 = Object.prototype.hasOwnProperty;
    var isArray2 = Array.isArray;
    var hexTable = function() {
      var array = [];
      for (var i = 0; i < 256; ++i) {
        array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
      }
      return array;
    }();
    var compactQueue = function compactQueue2(queue) {
      while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if (isArray2(obj)) {
          var compacted = [];
          for (var j = 0; j < obj.length; ++j) {
            if (typeof obj[j] !== "undefined") {
              compacted.push(obj[j]);
            }
          }
          item.obj[item.prop] = compacted;
        }
      }
    };
    var arrayToObject = function arrayToObject2(source, options) {
      var obj = options && options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== "undefined") {
          obj[i] = source[i];
        }
      }
      return obj;
    };
    var merge = function merge2(target, source, options) {
      if (!source) {
        return target;
      }
      if (typeof source !== "object") {
        if (isArray2(target)) {
          target.push(source);
        } else if (target && typeof target === "object") {
          if (options && (options.plainObjects || options.allowPrototypes) || !has2.call(Object.prototype, source)) {
            target[source] = true;
          }
        } else {
          return [target, source];
        }
        return target;
      }
      if (!target || typeof target !== "object") {
        return [target].concat(source);
      }
      var mergeTarget = target;
      if (isArray2(target) && !isArray2(source)) {
        mergeTarget = arrayToObject(target, options);
      }
      if (isArray2(target) && isArray2(source)) {
        source.forEach(function(item, i) {
          if (has2.call(target, i)) {
            var targetItem = target[i];
            if (targetItem && typeof targetItem === "object" && item && typeof item === "object") {
              target[i] = merge2(targetItem, item, options);
            } else {
              target.push(item);
            }
          } else {
            target[i] = item;
          }
        });
        return target;
      }
      return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if (has2.call(acc, key)) {
          acc[key] = merge2(acc[key], value, options);
        } else {
          acc[key] = value;
        }
        return acc;
      }, mergeTarget);
    };
    var assign = function assignSingleSource(target, source) {
      return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
      }, target);
    };
    var decode = function(str, decoder, charset) {
      var strWithoutPlus = str.replace(/\+/g, " ");
      if (charset === "iso-8859-1") {
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
      }
      try {
        return decodeURIComponent(strWithoutPlus);
      } catch (e) {
        return strWithoutPlus;
      }
    };
    var encode = function encode2(str, defaultEncoder, charset, kind, format) {
      if (str.length === 0) {
        return str;
      }
      var string = str;
      if (typeof str === "symbol") {
        string = Symbol.prototype.toString.call(str);
      } else if (typeof str !== "string") {
        string = String(str);
      }
      if (charset === "iso-8859-1") {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
          return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
        });
      }
      var out = "";
      for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);
        if (c === 45 || c === 46 || c === 95 || c === 126 || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || format === formats.RFC1738 && (c === 40 || c === 41)) {
          out += string.charAt(i);
          continue;
        }
        if (c < 128) {
          out = out + hexTable[c];
          continue;
        }
        if (c < 2048) {
          out = out + (hexTable[192 | c >> 6] + hexTable[128 | c & 63]);
          continue;
        }
        if (c < 55296 || c >= 57344) {
          out = out + (hexTable[224 | c >> 12] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63]);
          continue;
        }
        i += 1;
        c = 65536 + ((c & 1023) << 10 | string.charCodeAt(i) & 1023);
        out += hexTable[240 | c >> 18] + hexTable[128 | c >> 12 & 63] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63];
      }
      return out;
    };
    var compact16 = function compact17(value) {
      var queue = [{ obj: { o: value }, prop: "o" }];
      var refs = [];
      for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys4 = Object.keys(obj);
        for (var j = 0; j < keys4.length; ++j) {
          var key = keys4[j];
          var val = obj[key];
          if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
            queue.push({ obj, prop: key });
            refs.push(val);
          }
        }
      }
      compactQueue(queue);
      return value;
    };
    var isRegExp = function isRegExp2(obj) {
      return Object.prototype.toString.call(obj) === "[object RegExp]";
    };
    var isBuffer = function isBuffer2(obj) {
      if (!obj || typeof obj !== "object") {
        return false;
      }
      return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
    };
    var combine = function combine2(a, b) {
      return [].concat(a, b);
    };
    var maybeMap = function maybeMap2(val, fn) {
      if (isArray2(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
          mapped.push(fn(val[i]));
        }
        return mapped;
      }
      return fn(val);
    };
    module.exports = {
      arrayToObject,
      assign,
      combine,
      compact: compact16,
      decode,
      encode,
      isBuffer,
      isRegExp,
      maybeMap,
      merge
    };
  }
});

// ../../node_modules/.pnpm/qs@6.10.1/node_modules/qs/lib/stringify.js
var require_stringify = __commonJS({
  "../../node_modules/.pnpm/qs@6.10.1/node_modules/qs/lib/stringify.js"(exports, module) {
    "use strict";
    var getSideChannel = require_side_channel();
    var utils = require_utils();
    var formats = require_formats();
    var has2 = Object.prototype.hasOwnProperty;
    var arrayPrefixGenerators = {
      brackets: function brackets(prefix) {
        return prefix + "[]";
      },
      comma: "comma",
      indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
      },
      repeat: function repeat(prefix) {
        return prefix;
      }
    };
    var isArray2 = Array.isArray;
    var push = Array.prototype.push;
    var pushToArray = function(arr, valueOrArray) {
      push.apply(arr, isArray2(valueOrArray) ? valueOrArray : [valueOrArray]);
    };
    var toISO = Date.prototype.toISOString;
    var defaultFormat = formats["default"];
    var defaults = {
      addQueryPrefix: false,
      allowDots: false,
      charset: "utf-8",
      charsetSentinel: false,
      delimiter: "&",
      encode: true,
      encoder: utils.encode,
      encodeValuesOnly: false,
      format: defaultFormat,
      formatter: formats.formatters[defaultFormat],
      // deprecated
      indices: false,
      serializeDate: function serializeDate(date) {
        return toISO.call(date);
      },
      skipNulls: false,
      strictNullHandling: false
    };
    var isNonNullishPrimitive = function isNonNullishPrimitive2(v) {
      return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
    };
    var stringify = function stringify2(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter10, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
      var obj = object;
      if (sideChannel.has(object)) {
        throw new RangeError("Cyclic object value");
      }
      if (typeof filter10 === "function") {
        obj = filter10(prefix, obj);
      } else if (obj instanceof Date) {
        obj = serializeDate(obj);
      } else if (generateArrayPrefix === "comma" && isArray2(obj)) {
        obj = utils.maybeMap(obj, function(value2) {
          if (value2 instanceof Date) {
            return serializeDate(value2);
          }
          return value2;
        });
      }
      if (obj === null) {
        if (strictNullHandling) {
          return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, "key", format) : prefix;
        }
        obj = "";
      }
      if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
          var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, "key", format);
          return [formatter(keyValue) + "=" + formatter(encoder(obj, defaults.encoder, charset, "value", format))];
        }
        return [formatter(prefix) + "=" + formatter(String(obj))];
      }
      var values4 = [];
      if (typeof obj === "undefined") {
        return values4;
      }
      var objKeys;
      if (generateArrayPrefix === "comma" && isArray2(obj)) {
        objKeys = [{ value: obj.length > 0 ? obj.join(",") || null : void 0 }];
      } else if (isArray2(filter10)) {
        objKeys = filter10;
      } else {
        var keys4 = Object.keys(obj);
        objKeys = sort ? keys4.sort(sort) : keys4;
      }
      for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = typeof key === "object" && key.value !== void 0 ? key.value : obj[key];
        if (skipNulls && value === null) {
          continue;
        }
        var keyPrefix = isArray2(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? "." + key : "[" + key + "]");
        sideChannel.set(object, true);
        var valueSideChannel = getSideChannel();
        pushToArray(values4, stringify2(
          value,
          keyPrefix,
          generateArrayPrefix,
          strictNullHandling,
          skipNulls,
          encoder,
          filter10,
          sort,
          allowDots,
          serializeDate,
          format,
          formatter,
          encodeValuesOnly,
          charset,
          valueSideChannel
        ));
      }
      return values4;
    };
    var normalizeStringifyOptions = function normalizeStringifyOptions2(opts) {
      if (!opts) {
        return defaults;
      }
      if (opts.encoder !== null && opts.encoder !== void 0 && typeof opts.encoder !== "function") {
        throw new TypeError("Encoder has to be a function.");
      }
      var charset = opts.charset || defaults.charset;
      if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
        throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
      }
      var format = formats["default"];
      if (typeof opts.format !== "undefined") {
        if (!has2.call(formats.formatters, opts.format)) {
          throw new TypeError("Unknown format option provided.");
        }
        format = opts.format;
      }
      var formatter = formats.formatters[format];
      var filter10 = defaults.filter;
      if (typeof opts.filter === "function" || isArray2(opts.filter)) {
        filter10 = opts.filter;
      }
      return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? defaults.allowDots : !!opts.allowDots,
        charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter10,
        format,
        formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
      };
    };
    module.exports = function(object, opts) {
      var obj = object;
      var options = normalizeStringifyOptions(opts);
      var objKeys;
      var filter10;
      if (typeof options.filter === "function") {
        filter10 = options.filter;
        obj = filter10("", obj);
      } else if (isArray2(options.filter)) {
        filter10 = options.filter;
        objKeys = filter10;
      }
      var keys4 = [];
      if (typeof obj !== "object" || obj === null) {
        return "";
      }
      var arrayFormat;
      if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
      } else if (opts && "indices" in opts) {
        arrayFormat = opts.indices ? "indices" : "repeat";
      } else {
        arrayFormat = "indices";
      }
      var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
      if (!objKeys) {
        objKeys = Object.keys(obj);
      }
      if (options.sort) {
        objKeys.sort(options.sort);
      }
      var sideChannel = getSideChannel();
      for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) {
          continue;
        }
        pushToArray(keys4, stringify(
          obj[key],
          key,
          generateArrayPrefix,
          options.strictNullHandling,
          options.skipNulls,
          options.encode ? options.encoder : null,
          options.filter,
          options.sort,
          options.allowDots,
          options.serializeDate,
          options.format,
          options.formatter,
          options.encodeValuesOnly,
          options.charset,
          sideChannel
        ));
      }
      var joined = keys4.join(options.delimiter);
      var prefix = options.addQueryPrefix === true ? "?" : "";
      if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") {
          prefix += "utf8=%26%2310003%3B&";
        } else {
          prefix += "utf8=%E2%9C%93&";
        }
      }
      return joined.length > 0 ? prefix + joined : "";
    };
  }
});

// ../../node_modules/.pnpm/qs@6.10.1/node_modules/qs/lib/parse.js
var require_parse = __commonJS({
  "../../node_modules/.pnpm/qs@6.10.1/node_modules/qs/lib/parse.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var has2 = Object.prototype.hasOwnProperty;
    var isArray2 = Array.isArray;
    var defaults = {
      allowDots: false,
      allowPrototypes: false,
      allowSparse: false,
      arrayLimit: 20,
      charset: "utf-8",
      charsetSentinel: false,
      comma: false,
      decoder: utils.decode,
      delimiter: "&",
      depth: 5,
      ignoreQueryPrefix: false,
      interpretNumericEntities: false,
      parameterLimit: 1e3,
      parseArrays: true,
      plainObjects: false,
      strictNullHandling: false
    };
    var interpretNumericEntities = function(str) {
      return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
      });
    };
    var parseArrayValue = function(val, options) {
      if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) {
        return val.split(",");
      }
      return val;
    };
    var isoSentinel = "utf8=%26%2310003%3B";
    var charsetSentinel = "utf8=%E2%9C%93";
    var parseValues = function parseQueryStringValues(str, options) {
      var obj = {};
      var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
      var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
      var parts = cleanStr.split(options.delimiter, limit);
      var skipIndex = -1;
      var i;
      var charset = options.charset;
      if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
          if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === charsetSentinel) {
              charset = "utf-8";
            } else if (parts[i] === isoSentinel) {
              charset = "iso-8859-1";
            }
            skipIndex = i;
            i = parts.length;
          }
        }
      }
      for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
          continue;
        }
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
          key = options.decoder(part, defaults.decoder, charset, "key");
          val = options.strictNullHandling ? null : "";
        } else {
          key = options.decoder(part.slice(0, pos), defaults.decoder, charset, "key");
          val = utils.maybeMap(
            parseArrayValue(part.slice(pos + 1), options),
            function(encodedVal) {
              return options.decoder(encodedVal, defaults.decoder, charset, "value");
            }
          );
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") {
          val = interpretNumericEntities(val);
        }
        if (part.indexOf("[]=") > -1) {
          val = isArray2(val) ? [val] : val;
        }
        if (has2.call(obj, key)) {
          obj[key] = utils.combine(obj[key], val);
        } else {
          obj[key] = val;
        }
      }
      return obj;
    };
    var parseObject = function(chain, val, options, valuesParsed) {
      var leaf = valuesParsed ? val : parseArrayValue(val, options);
      for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) {
          obj = [].concat(leaf);
        } else {
          obj = options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
          var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
          var index = parseInt(cleanRoot, 10);
          if (!options.parseArrays && cleanRoot === "") {
            obj = { 0: leaf };
          } else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && (options.parseArrays && index <= options.arrayLimit)) {
            obj = [];
            obj[index] = leaf;
          } else {
            obj[cleanRoot] = leaf;
          }
        }
        leaf = obj;
      }
      return leaf;
    };
    var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
      if (!givenKey) {
        return;
      }
      var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
      var brackets = /(\[[^[\]]*])/;
      var child = /(\[[^[\]]*])/g;
      var segment = options.depth > 0 && brackets.exec(key);
      var parent = segment ? key.slice(0, segment.index) : key;
      var keys4 = [];
      if (parent) {
        if (!options.plainObjects && has2.call(Object.prototype, parent)) {
          if (!options.allowPrototypes) {
            return;
          }
        }
        keys4.push(parent);
      }
      var i = 0;
      while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has2.call(Object.prototype, segment[1].slice(1, -1))) {
          if (!options.allowPrototypes) {
            return;
          }
        }
        keys4.push(segment[1]);
      }
      if (segment) {
        keys4.push("[" + key.slice(segment.index) + "]");
      }
      return parseObject(keys4, val, options, valuesParsed);
    };
    var normalizeParseOptions = function normalizeParseOptions2(opts) {
      if (!opts) {
        return defaults;
      }
      if (opts.decoder !== null && opts.decoder !== void 0 && typeof opts.decoder !== "function") {
        throw new TypeError("Decoder has to be a function.");
      }
      if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
        throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
      }
      var charset = typeof opts.charset === "undefined" ? defaults.charset : opts.charset;
      return {
        allowDots: typeof opts.allowDots === "undefined" ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : defaults.arrayLimit,
        charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
      };
    };
    module.exports = function(str, opts) {
      var options = normalizeParseOptions(opts);
      if (str === "" || str === null || typeof str === "undefined") {
        return options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      }
      var tempObj = typeof str === "string" ? parseValues(str, options) : str;
      var obj = options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var keys4 = Object.keys(tempObj);
      for (var i = 0; i < keys4.length; ++i) {
        var key = keys4[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = utils.merge(obj, newObj, options);
      }
      if (options.allowSparse === true) {
        return obj;
      }
      return utils.compact(obj);
    };
  }
});

// ../../node_modules/.pnpm/qs@6.10.1/node_modules/qs/lib/index.js
var require_lib = __commonJS({
  "../../node_modules/.pnpm/qs@6.10.1/node_modules/qs/lib/index.js"(exports, module) {
    "use strict";
    var stringify = require_stringify();
    var parse = require_parse();
    var formats = require_formats();
    module.exports = {
      formats,
      parse,
      stringify
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/bind.js
var require_bind = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/bind.js"(exports, module) {
    "use strict";
    module.exports = function bind(fn, thisArg) {
      return function wrap() {
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i];
        }
        return fn.apply(thisArg, args);
      };
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/utils.js
var require_utils2 = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/utils.js"(exports, module) {
    "use strict";
    var bind = require_bind();
    var toString = Object.prototype.toString;
    function isArray2(val) {
      return toString.call(val) === "[object Array]";
    }
    function isUndefined3(val) {
      return typeof val === "undefined";
    }
    function isBuffer(val) {
      return val !== null && !isUndefined3(val) && val.constructor !== null && !isUndefined3(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
    }
    function isArrayBuffer(val) {
      return toString.call(val) === "[object ArrayBuffer]";
    }
    function isFormData(val) {
      return typeof FormData !== "undefined" && val instanceof FormData;
    }
    function isArrayBufferView(val) {
      var result;
      if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
        result = ArrayBuffer.isView(val);
      } else {
        result = val && val.buffer && val.buffer instanceof ArrayBuffer;
      }
      return result;
    }
    function isString(val) {
      return typeof val === "string";
    }
    function isNumber2(val) {
      return typeof val === "number";
    }
    function isObject2(val) {
      return val !== null && typeof val === "object";
    }
    function isPlainObject(val) {
      if (toString.call(val) !== "[object Object]") {
        return false;
      }
      var prototype = Object.getPrototypeOf(val);
      return prototype === null || prototype === Object.prototype;
    }
    function isDate(val) {
      return toString.call(val) === "[object Date]";
    }
    function isFile(val) {
      return toString.call(val) === "[object File]";
    }
    function isBlob(val) {
      return toString.call(val) === "[object Blob]";
    }
    function isFunction2(val) {
      return toString.call(val) === "[object Function]";
    }
    function isStream(val) {
      return isObject2(val) && isFunction2(val.pipe);
    }
    function isURLSearchParams(val) {
      return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
    }
    function trim(str) {
      return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    function isStandardBrowserEnv() {
      if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
        return false;
      }
      return typeof window !== "undefined" && typeof document !== "undefined";
    }
    function forEach2(obj, fn) {
      if (obj === null || typeof obj === "undefined") {
        return;
      }
      if (typeof obj !== "object") {
        obj = [obj];
      }
      if (isArray2(obj)) {
        for (var i = 0, l = obj.length; i < l; i++) {
          fn.call(null, obj[i], i, obj);
        }
      } else {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn.call(null, obj[key], key, obj);
          }
        }
      }
    }
    function merge() {
      var result = {};
      function assignValue(val, key) {
        if (isPlainObject(result[key]) && isPlainObject(val)) {
          result[key] = merge(result[key], val);
        } else if (isPlainObject(val)) {
          result[key] = merge({}, val);
        } else if (isArray2(val)) {
          result[key] = val.slice();
        } else {
          result[key] = val;
        }
      }
      for (var i = 0, l = arguments.length; i < l; i++) {
        forEach2(arguments[i], assignValue);
      }
      return result;
    }
    function extend(a, b, thisArg) {
      forEach2(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") {
          a[key] = bind(val, thisArg);
        } else {
          a[key] = val;
        }
      });
      return a;
    }
    function stripBOM(content) {
      if (content.charCodeAt(0) === 65279) {
        content = content.slice(1);
      }
      return content;
    }
    module.exports = {
      isArray: isArray2,
      isArrayBuffer,
      isBuffer,
      isFormData,
      isArrayBufferView,
      isString,
      isNumber: isNumber2,
      isObject: isObject2,
      isPlainObject,
      isUndefined: isUndefined3,
      isDate,
      isFile,
      isBlob,
      isFunction: isFunction2,
      isStream,
      isURLSearchParams,
      isStandardBrowserEnv,
      forEach: forEach2,
      merge,
      extend,
      trim,
      stripBOM
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/buildURL.js
var require_buildURL = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/buildURL.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    function encode(val) {
      return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }
    module.exports = function buildURL(url15, params, paramsSerializer2) {
      if (!params) {
        return url15;
      }
      var serializedParams;
      if (paramsSerializer2) {
        serializedParams = paramsSerializer2(params);
      } else if (utils.isURLSearchParams(params)) {
        serializedParams = params.toString();
      } else {
        var parts = [];
        utils.forEach(params, function serialize(val, key) {
          if (val === null || typeof val === "undefined") {
            return;
          }
          if (utils.isArray(val)) {
            key = key + "[]";
          } else {
            val = [val];
          }
          utils.forEach(val, function parseValue(v) {
            if (utils.isDate(v)) {
              v = v.toISOString();
            } else if (utils.isObject(v)) {
              v = JSON.stringify(v);
            }
            parts.push(encode(key) + "=" + encode(v));
          });
        });
        serializedParams = parts.join("&");
      }
      if (serializedParams) {
        var hashmarkIndex = url15.indexOf("#");
        if (hashmarkIndex !== -1) {
          url15 = url15.slice(0, hashmarkIndex);
        }
        url15 += (url15.indexOf("?") === -1 ? "?" : "&") + serializedParams;
      }
      return url15;
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/InterceptorManager.js
var require_InterceptorManager = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/InterceptorManager.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    function InterceptorManager() {
      this.handlers = [];
    }
    InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
      this.handlers.push({
        fulfilled,
        rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
      });
      return this.handlers.length - 1;
    };
    InterceptorManager.prototype.eject = function eject(id) {
      if (this.handlers[id]) {
        this.handlers[id] = null;
      }
    };
    InterceptorManager.prototype.forEach = function forEach2(fn) {
      utils.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) {
          fn(h);
        }
      });
    };
    module.exports = InterceptorManager;
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/normalizeHeaderName.js
var require_normalizeHeaderName = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/normalizeHeaderName.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    module.exports = function normalizeHeaderName(headers, normalizedName) {
      utils.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
          headers[normalizedName] = value;
          delete headers[name];
        }
      });
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/enhanceError.js
var require_enhanceError = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/enhanceError.js"(exports, module) {
    "use strict";
    module.exports = function enhanceError(error, config2, code, request, response) {
      error.config = config2;
      if (code) {
        error.code = code;
      }
      error.request = request;
      error.response = response;
      error.isAxiosError = true;
      error.toJSON = function toJSON() {
        return {
          // Standard
          message: this.message,
          name: this.name,
          // Microsoft
          description: this.description,
          number: this.number,
          // Mozilla
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          // Axios
          config: this.config,
          code: this.code,
          status: this.response && this.response.status ? this.response.status : null
        };
      };
      return error;
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/createError.js
var require_createError = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/createError.js"(exports, module) {
    "use strict";
    var enhanceError = require_enhanceError();
    module.exports = function createError(message, config2, code, request, response) {
      var error = new Error(message);
      return enhanceError(error, config2, code, request, response);
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/settle.js
var require_settle = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/settle.js"(exports, module) {
    "use strict";
    var createError = require_createError();
    module.exports = function settle(resolve, reject, response) {
      var validateStatus = response.config.validateStatus;
      if (!response.status || !validateStatus || validateStatus(response.status)) {
        resolve(response);
      } else {
        reject(createError(
          "Request failed with status code " + response.status,
          response.config,
          null,
          response.request,
          response
        ));
      }
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/cookies.js
var require_cookies = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/cookies.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    module.exports = utils.isStandardBrowserEnv() ? (
      // Standard browser envs support document.cookie
      function standardBrowserEnv() {
        return {
          write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if (utils.isNumber(expires)) {
              cookie.push("expires=" + new Date(expires).toGMTString());
            }
            if (utils.isString(path)) {
              cookie.push("path=" + path);
            }
            if (utils.isString(domain)) {
              cookie.push("domain=" + domain);
            }
            if (secure === true) {
              cookie.push("secure");
            }
            document.cookie = cookie.join("; ");
          },
          read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
          },
          remove: function remove(name) {
            this.write(name, "", Date.now() - 864e5);
          }
        };
      }()
    ) : (
      // Non standard browser env (web workers, react-native) lack needed support.
      function nonStandardBrowserEnv() {
        return {
          write: function write() {
          },
          read: function read() {
            return null;
          },
          remove: function remove() {
          }
        };
      }()
    );
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/isAbsoluteURL.js
var require_isAbsoluteURL = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/isAbsoluteURL.js"(exports, module) {
    "use strict";
    module.exports = function isAbsoluteURL(url15) {
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url15);
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/combineURLs.js
var require_combineURLs = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/combineURLs.js"(exports, module) {
    "use strict";
    module.exports = function combineURLs(baseURL, relativeURL) {
      return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/buildFullPath.js
var require_buildFullPath = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/buildFullPath.js"(exports, module) {
    "use strict";
    var isAbsoluteURL = require_isAbsoluteURL();
    var combineURLs = require_combineURLs();
    module.exports = function buildFullPath(baseURL, requestedURL) {
      if (baseURL && !isAbsoluteURL(requestedURL)) {
        return combineURLs(baseURL, requestedURL);
      }
      return requestedURL;
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/parseHeaders.js
var require_parseHeaders = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/parseHeaders.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var ignoreDuplicateOf = [
      "age",
      "authorization",
      "content-length",
      "content-type",
      "etag",
      "expires",
      "from",
      "host",
      "if-modified-since",
      "if-unmodified-since",
      "last-modified",
      "location",
      "max-forwards",
      "proxy-authorization",
      "referer",
      "retry-after",
      "user-agent"
    ];
    module.exports = function parseHeaders(headers) {
      var parsed = {};
      var key;
      var val;
      var i;
      if (!headers) {
        return parsed;
      }
      utils.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = utils.trim(line.substr(0, i)).toLowerCase();
        val = utils.trim(line.substr(i + 1));
        if (key) {
          if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
            return;
          }
          if (key === "set-cookie") {
            parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
          } else {
            parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
          }
        }
      });
      return parsed;
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/isURLSameOrigin.js
var require_isURLSameOrigin = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/isURLSameOrigin.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    module.exports = utils.isStandardBrowserEnv() ? (
      // Standard browser envs have full support of the APIs needed to test
      // whether the request URL is of the same origin as current location.
      function standardBrowserEnv() {
        var msie = /(msie|trident)/i.test(navigator.userAgent);
        var urlParsingNode = document.createElement("a");
        var originURL;
        function resolveURL(url15) {
          var href = url15;
          if (msie) {
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
          }
          urlParsingNode.setAttribute("href", href);
          return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
          };
        }
        originURL = resolveURL(window.location.href);
        return function isURLSameOrigin(requestURL) {
          var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
          return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
        };
      }()
    ) : (
      // Non standard browser envs (web workers, react-native) lack needed support.
      function nonStandardBrowserEnv() {
        return function isURLSameOrigin() {
          return true;
        };
      }()
    );
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/cancel/Cancel.js
var require_Cancel = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/cancel/Cancel.js"(exports, module) {
    "use strict";
    function Cancel(message) {
      this.message = message;
    }
    Cancel.prototype.toString = function toString() {
      return "Cancel" + (this.message ? ": " + this.message : "");
    };
    Cancel.prototype.__CANCEL__ = true;
    module.exports = Cancel;
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/adapters/xhr.js
var require_xhr = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/adapters/xhr.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var settle = require_settle();
    var cookies = require_cookies();
    var buildURL = require_buildURL();
    var buildFullPath = require_buildFullPath();
    var parseHeaders = require_parseHeaders();
    var isURLSameOrigin = require_isURLSameOrigin();
    var createError = require_createError();
    var defaults = require_defaults();
    var Cancel = require_Cancel();
    module.exports = function xhrAdapter(config2) {
      return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config2.data;
        var requestHeaders = config2.headers;
        var responseType = config2.responseType;
        var onCanceled;
        function done() {
          if (config2.cancelToken) {
            config2.cancelToken.unsubscribe(onCanceled);
          }
          if (config2.signal) {
            config2.signal.removeEventListener("abort", onCanceled);
          }
        }
        if (utils.isFormData(requestData)) {
          delete requestHeaders["Content-Type"];
        }
        var request = new XMLHttpRequest();
        if (config2.auth) {
          var username = config2.auth.username || "";
          var password = config2.auth.password ? unescape(encodeURIComponent(config2.auth.password)) : "";
          requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = buildFullPath(config2.baseURL, config2.url);
        request.open(config2.method.toUpperCase(), buildURL(fullPath, config2.params, config2.paramsSerializer), true);
        request.timeout = config2.timeout;
        function onloadend() {
          if (!request) {
            return;
          }
          var responseHeaders = "getAllResponseHeaders" in request ? parseHeaders(request.getAllResponseHeaders()) : null;
          var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
          var response = {
            data: responseData,
            status: request.status,
            statusText: request.statusText,
            headers: responseHeaders,
            config: config2,
            request
          };
          settle(function _resolve(value) {
            resolve(value);
            done();
          }, function _reject(err) {
            reject(err);
            done();
          }, response);
          request = null;
        }
        if ("onloadend" in request) {
          request.onloadend = onloadend;
        } else {
          request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) {
              return;
            }
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
              return;
            }
            setTimeout(onloadend);
          };
        }
        request.onabort = function handleAbort() {
          if (!request) {
            return;
          }
          reject(createError("Request aborted", config2, "ECONNABORTED", request));
          request = null;
        };
        request.onerror = function handleError() {
          reject(createError("Network Error", config2, null, request));
          request = null;
        };
        request.ontimeout = function handleTimeout() {
          var timeoutErrorMessage2 = config2.timeout ? "timeout of " + config2.timeout + "ms exceeded" : "timeout exceeded";
          var transitional = config2.transitional || defaults.transitional;
          if (config2.timeoutErrorMessage) {
            timeoutErrorMessage2 = config2.timeoutErrorMessage;
          }
          reject(createError(
            timeoutErrorMessage2,
            config2,
            transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
            request
          ));
          request = null;
        };
        if (utils.isStandardBrowserEnv()) {
          var xsrfValue = (config2.withCredentials || isURLSameOrigin(fullPath)) && config2.xsrfCookieName ? cookies.read(config2.xsrfCookieName) : void 0;
          if (xsrfValue) {
            requestHeaders[config2.xsrfHeaderName] = xsrfValue;
          }
        }
        if ("setRequestHeader" in request) {
          utils.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
              delete requestHeaders[key];
            } else {
              request.setRequestHeader(key, val);
            }
          });
        }
        if (!utils.isUndefined(config2.withCredentials)) {
          request.withCredentials = !!config2.withCredentials;
        }
        if (responseType && responseType !== "json") {
          request.responseType = config2.responseType;
        }
        if (typeof config2.onDownloadProgress === "function") {
          request.addEventListener("progress", config2.onDownloadProgress);
        }
        if (typeof config2.onUploadProgress === "function" && request.upload) {
          request.upload.addEventListener("progress", config2.onUploadProgress);
        }
        if (config2.cancelToken || config2.signal) {
          onCanceled = function(cancel) {
            if (!request) {
              return;
            }
            reject(!cancel || cancel && cancel.type ? new Cancel("canceled") : cancel);
            request.abort();
            request = null;
          };
          config2.cancelToken && config2.cancelToken.subscribe(onCanceled);
          if (config2.signal) {
            config2.signal.aborted ? onCanceled() : config2.signal.addEventListener("abort", onCanceled);
          }
        }
        if (!requestData) {
          requestData = null;
        }
        request.send(requestData);
      });
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/defaults.js
var require_defaults = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/defaults.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var normalizeHeaderName = require_normalizeHeaderName();
    var enhanceError = require_enhanceError();
    var DEFAULT_CONTENT_TYPE = {
      "Content-Type": "application/x-www-form-urlencoded"
    };
    function setContentTypeIfUnset(headers, value) {
      if (!utils.isUndefined(headers) && utils.isUndefined(headers["Content-Type"])) {
        headers["Content-Type"] = value;
      }
    }
    function getDefaultAdapter() {
      var adapter;
      if (typeof XMLHttpRequest !== "undefined") {
        adapter = require_xhr();
      } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
        adapter = require_xhr();
      }
      return adapter;
    }
    function stringifySafely(rawValue, parser, encoder) {
      if (utils.isString(rawValue)) {
        try {
          (parser || JSON.parse)(rawValue);
          return utils.trim(rawValue);
        } catch (e) {
          if (e.name !== "SyntaxError") {
            throw e;
          }
        }
      }
      return (encoder || JSON.stringify)(rawValue);
    }
    var defaults = {
      transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
      },
      adapter: getDefaultAdapter(),
      transformRequest: [function transformRequest(data, headers) {
        normalizeHeaderName(headers, "Accept");
        normalizeHeaderName(headers, "Content-Type");
        if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
          return data;
        }
        if (utils.isArrayBufferView(data)) {
          return data.buffer;
        }
        if (utils.isURLSearchParams(data)) {
          setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
          return data.toString();
        }
        if (utils.isObject(data) || headers && headers["Content-Type"] === "application/json") {
          setContentTypeIfUnset(headers, "application/json");
          return stringifySafely(data);
        }
        return data;
      }],
      transformResponse: [function transformResponse(data) {
        var transitional = this.transitional || defaults.transitional;
        var silentJSONParsing = transitional && transitional.silentJSONParsing;
        var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
        var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
        if (strictJSONParsing || forcedJSONParsing && utils.isString(data) && data.length) {
          try {
            return JSON.parse(data);
          } catch (e) {
            if (strictJSONParsing) {
              if (e.name === "SyntaxError") {
                throw enhanceError(e, this, "E_JSON_PARSE");
              }
              throw e;
            }
          }
        }
        return data;
      }],
      /**
       * A timeout in milliseconds to abort a request. If set to 0 (default) a
       * timeout is not created.
       */
      timeout: 0,
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      maxContentLength: -1,
      maxBodyLength: -1,
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      },
      headers: {
        common: {
          "Accept": "application/json, text/plain, */*"
        }
      }
    };
    utils.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
      defaults.headers[method] = {};
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
    });
    module.exports = defaults;
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/transformData.js
var require_transformData = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/transformData.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var defaults = require_defaults();
    module.exports = function transformData(data, headers, fns) {
      var context = this || defaults;
      utils.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
      });
      return data;
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/cancel/isCancel.js
var require_isCancel = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/cancel/isCancel.js"(exports, module) {
    "use strict";
    module.exports = function isCancel(value) {
      return !!(value && value.__CANCEL__);
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/dispatchRequest.js
var require_dispatchRequest = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/dispatchRequest.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var transformData = require_transformData();
    var isCancel = require_isCancel();
    var defaults = require_defaults();
    var Cancel = require_Cancel();
    function throwIfCancellationRequested(config2) {
      if (config2.cancelToken) {
        config2.cancelToken.throwIfRequested();
      }
      if (config2.signal && config2.signal.aborted) {
        throw new Cancel("canceled");
      }
    }
    module.exports = function dispatchRequest(config2) {
      throwIfCancellationRequested(config2);
      config2.headers = config2.headers || {};
      config2.data = transformData.call(
        config2,
        config2.data,
        config2.headers,
        config2.transformRequest
      );
      config2.headers = utils.merge(
        config2.headers.common || {},
        config2.headers[config2.method] || {},
        config2.headers
      );
      utils.forEach(
        ["delete", "get", "head", "post", "put", "patch", "common"],
        function cleanHeaderConfig(method) {
          delete config2.headers[method];
        }
      );
      var adapter = config2.adapter || defaults.adapter;
      return adapter(config2).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config2);
        response.data = transformData.call(
          config2,
          response.data,
          response.headers,
          config2.transformResponse
        );
        return response;
      }, function onAdapterRejection(reason) {
        if (!isCancel(reason)) {
          throwIfCancellationRequested(config2);
          if (reason && reason.response) {
            reason.response.data = transformData.call(
              config2,
              reason.response.data,
              reason.response.headers,
              config2.transformResponse
            );
          }
        }
        return Promise.reject(reason);
      });
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/mergeConfig.js
var require_mergeConfig = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/mergeConfig.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    module.exports = function mergeConfig(config1, config2) {
      config2 = config2 || {};
      var config3 = {};
      function getMergedValue(target, source) {
        if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
          return utils.merge(target, source);
        } else if (utils.isPlainObject(source)) {
          return utils.merge({}, source);
        } else if (utils.isArray(source)) {
          return source.slice();
        }
        return source;
      }
      function mergeDeepProperties(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function valueFromConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(void 0, config2[prop]);
        }
      }
      function defaultToConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(void 0, config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function mergeDirectKeys(prop) {
        if (prop in config2) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (prop in config1) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      var mergeMap2 = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
      };
      utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap2[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        utils.isUndefined(configValue) && merge !== mergeDirectKeys || (config3[prop] = configValue);
      });
      return config3;
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/env/data.js
var require_data = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/env/data.js"(exports, module) {
    module.exports = {
      "version": "0.24.0"
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/validator.js
var require_validator = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/validator.js"(exports, module) {
    "use strict";
    var VERSION = require_data().version;
    var validators = {};
    ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i) {
      validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
      };
    });
    var deprecatedWarnings = {};
    validators.transitional = function transitional(validator, version, message) {
      function formatMessage(opt, desc) {
        return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
      }
      return function(value, opt, opts) {
        if (validator === false) {
          throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
        }
        if (version && !deprecatedWarnings[opt]) {
          deprecatedWarnings[opt] = true;
          console.warn(
            formatMessage(
              opt,
              " has been deprecated since v" + version + " and will be removed in the near future"
            )
          );
        }
        return validator ? validator(value, opt, opts) : true;
      };
    };
    function assertOptions(options, schema, allowUnknown) {
      if (typeof options !== "object") {
        throw new TypeError("options must be an object");
      }
      var keys4 = Object.keys(options);
      var i = keys4.length;
      while (i-- > 0) {
        var opt = keys4[i];
        var validator = schema[opt];
        if (validator) {
          var value = options[opt];
          var result = value === void 0 || validator(value, opt, options);
          if (result !== true) {
            throw new TypeError("option " + opt + " must be " + result);
          }
          continue;
        }
        if (allowUnknown !== true) {
          throw Error("Unknown option " + opt);
        }
      }
    }
    module.exports = {
      assertOptions,
      validators
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/Axios.js
var require_Axios = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/core/Axios.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var buildURL = require_buildURL();
    var InterceptorManager = require_InterceptorManager();
    var dispatchRequest = require_dispatchRequest();
    var mergeConfig = require_mergeConfig();
    var validator = require_validator();
    var validators = validator.validators;
    function Axios2(instanceConfig) {
      this.defaults = instanceConfig;
      this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
      };
    }
    Axios2.prototype.request = function request(config2) {
      if (typeof config2 === "string") {
        config2 = arguments[1] || {};
        config2.url = arguments[0];
      } else {
        config2 = config2 || {};
      }
      config2 = mergeConfig(this.defaults, config2);
      if (config2.method) {
        config2.method = config2.method.toLowerCase();
      } else if (this.defaults.method) {
        config2.method = this.defaults.method.toLowerCase();
      } else {
        config2.method = "get";
      }
      var transitional = config2.transitional;
      if (transitional !== void 0) {
        validator.assertOptions(transitional, {
          silentJSONParsing: validators.transitional(validators.boolean),
          forcedJSONParsing: validators.transitional(validators.boolean),
          clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
      }
      var requestInterceptorChain = [];
      var synchronousRequestInterceptors = true;
      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config2) === false) {
          return;
        }
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
      });
      var responseInterceptorChain = [];
      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
      });
      var promise;
      if (!synchronousRequestInterceptors) {
        var chain = [dispatchRequest, void 0];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config2);
        while (chain.length) {
          promise = promise.then(chain.shift(), chain.shift());
        }
        return promise;
      }
      var newConfig = config2;
      while (requestInterceptorChain.length) {
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
          newConfig = onFulfilled(newConfig);
        } catch (error) {
          onRejected(error);
          break;
        }
      }
      try {
        promise = dispatchRequest(newConfig);
      } catch (error) {
        return Promise.reject(error);
      }
      while (responseInterceptorChain.length) {
        promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
      }
      return promise;
    };
    Axios2.prototype.getUri = function getUri(config2) {
      config2 = mergeConfig(this.defaults, config2);
      return buildURL(config2.url, config2.params, config2.paramsSerializer).replace(/^\?/, "");
    };
    utils.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
      Axios2.prototype[method] = function(url15, config2) {
        return this.request(mergeConfig(config2 || {}, {
          method,
          url: url15,
          data: (config2 || {}).data
        }));
      };
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      Axios2.prototype[method] = function(url15, data, config2) {
        return this.request(mergeConfig(config2 || {}, {
          method,
          url: url15,
          data
        }));
      };
    });
    module.exports = Axios2;
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/cancel/CancelToken.js
var require_CancelToken = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/cancel/CancelToken.js"(exports, module) {
    "use strict";
    var Cancel = require_Cancel();
    function CancelToken(executor) {
      if (typeof executor !== "function") {
        throw new TypeError("executor must be a function.");
      }
      var resolvePromise;
      this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
      });
      var token = this;
      this.promise.then(function(cancel) {
        if (!token._listeners)
          return;
        var i;
        var l = token._listeners.length;
        for (i = 0; i < l; i++) {
          token._listeners[i](cancel);
        }
        token._listeners = null;
      });
      this.promise.then = function(onfulfilled) {
        var _resolve;
        var promise = new Promise(function(resolve) {
          token.subscribe(resolve);
          _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
          token.unsubscribe(_resolve);
        };
        return promise;
      };
      executor(function cancel(message) {
        if (token.reason) {
          return;
        }
        token.reason = new Cancel(message);
        resolvePromise(token.reason);
      });
    }
    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
      if (this.reason) {
        throw this.reason;
      }
    };
    CancelToken.prototype.subscribe = function subscribe(listener) {
      if (this.reason) {
        listener(this.reason);
        return;
      }
      if (this._listeners) {
        this._listeners.push(listener);
      } else {
        this._listeners = [listener];
      }
    };
    CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
      if (!this._listeners) {
        return;
      }
      var index = this._listeners.indexOf(listener);
      if (index !== -1) {
        this._listeners.splice(index, 1);
      }
    };
    CancelToken.source = function source() {
      var cancel;
      var token = new CancelToken(function executor(c) {
        cancel = c;
      });
      return {
        token,
        cancel
      };
    };
    module.exports = CancelToken;
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/spread.js
var require_spread = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/spread.js"(exports, module) {
    "use strict";
    module.exports = function spread(callback) {
      return function wrap(arr) {
        return callback.apply(null, arr);
      };
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/isAxiosError.js
var require_isAxiosError = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/helpers/isAxiosError.js"(exports, module) {
    "use strict";
    module.exports = function isAxiosError(payload) {
      return typeof payload === "object" && payload.isAxiosError === true;
    };
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/axios.js
var require_axios = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/lib/axios.js"(exports, module) {
    "use strict";
    var utils = require_utils2();
    var bind = require_bind();
    var Axios2 = require_Axios();
    var mergeConfig = require_mergeConfig();
    var defaults = require_defaults();
    function createInstance(defaultConfig) {
      var context = new Axios2(defaultConfig);
      var instance = bind(Axios2.prototype.request, context);
      utils.extend(instance, Axios2.prototype, context);
      utils.extend(instance, context);
      instance.create = function create(instanceConfig) {
        return createInstance(mergeConfig(defaultConfig, instanceConfig));
      };
      return instance;
    }
    var axios4 = createInstance(defaults);
    axios4.Axios = Axios2;
    axios4.Cancel = require_Cancel();
    axios4.CancelToken = require_CancelToken();
    axios4.isCancel = require_isCancel();
    axios4.VERSION = require_data().version;
    axios4.all = function all(promises) {
      return Promise.all(promises);
    };
    axios4.spread = require_spread();
    axios4.isAxiosError = require_isAxiosError();
    module.exports = axios4;
    module.exports.default = axios4;
  }
});

// ../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/index.js
var require_axios2 = __commonJS({
  "../../node_modules/.pnpm/axios@0.24.0/node_modules/axios/index.js"(exports, module) {
    module.exports = require_axios();
  }
});

// ../../node_modules/.pnpm/fast-deep-equal@3.1.3/node_modules/fast-deep-equal/index.js
var require_fast_deep_equal = __commonJS({
  "../../node_modules/.pnpm/fast-deep-equal@3.1.3/node_modules/fast-deep-equal/index.js"(exports, module) {
    "use strict";
    module.exports = function equal(a, b) {
      if (a === b)
        return true;
      if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor)
          return false;
        var length, i, keys4;
        if (Array.isArray(a)) {
          length = a.length;
          if (length != b.length)
            return false;
          for (i = length; i-- !== 0; )
            if (!equal(a[i], b[i]))
              return false;
          return true;
        }
        if (a.constructor === RegExp)
          return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf)
          return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString)
          return a.toString() === b.toString();
        keys4 = Object.keys(a);
        length = keys4.length;
        if (length !== Object.keys(b).length)
          return false;
        for (i = length; i-- !== 0; )
          if (!Object.prototype.hasOwnProperty.call(b, keys4[i]))
            return false;
        for (i = length; i-- !== 0; ) {
          var key = keys4[i];
          if (!equal(a[key], b[key]))
            return false;
        }
        return true;
      }
      return a !== a && b !== b;
    };
  }
});

// ../../node_modules/.pnpm/is-buffer@2.0.5/node_modules/is-buffer/index.js
var require_is_buffer = __commonJS({
  "../../node_modules/.pnpm/is-buffer@2.0.5/node_modules/is-buffer/index.js"(exports, module) {
    module.exports = function isBuffer(obj) {
      return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj);
    };
  }
});

// ../../node_modules/.pnpm/axios-mock-adapter@1.22.0_axios@0.24.0/node_modules/axios-mock-adapter/src/is_blob.js
var require_is_blob = __commonJS({
  "../../node_modules/.pnpm/axios-mock-adapter@1.22.0_axios@0.24.0/node_modules/axios-mock-adapter/src/is_blob.js"(exports, module) {
    function isBlob(value) {
      if (typeof Blob === "undefined") {
        return false;
      }
      return value instanceof Blob || Object.prototype.toString.call(value) === "[object Blob]";
    }
    module.exports = isBlob;
  }
});

// ../../node_modules/.pnpm/axios-mock-adapter@1.22.0_axios@0.24.0/node_modules/axios-mock-adapter/src/utils.js
var require_utils3 = __commonJS({
  "../../node_modules/.pnpm/axios-mock-adapter@1.22.0_axios@0.24.0/node_modules/axios-mock-adapter/src/utils.js"(exports, module) {
    "use strict";
    var axios4 = require_axios2();
    var isEqual2 = require_fast_deep_equal();
    var isBuffer = require_is_buffer();
    var isBlob = require_is_blob();
    var toString = Object.prototype.toString;
    function find7(array, predicate) {
      var length = array.length;
      for (var i = 0; i < length; i++) {
        var value = array[i];
        if (predicate(value))
          return value;
      }
    }
    function isFunction2(val) {
      return toString.call(val) === "[object Function]";
    }
    function isObjectOrArray(val) {
      return val !== null && typeof val === "object";
    }
    function isStream(val) {
      return isObjectOrArray(val) && isFunction2(val.pipe);
    }
    function isArrayBuffer(val) {
      return toString.call(val) === "[object ArrayBuffer]";
    }
    function combineUrls(baseURL, url15) {
      if (baseURL) {
        return baseURL.replace(/\/+$/, "") + "/" + url15.replace(/^\/+/, "");
      }
      return url15;
    }
    function findHandler(handlers, method, url15, body, parameters, headers, baseURL) {
      return find7(handlers[method.toLowerCase()], function(handler) {
        if (typeof handler[0] === "string") {
          return (isUrlMatching(url15, handler[0]) || isUrlMatching(combineUrls(baseURL, url15), handler[0])) && isBodyOrParametersMatching(method, body, parameters, handler[1]) && isObjectMatching(headers, handler[2]);
        } else if (handler[0] instanceof RegExp) {
          return (handler[0].test(url15) || handler[0].test(combineUrls(baseURL, url15))) && isBodyOrParametersMatching(method, body, parameters, handler[1]) && isObjectMatching(headers, handler[2]);
        }
      });
    }
    function isUrlMatching(url15, required) {
      var noSlashUrl = url15[0] === "/" ? url15.substr(1) : url15;
      var noSlashRequired = required[0] === "/" ? required.substr(1) : required;
      return noSlashUrl === noSlashRequired;
    }
    function isBodyOrParametersMatching(method, body, parameters, required) {
      var allowedParamsMethods = ["delete", "get", "head", "options"];
      if (allowedParamsMethods.indexOf(method.toLowerCase()) >= 0) {
        var data = required ? required.data : void 0;
        var params = required ? required.params : void 0;
        return isObjectMatching(parameters, params) && isBodyMatching(body, data);
      } else {
        return isBodyMatching(body, required);
      }
    }
    function isObjectMatching(actual, expected) {
      if (expected === void 0)
        return true;
      if (typeof expected.asymmetricMatch === "function") {
        return expected.asymmetricMatch(actual);
      }
      return isEqual2(actual, expected);
    }
    function isBodyMatching(body, requiredBody) {
      if (requiredBody === void 0) {
        return true;
      }
      var parsedBody;
      try {
        parsedBody = JSON.parse(body);
      } catch (e) {
      }
      return isObjectMatching(parsedBody ? parsedBody : body, requiredBody);
    }
    function purgeIfReplyOnce(mock, handler) {
      Object.keys(mock.handlers).forEach(function(key) {
        var index = mock.handlers[key].indexOf(handler);
        if (index > -1) {
          mock.handlers[key].splice(index, 1);
        }
      });
    }
    function settle(resolve, reject, response, delay) {
      if (delay > 0) {
        setTimeout(settle, delay, resolve, reject, response);
        return;
      }
      if (!response.config.validateStatus || response.config.validateStatus(response.status)) {
        resolve(response);
      } else {
        reject(
          createAxiosError(
            "Request failed with status code " + response.status,
            response.config,
            response
          )
        );
      }
    }
    function createAxiosError(message, config2, response, code) {
      if (typeof axios4.AxiosError === "function") {
        return axios4.AxiosError.from(new Error(message), code, config2, null, response);
      }
      var error = new Error(message);
      error.isAxiosError = true;
      error.config = config2;
      if (response !== void 0) {
        error.response = response;
      }
      if (code !== void 0) {
        error.code = code;
      }
      error.toJSON = function toJSON() {
        return {
          // Standard
          message: this.message,
          name: this.name,
          // Microsoft
          description: this.description,
          number: this.number,
          // Mozilla
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          // Axios
          config: this.config,
          code: this.code
        };
      };
      return error;
    }
    function createCouldNotFindMockError(config2) {
      var message = "Could not find mock for: \n" + JSON.stringify(config2, ["method", "url"], 2);
      var error = new Error(message);
      error.isCouldNotFindMockError = true;
      error.url = config2.url;
      error.method = config2.method;
      return error;
    }
    module.exports = {
      find: find7,
      findHandler,
      purgeIfReplyOnce,
      settle,
      isStream,
      isArrayBuffer,
      isFunction: isFunction2,
      isObjectOrArray,
      isBuffer,
      isBlob,
      isBodyOrParametersMatching,
      isEqual: isEqual2,
      createAxiosError,
      createCouldNotFindMockError
    };
  }
});

// ../../node_modules/.pnpm/axios-mock-adapter@1.22.0_axios@0.24.0/node_modules/axios-mock-adapter/src/handle_request.js
var require_handle_request = __commonJS({
  "../../node_modules/.pnpm/axios-mock-adapter@1.22.0_axios@0.24.0/node_modules/axios-mock-adapter/src/handle_request.js"(exports, module) {
    "use strict";
    var utils = require_utils3();
    function transformRequest(data) {
      if (utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isBlob(data)) {
        return data;
      }
      if (utils.isObjectOrArray(data)) {
        return JSON.parse(JSON.stringify(data));
      }
      return data;
    }
    function makeResponse(result, config2) {
      return {
        status: result[0],
        data: transformRequest(result[1]),
        headers: result[2],
        config: config2,
        request: {
          responseURL: config2.url
        }
      };
    }
    function passThroughRequest(mockAdapter, resolve, reject, config2) {
      var baseURL = config2.baseURL;
      if (config2.baseURL && !/^https?:/.test(config2.baseURL)) {
        baseURL = void 0;
      }
      if (typeof mockAdapter.originalAdapter === "function") {
        return mockAdapter.originalAdapter(config2).then(resolve, reject);
      }
      mockAdapter.axiosInstanceWithoutInterceptors(Object.assign({}, config2, {
        baseURL,
        //  Use the original adapter, not the mock adapter
        adapter: mockAdapter.originalAdapter,
        // The request transformation runs on the original axios handler already
        transformRequest: [],
        transformResponse: []
      })).then(resolve, reject);
    }
    function handleRequest(mockAdapter, resolve, reject, config2) {
      var url15 = config2.url || "";
      if (config2.baseURL && url15.substr(0, config2.baseURL.length) === config2.baseURL) {
        url15 = url15.slice(config2.baseURL.length);
      }
      delete config2.adapter;
      mockAdapter.history[config2.method].push(config2);
      var handler = utils.findHandler(
        mockAdapter.handlers,
        config2.method,
        url15,
        config2.data,
        config2.params,
        config2.headers && config2.headers.constructor.name === "AxiosHeaders" ? Object.assign({}, config2.headers) : config2.headers,
        config2.baseURL
      );
      if (handler) {
        if (handler.length === 7) {
          utils.purgeIfReplyOnce(mockAdapter, handler);
        }
        if (handler.length === 2) {
          passThroughRequest(mockAdapter, resolve, reject, config2);
        } else if (typeof handler[3] !== "function") {
          utils.settle(
            resolve,
            reject,
            makeResponse(handler.slice(3), config2),
            getEffectiveDelay(mockAdapter, handler)
          );
        } else {
          var result = handler[3](config2);
          if (typeof result.then !== "function") {
            utils.settle(
              resolve,
              reject,
              makeResponse(result, config2),
              getEffectiveDelay(mockAdapter, handler)
            );
          } else {
            result.then(
              function(result2) {
                if (result2.config && result2.status) {
                  utils.settle(
                    resolve,
                    reject,
                    makeResponse(
                      [result2.status, result2.data, result2.headers],
                      result2.config
                    ),
                    0
                  );
                } else {
                  utils.settle(
                    resolve,
                    reject,
                    makeResponse(result2, config2),
                    getEffectiveDelay(mockAdapter, handler)
                  );
                }
              },
              function(error) {
                if (mockAdapter.delayResponse > 0) {
                  setTimeout(function() {
                    reject(error);
                  }, getEffectiveDelay(mockAdapter, handler));
                } else {
                  reject(error);
                }
              }
            );
          }
        }
      } else {
        switch (mockAdapter.onNoMatch) {
          case "passthrough":
            passThroughRequest(mockAdapter, resolve, reject, config2);
            break;
          case "throwException":
            throw utils.createCouldNotFindMockError(config2);
          default:
            utils.settle(
              resolve,
              reject,
              {
                status: 404,
                config: config2
              },
              mockAdapter.delayResponse
            );
        }
      }
    }
    function getEffectiveDelay(adapter, handler) {
      var delayPerRequest;
      if (handler.length === 8) {
        delayPerRequest = handler[7];
      }
      return delayPerRequest ? delayPerRequest : adapter.delayResponse;
    }
    module.exports = handleRequest;
  }
});

// ../../node_modules/.pnpm/axios-mock-adapter@1.22.0_axios@0.24.0/node_modules/axios-mock-adapter/src/index.js
var require_src = __commonJS({
  "../../node_modules/.pnpm/axios-mock-adapter@1.22.0_axios@0.24.0/node_modules/axios-mock-adapter/src/index.js"(exports, module) {
    "use strict";
    var handleRequest = require_handle_request();
    var utils = require_utils3();
    var VERBS = [
      "get",
      "post",
      "head",
      "delete",
      "patch",
      "put",
      "options",
      "list",
      "link",
      "unlink"
    ];
    function adapter() {
      return function(config2) {
        var mockAdapter = this;
        return new Promise(function(resolve, reject) {
          handleRequest(mockAdapter, resolve, reject, config2);
        });
      }.bind(this);
    }
    function getVerbObject() {
      return VERBS.reduce(function(accumulator, verb) {
        accumulator[verb] = [];
        return accumulator;
      }, {});
    }
    function reset() {
      resetHandlers.call(this);
      resetHistory.call(this);
    }
    function resetHandlers() {
      this.handlers = getVerbObject();
    }
    function resetHistory() {
      this.history = getVerbObject();
    }
    function MockAdapter2(axiosInstance, options) {
      reset.call(this);
      if (axiosInstance) {
        this.axiosInstance = axiosInstance;
        this.axiosInstanceWithoutInterceptors = axiosInstance.create ? axiosInstance.create() : void 0;
        this.originalAdapter = axiosInstance.defaults.adapter;
        this.delayResponse = options && options.delayResponse > 0 ? options.delayResponse : null;
        this.onNoMatch = options && options.onNoMatch || null;
        axiosInstance.defaults.adapter = this.adapter.call(this);
      } else {
        throw new Error("Please provide an instance of axios to mock");
      }
    }
    MockAdapter2.prototype.adapter = adapter;
    MockAdapter2.prototype.restore = function restore() {
      if (this.axiosInstance) {
        this.axiosInstance.defaults.adapter = this.originalAdapter;
        this.axiosInstance = void 0;
      }
    };
    MockAdapter2.prototype.reset = reset;
    MockAdapter2.prototype.resetHandlers = resetHandlers;
    MockAdapter2.prototype.resetHistory = resetHistory;
    VERBS.concat("any").forEach(function(method) {
      var methodName = "on" + method.charAt(0).toUpperCase() + method.slice(1);
      MockAdapter2.prototype[methodName] = function(matcher, body, requestHeaders) {
        var _this = this;
        var matcher = matcher === void 0 ? /.*/ : matcher;
        function reply(code, response, headers) {
          var handler = [matcher, body, requestHeaders, code, response, headers];
          addHandler(method, _this.handlers, handler);
          return _this;
        }
        function replyWithDelay(delay, code, response, headers) {
          var handler = [matcher, body, requestHeaders, code, response, headers, false, delay];
          addHandler(method, _this.handlers, handler);
          return _this;
        }
        function withDelayInMs(delay) {
          return function(code, response, headers) {
            replyWithDelay(delay, code, response, headers);
          };
        }
        function replyOnce(code, response, headers) {
          var handler = [
            matcher,
            body,
            requestHeaders,
            code,
            response,
            headers,
            true
          ];
          addHandler(method, _this.handlers, handler);
          return _this;
        }
        return {
          reply,
          replyOnce,
          withDelayInMs,
          passThrough: function passThrough() {
            var handler = [matcher, body];
            addHandler(method, _this.handlers, handler);
            return _this;
          },
          abortRequest: function() {
            return reply(function(config2) {
              var error = utils.createAxiosError(
                "Request aborted",
                config2,
                void 0,
                "ECONNABORTED"
              );
              return Promise.reject(error);
            });
          },
          abortRequestOnce: function() {
            return replyOnce(function(config2) {
              var error = utils.createAxiosError(
                "Request aborted",
                config2,
                void 0,
                "ECONNABORTED"
              );
              return Promise.reject(error);
            });
          },
          networkError: function() {
            return reply(function(config2) {
              var error = utils.createAxiosError("Network Error", config2);
              return Promise.reject(error);
            });
          },
          networkErrorOnce: function() {
            return replyOnce(function(config2) {
              var error = utils.createAxiosError("Network Error", config2);
              return Promise.reject(error);
            });
          },
          timeout: function() {
            return reply(function(config2) {
              var error = utils.createAxiosError(
                config2.timeoutErrorMessage || "timeout of " + config2.timeout + "ms exceeded",
                config2,
                void 0,
                config2.transitional && config2.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED"
              );
              return Promise.reject(error);
            });
          },
          timeoutOnce: function() {
            return replyOnce(function(config2) {
              var error = utils.createAxiosError(
                config2.timeoutErrorMessage || "timeout of " + config2.timeout + "ms exceeded",
                config2,
                void 0,
                config2.transitional && config2.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED"
              );
              return Promise.reject(error);
            });
          }
        };
      };
    });
    function findInHandlers(method, handlers, handler) {
      var index = -1;
      for (var i = 0; i < handlers[method].length; i += 1) {
        var item = handlers[method][i];
        var isReplyOnce = item.length === 7;
        var comparePaths = item[0] instanceof RegExp && handler[0] instanceof RegExp ? String(item[0]) === String(handler[0]) : item[0] === handler[0];
        var isSame = comparePaths && utils.isEqual(item[1], handler[1]) && utils.isEqual(item[2], handler[2]);
        if (isSame && !isReplyOnce) {
          index = i;
        }
      }
      return index;
    }
    function addHandler(method, handlers, handler) {
      if (method === "any") {
        VERBS.forEach(function(verb) {
          handlers[verb].push(handler);
        });
      } else {
        var indexOfExistingHandler = findInHandlers(method, handlers, handler);
        if (indexOfExistingHandler > -1 && handler.length < 7) {
          handlers[method].splice(indexOfExistingHandler, 1, handler);
        } else {
          handlers[method].push(handler);
        }
      }
    }
    module.exports = MockAdapter2;
    module.exports.default = MockAdapter2;
  }
});

// ../../node_modules/.pnpm/axios-observable@2.0.0_axios@0.24.0+rxjs@6.6.7/node_modules/axios-observable/dist/axios-observable.interface.js
var require_axios_observable_interface = __commonJS({
  "../../node_modules/.pnpm/axios-observable@2.0.0_axios@0.24.0+rxjs@6.6.7/node_modules/axios-observable/dist/axios-observable.interface.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/isFunction.js
var require_isFunction = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/isFunction.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function isFunction2(x) {
      return typeof x === "function";
    }
    exports.isFunction = isFunction2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/config.js
var require_config = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/config.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var _enable_super_gross_mode_that_will_cause_bad_things2 = false;
    exports.config = {
      Promise: void 0,
      set useDeprecatedSynchronousErrorHandling(value) {
        if (value) {
          var error = new Error();
          console.warn("DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n" + error.stack);
        } else if (_enable_super_gross_mode_that_will_cause_bad_things2) {
          console.log("RxJS: Back to a better error behavior. Thank you. <3");
        }
        _enable_super_gross_mode_that_will_cause_bad_things2 = value;
      },
      get useDeprecatedSynchronousErrorHandling() {
        return _enable_super_gross_mode_that_will_cause_bad_things2;
      }
    };
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/hostReportError.js
var require_hostReportError = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/hostReportError.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function hostReportError2(err) {
      setTimeout(function() {
        throw err;
      }, 0);
    }
    exports.hostReportError = hostReportError2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/Observer.js
var require_Observer = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/Observer.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var config_1 = require_config();
    var hostReportError_1 = require_hostReportError();
    exports.empty = {
      closed: true,
      next: function(value) {
      },
      error: function(err) {
        if (config_1.config.useDeprecatedSynchronousErrorHandling) {
          throw err;
        } else {
          hostReportError_1.hostReportError(err);
        }
      },
      complete: function() {
      }
    };
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/isArray.js
var require_isArray = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/isArray.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isArray = function() {
      return Array.isArray || function(x) {
        return x && typeof x.length === "number";
      };
    }();
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/isObject.js
var require_isObject = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/isObject.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function isObject2(x) {
      return x !== null && typeof x === "object";
    }
    exports.isObject = isObject2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/UnsubscriptionError.js
var require_UnsubscriptionError = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/UnsubscriptionError.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var UnsubscriptionErrorImpl2 = function() {
      function UnsubscriptionErrorImpl3(errors) {
        Error.call(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
          return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
        return this;
      }
      UnsubscriptionErrorImpl3.prototype = Object.create(Error.prototype);
      return UnsubscriptionErrorImpl3;
    }();
    exports.UnsubscriptionError = UnsubscriptionErrorImpl2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/Subscription.js
var require_Subscription = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/Subscription.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var isArray_1 = require_isArray();
    var isObject_1 = require_isObject();
    var isFunction_1 = require_isFunction();
    var UnsubscriptionError_1 = require_UnsubscriptionError();
    var Subscription2 = function() {
      function Subscription3(unsubscribe) {
        this.closed = false;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (unsubscribe) {
          this._ctorUnsubscribe = true;
          this._unsubscribe = unsubscribe;
        }
      }
      Subscription3.prototype.unsubscribe = function() {
        var errors;
        if (this.closed) {
          return;
        }
        var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (_parentOrParents instanceof Subscription3) {
          _parentOrParents.remove(this);
        } else if (_parentOrParents !== null) {
          for (var index = 0; index < _parentOrParents.length; ++index) {
            var parent_1 = _parentOrParents[index];
            parent_1.remove(this);
          }
        }
        if (isFunction_1.isFunction(_unsubscribe)) {
          if (_ctorUnsubscribe) {
            this._unsubscribe = void 0;
          }
          try {
            _unsubscribe.call(this);
          } catch (e) {
            errors = e instanceof UnsubscriptionError_1.UnsubscriptionError ? flattenUnsubscriptionErrors2(e.errors) : [e];
          }
        }
        if (isArray_1.isArray(_subscriptions)) {
          var index = -1;
          var len = _subscriptions.length;
          while (++index < len) {
            var sub = _subscriptions[index];
            if (isObject_1.isObject(sub)) {
              try {
                sub.unsubscribe();
              } catch (e) {
                errors = errors || [];
                if (e instanceof UnsubscriptionError_1.UnsubscriptionError) {
                  errors = errors.concat(flattenUnsubscriptionErrors2(e.errors));
                } else {
                  errors.push(e);
                }
              }
            }
          }
        }
        if (errors) {
          throw new UnsubscriptionError_1.UnsubscriptionError(errors);
        }
      };
      Subscription3.prototype.add = function(teardown) {
        var subscription = teardown;
        if (!teardown) {
          return Subscription3.EMPTY;
        }
        switch (typeof teardown) {
          case "function":
            subscription = new Subscription3(teardown);
          case "object":
            if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== "function") {
              return subscription;
            } else if (this.closed) {
              subscription.unsubscribe();
              return subscription;
            } else if (!(subscription instanceof Subscription3)) {
              var tmp = subscription;
              subscription = new Subscription3();
              subscription._subscriptions = [tmp];
            }
            break;
          default: {
            throw new Error("unrecognized teardown " + teardown + " added to Subscription.");
          }
        }
        var _parentOrParents = subscription._parentOrParents;
        if (_parentOrParents === null) {
          subscription._parentOrParents = this;
        } else if (_parentOrParents instanceof Subscription3) {
          if (_parentOrParents === this) {
            return subscription;
          }
          subscription._parentOrParents = [_parentOrParents, this];
        } else if (_parentOrParents.indexOf(this) === -1) {
          _parentOrParents.push(this);
        } else {
          return subscription;
        }
        var subscriptions = this._subscriptions;
        if (subscriptions === null) {
          this._subscriptions = [subscription];
        } else {
          subscriptions.push(subscription);
        }
        return subscription;
      };
      Subscription3.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
          var subscriptionIndex = subscriptions.indexOf(subscription);
          if (subscriptionIndex !== -1) {
            subscriptions.splice(subscriptionIndex, 1);
          }
        }
      };
      Subscription3.EMPTY = function(empty3) {
        empty3.closed = true;
        return empty3;
      }(new Subscription3());
      return Subscription3;
    }();
    exports.Subscription = Subscription2;
    function flattenUnsubscriptionErrors2(errors) {
      return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof UnsubscriptionError_1.UnsubscriptionError ? err.errors : err);
      }, []);
    }
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/symbol/rxSubscriber.js
var require_rxSubscriber = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/symbol/rxSubscriber.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.rxSubscriber = function() {
      return typeof Symbol === "function" ? Symbol("rxSubscriber") : "@@rxSubscriber_" + Math.random();
    }();
    exports.$$rxSubscriber = exports.rxSubscriber;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/Subscriber.js
var require_Subscriber = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/Subscriber.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var isFunction_1 = require_isFunction();
    var Observer_1 = require_Observer();
    var Subscription_1 = require_Subscription();
    var rxSubscriber_1 = require_rxSubscriber();
    var config_1 = require_config();
    var hostReportError_1 = require_hostReportError();
    var Subscriber2 = function(_super) {
      __extends12(Subscriber3, _super);
      function Subscriber3(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch (arguments.length) {
          case 0:
            _this.destination = Observer_1.empty;
            break;
          case 1:
            if (!destinationOrNext) {
              _this.destination = Observer_1.empty;
              break;
            }
            if (typeof destinationOrNext === "object") {
              if (destinationOrNext instanceof Subscriber3) {
                _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                _this.destination = destinationOrNext;
                destinationOrNext.add(_this);
              } else {
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber2(_this, destinationOrNext);
              }
              break;
            }
          default:
            _this.syncErrorThrowable = true;
            _this.destination = new SafeSubscriber2(_this, destinationOrNext, error, complete);
            break;
        }
        return _this;
      }
      Subscriber3.prototype[rxSubscriber_1.rxSubscriber] = function() {
        return this;
      };
      Subscriber3.create = function(next, error, complete) {
        var subscriber = new Subscriber3(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
      };
      Subscriber3.prototype.next = function(value) {
        if (!this.isStopped) {
          this._next(value);
        }
      };
      Subscriber3.prototype.error = function(err) {
        if (!this.isStopped) {
          this.isStopped = true;
          this._error(err);
        }
      };
      Subscriber3.prototype.complete = function() {
        if (!this.isStopped) {
          this.isStopped = true;
          this._complete();
        }
      };
      Subscriber3.prototype.unsubscribe = function() {
        if (this.closed) {
          return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
      };
      Subscriber3.prototype._next = function(value) {
        this.destination.next(value);
      };
      Subscriber3.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
      };
      Subscriber3.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
      };
      Subscriber3.prototype._unsubscribeAndRecycle = function() {
        var _parentOrParents = this._parentOrParents;
        this._parentOrParents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parentOrParents = _parentOrParents;
        return this;
      };
      return Subscriber3;
    }(Subscription_1.Subscription);
    exports.Subscriber = Subscriber2;
    var SafeSubscriber2 = function(_super) {
      __extends12(SafeSubscriber3, _super);
      function SafeSubscriber3(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if (isFunction_1.isFunction(observerOrNext)) {
          next = observerOrNext;
        } else if (observerOrNext) {
          next = observerOrNext.next;
          error = observerOrNext.error;
          complete = observerOrNext.complete;
          if (observerOrNext !== Observer_1.empty) {
            context = Object.create(observerOrNext);
            if (isFunction_1.isFunction(context.unsubscribe)) {
              _this.add(context.unsubscribe.bind(context));
            }
            context.unsubscribe = _this.unsubscribe.bind(_this);
          }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
      }
      SafeSubscriber3.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
          var _parentSubscriber = this._parentSubscriber;
          if (!config_1.config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
            this.__tryOrUnsub(this._next, value);
          } else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
            this.unsubscribe();
          }
        }
      };
      SafeSubscriber3.prototype.error = function(err) {
        if (!this.isStopped) {
          var _parentSubscriber = this._parentSubscriber;
          var useDeprecatedSynchronousErrorHandling = config_1.config.useDeprecatedSynchronousErrorHandling;
          if (this._error) {
            if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
              this.__tryOrUnsub(this._error, err);
              this.unsubscribe();
            } else {
              this.__tryOrSetError(_parentSubscriber, this._error, err);
              this.unsubscribe();
            }
          } else if (!_parentSubscriber.syncErrorThrowable) {
            this.unsubscribe();
            if (useDeprecatedSynchronousErrorHandling) {
              throw err;
            }
            hostReportError_1.hostReportError(err);
          } else {
            if (useDeprecatedSynchronousErrorHandling) {
              _parentSubscriber.syncErrorValue = err;
              _parentSubscriber.syncErrorThrown = true;
            } else {
              hostReportError_1.hostReportError(err);
            }
            this.unsubscribe();
          }
        }
      };
      SafeSubscriber3.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
          var _parentSubscriber = this._parentSubscriber;
          if (this._complete) {
            var wrappedComplete = function() {
              return _this._complete.call(_this._context);
            };
            if (!config_1.config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
              this.__tryOrUnsub(wrappedComplete);
              this.unsubscribe();
            } else {
              this.__tryOrSetError(_parentSubscriber, wrappedComplete);
              this.unsubscribe();
            }
          } else {
            this.unsubscribe();
          }
        }
      };
      SafeSubscriber3.prototype.__tryOrUnsub = function(fn, value) {
        try {
          fn.call(this._context, value);
        } catch (err) {
          this.unsubscribe();
          if (config_1.config.useDeprecatedSynchronousErrorHandling) {
            throw err;
          } else {
            hostReportError_1.hostReportError(err);
          }
        }
      };
      SafeSubscriber3.prototype.__tryOrSetError = function(parent, fn, value) {
        if (!config_1.config.useDeprecatedSynchronousErrorHandling) {
          throw new Error("bad call");
        }
        try {
          fn.call(this._context, value);
        } catch (err) {
          if (config_1.config.useDeprecatedSynchronousErrorHandling) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
          } else {
            hostReportError_1.hostReportError(err);
            return true;
          }
        }
        return false;
      };
      SafeSubscriber3.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
      };
      return SafeSubscriber3;
    }(Subscriber2);
    exports.SafeSubscriber = SafeSubscriber2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/canReportError.js
var require_canReportError = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/canReportError.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Subscriber_1 = require_Subscriber();
    function canReportError2(observer) {
      while (observer) {
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) {
          return false;
        } else if (destination && destination instanceof Subscriber_1.Subscriber) {
          observer = destination;
        } else {
          observer = null;
        }
      }
      return true;
    }
    exports.canReportError = canReportError2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/toSubscriber.js
var require_toSubscriber = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/toSubscriber.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Subscriber_1 = require_Subscriber();
    var rxSubscriber_1 = require_rxSubscriber();
    var Observer_1 = require_Observer();
    function toSubscriber2(nextOrObserver, error, complete) {
      if (nextOrObserver) {
        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
          return nextOrObserver;
        }
        if (nextOrObserver[rxSubscriber_1.rxSubscriber]) {
          return nextOrObserver[rxSubscriber_1.rxSubscriber]();
        }
      }
      if (!nextOrObserver && !error && !complete) {
        return new Subscriber_1.Subscriber(Observer_1.empty);
      }
      return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
    }
    exports.toSubscriber = toSubscriber2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/symbol/observable.js
var require_observable = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/symbol/observable.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.observable = function() {
      return typeof Symbol === "function" && Symbol.observable || "@@observable";
    }();
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/identity.js
var require_identity = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/identity.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function identity3(x) {
      return x;
    }
    exports.identity = identity3;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/pipe.js
var require_pipe = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/pipe.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var identity_1 = require_identity();
    function pipe2() {
      var fns = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
      }
      return pipeFromArray2(fns);
    }
    exports.pipe = pipe2;
    function pipeFromArray2(fns) {
      if (fns.length === 0) {
        return identity_1.identity;
      }
      if (fns.length === 1) {
        return fns[0];
      }
      return function piped(input) {
        return fns.reduce(function(prev, fn) {
          return fn(prev);
        }, input);
      };
    }
    exports.pipeFromArray = pipeFromArray2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/Observable.js
var require_Observable = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/Observable.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var canReportError_1 = require_canReportError();
    var toSubscriber_1 = require_toSubscriber();
    var observable_1 = require_observable();
    var pipe_1 = require_pipe();
    var config_1 = require_config();
    var Observable6 = function() {
      function Observable7(subscribe) {
        this._isScalar = false;
        if (subscribe) {
          this._subscribe = subscribe;
        }
      }
      Observable7.prototype.lift = function(operator) {
        var observable2 = new Observable7();
        observable2.source = this;
        observable2.operator = operator;
        return observable2;
      };
      Observable7.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
        if (operator) {
          sink.add(operator.call(sink, this.source));
        } else {
          sink.add(this.source || config_1.config.useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        }
        if (config_1.config.useDeprecatedSynchronousErrorHandling) {
          if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) {
              throw sink.syncErrorValue;
            }
          }
        }
        return sink;
      };
      Observable7.prototype._trySubscribe = function(sink) {
        try {
          return this._subscribe(sink);
        } catch (err) {
          if (config_1.config.useDeprecatedSynchronousErrorHandling) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
          }
          if (canReportError_1.canReportError(sink)) {
            sink.error(err);
          } else {
            console.warn(err);
          }
        }
      };
      Observable7.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor2(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
          var subscription;
          subscription = _this.subscribe(function(value) {
            try {
              next(value);
            } catch (err) {
              reject(err);
              if (subscription) {
                subscription.unsubscribe();
              }
            }
          }, reject, resolve);
        });
      };
      Observable7.prototype._subscribe = function(subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
      };
      Observable7.prototype[observable_1.observable] = function() {
        return this;
      };
      Observable7.prototype.pipe = function() {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          operations[_i] = arguments[_i];
        }
        if (operations.length === 0) {
          return this;
        }
        return pipe_1.pipeFromArray(operations)(this);
      };
      Observable7.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor2(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
          var value;
          _this.subscribe(function(x) {
            return value = x;
          }, function(err) {
            return reject(err);
          }, function() {
            return resolve(value);
          });
        });
      };
      Observable7.create = function(subscribe) {
        return new Observable7(subscribe);
      };
      return Observable7;
    }();
    exports.Observable = Observable6;
    function getPromiseCtor2(promiseCtor) {
      if (!promiseCtor) {
        promiseCtor = config_1.config.Promise || Promise;
      }
      if (!promiseCtor) {
        throw new Error("no Promise impl found");
      }
      return promiseCtor;
    }
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/ObjectUnsubscribedError.js
var require_ObjectUnsubscribedError = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/ObjectUnsubscribedError.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ObjectUnsubscribedErrorImpl = function() {
      function ObjectUnsubscribedErrorImpl2() {
        Error.call(this);
        this.message = "object unsubscribed";
        this.name = "ObjectUnsubscribedError";
        return this;
      }
      ObjectUnsubscribedErrorImpl2.prototype = Object.create(Error.prototype);
      return ObjectUnsubscribedErrorImpl2;
    }();
    exports.ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/SubjectSubscription.js
var require_SubjectSubscription = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/SubjectSubscription.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var Subscription_1 = require_Subscription();
    var SubjectSubscription = function(_super) {
      __extends12(SubjectSubscription2, _super);
      function SubjectSubscription2(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
      }
      SubjectSubscription2.prototype.unsubscribe = function() {
        if (this.closed) {
          return;
        }
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
          return;
        }
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) {
          observers.splice(subscriberIndex, 1);
        }
      };
      return SubjectSubscription2;
    }(Subscription_1.Subscription);
    exports.SubjectSubscription = SubjectSubscription;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/Subject.js
var require_Subject = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/Subject.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var Subscriber_1 = require_Subscriber();
    var Subscription_1 = require_Subscription();
    var ObjectUnsubscribedError_1 = require_ObjectUnsubscribedError();
    var SubjectSubscription_1 = require_SubjectSubscription();
    var rxSubscriber_1 = require_rxSubscriber();
    var SubjectSubscriber = function(_super) {
      __extends12(SubjectSubscriber2, _super);
      function SubjectSubscriber2(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
      }
      return SubjectSubscriber2;
    }(Subscriber_1.Subscriber);
    exports.SubjectSubscriber = SubjectSubscriber;
    var Subject = function(_super) {
      __extends12(Subject2, _super);
      function Subject2() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
      }
      Subject2.prototype[rxSubscriber_1.rxSubscriber] = function() {
        return new SubjectSubscriber(this);
      };
      Subject2.prototype.lift = function(operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
      };
      Subject2.prototype.next = function(value) {
        if (this.closed) {
          throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        if (!this.isStopped) {
          var observers = this.observers;
          var len = observers.length;
          var copy = observers.slice();
          for (var i = 0; i < len; i++) {
            copy[i].next(value);
          }
        }
      };
      Subject2.prototype.error = function(err) {
        if (this.closed) {
          throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
          copy[i].error(err);
        }
        this.observers.length = 0;
      };
      Subject2.prototype.complete = function() {
        if (this.closed) {
          throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
          copy[i].complete();
        }
        this.observers.length = 0;
      };
      Subject2.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
      };
      Subject2.prototype._trySubscribe = function(subscriber) {
        if (this.closed) {
          throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        } else {
          return _super.prototype._trySubscribe.call(this, subscriber);
        }
      };
      Subject2.prototype._subscribe = function(subscriber) {
        if (this.closed) {
          throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        } else if (this.hasError) {
          subscriber.error(this.thrownError);
          return Subscription_1.Subscription.EMPTY;
        } else if (this.isStopped) {
          subscriber.complete();
          return Subscription_1.Subscription.EMPTY;
        } else {
          this.observers.push(subscriber);
          return new SubjectSubscription_1.SubjectSubscription(this, subscriber);
        }
      };
      Subject2.prototype.asObservable = function() {
        var observable2 = new Observable_1.Observable();
        observable2.source = this;
        return observable2;
      };
      Subject2.create = function(destination, source) {
        return new AnonymousSubject(destination, source);
      };
      return Subject2;
    }(Observable_1.Observable);
    exports.Subject = Subject;
    var AnonymousSubject = function(_super) {
      __extends12(AnonymousSubject2, _super);
      function AnonymousSubject2(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
      }
      AnonymousSubject2.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) {
          destination.next(value);
        }
      };
      AnonymousSubject2.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) {
          this.destination.error(err);
        }
      };
      AnonymousSubject2.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) {
          this.destination.complete();
        }
      };
      AnonymousSubject2.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) {
          return this.source.subscribe(subscriber);
        } else {
          return Subscription_1.Subscription.EMPTY;
        }
      };
      return AnonymousSubject2;
    }(Subject);
    exports.AnonymousSubject = AnonymousSubject;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/operators/refCount.js
var require_refCount = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/operators/refCount.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var Subscriber_1 = require_Subscriber();
    function refCount() {
      return function refCountOperatorFunction(source) {
        return source.lift(new RefCountOperator(source));
      };
    }
    exports.refCount = refCount;
    var RefCountOperator = function() {
      function RefCountOperator2(connectable) {
        this.connectable = connectable;
      }
      RefCountOperator2.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
          refCounter.connection = connectable.connect();
        }
        return subscription;
      };
      return RefCountOperator2;
    }();
    var RefCountSubscriber = function(_super) {
      __extends12(RefCountSubscriber2, _super);
      function RefCountSubscriber2(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
      }
      RefCountSubscriber2.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
          this.connection = null;
          return;
        }
        this.connectable = null;
        var refCount2 = connectable._refCount;
        if (refCount2 <= 0) {
          this.connection = null;
          return;
        }
        connectable._refCount = refCount2 - 1;
        if (refCount2 > 1) {
          this.connection = null;
          return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
          sharedConnection.unsubscribe();
        }
      };
      return RefCountSubscriber2;
    }(Subscriber_1.Subscriber);
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/ConnectableObservable.js
var require_ConnectableObservable = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/ConnectableObservable.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var Subject_1 = require_Subject();
    var Observable_1 = require_Observable();
    var Subscriber_1 = require_Subscriber();
    var Subscription_1 = require_Subscription();
    var refCount_1 = require_refCount();
    var ConnectableObservable = function(_super) {
      __extends12(ConnectableObservable2, _super);
      function ConnectableObservable2(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._refCount = 0;
        _this._isComplete = false;
        return _this;
      }
      ConnectableObservable2.prototype._subscribe = function(subscriber) {
        return this.getSubject().subscribe(subscriber);
      };
      ConnectableObservable2.prototype.getSubject = function() {
        var subject = this._subject;
        if (!subject || subject.isStopped) {
          this._subject = this.subjectFactory();
        }
        return this._subject;
      };
      ConnectableObservable2.prototype.connect = function() {
        var connection = this._connection;
        if (!connection) {
          this._isComplete = false;
          connection = this._connection = new Subscription_1.Subscription();
          connection.add(this.source.subscribe(new ConnectableSubscriber(this.getSubject(), this)));
          if (connection.closed) {
            this._connection = null;
            connection = Subscription_1.Subscription.EMPTY;
          }
        }
        return connection;
      };
      ConnectableObservable2.prototype.refCount = function() {
        return refCount_1.refCount()(this);
      };
      return ConnectableObservable2;
    }(Observable_1.Observable);
    exports.ConnectableObservable = ConnectableObservable;
    exports.connectableObservableDescriptor = function() {
      var connectableProto = ConnectableObservable.prototype;
      return {
        operator: { value: null },
        _refCount: { value: 0, writable: true },
        _subject: { value: null, writable: true },
        _connection: { value: null, writable: true },
        _subscribe: { value: connectableProto._subscribe },
        _isComplete: { value: connectableProto._isComplete, writable: true },
        getSubject: { value: connectableProto.getSubject },
        connect: { value: connectableProto.connect },
        refCount: { value: connectableProto.refCount }
      };
    }();
    var ConnectableSubscriber = function(_super) {
      __extends12(ConnectableSubscriber2, _super);
      function ConnectableSubscriber2(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
      }
      ConnectableSubscriber2.prototype._error = function(err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
      };
      ConnectableSubscriber2.prototype._complete = function() {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
      };
      ConnectableSubscriber2.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (connectable) {
          this.connectable = null;
          var connection = connectable._connection;
          connectable._refCount = 0;
          connectable._subject = null;
          connectable._connection = null;
          if (connection) {
            connection.unsubscribe();
          }
        }
      };
      return ConnectableSubscriber2;
    }(Subject_1.SubjectSubscriber);
    var RefCountOperator = function() {
      function RefCountOperator2(connectable) {
        this.connectable = connectable;
      }
      RefCountOperator2.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
          refCounter.connection = connectable.connect();
        }
        return subscription;
      };
      return RefCountOperator2;
    }();
    var RefCountSubscriber = function(_super) {
      __extends12(RefCountSubscriber2, _super);
      function RefCountSubscriber2(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
      }
      RefCountSubscriber2.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
          this.connection = null;
          return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
          this.connection = null;
          return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
          this.connection = null;
          return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
          sharedConnection.unsubscribe();
        }
      };
      return RefCountSubscriber2;
    }(Subscriber_1.Subscriber);
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/operators/groupBy.js
var require_groupBy = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/operators/groupBy.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var Subscriber_1 = require_Subscriber();
    var Subscription_1 = require_Subscription();
    var Observable_1 = require_Observable();
    var Subject_1 = require_Subject();
    function groupBy3(keySelector, elementSelector, durationSelector, subjectSelector) {
      return function(source) {
        return source.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
      };
    }
    exports.groupBy = groupBy3;
    var GroupByOperator = function() {
      function GroupByOperator2(keySelector, elementSelector, durationSelector, subjectSelector) {
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
      }
      GroupByOperator2.prototype.call = function(subscriber, source) {
        return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
      };
      return GroupByOperator2;
    }();
    var GroupBySubscriber = function(_super) {
      __extends12(GroupBySubscriber2, _super);
      function GroupBySubscriber2(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.elementSelector = elementSelector;
        _this.durationSelector = durationSelector;
        _this.subjectSelector = subjectSelector;
        _this.groups = null;
        _this.attemptedToUnsubscribe = false;
        _this.count = 0;
        return _this;
      }
      GroupBySubscriber2.prototype._next = function(value) {
        var key;
        try {
          key = this.keySelector(value);
        } catch (err) {
          this.error(err);
          return;
        }
        this._group(value, key);
      };
      GroupBySubscriber2.prototype._group = function(value, key) {
        var groups = this.groups;
        if (!groups) {
          groups = this.groups = /* @__PURE__ */ new Map();
        }
        var group = groups.get(key);
        var element;
        if (this.elementSelector) {
          try {
            element = this.elementSelector(value);
          } catch (err) {
            this.error(err);
          }
        } else {
          element = value;
        }
        if (!group) {
          group = this.subjectSelector ? this.subjectSelector() : new Subject_1.Subject();
          groups.set(key, group);
          var groupedObservable = new GroupedObservable(key, group, this);
          this.destination.next(groupedObservable);
          if (this.durationSelector) {
            var duration = void 0;
            try {
              duration = this.durationSelector(new GroupedObservable(key, group));
            } catch (err) {
              this.error(err);
              return;
            }
            this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
          }
        }
        if (!group.closed) {
          group.next(element);
        }
      };
      GroupBySubscriber2.prototype._error = function(err) {
        var groups = this.groups;
        if (groups) {
          groups.forEach(function(group, key) {
            group.error(err);
          });
          groups.clear();
        }
        this.destination.error(err);
      };
      GroupBySubscriber2.prototype._complete = function() {
        var groups = this.groups;
        if (groups) {
          groups.forEach(function(group, key) {
            group.complete();
          });
          groups.clear();
        }
        this.destination.complete();
      };
      GroupBySubscriber2.prototype.removeGroup = function(key) {
        this.groups.delete(key);
      };
      GroupBySubscriber2.prototype.unsubscribe = function() {
        if (!this.closed) {
          this.attemptedToUnsubscribe = true;
          if (this.count === 0) {
            _super.prototype.unsubscribe.call(this);
          }
        }
      };
      return GroupBySubscriber2;
    }(Subscriber_1.Subscriber);
    var GroupDurationSubscriber = function(_super) {
      __extends12(GroupDurationSubscriber2, _super);
      function GroupDurationSubscriber2(key, group, parent) {
        var _this = _super.call(this, group) || this;
        _this.key = key;
        _this.group = group;
        _this.parent = parent;
        return _this;
      }
      GroupDurationSubscriber2.prototype._next = function(value) {
        this.complete();
      };
      GroupDurationSubscriber2.prototype._unsubscribe = function() {
        var _a = this, parent = _a.parent, key = _a.key;
        this.key = this.parent = null;
        if (parent) {
          parent.removeGroup(key);
        }
      };
      return GroupDurationSubscriber2;
    }(Subscriber_1.Subscriber);
    var GroupedObservable = function(_super) {
      __extends12(GroupedObservable2, _super);
      function GroupedObservable2(key, groupSubject, refCountSubscription) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.groupSubject = groupSubject;
        _this.refCountSubscription = refCountSubscription;
        return _this;
      }
      GroupedObservable2.prototype._subscribe = function(subscriber) {
        var subscription = new Subscription_1.Subscription();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) {
          subscription.add(new InnerRefCountSubscription(refCountSubscription));
        }
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
      };
      return GroupedObservable2;
    }(Observable_1.Observable);
    exports.GroupedObservable = GroupedObservable;
    var InnerRefCountSubscription = function(_super) {
      __extends12(InnerRefCountSubscription2, _super);
      function InnerRefCountSubscription2(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        parent.count++;
        return _this;
      }
      InnerRefCountSubscription2.prototype.unsubscribe = function() {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
          _super.prototype.unsubscribe.call(this);
          parent.count -= 1;
          if (parent.count === 0 && parent.attemptedToUnsubscribe) {
            parent.unsubscribe();
          }
        }
      };
      return InnerRefCountSubscription2;
    }(Subscription_1.Subscription);
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/BehaviorSubject.js
var require_BehaviorSubject = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/BehaviorSubject.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var Subject_1 = require_Subject();
    var ObjectUnsubscribedError_1 = require_ObjectUnsubscribedError();
    var BehaviorSubject = function(_super) {
      __extends12(BehaviorSubject2, _super);
      function BehaviorSubject2(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
      }
      Object.defineProperty(BehaviorSubject2.prototype, "value", {
        get: function() {
          return this.getValue();
        },
        enumerable: true,
        configurable: true
      });
      BehaviorSubject2.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) {
          subscriber.next(this._value);
        }
        return subscription;
      };
      BehaviorSubject2.prototype.getValue = function() {
        if (this.hasError) {
          throw this.thrownError;
        } else if (this.closed) {
          throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        } else {
          return this._value;
        }
      };
      BehaviorSubject2.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
      };
      return BehaviorSubject2;
    }(Subject_1.Subject);
    exports.BehaviorSubject = BehaviorSubject;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/Action.js
var require_Action = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/Action.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var Subscription_1 = require_Subscription();
    var Action = function(_super) {
      __extends12(Action2, _super);
      function Action2(scheduler, work) {
        return _super.call(this) || this;
      }
      Action2.prototype.schedule = function(state, delay) {
        if (delay === void 0) {
          delay = 0;
        }
        return this;
      };
      return Action2;
    }(Subscription_1.Subscription);
    exports.Action = Action;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/AsyncAction.js
var require_AsyncAction = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/AsyncAction.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var Action_1 = require_Action();
    var AsyncAction = function(_super) {
      __extends12(AsyncAction2, _super);
      function AsyncAction2(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
      }
      AsyncAction2.prototype.schedule = function(state, delay) {
        if (delay === void 0) {
          delay = 0;
        }
        if (this.closed) {
          return this;
        }
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) {
          this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.pending = true;
        this.delay = delay;
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
      };
      AsyncAction2.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) {
          delay = 0;
        }
        return setInterval(scheduler.flush.bind(scheduler, this), delay);
      };
      AsyncAction2.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) {
          delay = 0;
        }
        if (delay !== null && this.delay === delay && this.pending === false) {
          return id;
        }
        clearInterval(id);
        return void 0;
      };
      AsyncAction2.prototype.execute = function(state, delay) {
        if (this.closed) {
          return new Error("executing a cancelled action");
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
          return error;
        } else if (this.pending === false && this.id != null) {
          this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
      };
      AsyncAction2.prototype._execute = function(state, delay) {
        var errored = false;
        var errorValue = void 0;
        try {
          this.work(state);
        } catch (e) {
          errored = true;
          errorValue = !!e && e || new Error(e);
        }
        if (errored) {
          this.unsubscribe();
          return errorValue;
        }
      };
      AsyncAction2.prototype._unsubscribe = function() {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) {
          actions.splice(index, 1);
        }
        if (id != null) {
          this.id = this.recycleAsyncId(scheduler, id, null);
        }
        this.delay = null;
      };
      return AsyncAction2;
    }(Action_1.Action);
    exports.AsyncAction = AsyncAction;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/QueueAction.js
var require_QueueAction = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/QueueAction.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var AsyncAction_1 = require_AsyncAction();
    var QueueAction = function(_super) {
      __extends12(QueueAction2, _super);
      function QueueAction2(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
      }
      QueueAction2.prototype.schedule = function(state, delay) {
        if (delay === void 0) {
          delay = 0;
        }
        if (delay > 0) {
          return _super.prototype.schedule.call(this, state, delay);
        }
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
      };
      QueueAction2.prototype.execute = function(state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
      };
      QueueAction2.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) {
          delay = 0;
        }
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) {
          return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        return scheduler.flush(this);
      };
      return QueueAction2;
    }(AsyncAction_1.AsyncAction);
    exports.QueueAction = QueueAction;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/Scheduler.js
var require_Scheduler = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/Scheduler.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Scheduler = function() {
      function Scheduler2(SchedulerAction, now) {
        if (now === void 0) {
          now = Scheduler2.now;
        }
        this.SchedulerAction = SchedulerAction;
        this.now = now;
      }
      Scheduler2.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) {
          delay = 0;
        }
        return new this.SchedulerAction(this, work).schedule(state, delay);
      };
      Scheduler2.now = function() {
        return Date.now();
      };
      return Scheduler2;
    }();
    exports.Scheduler = Scheduler;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/AsyncScheduler.js
var require_AsyncScheduler = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/AsyncScheduler.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var Scheduler_1 = require_Scheduler();
    var AsyncScheduler = function(_super) {
      __extends12(AsyncScheduler2, _super);
      function AsyncScheduler2(SchedulerAction, now) {
        if (now === void 0) {
          now = Scheduler_1.Scheduler.now;
        }
        var _this = _super.call(this, SchedulerAction, function() {
          if (AsyncScheduler2.delegate && AsyncScheduler2.delegate !== _this) {
            return AsyncScheduler2.delegate.now();
          } else {
            return now();
          }
        }) || this;
        _this.actions = [];
        _this.active = false;
        _this.scheduled = void 0;
        return _this;
      }
      AsyncScheduler2.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) {
          delay = 0;
        }
        if (AsyncScheduler2.delegate && AsyncScheduler2.delegate !== this) {
          return AsyncScheduler2.delegate.schedule(work, delay, state);
        } else {
          return _super.prototype.schedule.call(this, work, delay, state);
        }
      };
      AsyncScheduler2.prototype.flush = function(action) {
        var actions = this.actions;
        if (this.active) {
          actions.push(action);
          return;
        }
        var error;
        this.active = true;
        do {
          if (error = action.execute(action.state, action.delay)) {
            break;
          }
        } while (action = actions.shift());
        this.active = false;
        if (error) {
          while (action = actions.shift()) {
            action.unsubscribe();
          }
          throw error;
        }
      };
      return AsyncScheduler2;
    }(Scheduler_1.Scheduler);
    exports.AsyncScheduler = AsyncScheduler;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/QueueScheduler.js
var require_QueueScheduler = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/QueueScheduler.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var AsyncScheduler_1 = require_AsyncScheduler();
    var QueueScheduler = function(_super) {
      __extends12(QueueScheduler2, _super);
      function QueueScheduler2() {
        return _super !== null && _super.apply(this, arguments) || this;
      }
      return QueueScheduler2;
    }(AsyncScheduler_1.AsyncScheduler);
    exports.QueueScheduler = QueueScheduler;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/queue.js
var require_queue = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/queue.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var QueueAction_1 = require_QueueAction();
    var QueueScheduler_1 = require_QueueScheduler();
    exports.queueScheduler = new QueueScheduler_1.QueueScheduler(QueueAction_1.QueueAction);
    exports.queue = exports.queueScheduler;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/empty.js
var require_empty = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/empty.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    exports.EMPTY = new Observable_1.Observable(function(subscriber) {
      return subscriber.complete();
    });
    function empty3(scheduler) {
      return scheduler ? emptyScheduled2(scheduler) : exports.EMPTY;
    }
    exports.empty = empty3;
    function emptyScheduled2(scheduler) {
      return new Observable_1.Observable(function(subscriber) {
        return scheduler.schedule(function() {
          return subscriber.complete();
        });
      });
    }
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/isScheduler.js
var require_isScheduler = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/isScheduler.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function isScheduler(value) {
      return value && typeof value.schedule === "function";
    }
    exports.isScheduler = isScheduler;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/subscribeToArray.js
var require_subscribeToArray = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/subscribeToArray.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.subscribeToArray = function(array) {
      return function(subscriber) {
        for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
          subscriber.next(array[i]);
        }
        subscriber.complete();
      };
    };
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduled/scheduleArray.js
var require_scheduleArray = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduled/scheduleArray.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var Subscription_1 = require_Subscription();
    function scheduleArray2(input, scheduler) {
      return new Observable_1.Observable(function(subscriber) {
        var sub = new Subscription_1.Subscription();
        var i = 0;
        sub.add(scheduler.schedule(function() {
          if (i === input.length) {
            subscriber.complete();
            return;
          }
          subscriber.next(input[i++]);
          if (!subscriber.closed) {
            sub.add(this.schedule());
          }
        }));
        return sub;
      });
    }
    exports.scheduleArray = scheduleArray2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/fromArray.js
var require_fromArray = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/fromArray.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var subscribeToArray_1 = require_subscribeToArray();
    var scheduleArray_1 = require_scheduleArray();
    function fromArray(input, scheduler) {
      if (!scheduler) {
        return new Observable_1.Observable(subscribeToArray_1.subscribeToArray(input));
      } else {
        return scheduleArray_1.scheduleArray(input, scheduler);
      }
    }
    exports.fromArray = fromArray;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/of.js
var require_of = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/of.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var isScheduler_1 = require_isScheduler();
    var fromArray_1 = require_fromArray();
    var scheduleArray_1 = require_scheduleArray();
    function of2() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var scheduler = args[args.length - 1];
      if (isScheduler_1.isScheduler(scheduler)) {
        args.pop();
        return scheduleArray_1.scheduleArray(args, scheduler);
      } else {
        return fromArray_1.fromArray(args);
      }
    }
    exports.of = of2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/throwError.js
var require_throwError = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/throwError.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    function throwError(error, scheduler) {
      if (!scheduler) {
        return new Observable_1.Observable(function(subscriber) {
          return subscriber.error(error);
        });
      } else {
        return new Observable_1.Observable(function(subscriber) {
          return scheduler.schedule(dispatch, 0, { error, subscriber });
        });
      }
    }
    exports.throwError = throwError;
    function dispatch(_a) {
      var error = _a.error, subscriber = _a.subscriber;
      subscriber.error(error);
    }
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/Notification.js
var require_Notification = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/Notification.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var empty_1 = require_empty();
    var of_1 = require_of();
    var throwError_1 = require_throwError();
    var NotificationKind;
    (function(NotificationKind2) {
      NotificationKind2["NEXT"] = "N";
      NotificationKind2["ERROR"] = "E";
      NotificationKind2["COMPLETE"] = "C";
    })(NotificationKind = exports.NotificationKind || (exports.NotificationKind = {}));
    var Notification = function() {
      function Notification2(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === "N";
      }
      Notification2.prototype.observe = function(observer) {
        switch (this.kind) {
          case "N":
            return observer.next && observer.next(this.value);
          case "E":
            return observer.error && observer.error(this.error);
          case "C":
            return observer.complete && observer.complete();
        }
      };
      Notification2.prototype.do = function(next, error, complete) {
        var kind = this.kind;
        switch (kind) {
          case "N":
            return next && next(this.value);
          case "E":
            return error && error(this.error);
          case "C":
            return complete && complete();
        }
      };
      Notification2.prototype.accept = function(nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === "function") {
          return this.observe(nextOrObserver);
        } else {
          return this.do(nextOrObserver, error, complete);
        }
      };
      Notification2.prototype.toObservable = function() {
        var kind = this.kind;
        switch (kind) {
          case "N":
            return of_1.of(this.value);
          case "E":
            return throwError_1.throwError(this.error);
          case "C":
            return empty_1.empty();
        }
        throw new Error("unexpected notification kind value");
      };
      Notification2.createNext = function(value) {
        if (typeof value !== "undefined") {
          return new Notification2("N", value);
        }
        return Notification2.undefinedValueNotification;
      };
      Notification2.createError = function(err) {
        return new Notification2("E", void 0, err);
      };
      Notification2.createComplete = function() {
        return Notification2.completeNotification;
      };
      Notification2.completeNotification = new Notification2("C");
      Notification2.undefinedValueNotification = new Notification2("N", void 0);
      return Notification2;
    }();
    exports.Notification = Notification;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/operators/observeOn.js
var require_observeOn = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/operators/observeOn.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var Subscriber_1 = require_Subscriber();
    var Notification_1 = require_Notification();
    function observeOn(scheduler, delay) {
      if (delay === void 0) {
        delay = 0;
      }
      return function observeOnOperatorFunction(source) {
        return source.lift(new ObserveOnOperator(scheduler, delay));
      };
    }
    exports.observeOn = observeOn;
    var ObserveOnOperator = function() {
      function ObserveOnOperator2(scheduler, delay) {
        if (delay === void 0) {
          delay = 0;
        }
        this.scheduler = scheduler;
        this.delay = delay;
      }
      ObserveOnOperator2.prototype.call = function(subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
      };
      return ObserveOnOperator2;
    }();
    exports.ObserveOnOperator = ObserveOnOperator;
    var ObserveOnSubscriber = function(_super) {
      __extends12(ObserveOnSubscriber2, _super);
      function ObserveOnSubscriber2(destination, scheduler, delay) {
        if (delay === void 0) {
          delay = 0;
        }
        var _this = _super.call(this, destination) || this;
        _this.scheduler = scheduler;
        _this.delay = delay;
        return _this;
      }
      ObserveOnSubscriber2.dispatch = function(arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
      };
      ObserveOnSubscriber2.prototype.scheduleMessage = function(notification) {
        var destination = this.destination;
        destination.add(this.scheduler.schedule(ObserveOnSubscriber2.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
      };
      ObserveOnSubscriber2.prototype._next = function(value) {
        this.scheduleMessage(Notification_1.Notification.createNext(value));
      };
      ObserveOnSubscriber2.prototype._error = function(err) {
        this.scheduleMessage(Notification_1.Notification.createError(err));
        this.unsubscribe();
      };
      ObserveOnSubscriber2.prototype._complete = function() {
        this.scheduleMessage(Notification_1.Notification.createComplete());
        this.unsubscribe();
      };
      return ObserveOnSubscriber2;
    }(Subscriber_1.Subscriber);
    exports.ObserveOnSubscriber = ObserveOnSubscriber;
    var ObserveOnMessage = function() {
      function ObserveOnMessage2(notification, destination) {
        this.notification = notification;
        this.destination = destination;
      }
      return ObserveOnMessage2;
    }();
    exports.ObserveOnMessage = ObserveOnMessage;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/ReplaySubject.js
var require_ReplaySubject = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/ReplaySubject.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var Subject_1 = require_Subject();
    var queue_1 = require_queue();
    var Subscription_1 = require_Subscription();
    var observeOn_1 = require_observeOn();
    var ObjectUnsubscribedError_1 = require_ObjectUnsubscribedError();
    var SubjectSubscription_1 = require_SubjectSubscription();
    var ReplaySubject = function(_super) {
      __extends12(ReplaySubject2, _super);
      function ReplaySubject2(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) {
          bufferSize = Number.POSITIVE_INFINITY;
        }
        if (windowTime === void 0) {
          windowTime = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this) || this;
        _this.scheduler = scheduler;
        _this._events = [];
        _this._infiniteTimeWindow = false;
        _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        _this._windowTime = windowTime < 1 ? 1 : windowTime;
        if (windowTime === Number.POSITIVE_INFINITY) {
          _this._infiniteTimeWindow = true;
          _this.next = _this.nextInfiniteTimeWindow;
        } else {
          _this.next = _this.nextTimeWindow;
        }
        return _this;
      }
      ReplaySubject2.prototype.nextInfiniteTimeWindow = function(value) {
        if (!this.isStopped) {
          var _events = this._events;
          _events.push(value);
          if (_events.length > this._bufferSize) {
            _events.shift();
          }
        }
        _super.prototype.next.call(this, value);
      };
      ReplaySubject2.prototype.nextTimeWindow = function(value) {
        if (!this.isStopped) {
          this._events.push(new ReplayEvent(this._getNow(), value));
          this._trimBufferThenGetEvents();
        }
        _super.prototype.next.call(this, value);
      };
      ReplaySubject2.prototype._subscribe = function(subscriber) {
        var _infiniteTimeWindow = this._infiniteTimeWindow;
        var _events = _infiniteTimeWindow ? this._events : this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var len = _events.length;
        var subscription;
        if (this.closed) {
          throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        } else if (this.isStopped || this.hasError) {
          subscription = Subscription_1.Subscription.EMPTY;
        } else {
          this.observers.push(subscriber);
          subscription = new SubjectSubscription_1.SubjectSubscription(this, subscriber);
        }
        if (scheduler) {
          subscriber.add(subscriber = new observeOn_1.ObserveOnSubscriber(subscriber, scheduler));
        }
        if (_infiniteTimeWindow) {
          for (var i = 0; i < len && !subscriber.closed; i++) {
            subscriber.next(_events[i]);
          }
        } else {
          for (var i = 0; i < len && !subscriber.closed; i++) {
            subscriber.next(_events[i].value);
          }
        }
        if (this.hasError) {
          subscriber.error(this.thrownError);
        } else if (this.isStopped) {
          subscriber.complete();
        }
        return subscription;
      };
      ReplaySubject2.prototype._getNow = function() {
        return (this.scheduler || queue_1.queue).now();
      };
      ReplaySubject2.prototype._trimBufferThenGetEvents = function() {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        while (spliceCount < eventsCount) {
          if (now - _events[spliceCount].time < _windowTime) {
            break;
          }
          spliceCount++;
        }
        if (eventsCount > _bufferSize) {
          spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        }
        if (spliceCount > 0) {
          _events.splice(0, spliceCount);
        }
        return _events;
      };
      return ReplaySubject2;
    }(Subject_1.Subject);
    exports.ReplaySubject = ReplaySubject;
    var ReplayEvent = function() {
      function ReplayEvent2(time, value) {
        this.time = time;
        this.value = value;
      }
      return ReplayEvent2;
    }();
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/AsyncSubject.js
var require_AsyncSubject = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/AsyncSubject.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var Subject_1 = require_Subject();
    var Subscription_1 = require_Subscription();
    var AsyncSubject = function(_super) {
      __extends12(AsyncSubject2, _super);
      function AsyncSubject2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = null;
        _this.hasNext = false;
        _this.hasCompleted = false;
        return _this;
      }
      AsyncSubject2.prototype._subscribe = function(subscriber) {
        if (this.hasError) {
          subscriber.error(this.thrownError);
          return Subscription_1.Subscription.EMPTY;
        } else if (this.hasCompleted && this.hasNext) {
          subscriber.next(this.value);
          subscriber.complete();
          return Subscription_1.Subscription.EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
      };
      AsyncSubject2.prototype.next = function(value) {
        if (!this.hasCompleted) {
          this.value = value;
          this.hasNext = true;
        }
      };
      AsyncSubject2.prototype.error = function(error) {
        if (!this.hasCompleted) {
          _super.prototype.error.call(this, error);
        }
      };
      AsyncSubject2.prototype.complete = function() {
        this.hasCompleted = true;
        if (this.hasNext) {
          _super.prototype.next.call(this, this.value);
        }
        _super.prototype.complete.call(this);
      };
      return AsyncSubject2;
    }(Subject_1.Subject);
    exports.AsyncSubject = AsyncSubject;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/Immediate.js
var require_Immediate = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/Immediate.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var nextHandle = 1;
    var RESOLVED = function() {
      return Promise.resolve();
    }();
    var activeHandles = {};
    function findAndClearHandle(handle) {
      if (handle in activeHandles) {
        delete activeHandles[handle];
        return true;
      }
      return false;
    }
    exports.Immediate = {
      setImmediate: function(cb) {
        var handle = nextHandle++;
        activeHandles[handle] = true;
        RESOLVED.then(function() {
          return findAndClearHandle(handle) && cb();
        });
        return handle;
      },
      clearImmediate: function(handle) {
        findAndClearHandle(handle);
      }
    };
    exports.TestTools = {
      pending: function() {
        return Object.keys(activeHandles).length;
      }
    };
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/AsapAction.js
var require_AsapAction = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/AsapAction.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var Immediate_1 = require_Immediate();
    var AsyncAction_1 = require_AsyncAction();
    var AsapAction = function(_super) {
      __extends12(AsapAction2, _super);
      function AsapAction2(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
      }
      AsapAction2.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) {
          delay = 0;
        }
        if (delay !== null && delay > 0) {
          return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = Immediate_1.Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
      };
      AsapAction2.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) {
          delay = 0;
        }
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) {
          return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        if (scheduler.actions.length === 0) {
          Immediate_1.Immediate.clearImmediate(id);
          scheduler.scheduled = void 0;
        }
        return void 0;
      };
      return AsapAction2;
    }(AsyncAction_1.AsyncAction);
    exports.AsapAction = AsapAction;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/AsapScheduler.js
var require_AsapScheduler = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/AsapScheduler.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var AsyncScheduler_1 = require_AsyncScheduler();
    var AsapScheduler = function(_super) {
      __extends12(AsapScheduler2, _super);
      function AsapScheduler2() {
        return _super !== null && _super.apply(this, arguments) || this;
      }
      AsapScheduler2.prototype.flush = function(action) {
        this.active = true;
        this.scheduled = void 0;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
          if (error = action.execute(action.state, action.delay)) {
            break;
          }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
          while (++index < count && (action = actions.shift())) {
            action.unsubscribe();
          }
          throw error;
        }
      };
      return AsapScheduler2;
    }(AsyncScheduler_1.AsyncScheduler);
    exports.AsapScheduler = AsapScheduler;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/asap.js
var require_asap = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/asap.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var AsapAction_1 = require_AsapAction();
    var AsapScheduler_1 = require_AsapScheduler();
    exports.asapScheduler = new AsapScheduler_1.AsapScheduler(AsapAction_1.AsapAction);
    exports.asap = exports.asapScheduler;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/async.js
var require_async = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/async.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var AsyncAction_1 = require_AsyncAction();
    var AsyncScheduler_1 = require_AsyncScheduler();
    exports.asyncScheduler = new AsyncScheduler_1.AsyncScheduler(AsyncAction_1.AsyncAction);
    exports.async = exports.asyncScheduler;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/AnimationFrameAction.js
var require_AnimationFrameAction = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/AnimationFrameAction.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var AsyncAction_1 = require_AsyncAction();
    var AnimationFrameAction = function(_super) {
      __extends12(AnimationFrameAction2, _super);
      function AnimationFrameAction2(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
      }
      AnimationFrameAction2.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) {
          delay = 0;
        }
        if (delay !== null && delay > 0) {
          return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = requestAnimationFrame(function() {
          return scheduler.flush(null);
        }));
      };
      AnimationFrameAction2.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) {
          delay = 0;
        }
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) {
          return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        if (scheduler.actions.length === 0) {
          cancelAnimationFrame(id);
          scheduler.scheduled = void 0;
        }
        return void 0;
      };
      return AnimationFrameAction2;
    }(AsyncAction_1.AsyncAction);
    exports.AnimationFrameAction = AnimationFrameAction;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/AnimationFrameScheduler.js
var require_AnimationFrameScheduler = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/AnimationFrameScheduler.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var AsyncScheduler_1 = require_AsyncScheduler();
    var AnimationFrameScheduler = function(_super) {
      __extends12(AnimationFrameScheduler2, _super);
      function AnimationFrameScheduler2() {
        return _super !== null && _super.apply(this, arguments) || this;
      }
      AnimationFrameScheduler2.prototype.flush = function(action) {
        this.active = true;
        this.scheduled = void 0;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
          if (error = action.execute(action.state, action.delay)) {
            break;
          }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
          while (++index < count && (action = actions.shift())) {
            action.unsubscribe();
          }
          throw error;
        }
      };
      return AnimationFrameScheduler2;
    }(AsyncScheduler_1.AsyncScheduler);
    exports.AnimationFrameScheduler = AnimationFrameScheduler;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/animationFrame.js
var require_animationFrame = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/animationFrame.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var AnimationFrameAction_1 = require_AnimationFrameAction();
    var AnimationFrameScheduler_1 = require_AnimationFrameScheduler();
    exports.animationFrameScheduler = new AnimationFrameScheduler_1.AnimationFrameScheduler(AnimationFrameAction_1.AnimationFrameAction);
    exports.animationFrame = exports.animationFrameScheduler;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/VirtualTimeScheduler.js
var require_VirtualTimeScheduler = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduler/VirtualTimeScheduler.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var AsyncAction_1 = require_AsyncAction();
    var AsyncScheduler_1 = require_AsyncScheduler();
    var VirtualTimeScheduler = function(_super) {
      __extends12(VirtualTimeScheduler2, _super);
      function VirtualTimeScheduler2(SchedulerAction, maxFrames) {
        if (SchedulerAction === void 0) {
          SchedulerAction = VirtualAction;
        }
        if (maxFrames === void 0) {
          maxFrames = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this, SchedulerAction, function() {
          return _this.frame;
        }) || this;
        _this.maxFrames = maxFrames;
        _this.frame = 0;
        _this.index = -1;
        return _this;
      }
      VirtualTimeScheduler2.prototype.flush = function() {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while ((action = actions[0]) && action.delay <= maxFrames) {
          actions.shift();
          this.frame = action.delay;
          if (error = action.execute(action.state, action.delay)) {
            break;
          }
        }
        if (error) {
          while (action = actions.shift()) {
            action.unsubscribe();
          }
          throw error;
        }
      };
      VirtualTimeScheduler2.frameTimeFactor = 10;
      return VirtualTimeScheduler2;
    }(AsyncScheduler_1.AsyncScheduler);
    exports.VirtualTimeScheduler = VirtualTimeScheduler;
    var VirtualAction = function(_super) {
      __extends12(VirtualAction2, _super);
      function VirtualAction2(scheduler, work, index) {
        if (index === void 0) {
          index = scheduler.index += 1;
        }
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.index = index;
        _this.active = true;
        _this.index = scheduler.index = index;
        return _this;
      }
      VirtualAction2.prototype.schedule = function(state, delay) {
        if (delay === void 0) {
          delay = 0;
        }
        if (!this.id) {
          return _super.prototype.schedule.call(this, state, delay);
        }
        this.active = false;
        var action = new VirtualAction2(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
      };
      VirtualAction2.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) {
          delay = 0;
        }
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction2.sortActions);
        return true;
      };
      VirtualAction2.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) {
          delay = 0;
        }
        return void 0;
      };
      VirtualAction2.prototype._execute = function(state, delay) {
        if (this.active === true) {
          return _super.prototype._execute.call(this, state, delay);
        }
      };
      VirtualAction2.sortActions = function(a, b) {
        if (a.delay === b.delay) {
          if (a.index === b.index) {
            return 0;
          } else if (a.index > b.index) {
            return 1;
          } else {
            return -1;
          }
        } else if (a.delay > b.delay) {
          return 1;
        } else {
          return -1;
        }
      };
      return VirtualAction2;
    }(AsyncAction_1.AsyncAction);
    exports.VirtualAction = VirtualAction;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/noop.js
var require_noop = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/noop.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function noop2() {
    }
    exports.noop = noop2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/isObservable.js
var require_isObservable = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/isObservable.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    function isObservable(obj) {
      return !!obj && (obj instanceof Observable_1.Observable || typeof obj.lift === "function" && typeof obj.subscribe === "function");
    }
    exports.isObservable = isObservable;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/ArgumentOutOfRangeError.js
var require_ArgumentOutOfRangeError = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/ArgumentOutOfRangeError.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ArgumentOutOfRangeErrorImpl2 = function() {
      function ArgumentOutOfRangeErrorImpl3() {
        Error.call(this);
        this.message = "argument out of range";
        this.name = "ArgumentOutOfRangeError";
        return this;
      }
      ArgumentOutOfRangeErrorImpl3.prototype = Object.create(Error.prototype);
      return ArgumentOutOfRangeErrorImpl3;
    }();
    exports.ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/EmptyError.js
var require_EmptyError = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/EmptyError.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var EmptyErrorImpl = function() {
      function EmptyErrorImpl2() {
        Error.call(this);
        this.message = "no elements in sequence";
        this.name = "EmptyError";
        return this;
      }
      EmptyErrorImpl2.prototype = Object.create(Error.prototype);
      return EmptyErrorImpl2;
    }();
    exports.EmptyError = EmptyErrorImpl;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/TimeoutError.js
var require_TimeoutError = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/TimeoutError.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var TimeoutErrorImpl = function() {
      function TimeoutErrorImpl2() {
        Error.call(this);
        this.message = "Timeout has occurred";
        this.name = "TimeoutError";
        return this;
      }
      TimeoutErrorImpl2.prototype = Object.create(Error.prototype);
      return TimeoutErrorImpl2;
    }();
    exports.TimeoutError = TimeoutErrorImpl;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/operators/map.js
var require_map = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/operators/map.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var Subscriber_1 = require_Subscriber();
    function map39(project, thisArg) {
      return function mapOperation(source) {
        if (typeof project !== "function") {
          throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
        }
        return source.lift(new MapOperator2(project, thisArg));
      };
    }
    exports.map = map39;
    var MapOperator2 = function() {
      function MapOperator3(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
      }
      MapOperator3.prototype.call = function(subscriber, source) {
        return source.subscribe(new MapSubscriber2(subscriber, this.project, this.thisArg));
      };
      return MapOperator3;
    }();
    exports.MapOperator = MapOperator2;
    var MapSubscriber2 = function(_super) {
      __extends12(MapSubscriber3, _super);
      function MapSubscriber3(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
      }
      MapSubscriber3.prototype._next = function(value) {
        var result;
        try {
          result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
          this.destination.error(err);
          return;
        }
        this.destination.next(result);
      };
      return MapSubscriber3;
    }(Subscriber_1.Subscriber);
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/bindCallback.js
var require_bindCallback = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/bindCallback.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var AsyncSubject_1 = require_AsyncSubject();
    var map_1 = require_map();
    var canReportError_1 = require_canReportError();
    var isArray_1 = require_isArray();
    var isScheduler_1 = require_isScheduler();
    function bindCallback(callbackFunc, resultSelector, scheduler) {
      if (resultSelector) {
        if (isScheduler_1.isScheduler(resultSelector)) {
          scheduler = resultSelector;
        } else {
          return function() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            return bindCallback(callbackFunc, scheduler).apply(void 0, args).pipe(map_1.map(function(args2) {
              return isArray_1.isArray(args2) ? resultSelector.apply(void 0, args2) : resultSelector(args2);
            }));
          };
        }
      }
      return function() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        var context = this;
        var subject;
        var params = {
          context,
          subject,
          callbackFunc,
          scheduler
        };
        return new Observable_1.Observable(function(subscriber) {
          if (!scheduler) {
            if (!subject) {
              subject = new AsyncSubject_1.AsyncSubject();
              var handler = function() {
                var innerArgs = [];
                for (var _i2 = 0; _i2 < arguments.length; _i2++) {
                  innerArgs[_i2] = arguments[_i2];
                }
                subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                subject.complete();
              };
              try {
                callbackFunc.apply(context, args.concat([handler]));
              } catch (err) {
                if (canReportError_1.canReportError(subject)) {
                  subject.error(err);
                } else {
                  console.warn(err);
                }
              }
            }
            return subject.subscribe(subscriber);
          } else {
            var state = {
              args,
              subscriber,
              params
            };
            return scheduler.schedule(dispatch, 0, state);
          }
        });
      };
    }
    exports.bindCallback = bindCallback;
    function dispatch(state) {
      var _this = this;
      var self2 = this;
      var args = state.args, subscriber = state.subscriber, params = state.params;
      var callbackFunc = params.callbackFunc, context = params.context, scheduler = params.scheduler;
      var subject = params.subject;
      if (!subject) {
        subject = params.subject = new AsyncSubject_1.AsyncSubject();
        var handler = function() {
          var innerArgs = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            innerArgs[_i] = arguments[_i];
          }
          var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
          _this.add(scheduler.schedule(dispatchNext, 0, { value, subject }));
        };
        try {
          callbackFunc.apply(context, args.concat([handler]));
        } catch (err) {
          subject.error(err);
        }
      }
      this.add(subject.subscribe(subscriber));
    }
    function dispatchNext(state) {
      var value = state.value, subject = state.subject;
      subject.next(value);
      subject.complete();
    }
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/bindNodeCallback.js
var require_bindNodeCallback = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/bindNodeCallback.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var AsyncSubject_1 = require_AsyncSubject();
    var map_1 = require_map();
    var canReportError_1 = require_canReportError();
    var isScheduler_1 = require_isScheduler();
    var isArray_1 = require_isArray();
    function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
      if (resultSelector) {
        if (isScheduler_1.isScheduler(resultSelector)) {
          scheduler = resultSelector;
        } else {
          return function() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            return bindNodeCallback(callbackFunc, scheduler).apply(void 0, args).pipe(map_1.map(function(args2) {
              return isArray_1.isArray(args2) ? resultSelector.apply(void 0, args2) : resultSelector(args2);
            }));
          };
        }
      }
      return function() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        var params = {
          subject: void 0,
          args,
          callbackFunc,
          scheduler,
          context: this
        };
        return new Observable_1.Observable(function(subscriber) {
          var context = params.context;
          var subject = params.subject;
          if (!scheduler) {
            if (!subject) {
              subject = params.subject = new AsyncSubject_1.AsyncSubject();
              var handler = function() {
                var innerArgs = [];
                for (var _i2 = 0; _i2 < arguments.length; _i2++) {
                  innerArgs[_i2] = arguments[_i2];
                }
                var err = innerArgs.shift();
                if (err) {
                  subject.error(err);
                  return;
                }
                subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                subject.complete();
              };
              try {
                callbackFunc.apply(context, args.concat([handler]));
              } catch (err) {
                if (canReportError_1.canReportError(subject)) {
                  subject.error(err);
                } else {
                  console.warn(err);
                }
              }
            }
            return subject.subscribe(subscriber);
          } else {
            return scheduler.schedule(dispatch, 0, { params, subscriber, context });
          }
        });
      };
    }
    exports.bindNodeCallback = bindNodeCallback;
    function dispatch(state) {
      var _this = this;
      var params = state.params, subscriber = state.subscriber, context = state.context;
      var callbackFunc = params.callbackFunc, args = params.args, scheduler = params.scheduler;
      var subject = params.subject;
      if (!subject) {
        subject = params.subject = new AsyncSubject_1.AsyncSubject();
        var handler = function() {
          var innerArgs = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            innerArgs[_i] = arguments[_i];
          }
          var err = innerArgs.shift();
          if (err) {
            _this.add(scheduler.schedule(dispatchError, 0, { err, subject }));
          } else {
            var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
            _this.add(scheduler.schedule(dispatchNext, 0, { value, subject }));
          }
        };
        try {
          callbackFunc.apply(context, args.concat([handler]));
        } catch (err) {
          this.add(scheduler.schedule(dispatchError, 0, { err, subject }));
        }
      }
      this.add(subject.subscribe(subscriber));
    }
    function dispatchNext(arg) {
      var value = arg.value, subject = arg.subject;
      subject.next(value);
      subject.complete();
    }
    function dispatchError(arg) {
      var err = arg.err, subject = arg.subject;
      subject.error(err);
    }
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/OuterSubscriber.js
var require_OuterSubscriber = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/OuterSubscriber.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var Subscriber_1 = require_Subscriber();
    var OuterSubscriber = function(_super) {
      __extends12(OuterSubscriber2, _super);
      function OuterSubscriber2() {
        return _super !== null && _super.apply(this, arguments) || this;
      }
      OuterSubscriber2.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
      };
      OuterSubscriber2.prototype.notifyError = function(error, innerSub) {
        this.destination.error(error);
      };
      OuterSubscriber2.prototype.notifyComplete = function(innerSub) {
        this.destination.complete();
      };
      return OuterSubscriber2;
    }(Subscriber_1.Subscriber);
    exports.OuterSubscriber = OuterSubscriber;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/InnerSubscriber.js
var require_InnerSubscriber = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/InnerSubscriber.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var Subscriber_1 = require_Subscriber();
    var InnerSubscriber = function(_super) {
      __extends12(InnerSubscriber2, _super);
      function InnerSubscriber2(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        _this.index = 0;
        return _this;
      }
      InnerSubscriber2.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
      };
      InnerSubscriber2.prototype._error = function(error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
      };
      InnerSubscriber2.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
      };
      return InnerSubscriber2;
    }(Subscriber_1.Subscriber);
    exports.InnerSubscriber = InnerSubscriber;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/subscribeToPromise.js
var require_subscribeToPromise = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/subscribeToPromise.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var hostReportError_1 = require_hostReportError();
    exports.subscribeToPromise = function(promise) {
      return function(subscriber) {
        promise.then(function(value) {
          if (!subscriber.closed) {
            subscriber.next(value);
            subscriber.complete();
          }
        }, function(err) {
          return subscriber.error(err);
        }).then(null, hostReportError_1.hostReportError);
        return subscriber;
      };
    };
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/symbol/iterator.js
var require_iterator = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/symbol/iterator.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function getSymbolIterator2() {
      if (typeof Symbol !== "function" || !Symbol.iterator) {
        return "@@iterator";
      }
      return Symbol.iterator;
    }
    exports.getSymbolIterator = getSymbolIterator2;
    exports.iterator = getSymbolIterator2();
    exports.$$iterator = exports.iterator;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/subscribeToIterable.js
var require_subscribeToIterable = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/subscribeToIterable.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var iterator_1 = require_iterator();
    exports.subscribeToIterable = function(iterable) {
      return function(subscriber) {
        var iterator2 = iterable[iterator_1.iterator]();
        do {
          var item = void 0;
          try {
            item = iterator2.next();
          } catch (err) {
            subscriber.error(err);
            return subscriber;
          }
          if (item.done) {
            subscriber.complete();
            break;
          }
          subscriber.next(item.value);
          if (subscriber.closed) {
            break;
          }
        } while (true);
        if (typeof iterator2.return === "function") {
          subscriber.add(function() {
            if (iterator2.return) {
              iterator2.return();
            }
          });
        }
        return subscriber;
      };
    };
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/subscribeToObservable.js
var require_subscribeToObservable = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/subscribeToObservable.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var observable_1 = require_observable();
    exports.subscribeToObservable = function(obj) {
      return function(subscriber) {
        var obs = obj[observable_1.observable]();
        if (typeof obs.subscribe !== "function") {
          throw new TypeError("Provided object does not correctly implement Symbol.observable");
        } else {
          return obs.subscribe(subscriber);
        }
      };
    };
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/isArrayLike.js
var require_isArrayLike = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/isArrayLike.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isArrayLike = function(x) {
      return x && typeof x.length === "number" && typeof x !== "function";
    };
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/isPromise.js
var require_isPromise = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/isPromise.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function isPromise2(value) {
      return !!value && typeof value.subscribe !== "function" && typeof value.then === "function";
    }
    exports.isPromise = isPromise2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/subscribeTo.js
var require_subscribeTo = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/subscribeTo.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var subscribeToArray_1 = require_subscribeToArray();
    var subscribeToPromise_1 = require_subscribeToPromise();
    var subscribeToIterable_1 = require_subscribeToIterable();
    var subscribeToObservable_1 = require_subscribeToObservable();
    var isArrayLike_1 = require_isArrayLike();
    var isPromise_1 = require_isPromise();
    var isObject_1 = require_isObject();
    var iterator_1 = require_iterator();
    var observable_1 = require_observable();
    exports.subscribeTo = function(result) {
      if (!!result && typeof result[observable_1.observable] === "function") {
        return subscribeToObservable_1.subscribeToObservable(result);
      } else if (isArrayLike_1.isArrayLike(result)) {
        return subscribeToArray_1.subscribeToArray(result);
      } else if (isPromise_1.isPromise(result)) {
        return subscribeToPromise_1.subscribeToPromise(result);
      } else if (!!result && typeof result[iterator_1.iterator] === "function") {
        return subscribeToIterable_1.subscribeToIterable(result);
      } else {
        var value = isObject_1.isObject(result) ? "an invalid object" : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.";
        throw new TypeError(msg);
      }
    };
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/subscribeToResult.js
var require_subscribeToResult = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/subscribeToResult.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var InnerSubscriber_1 = require_InnerSubscriber();
    var subscribeTo_1 = require_subscribeTo();
    var Observable_1 = require_Observable();
    function subscribeToResult(outerSubscriber, result, outerValue, outerIndex, innerSubscriber) {
      if (innerSubscriber === void 0) {
        innerSubscriber = new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
      }
      if (innerSubscriber.closed) {
        return void 0;
      }
      if (result instanceof Observable_1.Observable) {
        return result.subscribe(innerSubscriber);
      }
      return subscribeTo_1.subscribeTo(result)(innerSubscriber);
    }
    exports.subscribeToResult = subscribeToResult;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/combineLatest.js
var require_combineLatest = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/combineLatest.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var isScheduler_1 = require_isScheduler();
    var isArray_1 = require_isArray();
    var OuterSubscriber_1 = require_OuterSubscriber();
    var subscribeToResult_1 = require_subscribeToResult();
    var fromArray_1 = require_fromArray();
    var NONE = {};
    function combineLatest() {
      var observables = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
      }
      var resultSelector = void 0;
      var scheduler = void 0;
      if (isScheduler_1.isScheduler(observables[observables.length - 1])) {
        scheduler = observables.pop();
      }
      if (typeof observables[observables.length - 1] === "function") {
        resultSelector = observables.pop();
      }
      if (observables.length === 1 && isArray_1.isArray(observables[0])) {
        observables = observables[0];
      }
      return fromArray_1.fromArray(observables, scheduler).lift(new CombineLatestOperator(resultSelector));
    }
    exports.combineLatest = combineLatest;
    var CombineLatestOperator = function() {
      function CombineLatestOperator2(resultSelector) {
        this.resultSelector = resultSelector;
      }
      CombineLatestOperator2.prototype.call = function(subscriber, source) {
        return source.subscribe(new CombineLatestSubscriber(subscriber, this.resultSelector));
      };
      return CombineLatestOperator2;
    }();
    exports.CombineLatestOperator = CombineLatestOperator;
    var CombineLatestSubscriber = function(_super) {
      __extends12(CombineLatestSubscriber2, _super);
      function CombineLatestSubscriber2(destination, resultSelector) {
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.active = 0;
        _this.values = [];
        _this.observables = [];
        return _this;
      }
      CombineLatestSubscriber2.prototype._next = function(observable2) {
        this.values.push(NONE);
        this.observables.push(observable2);
      };
      CombineLatestSubscriber2.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
          this.destination.complete();
        } else {
          this.active = len;
          this.toRespond = len;
          for (var i = 0; i < len; i++) {
            var observable2 = observables[i];
            this.add(subscribeToResult_1.subscribeToResult(this, observable2, void 0, i));
          }
        }
      };
      CombineLatestSubscriber2.prototype.notifyComplete = function(unused) {
        if ((this.active -= 1) === 0) {
          this.destination.complete();
        }
      };
      CombineLatestSubscriber2.prototype.notifyNext = function(_outerValue, innerValue, outerIndex) {
        var values4 = this.values;
        var oldVal = values4[outerIndex];
        var toRespond = !this.toRespond ? 0 : oldVal === NONE ? --this.toRespond : this.toRespond;
        values4[outerIndex] = innerValue;
        if (toRespond === 0) {
          if (this.resultSelector) {
            this._tryResultSelector(values4);
          } else {
            this.destination.next(values4.slice());
          }
        }
      };
      CombineLatestSubscriber2.prototype._tryResultSelector = function(values4) {
        var result;
        try {
          result = this.resultSelector.apply(this, values4);
        } catch (err) {
          this.destination.error(err);
          return;
        }
        this.destination.next(result);
      };
      return CombineLatestSubscriber2;
    }(OuterSubscriber_1.OuterSubscriber);
    exports.CombineLatestSubscriber = CombineLatestSubscriber;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduled/scheduleObservable.js
var require_scheduleObservable = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduled/scheduleObservable.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var Subscription_1 = require_Subscription();
    var observable_1 = require_observable();
    function scheduleObservable2(input, scheduler) {
      return new Observable_1.Observable(function(subscriber) {
        var sub = new Subscription_1.Subscription();
        sub.add(scheduler.schedule(function() {
          var observable2 = input[observable_1.observable]();
          sub.add(observable2.subscribe({
            next: function(value) {
              sub.add(scheduler.schedule(function() {
                return subscriber.next(value);
              }));
            },
            error: function(err) {
              sub.add(scheduler.schedule(function() {
                return subscriber.error(err);
              }));
            },
            complete: function() {
              sub.add(scheduler.schedule(function() {
                return subscriber.complete();
              }));
            }
          }));
        }));
        return sub;
      });
    }
    exports.scheduleObservable = scheduleObservable2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduled/schedulePromise.js
var require_schedulePromise = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduled/schedulePromise.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var Subscription_1 = require_Subscription();
    function schedulePromise2(input, scheduler) {
      return new Observable_1.Observable(function(subscriber) {
        var sub = new Subscription_1.Subscription();
        sub.add(scheduler.schedule(function() {
          return input.then(function(value) {
            sub.add(scheduler.schedule(function() {
              subscriber.next(value);
              sub.add(scheduler.schedule(function() {
                return subscriber.complete();
              }));
            }));
          }, function(err) {
            sub.add(scheduler.schedule(function() {
              return subscriber.error(err);
            }));
          });
        }));
        return sub;
      });
    }
    exports.schedulePromise = schedulePromise2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduled/scheduleIterable.js
var require_scheduleIterable = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduled/scheduleIterable.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var Subscription_1 = require_Subscription();
    var iterator_1 = require_iterator();
    function scheduleIterable2(input, scheduler) {
      if (!input) {
        throw new Error("Iterable cannot be null");
      }
      return new Observable_1.Observable(function(subscriber) {
        var sub = new Subscription_1.Subscription();
        var iterator2;
        sub.add(function() {
          if (iterator2 && typeof iterator2.return === "function") {
            iterator2.return();
          }
        });
        sub.add(scheduler.schedule(function() {
          iterator2 = input[iterator_1.iterator]();
          sub.add(scheduler.schedule(function() {
            if (subscriber.closed) {
              return;
            }
            var value;
            var done;
            try {
              var result = iterator2.next();
              value = result.value;
              done = result.done;
            } catch (err) {
              subscriber.error(err);
              return;
            }
            if (done) {
              subscriber.complete();
            } else {
              subscriber.next(value);
              this.schedule();
            }
          }));
        }));
        return sub;
      });
    }
    exports.scheduleIterable = scheduleIterable2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/isInteropObservable.js
var require_isInteropObservable = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/isInteropObservable.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var observable_1 = require_observable();
    function isInteropObservable2(input) {
      return input && typeof input[observable_1.observable] === "function";
    }
    exports.isInteropObservable = isInteropObservable2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/isIterable.js
var require_isIterable = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/isIterable.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var iterator_1 = require_iterator();
    function isIterable2(input) {
      return input && typeof input[iterator_1.iterator] === "function";
    }
    exports.isIterable = isIterable2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduled/scheduled.js
var require_scheduled = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/scheduled/scheduled.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var scheduleObservable_1 = require_scheduleObservable();
    var schedulePromise_1 = require_schedulePromise();
    var scheduleArray_1 = require_scheduleArray();
    var scheduleIterable_1 = require_scheduleIterable();
    var isInteropObservable_1 = require_isInteropObservable();
    var isPromise_1 = require_isPromise();
    var isArrayLike_1 = require_isArrayLike();
    var isIterable_1 = require_isIterable();
    function scheduled2(input, scheduler) {
      if (input != null) {
        if (isInteropObservable_1.isInteropObservable(input)) {
          return scheduleObservable_1.scheduleObservable(input, scheduler);
        } else if (isPromise_1.isPromise(input)) {
          return schedulePromise_1.schedulePromise(input, scheduler);
        } else if (isArrayLike_1.isArrayLike(input)) {
          return scheduleArray_1.scheduleArray(input, scheduler);
        } else if (isIterable_1.isIterable(input) || typeof input === "string") {
          return scheduleIterable_1.scheduleIterable(input, scheduler);
        }
      }
      throw new TypeError((input !== null && typeof input || input) + " is not observable");
    }
    exports.scheduled = scheduled2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/from.js
var require_from = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/from.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var subscribeTo_1 = require_subscribeTo();
    var scheduled_1 = require_scheduled();
    function from5(input, scheduler) {
      if (!scheduler) {
        if (input instanceof Observable_1.Observable) {
          return input;
        }
        return new Observable_1.Observable(subscribeTo_1.subscribeTo(input));
      } else {
        return scheduled_1.scheduled(input, scheduler);
      }
    }
    exports.from = from5;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/innerSubscribe.js
var require_innerSubscribe = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/innerSubscribe.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var Subscriber_1 = require_Subscriber();
    var Observable_1 = require_Observable();
    var subscribeTo_1 = require_subscribeTo();
    var SimpleInnerSubscriber2 = function(_super) {
      __extends12(SimpleInnerSubscriber3, _super);
      function SimpleInnerSubscriber3(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        return _this;
      }
      SimpleInnerSubscriber3.prototype._next = function(value) {
        this.parent.notifyNext(value);
      };
      SimpleInnerSubscriber3.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
      };
      SimpleInnerSubscriber3.prototype._complete = function() {
        this.parent.notifyComplete();
        this.unsubscribe();
      };
      return SimpleInnerSubscriber3;
    }(Subscriber_1.Subscriber);
    exports.SimpleInnerSubscriber = SimpleInnerSubscriber2;
    var ComplexInnerSubscriber = function(_super) {
      __extends12(ComplexInnerSubscriber2, _super);
      function ComplexInnerSubscriber2(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        return _this;
      }
      ComplexInnerSubscriber2.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this);
      };
      ComplexInnerSubscriber2.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
      };
      ComplexInnerSubscriber2.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
      };
      return ComplexInnerSubscriber2;
    }(Subscriber_1.Subscriber);
    exports.ComplexInnerSubscriber = ComplexInnerSubscriber;
    var SimpleOuterSubscriber2 = function(_super) {
      __extends12(SimpleOuterSubscriber3, _super);
      function SimpleOuterSubscriber3() {
        return _super !== null && _super.apply(this, arguments) || this;
      }
      SimpleOuterSubscriber3.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
      };
      SimpleOuterSubscriber3.prototype.notifyError = function(err) {
        this.destination.error(err);
      };
      SimpleOuterSubscriber3.prototype.notifyComplete = function() {
        this.destination.complete();
      };
      return SimpleOuterSubscriber3;
    }(Subscriber_1.Subscriber);
    exports.SimpleOuterSubscriber = SimpleOuterSubscriber2;
    var ComplexOuterSubscriber = function(_super) {
      __extends12(ComplexOuterSubscriber2, _super);
      function ComplexOuterSubscriber2() {
        return _super !== null && _super.apply(this, arguments) || this;
      }
      ComplexOuterSubscriber2.prototype.notifyNext = function(_outerValue, innerValue, _outerIndex, _innerSub) {
        this.destination.next(innerValue);
      };
      ComplexOuterSubscriber2.prototype.notifyError = function(error) {
        this.destination.error(error);
      };
      ComplexOuterSubscriber2.prototype.notifyComplete = function(_innerSub) {
        this.destination.complete();
      };
      return ComplexOuterSubscriber2;
    }(Subscriber_1.Subscriber);
    exports.ComplexOuterSubscriber = ComplexOuterSubscriber;
    function innerSubscribe2(result, innerSubscriber) {
      if (innerSubscriber.closed) {
        return void 0;
      }
      if (result instanceof Observable_1.Observable) {
        return result.subscribe(innerSubscriber);
      }
      var subscription;
      try {
        subscription = subscribeTo_1.subscribeTo(result)(innerSubscriber);
      } catch (error) {
        innerSubscriber.error(error);
      }
      return subscription;
    }
    exports.innerSubscribe = innerSubscribe2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/operators/mergeMap.js
var require_mergeMap = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/operators/mergeMap.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var map_1 = require_map();
    var from_1 = require_from();
    var innerSubscribe_1 = require_innerSubscribe();
    function mergeMap2(project, resultSelector, concurrent) {
      if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
      }
      if (typeof resultSelector === "function") {
        return function(source) {
          return source.pipe(mergeMap2(function(a, i) {
            return from_1.from(project(a, i)).pipe(map_1.map(function(b, ii) {
              return resultSelector(a, b, i, ii);
            }));
          }, concurrent));
        };
      } else if (typeof resultSelector === "number") {
        concurrent = resultSelector;
      }
      return function(source) {
        return source.lift(new MergeMapOperator2(project, concurrent));
      };
    }
    exports.mergeMap = mergeMap2;
    var MergeMapOperator2 = function() {
      function MergeMapOperator3(project, concurrent) {
        if (concurrent === void 0) {
          concurrent = Number.POSITIVE_INFINITY;
        }
        this.project = project;
        this.concurrent = concurrent;
      }
      MergeMapOperator3.prototype.call = function(observer, source) {
        return source.subscribe(new MergeMapSubscriber2(observer, this.project, this.concurrent));
      };
      return MergeMapOperator3;
    }();
    exports.MergeMapOperator = MergeMapOperator2;
    var MergeMapSubscriber2 = function(_super) {
      __extends12(MergeMapSubscriber3, _super);
      function MergeMapSubscriber3(destination, project, concurrent) {
        if (concurrent === void 0) {
          concurrent = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
      }
      MergeMapSubscriber3.prototype._next = function(value) {
        if (this.active < this.concurrent) {
          this._tryNext(value);
        } else {
          this.buffer.push(value);
        }
      };
      MergeMapSubscriber3.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
          result = this.project(value, index);
        } catch (err) {
          this.destination.error(err);
          return;
        }
        this.active++;
        this._innerSub(result);
      };
      MergeMapSubscriber3.prototype._innerSub = function(ish) {
        var innerSubscriber = new innerSubscribe_1.SimpleInnerSubscriber(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = innerSubscribe_1.innerSubscribe(ish, innerSubscriber);
        if (innerSubscription !== innerSubscriber) {
          destination.add(innerSubscription);
        }
      };
      MergeMapSubscriber3.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
          this.destination.complete();
        }
        this.unsubscribe();
      };
      MergeMapSubscriber3.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
      };
      MergeMapSubscriber3.prototype.notifyComplete = function() {
        var buffer = this.buffer;
        this.active--;
        if (buffer.length > 0) {
          this._next(buffer.shift());
        } else if (this.active === 0 && this.hasCompleted) {
          this.destination.complete();
        }
      };
      return MergeMapSubscriber3;
    }(innerSubscribe_1.SimpleOuterSubscriber);
    exports.MergeMapSubscriber = MergeMapSubscriber2;
    exports.flatMap = mergeMap2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/operators/mergeAll.js
var require_mergeAll = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/operators/mergeAll.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var mergeMap_1 = require_mergeMap();
    var identity_1 = require_identity();
    function mergeAll(concurrent) {
      if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
      }
      return mergeMap_1.mergeMap(identity_1.identity, concurrent);
    }
    exports.mergeAll = mergeAll;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/operators/concatAll.js
var require_concatAll = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/operators/concatAll.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var mergeAll_1 = require_mergeAll();
    function concatAll() {
      return mergeAll_1.mergeAll(1);
    }
    exports.concatAll = concatAll;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/concat.js
var require_concat = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/concat.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var of_1 = require_of();
    var concatAll_1 = require_concatAll();
    function concat() {
      var observables = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
      }
      return concatAll_1.concatAll()(of_1.of.apply(void 0, observables));
    }
    exports.concat = concat;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/defer.js
var require_defer = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/defer.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var from_1 = require_from();
    var empty_1 = require_empty();
    function defer(observableFactory) {
      return new Observable_1.Observable(function(subscriber) {
        var input;
        try {
          input = observableFactory();
        } catch (err) {
          subscriber.error(err);
          return void 0;
        }
        var source = input ? from_1.from(input) : empty_1.empty();
        return source.subscribe(subscriber);
      });
    }
    exports.defer = defer;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/forkJoin.js
var require_forkJoin = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/forkJoin.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var isArray_1 = require_isArray();
    var map_1 = require_map();
    var isObject_1 = require_isObject();
    var from_1 = require_from();
    function forkJoin3() {
      var sources = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
      }
      if (sources.length === 1) {
        var first_1 = sources[0];
        if (isArray_1.isArray(first_1)) {
          return forkJoinInternal(first_1, null);
        }
        if (isObject_1.isObject(first_1) && Object.getPrototypeOf(first_1) === Object.prototype) {
          var keys4 = Object.keys(first_1);
          return forkJoinInternal(keys4.map(function(key) {
            return first_1[key];
          }), keys4);
        }
      }
      if (typeof sources[sources.length - 1] === "function") {
        var resultSelector_1 = sources.pop();
        sources = sources.length === 1 && isArray_1.isArray(sources[0]) ? sources[0] : sources;
        return forkJoinInternal(sources, null).pipe(map_1.map(function(args) {
          return resultSelector_1.apply(void 0, args);
        }));
      }
      return forkJoinInternal(sources, null);
    }
    exports.forkJoin = forkJoin3;
    function forkJoinInternal(sources, keys4) {
      return new Observable_1.Observable(function(subscriber) {
        var len = sources.length;
        if (len === 0) {
          subscriber.complete();
          return;
        }
        var values4 = new Array(len);
        var completed = 0;
        var emitted = 0;
        var _loop_1 = function(i2) {
          var source = from_1.from(sources[i2]);
          var hasValue = false;
          subscriber.add(source.subscribe({
            next: function(value) {
              if (!hasValue) {
                hasValue = true;
                emitted++;
              }
              values4[i2] = value;
            },
            error: function(err) {
              return subscriber.error(err);
            },
            complete: function() {
              completed++;
              if (completed === len || !hasValue) {
                if (emitted === len) {
                  subscriber.next(keys4 ? keys4.reduce(function(result, key, i3) {
                    return result[key] = values4[i3], result;
                  }, {}) : values4);
                }
                subscriber.complete();
              }
            }
          }));
        };
        for (var i = 0; i < len; i++) {
          _loop_1(i);
        }
      });
    }
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/fromEvent.js
var require_fromEvent = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/fromEvent.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var isArray_1 = require_isArray();
    var isFunction_1 = require_isFunction();
    var map_1 = require_map();
    var toString = function() {
      return Object.prototype.toString;
    }();
    function fromEvent(target, eventName, options, resultSelector) {
      if (isFunction_1.isFunction(options)) {
        resultSelector = options;
        options = void 0;
      }
      if (resultSelector) {
        return fromEvent(target, eventName, options).pipe(map_1.map(function(args) {
          return isArray_1.isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args);
        }));
      }
      return new Observable_1.Observable(function(subscriber) {
        function handler(e) {
          if (arguments.length > 1) {
            subscriber.next(Array.prototype.slice.call(arguments));
          } else {
            subscriber.next(e);
          }
        }
        setupSubscription(target, eventName, handler, subscriber, options);
      });
    }
    exports.fromEvent = fromEvent;
    function setupSubscription(sourceObj, eventName, handler, subscriber, options) {
      var unsubscribe;
      if (isEventTarget(sourceObj)) {
        var source_1 = sourceObj;
        sourceObj.addEventListener(eventName, handler, options);
        unsubscribe = function() {
          return source_1.removeEventListener(eventName, handler, options);
        };
      } else if (isJQueryStyleEventEmitter(sourceObj)) {
        var source_2 = sourceObj;
        sourceObj.on(eventName, handler);
        unsubscribe = function() {
          return source_2.off(eventName, handler);
        };
      } else if (isNodeStyleEventEmitter(sourceObj)) {
        var source_3 = sourceObj;
        sourceObj.addListener(eventName, handler);
        unsubscribe = function() {
          return source_3.removeListener(eventName, handler);
        };
      } else if (sourceObj && sourceObj.length) {
        for (var i = 0, len = sourceObj.length; i < len; i++) {
          setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
        }
      } else {
        throw new TypeError("Invalid event target");
      }
      subscriber.add(unsubscribe);
    }
    function isNodeStyleEventEmitter(sourceObj) {
      return sourceObj && typeof sourceObj.addListener === "function" && typeof sourceObj.removeListener === "function";
    }
    function isJQueryStyleEventEmitter(sourceObj) {
      return sourceObj && typeof sourceObj.on === "function" && typeof sourceObj.off === "function";
    }
    function isEventTarget(sourceObj) {
      return sourceObj && typeof sourceObj.addEventListener === "function" && typeof sourceObj.removeEventListener === "function";
    }
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/fromEventPattern.js
var require_fromEventPattern = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/fromEventPattern.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var isArray_1 = require_isArray();
    var isFunction_1 = require_isFunction();
    var map_1 = require_map();
    function fromEventPattern(addHandler, removeHandler, resultSelector) {
      if (resultSelector) {
        return fromEventPattern(addHandler, removeHandler).pipe(map_1.map(function(args) {
          return isArray_1.isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args);
        }));
      }
      return new Observable_1.Observable(function(subscriber) {
        var handler = function() {
          var e = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            e[_i] = arguments[_i];
          }
          return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue;
        try {
          retValue = addHandler(handler);
        } catch (err) {
          subscriber.error(err);
          return void 0;
        }
        if (!isFunction_1.isFunction(removeHandler)) {
          return void 0;
        }
        return function() {
          return removeHandler(handler, retValue);
        };
      });
    }
    exports.fromEventPattern = fromEventPattern;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/generate.js
var require_generate = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/generate.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var identity_1 = require_identity();
    var isScheduler_1 = require_isScheduler();
    function generate(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
      var resultSelector;
      var initialState2;
      if (arguments.length == 1) {
        var options = initialStateOrOptions;
        initialState2 = options.initialState;
        condition = options.condition;
        iterate = options.iterate;
        resultSelector = options.resultSelector || identity_1.identity;
        scheduler = options.scheduler;
      } else if (resultSelectorOrObservable === void 0 || isScheduler_1.isScheduler(resultSelectorOrObservable)) {
        initialState2 = initialStateOrOptions;
        resultSelector = identity_1.identity;
        scheduler = resultSelectorOrObservable;
      } else {
        initialState2 = initialStateOrOptions;
        resultSelector = resultSelectorOrObservable;
      }
      return new Observable_1.Observable(function(subscriber) {
        var state = initialState2;
        if (scheduler) {
          return scheduler.schedule(dispatch, 0, {
            subscriber,
            iterate,
            condition,
            resultSelector,
            state
          });
        }
        do {
          if (condition) {
            var conditionResult = void 0;
            try {
              conditionResult = condition(state);
            } catch (err) {
              subscriber.error(err);
              return void 0;
            }
            if (!conditionResult) {
              subscriber.complete();
              break;
            }
          }
          var value = void 0;
          try {
            value = resultSelector(state);
          } catch (err) {
            subscriber.error(err);
            return void 0;
          }
          subscriber.next(value);
          if (subscriber.closed) {
            break;
          }
          try {
            state = iterate(state);
          } catch (err) {
            subscriber.error(err);
            return void 0;
          }
        } while (true);
        return void 0;
      });
    }
    exports.generate = generate;
    function dispatch(state) {
      var subscriber = state.subscriber, condition = state.condition;
      if (subscriber.closed) {
        return void 0;
      }
      if (state.needIterate) {
        try {
          state.state = state.iterate(state.state);
        } catch (err) {
          subscriber.error(err);
          return void 0;
        }
      } else {
        state.needIterate = true;
      }
      if (condition) {
        var conditionResult = void 0;
        try {
          conditionResult = condition(state.state);
        } catch (err) {
          subscriber.error(err);
          return void 0;
        }
        if (!conditionResult) {
          subscriber.complete();
          return void 0;
        }
        if (subscriber.closed) {
          return void 0;
        }
      }
      var value;
      try {
        value = state.resultSelector(state.state);
      } catch (err) {
        subscriber.error(err);
        return void 0;
      }
      if (subscriber.closed) {
        return void 0;
      }
      subscriber.next(value);
      if (subscriber.closed) {
        return void 0;
      }
      return this.schedule(state);
    }
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/iif.js
var require_iif = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/iif.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var defer_1 = require_defer();
    var empty_1 = require_empty();
    function iif(condition, trueResult, falseResult) {
      if (trueResult === void 0) {
        trueResult = empty_1.EMPTY;
      }
      if (falseResult === void 0) {
        falseResult = empty_1.EMPTY;
      }
      return defer_1.defer(function() {
        return condition() ? trueResult : falseResult;
      });
    }
    exports.iif = iif;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/isNumeric.js
var require_isNumeric = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/isNumeric.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var isArray_1 = require_isArray();
    function isNumeric(val) {
      return !isArray_1.isArray(val) && val - parseFloat(val) + 1 >= 0;
    }
    exports.isNumeric = isNumeric;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/interval.js
var require_interval = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/interval.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var async_1 = require_async();
    var isNumeric_1 = require_isNumeric();
    function interval(period, scheduler) {
      if (period === void 0) {
        period = 0;
      }
      if (scheduler === void 0) {
        scheduler = async_1.async;
      }
      if (!isNumeric_1.isNumeric(period) || period < 0) {
        period = 0;
      }
      if (!scheduler || typeof scheduler.schedule !== "function") {
        scheduler = async_1.async;
      }
      return new Observable_1.Observable(function(subscriber) {
        subscriber.add(scheduler.schedule(dispatch, period, { subscriber, counter: 0, period }));
        return subscriber;
      });
    }
    exports.interval = interval;
    function dispatch(state) {
      var subscriber = state.subscriber, counter = state.counter, period = state.period;
      subscriber.next(counter);
      this.schedule({ subscriber, counter: counter + 1, period }, period);
    }
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/merge.js
var require_merge = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/merge.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var isScheduler_1 = require_isScheduler();
    var mergeAll_1 = require_mergeAll();
    var fromArray_1 = require_fromArray();
    function merge() {
      var observables = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
      }
      var concurrent = Number.POSITIVE_INFINITY;
      var scheduler = null;
      var last2 = observables[observables.length - 1];
      if (isScheduler_1.isScheduler(last2)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === "number") {
          concurrent = observables.pop();
        }
      } else if (typeof last2 === "number") {
        concurrent = observables.pop();
      }
      if (scheduler === null && observables.length === 1 && observables[0] instanceof Observable_1.Observable) {
        return observables[0];
      }
      return mergeAll_1.mergeAll(concurrent)(fromArray_1.fromArray(observables, scheduler));
    }
    exports.merge = merge;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/never.js
var require_never = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/never.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var noop_1 = require_noop();
    exports.NEVER = new Observable_1.Observable(noop_1.noop);
    function never() {
      return exports.NEVER;
    }
    exports.never = never;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/onErrorResumeNext.js
var require_onErrorResumeNext = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/onErrorResumeNext.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var from_1 = require_from();
    var isArray_1 = require_isArray();
    var empty_1 = require_empty();
    function onErrorResumeNext() {
      var sources = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
      }
      if (sources.length === 0) {
        return empty_1.EMPTY;
      }
      var first3 = sources[0], remainder = sources.slice(1);
      if (sources.length === 1 && isArray_1.isArray(first3)) {
        return onErrorResumeNext.apply(void 0, first3);
      }
      return new Observable_1.Observable(function(subscriber) {
        var subNext = function() {
          return subscriber.add(onErrorResumeNext.apply(void 0, remainder).subscribe(subscriber));
        };
        return from_1.from(first3).subscribe({
          next: function(value) {
            subscriber.next(value);
          },
          error: subNext,
          complete: subNext
        });
      });
    }
    exports.onErrorResumeNext = onErrorResumeNext;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/pairs.js
var require_pairs = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/pairs.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var Subscription_1 = require_Subscription();
    function pairs(obj, scheduler) {
      if (!scheduler) {
        return new Observable_1.Observable(function(subscriber) {
          var keys4 = Object.keys(obj);
          for (var i = 0; i < keys4.length && !subscriber.closed; i++) {
            var key = keys4[i];
            if (obj.hasOwnProperty(key)) {
              subscriber.next([key, obj[key]]);
            }
          }
          subscriber.complete();
        });
      } else {
        return new Observable_1.Observable(function(subscriber) {
          var keys4 = Object.keys(obj);
          var subscription = new Subscription_1.Subscription();
          subscription.add(scheduler.schedule(dispatch, 0, { keys: keys4, index: 0, subscriber, subscription, obj }));
          return subscription;
        });
      }
    }
    exports.pairs = pairs;
    function dispatch(state) {
      var keys4 = state.keys, index = state.index, subscriber = state.subscriber, subscription = state.subscription, obj = state.obj;
      if (!subscriber.closed) {
        if (index < keys4.length) {
          var key = keys4[index];
          subscriber.next([key, obj[key]]);
          subscription.add(this.schedule({ keys: keys4, index: index + 1, subscriber, subscription, obj }));
        } else {
          subscriber.complete();
        }
      }
    }
    exports.dispatch = dispatch;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/not.js
var require_not = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/util/not.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function not(pred, thisArg) {
      function notPred() {
        return !notPred.pred.apply(notPred.thisArg, arguments);
      }
      notPred.pred = pred;
      notPred.thisArg = thisArg;
      return notPred;
    }
    exports.not = not;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/operators/filter.js
var require_filter = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/operators/filter.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var Subscriber_1 = require_Subscriber();
    function filter10(predicate, thisArg) {
      return function filterOperatorFunction(source) {
        return source.lift(new FilterOperator(predicate, thisArg));
      };
    }
    exports.filter = filter10;
    var FilterOperator = function() {
      function FilterOperator2(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
      }
      FilterOperator2.prototype.call = function(subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
      };
      return FilterOperator2;
    }();
    var FilterSubscriber = function(_super) {
      __extends12(FilterSubscriber2, _super);
      function FilterSubscriber2(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
      }
      FilterSubscriber2.prototype._next = function(value) {
        var result;
        try {
          result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
          this.destination.error(err);
          return;
        }
        if (result) {
          this.destination.next(value);
        }
      };
      return FilterSubscriber2;
    }(Subscriber_1.Subscriber);
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/partition.js
var require_partition = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/partition.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var not_1 = require_not();
    var subscribeTo_1 = require_subscribeTo();
    var filter_1 = require_filter();
    var Observable_1 = require_Observable();
    function partition2(source, predicate, thisArg) {
      return [
        filter_1.filter(predicate, thisArg)(new Observable_1.Observable(subscribeTo_1.subscribeTo(source))),
        filter_1.filter(not_1.not(predicate, thisArg))(new Observable_1.Observable(subscribeTo_1.subscribeTo(source)))
      ];
    }
    exports.partition = partition2;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/race.js
var require_race = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/race.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var isArray_1 = require_isArray();
    var fromArray_1 = require_fromArray();
    var OuterSubscriber_1 = require_OuterSubscriber();
    var subscribeToResult_1 = require_subscribeToResult();
    function race() {
      var observables = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
      }
      if (observables.length === 1) {
        if (isArray_1.isArray(observables[0])) {
          observables = observables[0];
        } else {
          return observables[0];
        }
      }
      return fromArray_1.fromArray(observables, void 0).lift(new RaceOperator());
    }
    exports.race = race;
    var RaceOperator = function() {
      function RaceOperator2() {
      }
      RaceOperator2.prototype.call = function(subscriber, source) {
        return source.subscribe(new RaceSubscriber(subscriber));
      };
      return RaceOperator2;
    }();
    exports.RaceOperator = RaceOperator;
    var RaceSubscriber = function(_super) {
      __extends12(RaceSubscriber2, _super);
      function RaceSubscriber2(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasFirst = false;
        _this.observables = [];
        _this.subscriptions = [];
        return _this;
      }
      RaceSubscriber2.prototype._next = function(observable2) {
        this.observables.push(observable2);
      };
      RaceSubscriber2.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
          this.destination.complete();
        } else {
          for (var i = 0; i < len && !this.hasFirst; i++) {
            var observable2 = observables[i];
            var subscription = subscribeToResult_1.subscribeToResult(this, observable2, void 0, i);
            if (this.subscriptions) {
              this.subscriptions.push(subscription);
            }
            this.add(subscription);
          }
          this.observables = null;
        }
      };
      RaceSubscriber2.prototype.notifyNext = function(_outerValue, innerValue, outerIndex) {
        if (!this.hasFirst) {
          this.hasFirst = true;
          for (var i = 0; i < this.subscriptions.length; i++) {
            if (i !== outerIndex) {
              var subscription = this.subscriptions[i];
              subscription.unsubscribe();
              this.remove(subscription);
            }
          }
          this.subscriptions = null;
        }
        this.destination.next(innerValue);
      };
      return RaceSubscriber2;
    }(OuterSubscriber_1.OuterSubscriber);
    exports.RaceSubscriber = RaceSubscriber;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/range.js
var require_range2 = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/range.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    function range(start, count, scheduler) {
      if (start === void 0) {
        start = 0;
      }
      return new Observable_1.Observable(function(subscriber) {
        if (count === void 0) {
          count = start;
          start = 0;
        }
        var index = 0;
        var current = start;
        if (scheduler) {
          return scheduler.schedule(dispatch, 0, {
            index,
            count,
            start,
            subscriber
          });
        } else {
          do {
            if (index++ >= count) {
              subscriber.complete();
              break;
            }
            subscriber.next(current++);
            if (subscriber.closed) {
              break;
            }
          } while (true);
        }
        return void 0;
      });
    }
    exports.range = range;
    function dispatch(state) {
      var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
      if (index >= count) {
        subscriber.complete();
        return;
      }
      subscriber.next(start);
      if (subscriber.closed) {
        return;
      }
      state.index = index + 1;
      state.start = start + 1;
      this.schedule(state);
    }
    exports.dispatch = dispatch;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/timer.js
var require_timer = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/timer.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var async_1 = require_async();
    var isNumeric_1 = require_isNumeric();
    var isScheduler_1 = require_isScheduler();
    function timer(dueTime, periodOrScheduler, scheduler) {
      if (dueTime === void 0) {
        dueTime = 0;
      }
      var period = -1;
      if (isNumeric_1.isNumeric(periodOrScheduler)) {
        period = Number(periodOrScheduler) < 1 && 1 || Number(periodOrScheduler);
      } else if (isScheduler_1.isScheduler(periodOrScheduler)) {
        scheduler = periodOrScheduler;
      }
      if (!isScheduler_1.isScheduler(scheduler)) {
        scheduler = async_1.async;
      }
      return new Observable_1.Observable(function(subscriber) {
        var due = isNumeric_1.isNumeric(dueTime) ? dueTime : +dueTime - scheduler.now();
        return scheduler.schedule(dispatch, due, {
          index: 0,
          period,
          subscriber
        });
      });
    }
    exports.timer = timer;
    function dispatch(state) {
      var index = state.index, period = state.period, subscriber = state.subscriber;
      subscriber.next(index);
      if (subscriber.closed) {
        return;
      } else if (period === -1) {
        return subscriber.complete();
      }
      state.index = index + 1;
      this.schedule(state, period);
    }
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/using.js
var require_using = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/using.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    var from_1 = require_from();
    var empty_1 = require_empty();
    function using(resourceFactory, observableFactory) {
      return new Observable_1.Observable(function(subscriber) {
        var resource;
        try {
          resource = resourceFactory();
        } catch (err) {
          subscriber.error(err);
          return void 0;
        }
        var result;
        try {
          result = observableFactory(resource);
        } catch (err) {
          subscriber.error(err);
          return void 0;
        }
        var source = result ? from_1.from(result) : empty_1.EMPTY;
        var subscription = source.subscribe(subscriber);
        return function() {
          subscription.unsubscribe();
          if (resource) {
            resource.unsubscribe();
          }
        };
      });
    }
    exports.using = using;
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/zip.js
var require_zip = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/internal/observable/zip.js"(exports) {
    "use strict";
    var __extends12 = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    var fromArray_1 = require_fromArray();
    var isArray_1 = require_isArray();
    var Subscriber_1 = require_Subscriber();
    var iterator_1 = require_iterator();
    var innerSubscribe_1 = require_innerSubscribe();
    function zip() {
      var observables = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
      }
      var resultSelector = observables[observables.length - 1];
      if (typeof resultSelector === "function") {
        observables.pop();
      }
      return fromArray_1.fromArray(observables, void 0).lift(new ZipOperator(resultSelector));
    }
    exports.zip = zip;
    var ZipOperator = function() {
      function ZipOperator2(resultSelector) {
        this.resultSelector = resultSelector;
      }
      ZipOperator2.prototype.call = function(subscriber, source) {
        return source.subscribe(new ZipSubscriber(subscriber, this.resultSelector));
      };
      return ZipOperator2;
    }();
    exports.ZipOperator = ZipOperator;
    var ZipSubscriber = function(_super) {
      __extends12(ZipSubscriber2, _super);
      function ZipSubscriber2(destination, resultSelector, values4) {
        if (values4 === void 0) {
          values4 = /* @__PURE__ */ Object.create(null);
        }
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.iterators = [];
        _this.active = 0;
        _this.resultSelector = typeof resultSelector === "function" ? resultSelector : void 0;
        return _this;
      }
      ZipSubscriber2.prototype._next = function(value) {
        var iterators = this.iterators;
        if (isArray_1.isArray(value)) {
          iterators.push(new StaticArrayIterator(value));
        } else if (typeof value[iterator_1.iterator] === "function") {
          iterators.push(new StaticIterator(value[iterator_1.iterator]()));
        } else {
          iterators.push(new ZipBufferIterator(this.destination, this, value));
        }
      };
      ZipSubscriber2.prototype._complete = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        this.unsubscribe();
        if (len === 0) {
          this.destination.complete();
          return;
        }
        this.active = len;
        for (var i = 0; i < len; i++) {
          var iterator2 = iterators[i];
          if (iterator2.stillUnsubscribed) {
            var destination = this.destination;
            destination.add(iterator2.subscribe());
          } else {
            this.active--;
          }
        }
      };
      ZipSubscriber2.prototype.notifyInactive = function() {
        this.active--;
        if (this.active === 0) {
          this.destination.complete();
        }
      };
      ZipSubscriber2.prototype.checkIterators = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        for (var i = 0; i < len; i++) {
          var iterator2 = iterators[i];
          if (typeof iterator2.hasValue === "function" && !iterator2.hasValue()) {
            return;
          }
        }
        var shouldComplete = false;
        var args = [];
        for (var i = 0; i < len; i++) {
          var iterator2 = iterators[i];
          var result = iterator2.next();
          if (iterator2.hasCompleted()) {
            shouldComplete = true;
          }
          if (result.done) {
            destination.complete();
            return;
          }
          args.push(result.value);
        }
        if (this.resultSelector) {
          this._tryresultSelector(args);
        } else {
          destination.next(args);
        }
        if (shouldComplete) {
          destination.complete();
        }
      };
      ZipSubscriber2.prototype._tryresultSelector = function(args) {
        var result;
        try {
          result = this.resultSelector.apply(this, args);
        } catch (err) {
          this.destination.error(err);
          return;
        }
        this.destination.next(result);
      };
      return ZipSubscriber2;
    }(Subscriber_1.Subscriber);
    exports.ZipSubscriber = ZipSubscriber;
    var StaticIterator = function() {
      function StaticIterator2(iterator2) {
        this.iterator = iterator2;
        this.nextResult = iterator2.next();
      }
      StaticIterator2.prototype.hasValue = function() {
        return true;
      };
      StaticIterator2.prototype.next = function() {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
      };
      StaticIterator2.prototype.hasCompleted = function() {
        var nextResult = this.nextResult;
        return Boolean(nextResult && nextResult.done);
      };
      return StaticIterator2;
    }();
    var StaticArrayIterator = function() {
      function StaticArrayIterator2(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
      }
      StaticArrayIterator2.prototype[iterator_1.iterator] = function() {
        return this;
      };
      StaticArrayIterator2.prototype.next = function(value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
      };
      StaticArrayIterator2.prototype.hasValue = function() {
        return this.array.length > this.index;
      };
      StaticArrayIterator2.prototype.hasCompleted = function() {
        return this.array.length === this.index;
      };
      return StaticArrayIterator2;
    }();
    var ZipBufferIterator = function(_super) {
      __extends12(ZipBufferIterator2, _super);
      function ZipBufferIterator2(destination, parent, observable2) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        _this.observable = observable2;
        _this.stillUnsubscribed = true;
        _this.buffer = [];
        _this.isComplete = false;
        return _this;
      }
      ZipBufferIterator2.prototype[iterator_1.iterator] = function() {
        return this;
      };
      ZipBufferIterator2.prototype.next = function() {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) {
          return { value: null, done: true };
        } else {
          return { value: buffer.shift(), done: false };
        }
      };
      ZipBufferIterator2.prototype.hasValue = function() {
        return this.buffer.length > 0;
      };
      ZipBufferIterator2.prototype.hasCompleted = function() {
        return this.buffer.length === 0 && this.isComplete;
      };
      ZipBufferIterator2.prototype.notifyComplete = function() {
        if (this.buffer.length > 0) {
          this.isComplete = true;
          this.parent.notifyInactive();
        } else {
          this.destination.complete();
        }
      };
      ZipBufferIterator2.prototype.notifyNext = function(innerValue) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
      };
      ZipBufferIterator2.prototype.subscribe = function() {
        return innerSubscribe_1.innerSubscribe(this.observable, new innerSubscribe_1.SimpleInnerSubscriber(this));
      };
      return ZipBufferIterator2;
    }(innerSubscribe_1.SimpleOuterSubscriber);
  }
});

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/index.js
var require_rxjs = __commonJS({
  "../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Observable_1 = require_Observable();
    exports.Observable = Observable_1.Observable;
    var ConnectableObservable_1 = require_ConnectableObservable();
    exports.ConnectableObservable = ConnectableObservable_1.ConnectableObservable;
    var groupBy_1 = require_groupBy();
    exports.GroupedObservable = groupBy_1.GroupedObservable;
    var observable_1 = require_observable();
    exports.observable = observable_1.observable;
    var Subject_1 = require_Subject();
    exports.Subject = Subject_1.Subject;
    var BehaviorSubject_1 = require_BehaviorSubject();
    exports.BehaviorSubject = BehaviorSubject_1.BehaviorSubject;
    var ReplaySubject_1 = require_ReplaySubject();
    exports.ReplaySubject = ReplaySubject_1.ReplaySubject;
    var AsyncSubject_1 = require_AsyncSubject();
    exports.AsyncSubject = AsyncSubject_1.AsyncSubject;
    var asap_1 = require_asap();
    exports.asap = asap_1.asap;
    exports.asapScheduler = asap_1.asapScheduler;
    var async_1 = require_async();
    exports.async = async_1.async;
    exports.asyncScheduler = async_1.asyncScheduler;
    var queue_1 = require_queue();
    exports.queue = queue_1.queue;
    exports.queueScheduler = queue_1.queueScheduler;
    var animationFrame_1 = require_animationFrame();
    exports.animationFrame = animationFrame_1.animationFrame;
    exports.animationFrameScheduler = animationFrame_1.animationFrameScheduler;
    var VirtualTimeScheduler_1 = require_VirtualTimeScheduler();
    exports.VirtualTimeScheduler = VirtualTimeScheduler_1.VirtualTimeScheduler;
    exports.VirtualAction = VirtualTimeScheduler_1.VirtualAction;
    var Scheduler_1 = require_Scheduler();
    exports.Scheduler = Scheduler_1.Scheduler;
    var Subscription_1 = require_Subscription();
    exports.Subscription = Subscription_1.Subscription;
    var Subscriber_1 = require_Subscriber();
    exports.Subscriber = Subscriber_1.Subscriber;
    var Notification_1 = require_Notification();
    exports.Notification = Notification_1.Notification;
    exports.NotificationKind = Notification_1.NotificationKind;
    var pipe_1 = require_pipe();
    exports.pipe = pipe_1.pipe;
    var noop_1 = require_noop();
    exports.noop = noop_1.noop;
    var identity_1 = require_identity();
    exports.identity = identity_1.identity;
    var isObservable_1 = require_isObservable();
    exports.isObservable = isObservable_1.isObservable;
    var ArgumentOutOfRangeError_1 = require_ArgumentOutOfRangeError();
    exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
    var EmptyError_1 = require_EmptyError();
    exports.EmptyError = EmptyError_1.EmptyError;
    var ObjectUnsubscribedError_1 = require_ObjectUnsubscribedError();
    exports.ObjectUnsubscribedError = ObjectUnsubscribedError_1.ObjectUnsubscribedError;
    var UnsubscriptionError_1 = require_UnsubscriptionError();
    exports.UnsubscriptionError = UnsubscriptionError_1.UnsubscriptionError;
    var TimeoutError_1 = require_TimeoutError();
    exports.TimeoutError = TimeoutError_1.TimeoutError;
    var bindCallback_1 = require_bindCallback();
    exports.bindCallback = bindCallback_1.bindCallback;
    var bindNodeCallback_1 = require_bindNodeCallback();
    exports.bindNodeCallback = bindNodeCallback_1.bindNodeCallback;
    var combineLatest_1 = require_combineLatest();
    exports.combineLatest = combineLatest_1.combineLatest;
    var concat_1 = require_concat();
    exports.concat = concat_1.concat;
    var defer_1 = require_defer();
    exports.defer = defer_1.defer;
    var empty_1 = require_empty();
    exports.empty = empty_1.empty;
    var forkJoin_1 = require_forkJoin();
    exports.forkJoin = forkJoin_1.forkJoin;
    var from_1 = require_from();
    exports.from = from_1.from;
    var fromEvent_1 = require_fromEvent();
    exports.fromEvent = fromEvent_1.fromEvent;
    var fromEventPattern_1 = require_fromEventPattern();
    exports.fromEventPattern = fromEventPattern_1.fromEventPattern;
    var generate_1 = require_generate();
    exports.generate = generate_1.generate;
    var iif_1 = require_iif();
    exports.iif = iif_1.iif;
    var interval_1 = require_interval();
    exports.interval = interval_1.interval;
    var merge_1 = require_merge();
    exports.merge = merge_1.merge;
    var never_1 = require_never();
    exports.never = never_1.never;
    var of_1 = require_of();
    exports.of = of_1.of;
    var onErrorResumeNext_1 = require_onErrorResumeNext();
    exports.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
    var pairs_1 = require_pairs();
    exports.pairs = pairs_1.pairs;
    var partition_1 = require_partition();
    exports.partition = partition_1.partition;
    var race_1 = require_race();
    exports.race = race_1.race;
    var range_1 = require_range2();
    exports.range = range_1.range;
    var throwError_1 = require_throwError();
    exports.throwError = throwError_1.throwError;
    var timer_1 = require_timer();
    exports.timer = timer_1.timer;
    var using_1 = require_using();
    exports.using = using_1.using;
    var zip_1 = require_zip();
    exports.zip = zip_1.zip;
    var scheduled_1 = require_scheduled();
    exports.scheduled = scheduled_1.scheduled;
    var empty_2 = require_empty();
    exports.EMPTY = empty_2.EMPTY;
    var never_2 = require_never();
    exports.NEVER = never_2.NEVER;
    var config_1 = require_config();
    exports.config = config_1.config;
  }
});

// ../../node_modules/.pnpm/axios-observable@2.0.0_axios@0.24.0+rxjs@6.6.7/node_modules/axios-observable/dist/create-observable.js
var require_create_observable = __commonJS({
  "../../node_modules/.pnpm/axios-observable@2.0.0_axios@0.24.0+rxjs@6.6.7/node_modules/axios-observable/dist/create-observable.js"(exports) {
    "use strict";
    var __importDefault = exports && exports.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.createObservable = void 0;
    var rxjs_1 = require_rxjs();
    var axios_1 = __importDefault(require_axios2());
    function createObservable(promiseFactory, ...args) {
      let config2 = args[args.length - 1];
      config2 = config2 ? Object.assign({}, config2) : {};
      args[args.length - 1] = config2;
      let cancelSource;
      const hasCancelToken = !!config2.cancelToken;
      if (hasCancelToken) {
        console.warn(`No need to use cancel token, just unsubscribe the subscription would cancel the http request automatically`);
      }
      const observable2 = new rxjs_1.Observable((subscriber) => {
        if (!hasCancelToken) {
          cancelSource = axios_1.default.CancelToken.source();
          config2.cancelToken = cancelSource.token;
        }
        promiseFactory(...args).then((response) => {
          subscriber.next(response);
          subscriber.complete();
        }).catch((error) => subscriber.error(error));
      });
      const _subscribe = observable2.subscribe.bind(observable2);
      observable2.subscribe = (...args2) => {
        const subscription = _subscribe(...args2);
        const _unsubscribe = subscription.unsubscribe.bind(subscription);
        subscription.unsubscribe = () => {
          if (cancelSource) {
            cancelSource.cancel();
          }
          _unsubscribe();
        };
        return subscription;
      };
      return observable2;
    }
    exports.createObservable = createObservable;
  }
});

// ../../node_modules/.pnpm/axios-observable@2.0.0_axios@0.24.0+rxjs@6.6.7/node_modules/axios-observable/dist/axios.js
var require_axios3 = __commonJS({
  "../../node_modules/.pnpm/axios-observable@2.0.0_axios@0.24.0+rxjs@6.6.7/node_modules/axios-observable/dist/axios.js"(exports) {
    "use strict";
    var __importDefault = exports && exports.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Axios = void 0;
    var axios_1 = __importDefault(require_axios2());
    var create_observable_1 = require_create_observable();
    var Axios2 = class {
      constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
      }
      get defaults() {
        return this.axiosInstance.defaults;
      }
      get interceptors() {
        return this.axiosInstance.interceptors;
      }
      static request(config2) {
        return (0, create_observable_1.createObservable)(axios_1.default.request, config2);
      }
      static get(url15, config2) {
        return (0, create_observable_1.createObservable)(axios_1.default.get, url15, config2);
      }
      static post(url15, data, config2) {
        return (0, create_observable_1.createObservable)(axios_1.default.post, url15, data, config2);
      }
      static put(url15, data, config2) {
        return (0, create_observable_1.createObservable)(axios_1.default.put, url15, data, config2);
      }
      static patch(url15, data, config2) {
        return (0, create_observable_1.createObservable)(axios_1.default.patch, url15, data, config2);
      }
      static delete(url15, config2) {
        return (0, create_observable_1.createObservable)(axios_1.default.delete, url15, config2);
      }
      static head(url15, config2) {
        return (0, create_observable_1.createObservable)(axios_1.default.head, url15, config2);
      }
      static create(config2) {
        return new Axios2(axios_1.default.create(config2));
      }
      request(config2) {
        return (0, create_observable_1.createObservable)(this.axiosInstance.request, config2);
      }
      get(url15, config2) {
        return (0, create_observable_1.createObservable)(this.axiosInstance.get, url15, config2);
      }
      head(url15, config2) {
        return (0, create_observable_1.createObservable)(this.axiosInstance.head, url15, config2);
      }
      post(url15, data, config2) {
        return (0, create_observable_1.createObservable)(this.axiosInstance.post, url15, data, config2);
      }
      put(url15, data, config2) {
        return (0, create_observable_1.createObservable)(this.axiosInstance.put, url15, data, config2);
      }
      patch(url15, data, config2) {
        return (0, create_observable_1.createObservable)(this.axiosInstance.patch, url15, data, config2);
      }
      delete(url15, config2) {
        return (0, create_observable_1.createObservable)(this.axiosInstance.delete, url15, config2);
      }
    };
    exports.Axios = Axios2;
    Axios2.defaults = axios_1.default.defaults;
    Axios2.interceptors = axios_1.default.interceptors;
    exports.default = Axios2;
  }
});

// ../../node_modules/.pnpm/axios-observable@2.0.0_axios@0.24.0+rxjs@6.6.7/node_modules/axios-observable/dist/index.js
var require_dist = __commonJS({
  "../../node_modules/.pnpm/axios-observable@2.0.0_axios@0.24.0+rxjs@6.6.7/node_modules/axios-observable/dist/index.js"(exports) {
    "use strict";
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __exportStar = exports && exports.__exportStar || function(m, exports2) {
      for (var p in m)
        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p))
          __createBinding(exports2, m, p);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Axios = void 0;
    __exportStar(require_axios_observable_interface(), exports);
    var axios_1 = require_axios3();
    Object.defineProperty(exports, "Axios", { enumerable: true, get: function() {
      return axios_1.Axios;
    } });
    exports.default = axios_1.Axios;
  }
});

// src/typings/account.typings.ts
import { isStringEqual } from "@ic-anywhere/ic-utils";
var AccountCoverageSortField = /* @__PURE__ */ ((AccountCoverageSortField2) => {
  AccountCoverageSortField2["Role"] = "role";
  AccountCoverageSortField2["LastName"] = "contact.lastname";
  AccountCoverageSortField2["FirstName"] = "contact.firstname";
  AccountCoverageSortField2["AccountName"] = "contact.account.name";
  AccountCoverageSortField2["ActivityCount"] = "followupCoverage.activityCount";
  return AccountCoverageSortField2;
})(AccountCoverageSortField || {});
var SgRatings = /* @__PURE__ */ ((SgRatings2) => {
  SgRatings2["BDDF"] = "BDDF";
  SgRatings2["RAROC"] = "RAROC";
  return SgRatings2;
})(SgRatings || {});
var isFund = (type) => isStringEqual(type, "Fund");
var AccountRoleEnum = /* @__PURE__ */ ((AccountRoleEnum2) => {
  AccountRoleEnum2["pcruBanker"] = "PCRU Banker";
  AccountRoleEnum2["originator"] = "Originator";
  AccountRoleEnum2["contributor"] = "Contributor";
  AccountRoleEnum2["globalPcmSales"] = "GlobalPcmSales";
  AccountRoleEnum2["localRegionalPcmSales"] = "LocalRegionalPcmSales";
  AccountRoleEnum2["DealLeader"] = "DealLeader";
  AccountRoleEnum2["coverageSupport"] = "CoverageSupport";
  AccountRoleEnum2["banker"] = "Banker";
  return AccountRoleEnum2;
})(AccountRoleEnum || {});
var ClientProfileTieringListIds = /* @__PURE__ */ ((ClientProfileTieringListIds2) => {
  ClientProfileTieringListIds2["GLBA_PCRU_Segmentation"] = "8b98e67e-8c53-4e61-8248-855767ab6a56";
  ClientProfileTieringListIds2["GLBA_Steering_Country"] = "7d5790f3-374a-4b27-96aa-8e0d221bf73c";
  return ClientProfileTieringListIds2;
})(ClientProfileTieringListIds || {});

// src/typings/common.typings.ts
var DateFilterEnum = /* @__PURE__ */ ((DateFilterEnum2) => {
  DateFilterEnum2["Upcoming"] = "Upcoming";
  DateFilterEnum2["UpcomingFixed"] = "Upcoming ";
  DateFilterEnum2["FromLastYear"] = "From Last Year";
  DateFilterEnum2["FromLastYearFixed"] = "From Last Year ";
  DateFilterEnum2["CustomRange"] = "Custom Range";
  DateFilterEnum2["Past"] = "Past";
  DateFilterEnum2["All"] = "All";
  DateFilterEnum2["FromLastMonth"] = "From Last Month";
  DateFilterEnum2["FromLastWeek"] = "From Last Week";
  DateFilterEnum2["FromLast6Months"] = "From Last 6 Months";
  DateFilterEnum2["FromLast3Months"] = "From Last 3 Months";
  return DateFilterEnum2;
})(DateFilterEnum || {});
var DateFilterEnumExtended = /* @__PURE__ */ ((DateFilterEnumExtended2) => {
  DateFilterEnumExtended2["FromLastMonthFixed"] = "From Last Month ";
  DateFilterEnumExtended2["FromLastWeekFixed"] = "From Last Week ";
  return DateFilterEnumExtended2;
})(DateFilterEnumExtended || {});
var VisibilityType = /* @__PURE__ */ ((VisibilityType2) => {
  VisibilityType2["Confidential"] = "Confidential";
  VisibilityType2["Public"] = "Public";
  VisibilityType2["Restricted"] = "Restricted";
  VisibilityType2["Private"] = "Private";
  VisibilityType2["ClientTeamPrivate"] = "ClientTeamPrivate";
  VisibilityType2["ClientTeamCoverage"] = "ClientTeamCoverage";
  VisibilityType2["ClientTeamGroup"] = "ClientTeamGroup";
  VisibilityType2["MyTeam"] = "MyTeam";
  return VisibilityType2;
})(VisibilityType || {});

// src/typings/contact.typings.ts
var CivilityTypes = /* @__PURE__ */ ((CivilityTypes2) => {
  CivilityTypes2[CivilityTypes2["Mr"] = 1] = "Mr";
  CivilityTypes2[CivilityTypes2["Ms"] = 2] = "Ms";
  CivilityTypes2[CivilityTypes2["Mx"] = 3] = "Mx";
  return CivilityTypes2;
})(CivilityTypes || {});

// src/typings/events.typings.ts
var EventStatusNames = {
  1: "Draft",
  2: "Booking available",
  5: "Booking closed",
  6: "Completed",
  7: "Cancelled",
  8: "Save the date"
};
var ColorStatusNames = {
  1: "warning",
  2: "success",
  5: "primary",
  6: "success",
  7: "danger",
  8: "info"
};
var slotParticipantStatus = /* @__PURE__ */ ((slotParticipantStatus2) => {
  slotParticipantStatus2[slotParticipantStatus2["BOOKED"] = 1] = "BOOKED";
  slotParticipantStatus2[slotParticipantStatus2["CANCELLED"] = 2] = "CANCELLED";
  slotParticipantStatus2[slotParticipantStatus2["NOSHOW"] = 3] = "NOSHOW";
  slotParticipantStatus2[slotParticipantStatus2["DECLINED"] = 4] = "DECLINED";
  return slotParticipantStatus2;
})(slotParticipantStatus || {});
var SlotStatusNames = {
  1: "Booked",
  2: "Cancelled",
  3: "No show",
  4: "Declined"
};
var SlotColorStatusNames = {
  1: "success",
  2: "warning",
  3: "warning",
  4: "danger"
};
var SlotBookingStatuses = [
  { id: 0, name: "All statuses" },
  // doesnt exist in API status 0
  { id: 1, name: "Booked" },
  { id: 2, name: "Cancelled" },
  { id: 3, name: "No show" },
  { id: 4, name: "Declined" }
];
var EventAddressType = /* @__PURE__ */ ((EventAddressType3) => {
  EventAddressType3["BUSINESS"] = "1";
  EventAddressType3["CLIENT"] = "2";
  EventAddressType3["CUSTOM"] = "3";
  EventAddressType3["NONE"] = "0";
  return EventAddressType3;
})(EventAddressType || {});
var slotLocations = ["On site", "Virtual", "On site & virtual"];

// src/accounts/account.info.mapper.ts
import { compact as compact2, filter, find, includes, map as map2 } from "lodash-es";

// src/utils/formatUtils.ts
import { capitalize, join, map, replace, split, toUpper } from "lodash-es";
import { isStringEmpty } from "@ic-anywhere/ic-utils";
var formatAccountName = ({ name = "", accountLevel, country = "" } = {}) => {
  var _a;
  const accountLevelString = !isStringEmpty(accountLevel) ? `(${accountLevel})` : "";
  const countryName = (_a = country == null ? void 0 : country.toUpperCase()) != null ? _a : "";
  return join([name != null ? name : "", accountLevelString, countryName], " ").trim();
};
var getAccountCompleteName = (account) => {
  if (!account) {
    return "";
  }
  return formatAccountName({
    name: account.name,
    accountLevel: account.accountLevel,
    country: account.countryIso
  });
};
var formatContactFullName = (firstname, lastname) => isStringEmpty(firstname) && isStringEmpty(lastname) ? "" : `${join(map(split(firstname, " "), capitalize), " ") || ""} ${toUpper(lastname) || ""}`;
var getShortPathTeam = (team) => replace(team != null ? team : "", "SGCIB/", "");

// src/utils/queries.utils.ts
import { compact, every, identity, some } from "lodash-es";
var mapQueryResults = (queryResults, mapper = identity) => {
  var _a;
  const isAllSuccess = every(queryResults, (r) => r.isSuccess);
  const data = (_a = compact(queryResults.map(({ data: data2 }) => data2)).map(mapper)) != null ? _a : [];
  return {
    data,
    isFetching: some(queryResults, (r) => r.isFetching),
    isSuccess: isAllSuccess,
    isError: some(queryResults, (r) => r.isError)
  };
};

// src/accounts/account.info.mapper.ts
import { isStringEmpty as isStringEmpty2, isStringEqual as isStringEqual2, toDisplayedDate } from "@ic-anywhere/ic-utils";
var MY_ACCOUNT_TYPES = "My account types";
var MY_PROPERTIES = "My priorities";
var mapToTypology = (typologyDto) => {
  return {
    clientTypology: typologyDto.clientTypology,
    clientType: typologyDto.clientType,
    directionEntityComm: typologyDto.dec,
    directionRegion: typologyDto.dr,
    pcru: typologyDto.pcru,
    siren: typologyDto.siren,
    siret: typologyDto.siret,
    sgRating: typologyDto.sgRating,
    sgRatings: typologyDto.sgRatings,
    blockedJvBernsteinPreparation: typologyDto.blockedJvBernsteinPreparation
  };
};
var mapToCoverageWithAccount = (accounts, coverageDTO) => {
  const client = find(accounts, ({ id }) => id === coverageDTO.clientId);
  const coverage = mapToCoverage(coverageDTO);
  if (!(coverage == null ? void 0 : coverage.id)) {
    return void 0;
  }
  return { ...coverage, contact: { ...coverage.contact, account: client }, checked: false };
};
var mapToCoverage = (coverage) => {
  if (!(coverage == null ? void 0 : coverage.id) || !coverage.person) {
    return void 0;
  }
  const { id, role, person, region, blockNotification } = coverage;
  return {
    id,
    role,
    contact: person,
    region,
    blockNotification
  };
};
var mapToAddress = ({ street1, city, country, countryIso3, zipCode }) => {
  return {
    street1,
    city,
    country: country ? { country, iso3: countryIso3 } : void 0,
    zipCode
  };
};
var mapToAccount = (account) => {
  var _a, _b;
  const {
    id,
    name,
    fullCommercialName,
    coverage,
    bdrId,
    computedClientRootId,
    parent,
    country,
    portfolio,
    tieringLists,
    typology,
    clientIds,
    mainAddress,
    type,
    fundInfo
  } = account;
  const result = {
    id,
    name,
    fullCommercialName,
    type,
    typologyName: typology,
    accountLevel: (_a = clientIds == null ? void 0 : clientIds.internalId) == null ? void 0 : _a.level,
    accountBdrId: (_b = clientIds == null ? void 0 : clientIds.bdrLegalId) == null ? void 0 : _b.id,
    bdrId: mapToBdrIds(bdrId, clientIds),
    coverage: compact2(map2(coverage, mapToCoverage)),
    group: computedClientRootId ? { id: computedClientRootId } : void 0,
    parent: parent ? parent.parentId : void 0,
    country,
    countryIso: country == null ? void 0 : country.iso3,
    portfolio: portfolio ? { ...portfolio } : void 0,
    tieringLists: tieringLists ? mapToTieringLists(tieringLists) : [],
    strategic: {
      segmentation: getTieringListLevelByListId(tieringLists, "8b98e67e-8c53-4e61-8248-855767ab6a56" /* GLBA_PCRU_Segmentation */),
      steeringCountry: getTieringListLevelByListId(tieringLists, "7d5790f3-374a-4b27-96aa-8e0d221bf73c" /* GLBA_Steering_Country */)
    },
    address: mainAddress ? mapToAddress(mainAddress) : void 0,
    fundInfo: fundInfo ? { legalDelegatedManagingEntity: fundInfo.legalDelegatedManagingEntity } : void 0
  };
  if (isStringEmpty2(result.fullCommercialName)) {
    result.fullCommercialName = formatAccountName({
      name: result.name,
      accountLevel: result.accountLevel,
      country: result.countryIso
    });
  }
  return result;
};
var mapToBdrIds = (bdrId, clientIds) => {
  if (!bdrId && !clientIds) {
    return void 0;
  }
  return {
    bdrCommercialId: mapFromAccountsIdDTO(clientIds == null ? void 0 : clientIds.bdrCommercialId, bdrId == null ? void 0 : bdrId.bdrCommercialId),
    bdrLegalId: mapFromAccountsIdDTO(clientIds == null ? void 0 : clientIds.bdrLegalId, bdrId == null ? void 0 : bdrId.bdrLegalId),
    internalId: mapFromAccountsIdDTO(clientIds == null ? void 0 : clientIds.internalId, bdrId == null ? void 0 : bdrId.internalId),
    lei: clientIds == null ? void 0 : clientIds.lei,
    rctId: clientIds == null ? void 0 : clientIds.rctId,
    bdrMnemonic: clientIds == null ? void 0 : clientIds.bdrMnemonic
  };
};
var mapFromAccountsIdDTO = (fromClientId, fromBdrId) => {
  var _a, _b;
  if (!fromClientId && !fromBdrId) {
    return void 0;
  }
  return {
    id: (_a = fromClientId == null ? void 0 : fromClientId.id) != null ? _a : fromBdrId == null ? void 0 : fromBdrId.id,
    level: (_b = fromClientId == null ? void 0 : fromClientId.level) != null ? _b : fromBdrId == null ? void 0 : fromBdrId.level
  };
};
var mapToSgRating = (sgRatings, ratingName) => {
  const rating = find(sgRatings, (rating2) => isStringEqual2(rating2 == null ? void 0 : rating2.name, ratingName));
  return rating == null ? void 0 : rating.value;
};
var mapToFundInfo = ({ id, name, bdrId }) => {
  var _a, _b;
  if (!id) {
    return void 0;
  }
  return {
    legalDelegatedManagingEntity: {
      name: name != null ? name : "",
      bdrId: (_b = (_a = bdrId == null ? void 0 : bdrId.bdrCommercialId) == null ? void 0 : _a.id) != null ? _b : "",
      id
    }
  };
};
var mapToTieringLists = (tieringLists) => map2(filterDefaultLists(tieringLists), ({ list, level }) => ({
  listId: list.id,
  listName: list.name,
  levelId: level.id,
  levelName: level.name
}));
var filterDefaultLists = (clientLists) => filter(clientLists, (x) => {
  var _a;
  return !includes([MY_ACCOUNT_TYPES, MY_PROPERTIES], (_a = x.list) == null ? void 0 : _a.name);
});
var getTieringListLevelByListId = (tieringLists, idList) => {
  var _a, _b, _c;
  return (_c = (_b = (_a = find(tieringLists, ({ list }) => list.id === idList)) == null ? void 0 : _a.level) == null ? void 0 : _b.name) != null ? _c : "";
};
var mapGlobalInfo = (globalInfo) => {
  var _a, _b;
  const info = globalInfo[0];
  return {
    ...info,
    reviewDate: (_a = toDisplayedDate(info.reviewDate)) != null ? _a : "",
    validationDate: (_b = toDisplayedDate(info.validationDate)) != null ? _b : ""
  };
};
var mapToA2ds = (dtos) => {
  var _a;
  const a2dDTO = dtos[0];
  return {
    ...a2dDTO,
    score: a2dDTO.score && !isStringEmpty2(a2dDTO.score) ? mapToA2DStatus(a2dDTO.score) : null,
    detailScores: map2((_a = a2dDTO.detailScores) != null ? _a : [], (detail) => ({
      scoringName: detail.scoringName,
      reasonsAndActions: filter(detail.reasonsAndActions, (reason) => !!reason),
      score: detail.score && !isStringEmpty2(detail.score) ? mapToA2DStatus(detail.score) : null
    }))
  };
};
var mapToA2DStatus = (a2d) => {
  const statuses = {
    orange: "Restricted",
    red: "Red",
    green: "Green"
  };
  return statuses[a2d];
};
var mapToClientLists = (clientListsDto) => clientListsDto ? map2(clientListsDto.clientLists, mapToClientList) : [];
var mapToClientList = (clientListDto) => {
  const {
    id,
    name,
    visibility,
    inheritance,
    levels,
    description,
    startDate,
    endDate,
    isActive,
    owners,
    perimeterTeam
  } = clientListDto;
  return {
    id,
    name,
    visibility,
    inheritance,
    levels: map2(levels, (level) => ({ id: level.id, name: level.name })),
    description,
    startDate: startDate || "",
    endDate: endDate || "",
    isActive,
    owners: map2(owners, mapToContactFromReferenceDTO),
    perimeterTeam
  };
};
var mapToContactFromReferenceDTO = (contactDto) => ({
  id: contactDto.id,
  fullName: contactDto.fullName,
  organizationTeam: contactDto.organizationTeam
});

// src/accounts/account.info.api.ts
import { join as join2, uniq } from "lodash-es";
import { stringifyLists } from "@ic-anywhere/ic-utils";
var clientsUrl = "/2.0/clients";
var clientListsUrl = "/2.0/clientlists";
var urlPrivate = "/private/0.0/clients";
var defaultAccountProperties = [
  "clientIds",
  "country",
  "portfolio",
  "mainAddress",
  "typology",
  "customerRepresentative"
];
var requestAccountWithId = async (repository, accountId, properties2 = [
  "computedClientRootId",
  "coverage",
  "bdrId",
  "country",
  "clientIds",
  "mainAddress",
  "portfolio",
  "customerRepresentative",
  "tieringList",
  "fund",
  "typology"
]) => {
  var _a, _b, _c;
  const accountDto = await getAccountById(repository, accountId, properties2);
  const account = mapToAccount(accountDto);
  const isRelatedAccountIsFund = isFund(account.type);
  const relatedAccountId = isRelatedAccountIsFund ? (_b = (_a = account.fundInfo) == null ? void 0 : _a.legalDelegatedManagingEntity) == null ? void 0 : _b.id : (_c = account.group) == null ? void 0 : _c.id;
  if (!relatedAccountId) {
    return account;
  }
  const groupOrFund = await getRelatedAccount(repository, account.type, relatedAccountId);
  return isRelatedAccountIsFund ? { ...account, fundInfo: groupOrFund } : { ...account, group: groupOrFund };
};
var getRelatedAccount = (repository, type, accountId) => {
  return getAccountById(repository, accountId, ["clientIds", "country", "bdrId"]).then((groupOrFund) => {
    const { id, bdrId, name } = groupOrFund;
    return isFund(type) ? mapToFundInfo({ id, bdrId, name, type }) : groupOrFund;
  });
};
var getAccountById = async (repository, accountId, properties2, projectedOnLists) => {
  const projectedLists = projectedOnLists ? join2(
    uniq([
      ...projectedOnLists,
      "8b98e67e-8c53-4e61-8248-855767ab6a56" /* GLBA_PCRU_Segmentation */,
      "7d5790f3-374a-4b27-96aa-8e0d221bf73c" /* GLBA_Steering_Country */
    ]),
    ","
  ) : void 0;
  return repository.get(`${clientsUrl}/${accountId}`, stringifyLists({ properties: properties2, projectedOnLists: projectedLists })).then((res) => res.data);
};
var getPrivateClientById = (repo, id) => repo.get(`${urlPrivate}/${id}`).then(({ data }) => data);
var getAccountTypology = (repo, id) => repo.get(`${urlPrivate}/${id}`).then(({ data }) => mapToTypology(data));
var getAccountByBdrLegalId = (repo, bdrLegalId, queryParams) => {
  var _a;
  const params = {
    clientLegal: bdrLegalId,
    levels: "LE",
    ...queryParams,
    properties: (_a = queryParams.properties) != null ? _a : defaultAccountProperties
  };
  return repo.get(clientsUrl, stringifyLists(params)).then((accounts) => {
    var _a2;
    return ((_a2 = accounts.data) == null ? void 0 : _a2.length) > 0 ? accounts.data[0] : null;
  });
};
var getClientLists = (repository, paramsClientLists) => repository.get(clientListsUrl, stringifyLists(paramsClientLists)).then((res) => mapToClientLists(res.data));
var getHashtagsAccount = (repository, accountId, properties2 = ["hashtags"]) => repository.get(`${clientsUrl}/${accountId}`, stringifyLists({ properties: properties2 })).then((res) => res.data.hashtags);
var updateHashtagsAccount = (repository, accountId, hashtags) => repository.put(`${clientsUrl}/${accountId}/hashtags`, { hashtags }).then((res) => res.data);

// src/accounts/account.info.queries.ts
import { useQueries, useQuery } from "@tanstack/react-query";

// src/repository/repository.typings.ts
var OFFICE_ACCEPT_HEADERS = {
  OFFICE_DOCUMENT: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  STREAM: "application/octet-stream"
};

// src/repository/headers.ts
var defaultIcHeader = { "Content-Type": "application/json; charset=utf-8" };
var getImpersonateEmail = (impersonation) => impersonation && impersonation.impersonateAs && impersonation.impersonateAs.email ? impersonation.impersonateAs.email : void 0;
var getHeaders = (impersonation, sgConnectToken) => {
  const impersonateUserEmail = getImpersonateEmail(impersonation);
  const headers = {
    ...defaultIcHeader,
    authorization: sgConnectToken
  };
  return impersonateUserEmail ? { ...headers, impersonatingAs: impersonateUserEmail } : headers;
};
var getContactDbHeader = (impersonation, sgConnectToken) => {
  return {
    ...getHeaders(impersonation, sgConnectToken),
    contactDb: true,
    "x-contact-db": true
  };
};

// src/repository/constants.ts
var import_qs = __toESM(require_lib());
var emptyGuid = "00000000-0000-0000-0000-000000000000";
var oneMinutesInMs = 1e3 * 60 * 1;
var twoMinutesInMs = 1e3 * 60 * 2;
var fiveMinutesInMs = 1e3 * 60 * 5;
var tenMinutesInMs = 1e3 * 60 * 10;
var twoHoursInMs = 1e3 * 60 * 60 * 2;
var twelveHoursInMs = 1e3 * 60 * 60 * 12;
var defaultQueryClientOptions = {
  queries: {
    refetchOnWindowFocus: false,
    enabled: false,
    staleTime: Infinity,
    cacheTime: 0
  }
};
var DEFAULT_PAGE_SIZE = 500;
var defaultApiTimeout = 3e4;
var mediumApiTimeout = 6e4;
var shortApiTimeout = 5e3;
var defaultDownloadTimeout = 6e4;
var maxDownloadTimeout = 9e4;
var timeoutErrorMessage = "timeoutErrorMessage";
var defaultHeaders = { "Content-Type": "application/json; charset=utf-8" };
var contactDbHeader = { contactDb: true, "x-contact-db": true };
var paramsSerializer = (params) => import_qs.default.stringify(params, { arrayFormat: "comma" });

// src/repository/apiRepository.ts
var import_axios = __toESM(require_axios2());
import { getEnvironment as getEnvironment3, isStringEmpty as isStringEmpty4, parseFileNameFromDisposition } from "@ic-anywhere/ic-utils";

// src/logger/logger.ts
import { getLoggerEnvironment, isDevEnv } from "@ic-anywhere/ic-utils";
import { createLogger, Level } from "@dcc-cli/cli-web-logger";
var getLoggerByEnv = (appName) => {
  return isDevEnv() ? consoleLogger : webLibLogger(appName, window.location.pathname);
};
var webLibLogger = (appName, feature = "") => {
  const logger2 = createLogger("IC", getLoggerEnvironment());
  logger2.setCustom("feature", feature).setCustom("appName", appName);
  return {
    debug: (name, message) => {
      logger2.technical(name, message, Level.Info);
    },
    logError: (message, error, stack) => {
      logger2.technical(message, `${error != null ? error : ""} ${stack != null ? stack : ""}`, Level.Error);
    },
    logWarning: (message) => {
      logger2.technical(message, message, Level.Warn);
    },
    logEvent: (event) => {
      logger2.functional(event.event, event.description);
    },
    performance: (name, message, action) => {
      return logger2.performance(name, message, action);
    },
    startPerformanceMeasure: function(key) {
      logger2.startPerformanceMeasure(key);
    },
    endPerformanceMeasure: function(_name, message, key) {
      logger2.endPerformanceMeasure(`Log Performance ${appName}`, message, key);
    }
  };
};
var consoleLogger = {
  debug: (name, message) => {
    console.debug(name, message);
  },
  logError: (message, error, stack) => {
    console.error(message, `${error != null ? error : ""}${stack != null ? stack : ""}`, Level.Error);
  },
  logWarning: (message) => {
    console.warn(message, message, Level.Warn);
  },
  logEvent: (event) => {
    console.log(event.event, event.description);
  },
  performance: async (name, _message, action) => {
    console.time(name);
    const result = await action();
    console.timeEnd(name);
    return result;
  },
  startPerformanceMeasure: function(key) {
    console.time(key);
  },
  endPerformanceMeasure: function(name, message, key) {
    console.timeLog(key, `${name}: ${message}`);
    console.timeEnd(key);
  }
};

// src/repository/apiIntercepters.ts
import { getEnvironment as getEnvironment2, isStringEmpty as isStringEmpty3 } from "@ic-anywhere/ic-utils";
import { omit as omit2 } from "lodash-es";

// src/repository/repository.utils.ts
var import_axios_mock_adapter = __toESM(require_src());
var saveToFile = (file, overrideFileName) => {
  var _a;
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(file.blob);
  link.setAttribute("download", (_a = overrideFileName != null ? overrideFileName : file == null ? void 0 : file.fileName) != null ? _a : "report");
  document.body.appendChild(link);
  link.click();
  link.remove();
};
var getRepositoryMock = (config2) => {
  const { logger: logger2 = consoleLogger, impersonatingAs, isInLan } = config2;
  const repo = ApiRepository.Crm({ token: emptyGuid, logger: logger2, impersonatingAs, isInLan });
  return [new import_axios_mock_adapter.default(repo.axiosClient), repo];
};
var tryParseJsonField = (headers, field) => {
  if (!headers || !field) {
    return null;
  }
  try {
    return JSON.parse(headers[field]);
  } catch (err) {
    return null;
  }
};

// src/serviceUrls/serviceUrls.ts
import {
  getEnvironment,
  isUrlStartWith,
  joinUrls,
  replaceUrlBy,
  stringifyParams
} from "@ic-anywhere/ic-utils";
import { find as find2, includes as includes2, keys, omit } from "lodash-es";

// src/serviceUrls/serviceUrls.constants.ts
var CONTACT_DB_HEADER_NAME = "x-contact-db";
var CONTACT_HOM_LAN = "https://contacts-api-hom.fr.world.socgen";
var CONTACT_ISO_LAN = "https://contacts-api-iso.fr.world.socgen";
var CONTACT_PROD_LAN = "https://contacts-api.fr.world.socgen";
var SOA_HOM_LAN = "https://ic-api-hom.fr.world.socgen";
var SOA_ISO_LAN = "https://ic-api-iso.fr.world.socgen";
var SOA_PROD_LAN = "https://ic-api.fr.world.socgen";
var ANYWHERE_SERVICES_URL_HOM_LAN = "https://anywhere-services-hom.fr.world.socgen";
var ANYWHERE_SERVICES_URL_ISO_LAN = "https://anywhere-services-iso.fr.world.socgen";
var ANYWHERE_SERVICES_URL_PROD_LAN = "https://ic-anywhere-api.fr.world.socgen";
var SERVICE_URLS = {
  Events: {
    homologation: "https://events-hom.sgmarkets.com",
    iso: "https://events-iso.sgmarkets.com",
    production: "https://events.sgmarkets.com"
  },
  ContactDbPrivate: {
    homologation: CONTACT_HOM_LAN,
    iso: "https://api-s-uat.sgmarkets.com/thirdparties/contacts/private/v1",
    production: "https://api-s.sgmarkets.com/thirdparties/contacts/private/v1",
    isoLan: CONTACT_ISO_LAN,
    productionLan: CONTACT_PROD_LAN,
    activateDistributedTracing: true
  },
  ContactDbv1: {
    homologation: CONTACT_HOM_LAN,
    iso: "https://api-s-uat.sgmarkets.com/thirdparties/contacts/v1",
    production: "https://api-s.sgmarkets.com/thirdparties/contacts/v1",
    isoLan: CONTACT_ISO_LAN,
    productionLan: CONTACT_PROD_LAN,
    activateDistributedTracing: true
  },
  ContactDbv2: {
    homologation: CONTACT_HOM_LAN,
    iso: "https://api-s-uat.sgmarkets.com/thirdparties/contacts/v2",
    production: "https://api-s.sgmarkets.com/thirdparties/contacts/v2",
    isoLan: CONTACT_ISO_LAN,
    productionLan: CONTACT_PROD_LAN,
    activateDistributedTracing: true
  },
  SoaPrivate: {
    homologation: SOA_HOM_LAN,
    iso: "https://api-s-uat.sgmarkets.com/services/ic/crm/private/v1",
    production: "https://api-s.sgmarkets.com/services/ic/crm/private/v1",
    isoLan: SOA_ISO_LAN,
    productionLan: SOA_PROD_LAN,
    activateDistributedTracing: true
  },
  SoaV2: {
    homologation: SOA_HOM_LAN,
    iso: "https://api-s-uat.sgmarkets.com/services/ic/crm/v2",
    production: "https://api-s.sgmarkets.com/services/ic/crm/v2",
    isoLan: SOA_ISO_LAN,
    productionLan: SOA_PROD_LAN,
    activateDistributedTracing: true
  },
  SoaV3: {
    homologation: SOA_HOM_LAN,
    iso: "https://api-s-uat.sgmarkets.com/services/ic/crm/v3",
    production: "https://api-s.sgmarkets.com/services/ic/crm/v3",
    isoLan: SOA_ISO_LAN,
    productionLan: SOA_PROD_LAN,
    activateDistributedTracing: true
  },
  AnywhereServices: {
    homologation: ANYWHERE_SERVICES_URL_HOM_LAN,
    iso: "https://api-s-uat.sgmarkets.com/services/ic/crm/ui-private/v1",
    production: "https://api-s.sgmarkets.com/services/ic/crm/ui-private/v1",
    isoLan: ANYWHERE_SERVICES_URL_ISO_LAN,
    productionLan: ANYWHERE_SERVICES_URL_PROD_LAN,
    activateDistributedTracing: true
  },
  SGConnect: {
    homologation: "https://sgconnect-hom.fr.world.socgen",
    iso: "https://sso.sgmarkets.com",
    production: "https://sso.sgmarkets.com"
  },
  Sgr: {
    homologation: "https://sgr-web-access-uat.fr.world.socgen",
    iso: "https://sgr-web-access-uat.fr.world.socgen",
    production: "https://access.sgmarkets.com"
  },
  OutlookAddin: {
    homologation: `https://ic-iso.sgmarkets.com/outlook/setup.exe`,
    iso: "https://ic-iso.sgmarkets.com/outlook/setup.exe",
    production: "https://ic.sgmarkets.com/outlook/setup.exe"
  },
  SgIam: {
    homologation: "https://iam-hom.sgmarkets.com/access-management",
    iso: "https://iam.sgmarkets.com/access-management",
    production: "https://iam.sgmarkets.com/access-management"
  },
  Rct: {
    homologation: "https://maestro-rct-map-reject-uat.fr.world.socgen:50010",
    iso: "https://maestro-rct-map-reject.fr.world.socgen",
    production: "https://maestro-rct-map-reject.fr.world.socgen"
  },
  Maestro: {
    homologation: "https://maestro-search-uat.fr.world.socgen",
    iso: "https://api-maestro-search.fr.world.socgen",
    production: "https://api-maestro-search.fr.world.socgen"
  },
  CliGlobalView: {
    homologation: "https://clm-cli-global-view-api-uat.fr.world.socgen",
    production: "https://clm-cli-global-view-api.fr.world.socgen",
    iso: "https://clm-cli-global-view-api-uat.fr.world.socgen"
  },
  AnywhereLight: {
    homologation: "https://ic-hom.sgmarkets.com",
    iso: "https://ic-iso.sgmarkets.com",
    production: "https://ic.sgmarkets.com"
  },
  Vnext: {
    homologation: "https://ic-hom.sgmarkets.com",
    iso: "https://ic-iso.sgmarkets.com",
    production: "https://ic.sgmarkets.com"
  },
  SgmDocs: {
    homologation: "https://api-uat.sgdocs.dev.euw.gbis.sg-azure.com/api/v3",
    iso: "https://api.sgdocs.prd.euw.gbis.sg-azure.com/api/v3",
    production: "https://api.sgdocs.prd.euw.gbis.sg-azure.com/api/v3"
  },
  SgIamSyncIc: {
    homologation: "https://iam-hom.sgmarkets.com/user-management",
    iso: "https://iam.sgmarkets.com/user-management",
    production: "https://iam.sgmarkets.com/user-management"
  },
  R3c: {
    homologation: "https://r3c-searchthirdpartybankaccount-hom.fr.world.socgen",
    iso: "https://r3c-searchthirdpartybankaccount-hom.fr.world.socgen",
    production: "https://r3c-searchthirdpartybankaccount-prd.fr.world.socgen"
  },
  RegistrationTypes: {
    homologation: "https://h-api.group.socgen/reference-data/party/thirds",
    iso: "https://h-api.group.socgen/reference-data/party/thirds",
    production: "https://api.group.socgen/reference-data/party/thirds"
  },
  SGMAccessServices: {
    homologation: "https://api-s-uat.sgmarkets.com/services/access/private/v1",
    iso: "https://api-s-uat.sgmarkets.com/services/access/private/v1",
    production: "https://api-s.sgmarkets.com/services/access/private/v1"
  },
  Mifid2ResearchContract: {
    homologation: "https://pretrade-api-research-contract-uat.sgmpinsight.dev.euw.gbis.sg-azure.com",
    iso: "https://pretrade-api-research-contract-uat.sgmpinsight.dev.euw.gbis.sg-azure.com",
    production: "https://pretrade-api-research-contract-prd.sgmpinsight.prd.euw.gbis.sg-azure.com"
  },
  Lab: {
    homologation: "https://digital-uat.fr.world.socgen/cli-projects/labWelcomePage",
    iso: "https://digital-uat.fr.world.socgen/cli-projects/labWelcomePage",
    production: "https://digital.fr.world.socgen/cli-projects/labWelcomePage"
  }
};
var IC_GATEWAY_RULES = [
  { path: "/private/0.0", headerName: CONTACT_DB_HEADER_NAME, removePath: true, service: "ContactDbPrivate" },
  { path: "/1.0", headerName: CONTACT_DB_HEADER_NAME, removePath: true, service: "ContactDbv1" },
  { path: "/2.0", headerName: CONTACT_DB_HEADER_NAME, removePath: true, service: "ContactDbv2" },
  { path: "/private/0.0", removePath: true, service: "SoaPrivate" },
  { path: "/2.0", removePath: true, service: "SoaV2" },
  { path: "/3.0", removePath: true, service: "SoaV3" },
  { path: "/api/v3/", service: "SGConnect" },
  { path: "/network/api", service: "SGConnect" },
  { path: "/api/v1/contacts", service: "Mifid2ResearchContract" },
  { path: "/api/v1/clients", service: "Mifid2ResearchContract" },
  { path: "/api/v1/external", service: "SgIam" },
  { path: "/api/v1/user/sync-from-ic", service: "SgIamSyncIc" },
  { path: "/api/v1/accesses", service: "SGMAccessServices" },
  { path: "/api/v1/dummy-accesses", service: "SGMAccessServices" },
  { path: "/api/v1/requests", service: "SGMAccessServices" },
  { path: "/api/v4/", service: "Maestro" },
  { path: "/api/", removePath: true, service: "AnywhereServices" },
  { path: "/IC", service: "Sgr" },
  { path: "/rct", service: "Rct" },
  { path: "/registrations/api/v2", service: "RegistrationTypes" },
  { path: "/v1/financialData", service: "CliGlobalView" }
];
var iCUrlMappingConfig = {
  servicesUrls: SERVICE_URLS,
  urlGatewayRules: IC_GATEWAY_RULES
};

// src/serviceUrls/serviceUrls.ts
var replaceInPath = (inputPath, rule, env2) => {
  if (rule.removePath && (env2 === "production" || env2 === "iso")) {
    return replaceUrlBy(inputPath, rule.path, "");
  }
  return inputPath;
};
var matchPathPredicate = (urlPath, headers) => (rule) => isUrlStartWith(urlPath, rule.path) && (!rule.headerName || includes2(keys(headers), rule.headerName));
function groupServiceUrlsByEnv(serviceUrls, filterForDistributedTracing = false) {
  const initialValues = {
    homologation: [],
    iso: [],
    isoLan: [],
    production: [],
    productionLan: []
  };
  return Object.values(serviceUrls).filter((envUrl) => !filterForDistributedTracing || envUrl.activateDistributedTracing).map((fullEnvUrlObject) => omit(fullEnvUrlObject, "activateDistributedTracing")).reduce((acc, envUrl) => {
    const currentUrls = Object.keys(envUrl).reduce(
      (serviceUrls2, env2) => ({
        ...serviceUrls2,
        [env2]: [...serviceUrls2[env2], envUrl[env2]]
      }),
      initialValues
    );
    return {
      ...acc,
      homologation: [...acc.homologation, ...currentUrls.homologation],
      iso: [...acc.iso, ...currentUrls.iso],
      isoLan: [...acc.isoLan, ...currentUrls.isoLan],
      production: [...acc.production, ...currentUrls.production],
      productionLan: [...acc.productionLan, ...currentUrls.productionLan]
    };
  }, initialValues);
}
var getServiceUrl = (service, env2, isInLan = false, servicesUrls = SERVICE_URLS) => {
  const serviceUrls = servicesUrls[service];
  if (!serviceUrls || service === "SgIam" && env2 === "local") {
    return null;
  }
  switch (env2) {
    case "production":
      return isInLan && serviceUrls.productionLan ? serviceUrls.productionLan : serviceUrls.production;
    case "iso":
      return isInLan && serviceUrls.isoLan ? serviceUrls.isoLan : serviceUrls.iso;
    default:
      return serviceUrls.homologation;
  }
};
function getServiceUrlsByEnv(env2, filterForDistributedTracing = false, isInLan = false, serviceUrls = SERVICE_URLS) {
  const urls = groupServiceUrlsByEnv(serviceUrls, filterForDistributedTracing);
  switch (env2) {
    case "production":
      return isInLan && urls.productionLan ? urls.productionLan : urls.production;
    case "iso":
      return isInLan && urls.isoLan ? urls.isoLan : urls.iso;
    default:
      return urls.homologation;
  }
}
var buildUrl = (inputPath, headers, params, urlMappingConfig = iCUrlMappingConfig) => {
  const env2 = getEnvironment();
  return buildUrlForEnv(env2, inputPath, headers, params, void 0, urlMappingConfig);
};
var buildUrlForEnv = (env2, inputPath, headers, params, stringifyUrlOptions, urlMappingConfig = iCUrlMappingConfig) => {
  var _a;
  const strParams = params ? `${stringifyParams(params, stringifyUrlOptions)}` : "";
  const { isInLan, ...requestHeaders } = headers;
  const rule = find2(urlMappingConfig.urlGatewayRules, matchPathPredicate(inputPath, requestHeaders));
  if (!rule) {
    return `${inputPath}${strParams}`;
  }
  const rootUrl = (_a = getServiceUrl(rule.service, env2, isInLan, urlMappingConfig.servicesUrls)) != null ? _a : "";
  const path = isInLan ? inputPath : replaceInPath(inputPath, rule, env2);
  return `${joinUrls(rootUrl, path)}${strParams}`;
};

// src/repository/apiIntercepters.ts
import { generateUID } from "@sgbs-ui/core";

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/innerSubscribe.js
import * as tslib_12 from "tslib";

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/Subscriber.js
import * as tslib_1 from "tslib";

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/util/isFunction.js
function isFunction(x) {
  return typeof x === "function";
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/config.js
var _enable_super_gross_mode_that_will_cause_bad_things = false;
var config = {
  Promise: void 0,
  set useDeprecatedSynchronousErrorHandling(value) {
    if (value) {
      var error = /* @__PURE__ */ new Error();
      /* @__PURE__ */ console.warn("DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n" + error.stack);
    } else if (_enable_super_gross_mode_that_will_cause_bad_things) {
      /* @__PURE__ */ console.log("RxJS: Back to a better error behavior. Thank you. <3");
    }
    _enable_super_gross_mode_that_will_cause_bad_things = value;
  },
  get useDeprecatedSynchronousErrorHandling() {
    return _enable_super_gross_mode_that_will_cause_bad_things;
  }
};

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/util/hostReportError.js
function hostReportError(err) {
  setTimeout(function() {
    throw err;
  }, 0);
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/Observer.js
var empty = {
  closed: true,
  next: function(value) {
  },
  error: function(err) {
    if (config.useDeprecatedSynchronousErrorHandling) {
      throw err;
    } else {
      hostReportError(err);
    }
  },
  complete: function() {
  }
};

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/util/isArray.js
var isArray = /* @__PURE__ */ function() {
  return Array.isArray || function(x) {
    return x && typeof x.length === "number";
  };
}();

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/util/isObject.js
function isObject(x) {
  return x !== null && typeof x === "object";
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/util/UnsubscriptionError.js
var UnsubscriptionErrorImpl = /* @__PURE__ */ function() {
  function UnsubscriptionErrorImpl2(errors) {
    Error.call(this);
    this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
      return i + 1 + ") " + err.toString();
    }).join("\n  ") : "";
    this.name = "UnsubscriptionError";
    this.errors = errors;
    return this;
  }
  UnsubscriptionErrorImpl2.prototype = /* @__PURE__ */ Object.create(Error.prototype);
  return UnsubscriptionErrorImpl2;
}();
var UnsubscriptionError = UnsubscriptionErrorImpl;

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/Subscription.js
var Subscription = /* @__PURE__ */ function() {
  function Subscription2(unsubscribe) {
    this.closed = false;
    this._parentOrParents = null;
    this._subscriptions = null;
    if (unsubscribe) {
      this._ctorUnsubscribe = true;
      this._unsubscribe = unsubscribe;
    }
  }
  Subscription2.prototype.unsubscribe = function() {
    var errors;
    if (this.closed) {
      return;
    }
    var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
    this.closed = true;
    this._parentOrParents = null;
    this._subscriptions = null;
    if (_parentOrParents instanceof Subscription2) {
      _parentOrParents.remove(this);
    } else if (_parentOrParents !== null) {
      for (var index = 0; index < _parentOrParents.length; ++index) {
        var parent_1 = _parentOrParents[index];
        parent_1.remove(this);
      }
    }
    if (isFunction(_unsubscribe)) {
      if (_ctorUnsubscribe) {
        this._unsubscribe = void 0;
      }
      try {
        _unsubscribe.call(this);
      } catch (e) {
        errors = e instanceof UnsubscriptionError ? flattenUnsubscriptionErrors(e.errors) : [e];
      }
    }
    if (isArray(_subscriptions)) {
      var index = -1;
      var len = _subscriptions.length;
      while (++index < len) {
        var sub = _subscriptions[index];
        if (isObject(sub)) {
          try {
            sub.unsubscribe();
          } catch (e) {
            errors = errors || [];
            if (e instanceof UnsubscriptionError) {
              errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
            } else {
              errors.push(e);
            }
          }
        }
      }
    }
    if (errors) {
      throw new UnsubscriptionError(errors);
    }
  };
  Subscription2.prototype.add = function(teardown) {
    var subscription = teardown;
    if (!teardown) {
      return Subscription2.EMPTY;
    }
    switch (typeof teardown) {
      case "function":
        subscription = new Subscription2(teardown);
      case "object":
        if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== "function") {
          return subscription;
        } else if (this.closed) {
          subscription.unsubscribe();
          return subscription;
        } else if (!(subscription instanceof Subscription2)) {
          var tmp = subscription;
          subscription = new Subscription2();
          subscription._subscriptions = [tmp];
        }
        break;
      default: {
        throw new Error("unrecognized teardown " + teardown + " added to Subscription.");
      }
    }
    var _parentOrParents = subscription._parentOrParents;
    if (_parentOrParents === null) {
      subscription._parentOrParents = this;
    } else if (_parentOrParents instanceof Subscription2) {
      if (_parentOrParents === this) {
        return subscription;
      }
      subscription._parentOrParents = [_parentOrParents, this];
    } else if (_parentOrParents.indexOf(this) === -1) {
      _parentOrParents.push(this);
    } else {
      return subscription;
    }
    var subscriptions = this._subscriptions;
    if (subscriptions === null) {
      this._subscriptions = [subscription];
    } else {
      subscriptions.push(subscription);
    }
    return subscription;
  };
  Subscription2.prototype.remove = function(subscription) {
    var subscriptions = this._subscriptions;
    if (subscriptions) {
      var subscriptionIndex = subscriptions.indexOf(subscription);
      if (subscriptionIndex !== -1) {
        subscriptions.splice(subscriptionIndex, 1);
      }
    }
  };
  Subscription2.EMPTY = function(empty3) {
    empty3.closed = true;
    return empty3;
  }(new Subscription2());
  return Subscription2;
}();
function flattenUnsubscriptionErrors(errors) {
  return errors.reduce(function(errs, err) {
    return errs.concat(err instanceof UnsubscriptionError ? err.errors : err);
  }, []);
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/symbol/rxSubscriber.js
var rxSubscriber = /* @__PURE__ */ function() {
  return typeof Symbol === "function" ? /* @__PURE__ */ Symbol("rxSubscriber") : "@@rxSubscriber_" + /* @__PURE__ */ Math.random();
}();

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/Subscriber.js
var Subscriber = /* @__PURE__ */ function(_super) {
  tslib_1.__extends(Subscriber2, _super);
  function Subscriber2(destinationOrNext, error, complete) {
    var _this = _super.call(this) || this;
    _this.syncErrorValue = null;
    _this.syncErrorThrown = false;
    _this.syncErrorThrowable = false;
    _this.isStopped = false;
    switch (arguments.length) {
      case 0:
        _this.destination = empty;
        break;
      case 1:
        if (!destinationOrNext) {
          _this.destination = empty;
          break;
        }
        if (typeof destinationOrNext === "object") {
          if (destinationOrNext instanceof Subscriber2) {
            _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
            _this.destination = destinationOrNext;
            destinationOrNext.add(_this);
          } else {
            _this.syncErrorThrowable = true;
            _this.destination = new SafeSubscriber(_this, destinationOrNext);
          }
          break;
        }
      default:
        _this.syncErrorThrowable = true;
        _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
        break;
    }
    return _this;
  }
  Subscriber2.prototype[rxSubscriber] = function() {
    return this;
  };
  Subscriber2.create = function(next, error, complete) {
    var subscriber = new Subscriber2(next, error, complete);
    subscriber.syncErrorThrowable = false;
    return subscriber;
  };
  Subscriber2.prototype.next = function(value) {
    if (!this.isStopped) {
      this._next(value);
    }
  };
  Subscriber2.prototype.error = function(err) {
    if (!this.isStopped) {
      this.isStopped = true;
      this._error(err);
    }
  };
  Subscriber2.prototype.complete = function() {
    if (!this.isStopped) {
      this.isStopped = true;
      this._complete();
    }
  };
  Subscriber2.prototype.unsubscribe = function() {
    if (this.closed) {
      return;
    }
    this.isStopped = true;
    _super.prototype.unsubscribe.call(this);
  };
  Subscriber2.prototype._next = function(value) {
    this.destination.next(value);
  };
  Subscriber2.prototype._error = function(err) {
    this.destination.error(err);
    this.unsubscribe();
  };
  Subscriber2.prototype._complete = function() {
    this.destination.complete();
    this.unsubscribe();
  };
  Subscriber2.prototype._unsubscribeAndRecycle = function() {
    var _parentOrParents = this._parentOrParents;
    this._parentOrParents = null;
    this.unsubscribe();
    this.closed = false;
    this.isStopped = false;
    this._parentOrParents = _parentOrParents;
    return this;
  };
  return Subscriber2;
}(Subscription);
var SafeSubscriber = /* @__PURE__ */ function(_super) {
  tslib_1.__extends(SafeSubscriber2, _super);
  function SafeSubscriber2(_parentSubscriber, observerOrNext, error, complete) {
    var _this = _super.call(this) || this;
    _this._parentSubscriber = _parentSubscriber;
    var next;
    var context = _this;
    if (isFunction(observerOrNext)) {
      next = observerOrNext;
    } else if (observerOrNext) {
      next = observerOrNext.next;
      error = observerOrNext.error;
      complete = observerOrNext.complete;
      if (observerOrNext !== empty) {
        context = Object.create(observerOrNext);
        if (isFunction(context.unsubscribe)) {
          _this.add(context.unsubscribe.bind(context));
        }
        context.unsubscribe = _this.unsubscribe.bind(_this);
      }
    }
    _this._context = context;
    _this._next = next;
    _this._error = error;
    _this._complete = complete;
    return _this;
  }
  SafeSubscriber2.prototype.next = function(value) {
    if (!this.isStopped && this._next) {
      var _parentSubscriber = this._parentSubscriber;
      if (!config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
        this.__tryOrUnsub(this._next, value);
      } else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
        this.unsubscribe();
      }
    }
  };
  SafeSubscriber2.prototype.error = function(err) {
    if (!this.isStopped) {
      var _parentSubscriber = this._parentSubscriber;
      var useDeprecatedSynchronousErrorHandling = config.useDeprecatedSynchronousErrorHandling;
      if (this._error) {
        if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
          this.__tryOrUnsub(this._error, err);
          this.unsubscribe();
        } else {
          this.__tryOrSetError(_parentSubscriber, this._error, err);
          this.unsubscribe();
        }
      } else if (!_parentSubscriber.syncErrorThrowable) {
        this.unsubscribe();
        if (useDeprecatedSynchronousErrorHandling) {
          throw err;
        }
        hostReportError(err);
      } else {
        if (useDeprecatedSynchronousErrorHandling) {
          _parentSubscriber.syncErrorValue = err;
          _parentSubscriber.syncErrorThrown = true;
        } else {
          hostReportError(err);
        }
        this.unsubscribe();
      }
    }
  };
  SafeSubscriber2.prototype.complete = function() {
    var _this = this;
    if (!this.isStopped) {
      var _parentSubscriber = this._parentSubscriber;
      if (this._complete) {
        var wrappedComplete = function() {
          return _this._complete.call(_this._context);
        };
        if (!config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
          this.__tryOrUnsub(wrappedComplete);
          this.unsubscribe();
        } else {
          this.__tryOrSetError(_parentSubscriber, wrappedComplete);
          this.unsubscribe();
        }
      } else {
        this.unsubscribe();
      }
    }
  };
  SafeSubscriber2.prototype.__tryOrUnsub = function(fn, value) {
    try {
      fn.call(this._context, value);
    } catch (err) {
      this.unsubscribe();
      if (config.useDeprecatedSynchronousErrorHandling) {
        throw err;
      } else {
        hostReportError(err);
      }
    }
  };
  SafeSubscriber2.prototype.__tryOrSetError = function(parent, fn, value) {
    if (!config.useDeprecatedSynchronousErrorHandling) {
      throw new Error("bad call");
    }
    try {
      fn.call(this._context, value);
    } catch (err) {
      if (config.useDeprecatedSynchronousErrorHandling) {
        parent.syncErrorValue = err;
        parent.syncErrorThrown = true;
        return true;
      } else {
        hostReportError(err);
        return true;
      }
    }
    return false;
  };
  SafeSubscriber2.prototype._unsubscribe = function() {
    var _parentSubscriber = this._parentSubscriber;
    this._context = null;
    this._parentSubscriber = null;
    _parentSubscriber.unsubscribe();
  };
  return SafeSubscriber2;
}(Subscriber);

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/util/canReportError.js
function canReportError(observer) {
  while (observer) {
    var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
    if (closed_1 || isStopped) {
      return false;
    } else if (destination && destination instanceof Subscriber) {
      observer = destination;
    } else {
      observer = null;
    }
  }
  return true;
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/util/toSubscriber.js
function toSubscriber(nextOrObserver, error, complete) {
  if (nextOrObserver) {
    if (nextOrObserver instanceof Subscriber) {
      return nextOrObserver;
    }
    if (nextOrObserver[rxSubscriber]) {
      return nextOrObserver[rxSubscriber]();
    }
  }
  if (!nextOrObserver && !error && !complete) {
    return new Subscriber(empty);
  }
  return new Subscriber(nextOrObserver, error, complete);
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/symbol/observable.js
var observable = /* @__PURE__ */ function() {
  return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/util/identity.js
function identity2(x) {
  return x;
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/util/pipe.js
function pipe() {
  var fns = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    fns[_i] = arguments[_i];
  }
  return pipeFromArray(fns);
}
function pipeFromArray(fns) {
  if (fns.length === 0) {
    return identity2;
  }
  if (fns.length === 1) {
    return fns[0];
  }
  return function piped(input) {
    return fns.reduce(function(prev, fn) {
      return fn(prev);
    }, input);
  };
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/Observable.js
var Observable = /* @__PURE__ */ function() {
  function Observable6(subscribe) {
    this._isScalar = false;
    if (subscribe) {
      this._subscribe = subscribe;
    }
  }
  Observable6.prototype.lift = function(operator) {
    var observable2 = new Observable6();
    observable2.source = this;
    observable2.operator = operator;
    return observable2;
  };
  Observable6.prototype.subscribe = function(observerOrNext, error, complete) {
    var operator = this.operator;
    var sink = toSubscriber(observerOrNext, error, complete);
    if (operator) {
      sink.add(operator.call(sink, this.source));
    } else {
      sink.add(this.source || config.useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
    }
    if (config.useDeprecatedSynchronousErrorHandling) {
      if (sink.syncErrorThrowable) {
        sink.syncErrorThrowable = false;
        if (sink.syncErrorThrown) {
          throw sink.syncErrorValue;
        }
      }
    }
    return sink;
  };
  Observable6.prototype._trySubscribe = function(sink) {
    try {
      return this._subscribe(sink);
    } catch (err) {
      if (config.useDeprecatedSynchronousErrorHandling) {
        sink.syncErrorThrown = true;
        sink.syncErrorValue = err;
      }
      if (canReportError(sink)) {
        sink.error(err);
      } else {
        console.warn(err);
      }
    }
  };
  Observable6.prototype.forEach = function(next, promiseCtor) {
    var _this = this;
    promiseCtor = getPromiseCtor(promiseCtor);
    return new promiseCtor(function(resolve, reject) {
      var subscription;
      subscription = _this.subscribe(function(value) {
        try {
          next(value);
        } catch (err) {
          reject(err);
          if (subscription) {
            subscription.unsubscribe();
          }
        }
      }, reject, resolve);
    });
  };
  Observable6.prototype._subscribe = function(subscriber) {
    var source = this.source;
    return source && source.subscribe(subscriber);
  };
  Observable6.prototype[observable] = function() {
    return this;
  };
  Observable6.prototype.pipe = function() {
    var operations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      operations[_i] = arguments[_i];
    }
    if (operations.length === 0) {
      return this;
    }
    return pipeFromArray(operations)(this);
  };
  Observable6.prototype.toPromise = function(promiseCtor) {
    var _this = this;
    promiseCtor = getPromiseCtor(promiseCtor);
    return new promiseCtor(function(resolve, reject) {
      var value;
      _this.subscribe(function(x) {
        return value = x;
      }, function(err) {
        return reject(err);
      }, function() {
        return resolve(value);
      });
    });
  };
  Observable6.create = function(subscribe) {
    return new Observable6(subscribe);
  };
  return Observable6;
}();
function getPromiseCtor(promiseCtor) {
  if (!promiseCtor) {
    promiseCtor = config.Promise || Promise;
  }
  if (!promiseCtor) {
    throw new Error("no Promise impl found");
  }
  return promiseCtor;
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/util/subscribeToArray.js
var subscribeToArray = function(array) {
  return function(subscriber) {
    for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
      subscriber.next(array[i]);
    }
    subscriber.complete();
  };
};

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/util/subscribeToPromise.js
var subscribeToPromise = function(promise) {
  return function(subscriber) {
    promise.then(function(value) {
      if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
      }
    }, function(err) {
      return subscriber.error(err);
    }).then(null, hostReportError);
    return subscriber;
  };
};

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/symbol/iterator.js
function getSymbolIterator() {
  if (typeof Symbol !== "function" || !Symbol.iterator) {
    return "@@iterator";
  }
  return Symbol.iterator;
}
var iterator = /* @__PURE__ */ getSymbolIterator();

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/util/subscribeToIterable.js
var subscribeToIterable = function(iterable) {
  return function(subscriber) {
    var iterator2 = iterable[iterator]();
    do {
      var item = void 0;
      try {
        item = iterator2.next();
      } catch (err) {
        subscriber.error(err);
        return subscriber;
      }
      if (item.done) {
        subscriber.complete();
        break;
      }
      subscriber.next(item.value);
      if (subscriber.closed) {
        break;
      }
    } while (true);
    if (typeof iterator2.return === "function") {
      subscriber.add(function() {
        if (iterator2.return) {
          iterator2.return();
        }
      });
    }
    return subscriber;
  };
};

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/util/subscribeToObservable.js
var subscribeToObservable = function(obj) {
  return function(subscriber) {
    var obs = obj[observable]();
    if (typeof obs.subscribe !== "function") {
      throw new TypeError("Provided object does not correctly implement Symbol.observable");
    } else {
      return obs.subscribe(subscriber);
    }
  };
};

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/util/isArrayLike.js
var isArrayLike = function(x) {
  return x && typeof x.length === "number" && typeof x !== "function";
};

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/util/isPromise.js
function isPromise(value) {
  return !!value && typeof value.subscribe !== "function" && typeof value.then === "function";
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/util/subscribeTo.js
var subscribeTo = function(result) {
  if (!!result && typeof result[observable] === "function") {
    return subscribeToObservable(result);
  } else if (isArrayLike(result)) {
    return subscribeToArray(result);
  } else if (isPromise(result)) {
    return subscribeToPromise(result);
  } else if (!!result && typeof result[iterator] === "function") {
    return subscribeToIterable(result);
  } else {
    var value = isObject(result) ? "an invalid object" : "'" + result + "'";
    var msg = "You provided " + value + " where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.";
    throw new TypeError(msg);
  }
};

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/innerSubscribe.js
var SimpleInnerSubscriber = /* @__PURE__ */ function(_super) {
  tslib_12.__extends(SimpleInnerSubscriber2, _super);
  function SimpleInnerSubscriber2(parent) {
    var _this = _super.call(this) || this;
    _this.parent = parent;
    return _this;
  }
  SimpleInnerSubscriber2.prototype._next = function(value) {
    this.parent.notifyNext(value);
  };
  SimpleInnerSubscriber2.prototype._error = function(error) {
    this.parent.notifyError(error);
    this.unsubscribe();
  };
  SimpleInnerSubscriber2.prototype._complete = function() {
    this.parent.notifyComplete();
    this.unsubscribe();
  };
  return SimpleInnerSubscriber2;
}(Subscriber);
var SimpleOuterSubscriber = /* @__PURE__ */ function(_super) {
  tslib_12.__extends(SimpleOuterSubscriber2, _super);
  function SimpleOuterSubscriber2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SimpleOuterSubscriber2.prototype.notifyNext = function(innerValue) {
    this.destination.next(innerValue);
  };
  SimpleOuterSubscriber2.prototype.notifyError = function(err) {
    this.destination.error(err);
  };
  SimpleOuterSubscriber2.prototype.notifyComplete = function() {
    this.destination.complete();
  };
  return SimpleOuterSubscriber2;
}(Subscriber);
function innerSubscribe(result, innerSubscriber) {
  if (innerSubscriber.closed) {
    return void 0;
  }
  if (result instanceof Observable) {
    return result.subscribe(innerSubscriber);
  }
  var subscription;
  try {
    subscription = subscribeTo(result)(innerSubscriber);
  } catch (error) {
    innerSubscriber.error(error);
  }
  return subscription;
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/operators/catchError.js
import * as tslib_13 from "tslib";
function catchError(selector) {
  return function catchErrorOperatorFunction(source) {
    var operator = new CatchOperator(selector);
    var caught = source.lift(operator);
    return operator.caught = caught;
  };
}
var CatchOperator = /* @__PURE__ */ function() {
  function CatchOperator2(selector) {
    this.selector = selector;
  }
  CatchOperator2.prototype.call = function(subscriber, source) {
    return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
  };
  return CatchOperator2;
}();
var CatchSubscriber = /* @__PURE__ */ function(_super) {
  tslib_13.__extends(CatchSubscriber2, _super);
  function CatchSubscriber2(destination, selector, caught) {
    var _this = _super.call(this, destination) || this;
    _this.selector = selector;
    _this.caught = caught;
    return _this;
  }
  CatchSubscriber2.prototype.error = function(err) {
    if (!this.isStopped) {
      var result = void 0;
      try {
        result = this.selector(err, this.caught);
      } catch (err2) {
        _super.prototype.error.call(this, err2);
        return;
      }
      this._unsubscribeAndRecycle();
      var innerSubscriber = new SimpleInnerSubscriber(this);
      this.add(innerSubscriber);
      var innerSubscription = innerSubscribe(result, innerSubscriber);
      if (innerSubscription !== innerSubscriber) {
        this.add(innerSubscription);
      }
    }
  };
  return CatchSubscriber2;
}(SimpleOuterSubscriber);

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/scheduled/scheduleArray.js
function scheduleArray(input, scheduler) {
  return new Observable(function(subscriber) {
    var sub = new Subscription();
    var i = 0;
    sub.add(scheduler.schedule(function() {
      if (i === input.length) {
        subscriber.complete();
        return;
      }
      subscriber.next(input[i++]);
      if (!subscriber.closed) {
        sub.add(this.schedule());
      }
    }));
    return sub;
  });
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/scheduled/scheduleObservable.js
function scheduleObservable(input, scheduler) {
  return new Observable(function(subscriber) {
    var sub = new Subscription();
    sub.add(scheduler.schedule(function() {
      var observable2 = input[observable]();
      sub.add(observable2.subscribe({
        next: function(value) {
          sub.add(scheduler.schedule(function() {
            return subscriber.next(value);
          }));
        },
        error: function(err) {
          sub.add(scheduler.schedule(function() {
            return subscriber.error(err);
          }));
        },
        complete: function() {
          sub.add(scheduler.schedule(function() {
            return subscriber.complete();
          }));
        }
      }));
    }));
    return sub;
  });
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/scheduled/schedulePromise.js
function schedulePromise(input, scheduler) {
  return new Observable(function(subscriber) {
    var sub = new Subscription();
    sub.add(scheduler.schedule(function() {
      return input.then(function(value) {
        sub.add(scheduler.schedule(function() {
          subscriber.next(value);
          sub.add(scheduler.schedule(function() {
            return subscriber.complete();
          }));
        }));
      }, function(err) {
        sub.add(scheduler.schedule(function() {
          return subscriber.error(err);
        }));
      });
    }));
    return sub;
  });
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/scheduled/scheduleIterable.js
function scheduleIterable(input, scheduler) {
  if (!input) {
    throw new Error("Iterable cannot be null");
  }
  return new Observable(function(subscriber) {
    var sub = new Subscription();
    var iterator2;
    sub.add(function() {
      if (iterator2 && typeof iterator2.return === "function") {
        iterator2.return();
      }
    });
    sub.add(scheduler.schedule(function() {
      iterator2 = input[iterator]();
      sub.add(scheduler.schedule(function() {
        if (subscriber.closed) {
          return;
        }
        var value;
        var done;
        try {
          var result = iterator2.next();
          value = result.value;
          done = result.done;
        } catch (err) {
          subscriber.error(err);
          return;
        }
        if (done) {
          subscriber.complete();
        } else {
          subscriber.next(value);
          this.schedule();
        }
      }));
    }));
    return sub;
  });
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/util/isInteropObservable.js
function isInteropObservable(input) {
  return input && typeof input[observable] === "function";
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/util/isIterable.js
function isIterable(input) {
  return input && typeof input[iterator] === "function";
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/scheduled/scheduled.js
function scheduled(input, scheduler) {
  if (input != null) {
    if (isInteropObservable(input)) {
      return scheduleObservable(input, scheduler);
    } else if (isPromise(input)) {
      return schedulePromise(input, scheduler);
    } else if (isArrayLike(input)) {
      return scheduleArray(input, scheduler);
    } else if (isIterable(input) || typeof input === "string") {
      return scheduleIterable(input, scheduler);
    }
  }
  throw new TypeError((input !== null && typeof input || input) + " is not observable");
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/observable/from.js
function from(input, scheduler) {
  if (!scheduler) {
    if (input instanceof Observable) {
      return input;
    }
    return new Observable(subscribeTo(input));
  } else {
    return scheduled(input, scheduler);
  }
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/operators/mergeMap.js
import * as tslib_15 from "tslib";

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/operators/map.js
import * as tslib_14 from "tslib";
function map3(project, thisArg) {
  return function mapOperation(source) {
    if (typeof project !== "function") {
      throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
    }
    return source.lift(new MapOperator(project, thisArg));
  };
}
var MapOperator = /* @__PURE__ */ function() {
  function MapOperator2(project, thisArg) {
    this.project = project;
    this.thisArg = thisArg;
  }
  MapOperator2.prototype.call = function(subscriber, source) {
    return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
  };
  return MapOperator2;
}();
var MapSubscriber = /* @__PURE__ */ function(_super) {
  tslib_14.__extends(MapSubscriber2, _super);
  function MapSubscriber2(destination, project, thisArg) {
    var _this = _super.call(this, destination) || this;
    _this.project = project;
    _this.count = 0;
    _this.thisArg = thisArg || _this;
    return _this;
  }
  MapSubscriber2.prototype._next = function(value) {
    var result;
    try {
      result = this.project.call(this.thisArg, value, this.count++);
    } catch (err) {
      this.destination.error(err);
      return;
    }
    this.destination.next(result);
  };
  return MapSubscriber2;
}(Subscriber);

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/operators/mergeMap.js
function mergeMap(project, resultSelector, concurrent) {
  if (concurrent === void 0) {
    concurrent = Number.POSITIVE_INFINITY;
  }
  if (typeof resultSelector === "function") {
    return function(source) {
      return source.pipe(mergeMap(function(a, i) {
        return from(project(a, i)).pipe(map3(function(b, ii) {
          return resultSelector(a, b, i, ii);
        }));
      }, concurrent));
    };
  } else if (typeof resultSelector === "number") {
    concurrent = resultSelector;
  }
  return function(source) {
    return source.lift(new MergeMapOperator(project, concurrent));
  };
}
var MergeMapOperator = /* @__PURE__ */ function() {
  function MergeMapOperator2(project, concurrent) {
    if (concurrent === void 0) {
      concurrent = Number.POSITIVE_INFINITY;
    }
    this.project = project;
    this.concurrent = concurrent;
  }
  MergeMapOperator2.prototype.call = function(observer, source) {
    return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
  };
  return MergeMapOperator2;
}();
var MergeMapSubscriber = /* @__PURE__ */ function(_super) {
  tslib_15.__extends(MergeMapSubscriber2, _super);
  function MergeMapSubscriber2(destination, project, concurrent) {
    if (concurrent === void 0) {
      concurrent = Number.POSITIVE_INFINITY;
    }
    var _this = _super.call(this, destination) || this;
    _this.project = project;
    _this.concurrent = concurrent;
    _this.hasCompleted = false;
    _this.buffer = [];
    _this.active = 0;
    _this.index = 0;
    return _this;
  }
  MergeMapSubscriber2.prototype._next = function(value) {
    if (this.active < this.concurrent) {
      this._tryNext(value);
    } else {
      this.buffer.push(value);
    }
  };
  MergeMapSubscriber2.prototype._tryNext = function(value) {
    var result;
    var index = this.index++;
    try {
      result = this.project(value, index);
    } catch (err) {
      this.destination.error(err);
      return;
    }
    this.active++;
    this._innerSub(result);
  };
  MergeMapSubscriber2.prototype._innerSub = function(ish) {
    var innerSubscriber = new SimpleInnerSubscriber(this);
    var destination = this.destination;
    destination.add(innerSubscriber);
    var innerSubscription = innerSubscribe(ish, innerSubscriber);
    if (innerSubscription !== innerSubscriber) {
      destination.add(innerSubscription);
    }
  };
  MergeMapSubscriber2.prototype._complete = function() {
    this.hasCompleted = true;
    if (this.active === 0 && this.buffer.length === 0) {
      this.destination.complete();
    }
    this.unsubscribe();
  };
  MergeMapSubscriber2.prototype.notifyNext = function(innerValue) {
    this.destination.next(innerValue);
  };
  MergeMapSubscriber2.prototype.notifyComplete = function() {
    var buffer = this.buffer;
    this.active--;
    if (buffer.length > 0) {
      this._next(buffer.shift());
    } else if (this.active === 0 && this.hasCompleted) {
      this.destination.complete();
    }
  };
  return MergeMapSubscriber2;
}(SimpleOuterSubscriber);

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/operators/concatMap.js
function concatMap(project, resultSelector) {
  return mergeMap(project, resultSelector, 1);
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/operators/defaultIfEmpty.js
import * as tslib_16 from "tslib";
function defaultIfEmpty(defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = null;
  }
  return function(source) {
    return source.lift(new DefaultIfEmptyOperator(defaultValue));
  };
}
var DefaultIfEmptyOperator = /* @__PURE__ */ function() {
  function DefaultIfEmptyOperator2(defaultValue) {
    this.defaultValue = defaultValue;
  }
  DefaultIfEmptyOperator2.prototype.call = function(subscriber, source) {
    return source.subscribe(new DefaultIfEmptySubscriber(subscriber, this.defaultValue));
  };
  return DefaultIfEmptyOperator2;
}();
var DefaultIfEmptySubscriber = /* @__PURE__ */ function(_super) {
  tslib_16.__extends(DefaultIfEmptySubscriber2, _super);
  function DefaultIfEmptySubscriber2(destination, defaultValue) {
    var _this = _super.call(this, destination) || this;
    _this.defaultValue = defaultValue;
    _this.isEmpty = true;
    return _this;
  }
  DefaultIfEmptySubscriber2.prototype._next = function(value) {
    this.isEmpty = false;
    this.destination.next(value);
  };
  DefaultIfEmptySubscriber2.prototype._complete = function() {
    if (this.isEmpty) {
      this.destination.next(this.defaultValue);
    }
    this.destination.complete();
  };
  return DefaultIfEmptySubscriber2;
}(Subscriber);

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/observable/empty.js
var EMPTY = /* @__PURE__ */ new Observable(function(subscriber) {
  return subscriber.complete();
});
function empty2(scheduler) {
  return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
  return new Observable(function(subscriber) {
    return scheduler.schedule(function() {
      return subscriber.complete();
    });
  });
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/operators/distinctUntilChanged.js
import * as tslib_17 from "tslib";
function distinctUntilChanged(compare, keySelector) {
  return function(source) {
    return source.lift(new DistinctUntilChangedOperator(compare, keySelector));
  };
}
var DistinctUntilChangedOperator = /* @__PURE__ */ function() {
  function DistinctUntilChangedOperator2(compare, keySelector) {
    this.compare = compare;
    this.keySelector = keySelector;
  }
  DistinctUntilChangedOperator2.prototype.call = function(subscriber, source) {
    return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
  };
  return DistinctUntilChangedOperator2;
}();
var DistinctUntilChangedSubscriber = /* @__PURE__ */ function(_super) {
  tslib_17.__extends(DistinctUntilChangedSubscriber2, _super);
  function DistinctUntilChangedSubscriber2(destination, compare, keySelector) {
    var _this = _super.call(this, destination) || this;
    _this.keySelector = keySelector;
    _this.hasKey = false;
    if (typeof compare === "function") {
      _this.compare = compare;
    }
    return _this;
  }
  DistinctUntilChangedSubscriber2.prototype.compare = function(x, y) {
    return x === y;
  };
  DistinctUntilChangedSubscriber2.prototype._next = function(value) {
    var key;
    try {
      var keySelector = this.keySelector;
      key = keySelector ? keySelector(value) : value;
    } catch (err) {
      return this.destination.error(err);
    }
    var result = false;
    if (this.hasKey) {
      try {
        var compare = this.compare;
        result = compare(this.key, key);
      } catch (err) {
        return this.destination.error(err);
      }
    } else {
      this.hasKey = true;
    }
    if (!result) {
      this.key = key;
      this.destination.next(value);
    }
  };
  return DistinctUntilChangedSubscriber2;
}(Subscriber);

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/util/ArgumentOutOfRangeError.js
var ArgumentOutOfRangeErrorImpl = /* @__PURE__ */ function() {
  function ArgumentOutOfRangeErrorImpl2() {
    Error.call(this);
    this.message = "argument out of range";
    this.name = "ArgumentOutOfRangeError";
    return this;
  }
  ArgumentOutOfRangeErrorImpl2.prototype = /* @__PURE__ */ Object.create(Error.prototype);
  return ArgumentOutOfRangeErrorImpl2;
}();
var ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/operators/expand.js
import * as tslib_18 from "tslib";
function expand(project, concurrent, scheduler) {
  if (concurrent === void 0) {
    concurrent = Number.POSITIVE_INFINITY;
  }
  concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
  return function(source) {
    return source.lift(new ExpandOperator(project, concurrent, scheduler));
  };
}
var ExpandOperator = /* @__PURE__ */ function() {
  function ExpandOperator2(project, concurrent, scheduler) {
    this.project = project;
    this.concurrent = concurrent;
    this.scheduler = scheduler;
  }
  ExpandOperator2.prototype.call = function(subscriber, source) {
    return source.subscribe(new ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
  };
  return ExpandOperator2;
}();
var ExpandSubscriber = /* @__PURE__ */ function(_super) {
  tslib_18.__extends(ExpandSubscriber2, _super);
  function ExpandSubscriber2(destination, project, concurrent, scheduler) {
    var _this = _super.call(this, destination) || this;
    _this.project = project;
    _this.concurrent = concurrent;
    _this.scheduler = scheduler;
    _this.index = 0;
    _this.active = 0;
    _this.hasCompleted = false;
    if (concurrent < Number.POSITIVE_INFINITY) {
      _this.buffer = [];
    }
    return _this;
  }
  ExpandSubscriber2.dispatch = function(arg) {
    var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
    subscriber.subscribeToProjection(result, value, index);
  };
  ExpandSubscriber2.prototype._next = function(value) {
    var destination = this.destination;
    if (destination.closed) {
      this._complete();
      return;
    }
    var index = this.index++;
    if (this.active < this.concurrent) {
      destination.next(value);
      try {
        var project = this.project;
        var result = project(value, index);
        if (!this.scheduler) {
          this.subscribeToProjection(result, value, index);
        } else {
          var state = { subscriber: this, result, value, index };
          var destination_1 = this.destination;
          destination_1.add(this.scheduler.schedule(ExpandSubscriber2.dispatch, 0, state));
        }
      } catch (e) {
        destination.error(e);
      }
    } else {
      this.buffer.push(value);
    }
  };
  ExpandSubscriber2.prototype.subscribeToProjection = function(result, value, index) {
    this.active++;
    var destination = this.destination;
    destination.add(innerSubscribe(result, new SimpleInnerSubscriber(this)));
  };
  ExpandSubscriber2.prototype._complete = function() {
    this.hasCompleted = true;
    if (this.hasCompleted && this.active === 0) {
      this.destination.complete();
    }
    this.unsubscribe();
  };
  ExpandSubscriber2.prototype.notifyNext = function(innerValue) {
    this._next(innerValue);
  };
  ExpandSubscriber2.prototype.notifyComplete = function() {
    var buffer = this.buffer;
    this.active--;
    if (buffer && buffer.length > 0) {
      this._next(buffer.shift());
    }
    if (this.hasCompleted && this.active === 0) {
      this.destination.complete();
    }
  };
  return ExpandSubscriber2;
}(SimpleOuterSubscriber);

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/operators/takeLast.js
import * as tslib_19 from "tslib";
function takeLast(count) {
  return function takeLastOperatorFunction(source) {
    if (count === 0) {
      return empty2();
    } else {
      return source.lift(new TakeLastOperator(count));
    }
  };
}
var TakeLastOperator = /* @__PURE__ */ function() {
  function TakeLastOperator2(total) {
    this.total = total;
    if (this.total < 0) {
      throw new ArgumentOutOfRangeError();
    }
  }
  TakeLastOperator2.prototype.call = function(subscriber, source) {
    return source.subscribe(new TakeLastSubscriber(subscriber, this.total));
  };
  return TakeLastOperator2;
}();
var TakeLastSubscriber = /* @__PURE__ */ function(_super) {
  tslib_19.__extends(TakeLastSubscriber2, _super);
  function TakeLastSubscriber2(destination, total) {
    var _this = _super.call(this, destination) || this;
    _this.total = total;
    _this.ring = new Array();
    _this.count = 0;
    return _this;
  }
  TakeLastSubscriber2.prototype._next = function(value) {
    var ring = this.ring;
    var total = this.total;
    var count = this.count++;
    if (ring.length < total) {
      ring.push(value);
    } else {
      var index = count % total;
      ring[index] = value;
    }
  };
  TakeLastSubscriber2.prototype._complete = function() {
    var destination = this.destination;
    var count = this.count;
    if (count > 0) {
      var total = this.count >= this.total ? this.total : this.count;
      var ring = this.ring;
      for (var i = 0; i < total; i++) {
        var idx = count++ % total;
        destination.next(ring[idx]);
      }
    }
    destination.complete();
  };
  return TakeLastSubscriber2;
}(Subscriber);

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/operators/scan.js
import * as tslib_110 from "tslib";
function scan(accumulator, seed) {
  var hasSeed = false;
  if (arguments.length >= 2) {
    hasSeed = true;
  }
  return function scanOperatorFunction(source) {
    return source.lift(new ScanOperator(accumulator, seed, hasSeed));
  };
}
var ScanOperator = /* @__PURE__ */ function() {
  function ScanOperator2(accumulator, seed, hasSeed) {
    if (hasSeed === void 0) {
      hasSeed = false;
    }
    this.accumulator = accumulator;
    this.seed = seed;
    this.hasSeed = hasSeed;
  }
  ScanOperator2.prototype.call = function(subscriber, source) {
    return source.subscribe(new ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
  };
  return ScanOperator2;
}();
var ScanSubscriber = /* @__PURE__ */ function(_super) {
  tslib_110.__extends(ScanSubscriber2, _super);
  function ScanSubscriber2(destination, accumulator, _seed, hasSeed) {
    var _this = _super.call(this, destination) || this;
    _this.accumulator = accumulator;
    _this._seed = _seed;
    _this.hasSeed = hasSeed;
    _this.index = 0;
    return _this;
  }
  Object.defineProperty(ScanSubscriber2.prototype, "seed", {
    get: function() {
      return this._seed;
    },
    set: function(value) {
      this.hasSeed = true;
      this._seed = value;
    },
    enumerable: true,
    configurable: true
  });
  ScanSubscriber2.prototype._next = function(value) {
    if (!this.hasSeed) {
      this.seed = value;
      this.destination.next(value);
    } else {
      return this._tryNext(value);
    }
  };
  ScanSubscriber2.prototype._tryNext = function(value) {
    var index = this.index++;
    var result;
    try {
      result = this.accumulator(this.seed, value, index);
    } catch (err) {
      this.destination.error(err);
    }
    this.seed = result;
    this.destination.next(result);
  };
  return ScanSubscriber2;
}(Subscriber);

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/operators/reduce.js
function reduce(accumulator, seed) {
  if (arguments.length >= 2) {
    return function reduceOperatorFunctionWithSeed(source) {
      return pipe(scan(accumulator, seed), takeLast(1), defaultIfEmpty(seed))(source);
    };
  }
  return function reduceOperatorFunction(source) {
    return pipe(scan(function(acc, value, index) {
      return accumulator(acc, value, index + 1);
    }), takeLast(1))(source);
  };
}

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/operators/toArray.js
function toArrayReducer(arr, item, index) {
  if (index === 0) {
    return [item];
  }
  arr.push(item);
  return arr;
}
function toArray() {
  return reduce(toArrayReducer, []);
}

// src/repository/apiIntercepters.ts
import { ZodError } from "zod";
var createAxiosRequestConfig = (specialHeaders, token, impersonatingAs) => {
  let requestHeaders = { ...defaultHeaders, ...specialHeaders, authorization: token != null ? token : "" };
  requestHeaders = !isStringEmpty3(impersonatingAs) ? { ...requestHeaders, impersonatingAs } : requestHeaders;
  return {
    headers: requestHeaders,
    timeout: defaultApiTimeout,
    timeoutErrorMessage
  };
};
var getTokenAndImpersoHeaders = (appendImpersonatingAs) => {
  var _a, _b, _c;
  const sgwtConnect = (_a = document.querySelector("sgwt-connect")) == null ? void 0 : _a.sgwtConnect;
  const token = sgwtConnect == null ? void 0 : sgwtConnect.getAuthorizationHeader();
  const authValue = token ? { authorization: token } : {};
  let impersoValue = {};
  if (appendImpersonatingAs) {
    const localStorageValue = (_b = sessionStorage.getItem("impersonate")) == null ? void 0 : _b.replace("undefined", "{}");
    const impersonatingAs = (_c = JSON.parse(localStorageValue != null ? localStorageValue : "{}")) == null ? void 0 : _c.email;
    impersoValue = impersonatingAs ? { impersonatingAs } : {};
  }
  return { ...authValue, ...impersoValue };
};
var apiRequestHandler = (config2) => {
  return (request) => {
    const {
      logger: logger2,
      env: env2 = getEnvironment2(),
      appendImpersonatingAs = false,
      isInLan,
      urlMappingConfig = iCUrlMappingConfig
    } = config2;
    const key = generateUID();
    const isInLanFromHeaders = tryParseJsonField(request.headers, "isInLan");
    const authorization = getTokenAndImpersoHeaders(appendImpersonatingAs);
    const headers = {
      ...request.headers,
      ...authorization,
      isInLan: isInLanFromHeaders != null ? isInLanFromHeaders : isInLan
    };
    request.url = buildUrlForEnv(env2, request.url, headers, void 0, void 0, urlMappingConfig);
    request.headers = omit2(headers, "isInLan");
    request.xRequestID = key;
    const debugMessage = {
      type: "Request",
      url: request.url,
      params: request.params,
      method: request.method,
      data: request.data
    };
    logger2.debug("Http Request", JSON.stringify(debugMessage));
    logger2.startPerformanceMeasure(key);
    return request;
  };
};
var apiResponseHandler = (logger2) => {
  return (response) => {
    var _a;
    const xRequestId = (_a = response.config.xRequestID) != null ? _a : "";
    const debugMessage = {
      type: "Response",
      url: response.request.responseURL,
      status: response.status,
      statusText: response.statusText,
      responseHeaders: response.headers
    };
    logger2.debug("Http Response", JSON.stringify(debugMessage));
    logger2.endPerformanceMeasure("Performance log", response.request.responseURL, xRequestId);
    const repoResponse = {
      status: response.status,
      statusText: response.statusText,
      data: response.data,
      requestUrl: response.config.url,
      requestHeaders: response.config.headers
    };
    return repoResponse;
  };
};
var mapToErrorMessage = (error) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const data = (_a = error.response) == null ? void 0 : _a.data;
  const strData = typeof data === "string" ? data : null;
  const message = (_g = (_f = (_e = (_d = (_c = (_b = data == null ? void 0 : data.UserMessage) != null ? _b : data == null ? void 0 : data.userMessage) != null ? _c : data == null ? void 0 : data.message) != null ? _d : data == null ? void 0 : data.title) != null ? _e : strData) != null ? _f : error.message) != null ? _g : (
    // generic axios error
    "Unknown server error"
  );
  return typeof message === "string" ? message : null;
};
function mapToRepositoryError(error) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const message = mapToErrorMessage(error);
  return {
    data: (_a = error.response) == null ? void 0 : _a.data,
    etag: (_c = (_b = error.response) == null ? void 0 : _b.headers) == null ? void 0 : _c["etag"],
    requestUrl: error.config.url,
    status: (_d = error.response) == null ? void 0 : _d.status,
    type: (_e = error.response) == null ? void 0 : _e.status,
    message: (_g = message != null ? message : (_f = error.response) == null ? void 0 : _f.statusText) != null ? _g : "",
    details: (_i = (_h = error.response) == null ? void 0 : _h.data) == null ? void 0 : _i.details
  };
}
var mapZodErrorToRepositoryError = (error, url15, requestOrResponse) => {
  var _a, _b;
  return {
    data: error.issues,
    requestUrl: url15,
    status: 500,
    type: 500,
    message: `Zod error in ${requestOrResponse}`,
    details: ((_b = (_a = error.format()) == null ? void 0 : _a._errors) == null ? void 0 : _b.join(",")) || ""
  };
};
var apiErrorHandler = (logger2) => {
  return (error) => {
    var _a;
    if (!(error == null ? void 0 : error.isAxiosError)) {
      return Promise.reject({ errorMessage: "Unknown error" });
    }
    const repoError = mapToRepositoryError(error);
    logger2.logError(
      (_a = `${repoError.message} (${repoError.status}) calling ${repoError.requestUrl}`) != null ? _a : "",
      error,
      error.stack
    );
    return Promise.reject(repoError);
  };
};
var apiValidationHandler = (request, url15, eventSchemaConfig, body) => {
  var _a;
  if ((eventSchemaConfig == null ? void 0 : eventSchemaConfig.requestSchema) && body) {
    try {
      (_a = eventSchemaConfig == null ? void 0 : eventSchemaConfig.requestSchema) == null ? void 0 : _a.parse(body);
    } catch (err) {
      const mappedError = err instanceof ZodError ? mapZodErrorToRepositoryError(err, url15, "request") : err;
      throw mappedError;
    }
  }
  if (eventSchemaConfig == null ? void 0 : eventSchemaConfig.responseSchema) {
    return request().then((response) => {
      var _a2;
      {
        try {
          return { ...response, data: (_a2 = eventSchemaConfig == null ? void 0 : eventSchemaConfig.responseSchema) == null ? void 0 : _a2.parse(response.data) };
        } catch (error) {
          const mappedError = error instanceof ZodError ? mapZodErrorToRepositoryError(error, url15, "response") : error;
          throw mappedError;
        }
      }
    });
  }
  return request();
};
var apiRxValidationHandler = (request, url15, eventSchemaConfig, body) => {
  var _a;
  if ((eventSchemaConfig == null ? void 0 : eventSchemaConfig.requestSchema) && body) {
    try {
      (_a = eventSchemaConfig == null ? void 0 : eventSchemaConfig.requestSchema) == null ? void 0 : _a.parse(body);
    } catch (err) {
      const mappedError = err instanceof ZodError ? mapZodErrorToRepositoryError(err, url15, "request") : err;
      throw mappedError;
    }
  }
  if (eventSchemaConfig == null ? void 0 : eventSchemaConfig.responseSchema) {
    return request().pipe(
      map3((response) => {
        var _a2;
        {
          try {
            return (_a2 = eventSchemaConfig == null ? void 0 : eventSchemaConfig.responseSchema) == null ? void 0 : _a2.parse(response);
          } catch (error) {
            const mappedError = error instanceof ZodError ? mapZodErrorToRepositoryError(error, url15, "response") : error;
            throw mappedError;
          }
        }
      })
    );
  }
  return request();
};

// src/repository/apiRepository.ts
import { omit as omit3, reduce as reduce2 } from "lodash-es";
var createAxiosInstance = (specialHeaders, token, impersonatingAs) => {
  let requestHeaders = {
    ...defaultHeaders,
    ...specialHeaders,
    authorization: token != null ? token : ""
  };
  requestHeaders = !isStringEmpty4(impersonatingAs) ? { ...requestHeaders, impersonatingAs } : requestHeaders;
  return import_axios.default.create({
    headers: requestHeaders,
    timeout: defaultApiTimeout,
    timeoutErrorMessage
  });
};
var ApiRepository = class {
  constructor(config2) {
    this.config = config2 != null ? config2 : null;
    const {
      specialHeaders = {},
      token,
      logger: logger2 = consoleLogger,
      impersonatingAs,
      appendImpersonatingAs = false,
      env: env2 = getEnvironment3(),
      isInLan,
      urlMappingConfig
    } = config2 != null ? config2 : {};
    const axiosInstance = createAxiosInstance(specialHeaders, token, impersonatingAs);
    axiosInstance.interceptors.request.use(
      apiRequestHandler({ logger: logger2, env: env2, appendImpersonatingAs, isInLan, urlMappingConfig }),
      apiErrorHandler(logger2)
    );
    axiosInstance.interceptors.response.use(apiResponseHandler(logger2), apiErrorHandler(logger2));
    this.axiosClient = axiosInstance;
  }
  static Crm(config2) {
    return new ApiRepository(config2);
  }
  static ContactDb(config2) {
    return new ApiRepository({ ...config2, specialHeaders: contactDbHeader });
  }
  static CliGlobalView(config2) {
    return new ApiRepository({
      ...config2,
      specialHeaders: { Source: "swagger" }
    });
  }
  get(url15, params, config2, eventSchemaConfig) {
    const request = () => this.axiosClient.get(url15, {
      params,
      paramsSerializer,
      ...config2
    });
    return apiValidationHandler(request, url15, eventSchemaConfig);
  }
  put(url15, body, params, config2, eventSchemaConfig) {
    const request = () => this.axiosClient.put(url15, body, { params, ...config2 });
    return apiValidationHandler(request, url15, eventSchemaConfig, body);
  }
  patch(url15, body, params, config2, eventSchemaConfig) {
    const request = () => this.axiosClient.patch(url15, body, { params, ...config2 });
    return apiValidationHandler(request, url15, eventSchemaConfig, body);
  }
  post(url15, body, params, config2, eventSchemaConfig) {
    const request = () => this.axiosClient.post(url15, body, { params, ...config2 });
    return apiValidationHandler(request, url15, eventSchemaConfig, body);
  }
  delete(url15, params, config2, eventSchemaConfig) {
    const request = () => this.axiosClient.delete(url15, { params, ...config2 });
    return apiValidationHandler(request, url15, eventSchemaConfig);
  }
  download(url15, headers, options = {}, params) {
    const { method = "GET", body = {}, fileName } = options;
    const config2 = getAxiosRequestConfigForDownload(options, headers, params);
    const response = method === "POST" ? this.axiosClient.post(url15, body, config2) : this.axiosClient.get(url15, config2);
    return response.then((response2) => {
      var _a, _b, _c;
      const blobFileName = (_c = parseFileNameFromDisposition((_b = (_a = response2 == null ? void 0 : response2.data.xhr) == null ? void 0 : _a.getResponseHeader("content-disposition")) != null ? _b : "")) != null ? _c : fileName;
      return { blob: response2.data, fileName: blobFileName != null ? blobFileName : "" };
    });
  }
  uploadFormData(url15, payload, config2) {
    const formData = new FormData();
    Object.keys(payload).forEach((key) => {
      if (payload[key] && Array.isArray(payload[key])) {
        payload[key].forEach((el) => {
          formData.append(key, el);
        });
      } else {
        formData.append(key, payload[key]);
      }
    });
    return this.axiosClient.post(url15, formData, {
      ...config2,
      headers: omit3(config2 == null ? void 0 : config2.headers, "Content-Type")
    });
  }
  upload(url15, files, config2, fileParamName = "file") {
    const data = reduce2(
      files,
      (acc, file) => {
        acc.append(fileParamName, file);
        return acc;
      },
      new FormData()
    );
    return this.axiosClient.post(url15, data, {
      ...config2,
      headers: omit3(config2 == null ? void 0 : config2.headers, "Content-Type")
    });
  }
};
var getAxiosRequestConfigForDownload = (options, headers, params) => {
  const { accept = OFFICE_ACCEPT_HEADERS.STREAM, timeout = defaultDownloadTimeout } = options;
  return { headers: { ...headers, accept }, timeout, responseType: "blob", params };
};

// src/repository/apiRxRepository.ts
var rxAxios = __toESM(require_dist());
var import_rxjs2 = __toESM(require_rxjs());
import { parseFileNameFromDisposition as parseFileNameFromDisposition2 } from "@ic-anywhere/ic-utils";
import { omit as omit4, reduce as reduce3 } from "lodash-es";

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/observable/dom/AjaxObservable.js
import * as tslib_111 from "tslib";

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/util/root.js
var __window = typeof window !== "undefined" && window;
var __self = typeof self !== "undefined" && typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope && self;
var __global = typeof global !== "undefined" && global;
var _root = __window || __global || __self;

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/observable/dom/AjaxObservable.js
function getCORSRequest() {
  if (_root.XMLHttpRequest) {
    return new _root.XMLHttpRequest();
  } else if (!!_root.XDomainRequest) {
    return new _root.XDomainRequest();
  } else {
    throw new Error("CORS is not supported by your browser");
  }
}
function getXMLHttpRequest() {
  if (_root.XMLHttpRequest) {
    return new _root.XMLHttpRequest();
  } else {
    var progId = void 0;
    try {
      var progIds = ["Msxml2.XMLHTTP", "Microsoft.XMLHTTP", "Msxml2.XMLHTTP.4.0"];
      for (var i = 0; i < 3; i++) {
        try {
          progId = progIds[i];
          if (new _root.ActiveXObject(progId)) {
            break;
          }
        } catch (e) {
        }
      }
      return new _root.ActiveXObject(progId);
    } catch (e) {
      throw new Error("XMLHttpRequest is not supported by your browser");
    }
  }
}
function ajaxGet(url15, headers) {
  if (headers === void 0) {
    headers = null;
  }
  return new AjaxObservable({ method: "GET", url: url15, headers });
}
function ajaxPost(url15, body, headers) {
  return new AjaxObservable({ method: "POST", url: url15, body, headers });
}
function ajaxDelete(url15, headers) {
  return new AjaxObservable({ method: "DELETE", url: url15, headers });
}
function ajaxPut(url15, body, headers) {
  return new AjaxObservable({ method: "PUT", url: url15, body, headers });
}
function ajaxPatch(url15, body, headers) {
  return new AjaxObservable({ method: "PATCH", url: url15, body, headers });
}
var mapResponse = /* @__PURE__ */ map3(function(x, index) {
  return x.response;
});
function ajaxGetJSON(url15, headers) {
  return mapResponse(new AjaxObservable({
    method: "GET",
    url: url15,
    responseType: "json",
    headers
  }));
}
var AjaxObservable = /* @__PURE__ */ function(_super) {
  tslib_111.__extends(AjaxObservable2, _super);
  function AjaxObservable2(urlOrRequest) {
    var _this = _super.call(this) || this;
    var request = {
      async: true,
      createXHR: function() {
        return this.crossDomain ? getCORSRequest() : getXMLHttpRequest();
      },
      crossDomain: true,
      withCredentials: false,
      headers: {},
      method: "GET",
      responseType: "json",
      timeout: 0
    };
    if (typeof urlOrRequest === "string") {
      request.url = urlOrRequest;
    } else {
      for (var prop in urlOrRequest) {
        if (urlOrRequest.hasOwnProperty(prop)) {
          request[prop] = urlOrRequest[prop];
        }
      }
    }
    _this.request = request;
    return _this;
  }
  AjaxObservable2.prototype._subscribe = function(subscriber) {
    return new AjaxSubscriber(subscriber, this.request);
  };
  AjaxObservable2.create = function() {
    var create = function(urlOrRequest) {
      return new AjaxObservable2(urlOrRequest);
    };
    create.get = ajaxGet;
    create.post = ajaxPost;
    create.delete = ajaxDelete;
    create.put = ajaxPut;
    create.patch = ajaxPatch;
    create.getJSON = ajaxGetJSON;
    return create;
  }();
  return AjaxObservable2;
}(Observable);
var AjaxSubscriber = /* @__PURE__ */ function(_super) {
  tslib_111.__extends(AjaxSubscriber2, _super);
  function AjaxSubscriber2(destination, request) {
    var _this = _super.call(this, destination) || this;
    _this.request = request;
    _this.done = false;
    var headers = request.headers = request.headers || {};
    if (!request.crossDomain && !_this.getHeader(headers, "X-Requested-With")) {
      headers["X-Requested-With"] = "XMLHttpRequest";
    }
    var contentTypeHeader = _this.getHeader(headers, "Content-Type");
    if (!contentTypeHeader && !(_root.FormData && request.body instanceof _root.FormData) && typeof request.body !== "undefined") {
      headers["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8";
    }
    request.body = _this.serializeBody(request.body, _this.getHeader(request.headers, "Content-Type"));
    _this.send();
    return _this;
  }
  AjaxSubscriber2.prototype.next = function(e) {
    this.done = true;
    var _a = this, xhr = _a.xhr, request = _a.request, destination = _a.destination;
    var result;
    try {
      result = new AjaxResponse(e, xhr, request);
    } catch (err) {
      return destination.error(err);
    }
    destination.next(result);
  };
  AjaxSubscriber2.prototype.send = function() {
    var _a = this, request = _a.request, _b = _a.request, user = _b.user, method = _b.method, url15 = _b.url, async = _b.async, password = _b.password, headers = _b.headers, body = _b.body;
    try {
      var xhr = this.xhr = request.createXHR();
      this.setupEvents(xhr, request);
      if (user) {
        xhr.open(method, url15, async, user, password);
      } else {
        xhr.open(method, url15, async);
      }
      if (async) {
        xhr.timeout = request.timeout;
        xhr.responseType = request.responseType;
      }
      if ("withCredentials" in xhr) {
        xhr.withCredentials = !!request.withCredentials;
      }
      this.setHeaders(xhr, headers);
      if (body) {
        xhr.send(body);
      } else {
        xhr.send();
      }
    } catch (err) {
      this.error(err);
    }
  };
  AjaxSubscriber2.prototype.serializeBody = function(body, contentType) {
    if (!body || typeof body === "string") {
      return body;
    } else if (_root.FormData && body instanceof _root.FormData) {
      return body;
    }
    if (contentType) {
      var splitIndex = contentType.indexOf(";");
      if (splitIndex !== -1) {
        contentType = contentType.substring(0, splitIndex);
      }
    }
    switch (contentType) {
      case "application/x-www-form-urlencoded":
        return Object.keys(body).map(function(key) {
          return encodeURIComponent(key) + "=" + encodeURIComponent(body[key]);
        }).join("&");
      case "application/json":
        return JSON.stringify(body);
      default:
        return body;
    }
  };
  AjaxSubscriber2.prototype.setHeaders = function(xhr, headers) {
    for (var key in headers) {
      if (headers.hasOwnProperty(key)) {
        xhr.setRequestHeader(key, headers[key]);
      }
    }
  };
  AjaxSubscriber2.prototype.getHeader = function(headers, headerName) {
    for (var key in headers) {
      if (key.toLowerCase() === headerName.toLowerCase()) {
        return headers[key];
      }
    }
    return void 0;
  };
  AjaxSubscriber2.prototype.setupEvents = function(xhr, request) {
    var progressSubscriber = request.progressSubscriber;
    function xhrTimeout(e) {
      var _a = xhrTimeout, subscriber = _a.subscriber, progressSubscriber2 = _a.progressSubscriber, request2 = _a.request;
      if (progressSubscriber2) {
        progressSubscriber2.error(e);
      }
      var error;
      try {
        error = new AjaxTimeoutError(this, request2);
      } catch (err) {
        error = err;
      }
      subscriber.error(error);
    }
    xhr.ontimeout = xhrTimeout;
    xhrTimeout.request = request;
    xhrTimeout.subscriber = this;
    xhrTimeout.progressSubscriber = progressSubscriber;
    if (xhr.upload && "withCredentials" in xhr) {
      if (progressSubscriber) {
        var xhrProgress_1;
        xhrProgress_1 = function(e) {
          var progressSubscriber2 = xhrProgress_1.progressSubscriber;
          progressSubscriber2.next(e);
        };
        if (_root.XDomainRequest) {
          xhr.onprogress = xhrProgress_1;
        } else {
          xhr.upload.onprogress = xhrProgress_1;
        }
        xhrProgress_1.progressSubscriber = progressSubscriber;
      }
      var xhrError_1;
      xhrError_1 = function(e) {
        var _a = xhrError_1, progressSubscriber2 = _a.progressSubscriber, subscriber = _a.subscriber, request2 = _a.request;
        if (progressSubscriber2) {
          progressSubscriber2.error(e);
        }
        var error;
        try {
          error = new AjaxError("ajax error", this, request2);
        } catch (err) {
          error = err;
        }
        subscriber.error(error);
      };
      xhr.onerror = xhrError_1;
      xhrError_1.request = request;
      xhrError_1.subscriber = this;
      xhrError_1.progressSubscriber = progressSubscriber;
    }
    function xhrReadyStateChange(e) {
      return;
    }
    xhr.onreadystatechange = xhrReadyStateChange;
    xhrReadyStateChange.subscriber = this;
    xhrReadyStateChange.progressSubscriber = progressSubscriber;
    xhrReadyStateChange.request = request;
    function xhrLoad(e) {
      var _a = xhrLoad, subscriber = _a.subscriber, progressSubscriber2 = _a.progressSubscriber, request2 = _a.request;
      if (this.readyState === 4) {
        var status_1 = this.status === 1223 ? 204 : this.status;
        var response = this.responseType === "text" ? this.response || this.responseText : this.response;
        if (status_1 === 0) {
          status_1 = response ? 200 : 0;
        }
        if (status_1 < 400) {
          if (progressSubscriber2) {
            progressSubscriber2.complete();
          }
          subscriber.next(e);
          subscriber.complete();
        } else {
          if (progressSubscriber2) {
            progressSubscriber2.error(e);
          }
          var error = void 0;
          try {
            error = new AjaxError("ajax error " + status_1, this, request2);
          } catch (err) {
            error = err;
          }
          subscriber.error(error);
        }
      }
    }
    xhr.onload = xhrLoad;
    xhrLoad.subscriber = this;
    xhrLoad.progressSubscriber = progressSubscriber;
    xhrLoad.request = request;
  };
  AjaxSubscriber2.prototype.unsubscribe = function() {
    var _a = this, done = _a.done, xhr = _a.xhr;
    if (!done && xhr && xhr.readyState !== 4 && typeof xhr.abort === "function") {
      xhr.abort();
    }
    _super.prototype.unsubscribe.call(this);
  };
  return AjaxSubscriber2;
}(Subscriber);
var AjaxResponse = /* @__PURE__ */ function() {
  function AjaxResponse2(originalEvent, xhr, request) {
    this.originalEvent = originalEvent;
    this.xhr = xhr;
    this.request = request;
    this.status = xhr.status;
    this.responseType = xhr.responseType || request.responseType;
    this.response = parseXhrResponse(this.responseType, xhr);
  }
  return AjaxResponse2;
}();
var AjaxErrorImpl = /* @__PURE__ */ function() {
  function AjaxErrorImpl2(message, xhr, request) {
    Error.call(this);
    this.message = message;
    this.name = "AjaxError";
    this.xhr = xhr;
    this.request = request;
    this.status = xhr.status;
    this.responseType = xhr.responseType || request.responseType;
    this.response = parseXhrResponse(this.responseType, xhr);
    return this;
  }
  AjaxErrorImpl2.prototype = /* @__PURE__ */ Object.create(Error.prototype);
  return AjaxErrorImpl2;
}();
var AjaxError = AjaxErrorImpl;
function parseJson(xhr) {
  if ("response" in xhr) {
    return xhr.responseType ? xhr.response : JSON.parse(xhr.response || xhr.responseText || "null");
  } else {
    return JSON.parse(xhr.responseText || "null");
  }
}
function parseXhrResponse(responseType, xhr) {
  switch (responseType) {
    case "json":
      return parseJson(xhr);
    case "xml":
      return xhr.responseXML;
    case "text":
    default:
      return "response" in xhr ? xhr.response : xhr.responseText;
  }
}
function AjaxTimeoutErrorImpl(xhr, request) {
  AjaxError.call(this, "ajax timeout", xhr, request);
  this.name = "AjaxTimeoutError";
  return this;
}
var AjaxTimeoutError = AjaxTimeoutErrorImpl;

// ../../node_modules/.pnpm/rxjs@6.6.7/node_modules/rxjs/_esm5/internal/observable/dom/ajax.js
var ajax = /* @__PURE__ */ function() {
  return AjaxObservable.create;
}();

// src/repository/api.page.ts
var import_rxjs = __toESM(require_rxjs());
import { flatten, get as _get, isEqual, isUndefined, last } from "lodash-es";

// src/repository/api.error.ts
import { get } from "lodash-es";
import { logAjaxError } from "@ic-anywhere/ic-utils";
var ApiError = class {
  constructor(type, message = "", meta = null, etag, error, requestUrl, requestMethod) {
    this.type = type;
    this.message = message;
    this.meta = meta;
    this.etag = etag;
    this.error = error;
    this.requestUrl = requestUrl;
    this.requestMethod = requestMethod;
  }
};
var messageByErrorStatus = {
  404: "Cannot find the requested resource.",
  403: "You are not authorized to display the requested resource.",
  500: "Internal server error.",
  0: "No response received from the server. Please refresh the page and try again."
};
var catchApiError = (requestUrl, requestMethod) => catchError((error) => {
  logAjaxError(error);
  throw new ApiError(
    error.status,
    parseErrorMessage(error),
    error.response,
    getEtag(error),
    error,
    requestUrl,
    requestMethod
  );
});
var parseErrorMessage = ({ response, message, status }) => get(response, "UserMessage", messageByErrorStatus[status] || message);
var getEtag = (error) => error && error.xhr ? error.xhr.getResponseHeader("etag") || null : null;

// src/repository/api.page.ts
import { isStringEmpty as isStringEmpty5 } from "@ic-anywhere/ic-utils";
var post = (ajaxObservable = ajax, url15, headers, body) => ajaxObservable.post(url15, body, { ...headers }).pipe(
  map3((resp) => {
    const { response, status } = resp;
    return { data: response, status };
  }),
  catchApiError(url15, "POST")
);
var get2 = (ajaxObservable = ajax, url15, headers) => {
  return ajaxObservable.get(url15, { ...headers }).pipe(
    map3((resp) => {
      const { response, status } = resp;
      return { data: response, status };
    }),
    catchApiError(url15, "GET")
  );
};
var fetchLinkedPages = (ajaxObservable, { url: baseUrl10, body, headers, method }, options) => {
  const { iteratorField = "items", shouldFetchAllPagesAtOnce = true, useFromId = false } = options != null ? options : {};
  const fetchOnePage = (fetchBody, fetchUrl) => {
    const request = method === "POST" ? post(ajaxObservable, fetchUrl, headers, fetchBody) : get2(ajaxObservable, fetchUrl, headers);
    return request.pipe(
      map3(({ data, status }) => {
        const value = Array.isArray(data) ? { hasNextPage: status == 206, items: data || [] } : {
          ...data,
          hasNextPage: !!(data == null ? void 0 : data.nextPageUri),
          items: _get(data, iteratorField)
        };
        return value;
      })
    );
  };
  return shouldFetchAllPagesAtOnce ? fetchAllPagesAtOnce(fetchOnePage, body, baseUrl10, useFromId, method) : fetchPageByPage(fetchOnePage, body, baseUrl10);
};
var fetchAllPagesAtOnce = (fetchOnePage, initialBody, initialUrl, useFromId, method) => fetchOnePage(initialBody, initialUrl).pipe(
  expand(({ hasNextPage, page, items }) => {
    if (!hasNextPage) {
      return import_rxjs.EMPTY;
    }
    const fromId = useFromId ? last(items).id : null;
    const fromIdForGETmethod = method !== "POST" ? fromId : null;
    return fetchOnePage(
      getNextPageBody(initialBody, page, fromId ? fromId.toString() : null),
      getNextPageUri(initialUrl, page, fromIdForGETmethod ? fromIdForGETmethod == null ? void 0 : fromIdForGETmethod.toString() : null)
    );
  }),
  map3((paginatedList) => {
    var _a;
    return (_a = paginatedList == null ? void 0 : paginatedList.items) != null ? _a : [];
  }),
  toArray(),
  map3((arrays) => {
    var _a;
    return (_a = flatten(arrays)) != null ? _a : [];
  })
);
var fetchPageByPage = (fetch2, initBody, initUrl) => {
  return fetch2(initBody, initUrl).pipe(
    expand(
      ({ hasNextPage, page }) => hasNextPage ? fetch2(getNextPageBody(initBody, page, null), getNextPageUri(initUrl, page, null)) : import_rxjs.EMPTY
    ),
    scan((acc, paginatedList) => {
      var _a;
      return [...acc, ...(_a = paginatedList.items) != null ? _a : []];
    }, []),
    distinctUntilChanged(isEqual)
  );
};
var getNextPageUri = (baseUrl10, page, fromId) => {
  try {
    const url15 = new URL(baseUrl10);
    url15.searchParams.delete("page");
    url15.searchParams.delete("fromId");
    if (!isNaN(page)) {
      url15.searchParams.set("page", `${page + 1}`);
    }
    if (fromId && !isStringEmpty5(fromId)) {
      url15.searchParams.set("fromId", fromId);
    }
    return url15.toString();
  } catch (error) {
    return "";
  }
};
var getNextPageBody = (body, page, fromId) => {
  if (!body) {
    return void 0;
  }
  if (isUndefined(page) && !fromId) {
    console.error("getNextPageBody >> page or fromId should be defined here, as body is defined");
  }
  return fromId ? { ...body, fromId } : { ...body, page: page ? page + 1 : 0 };
};

// src/repository/apiRxRepository.ts
var ApiRxRepository = class {
  constructor(config2) {
    this.config = config2 != null ? config2 : null;
    const {
      specialHeaders = {},
      impersonatingAs,
      appendImpersonatingAs,
      token,
      logger: logger2 = consoleLogger,
      ajaxMethod,
      urlMappingConfig
    } = config2 != null ? config2 : {};
    this.ajaxClient = ajaxMethod != null ? ajaxMethod : ajax;
    const axiosInstance = rxAxios.Axios.create(createAxiosRequestConfig(specialHeaders, token, impersonatingAs != null ? impersonatingAs : ""));
    axiosInstance.interceptors.request.use(
      apiRequestHandler({ logger: logger2, urlMappingConfig, appendImpersonatingAs }),
      apiErrorHandler(logger2)
    );
    axiosInstance.interceptors.response.use(apiResponseHandler(logger2), apiErrorHandler(logger2));
    this.rxAxiosClient = axiosInstance;
  }
  static Crm(config2) {
    return new ApiRxRepository(config2);
  }
  static ContactDb(config2) {
    return new ApiRxRepository({ ...config2, specialHeaders: contactDbHeader });
  }
  get(url15, headers, params, config2, eventSchemaConfig) {
    const request = () => this.rxAxiosClient.get(url15, { params, paramsSerializer, headers, ...config2 }).pipe(map3(({ data }) => data));
    return apiRxValidationHandler(request, url15, eventSchemaConfig);
  }
  put(url15, headers, body, params, config2, eventSchemaConfig) {
    const request = () => this.rxAxiosClient.put(url15, body, { params, headers, ...config2 }).pipe(map3(({ data }) => data));
    return apiRxValidationHandler(request, url15, eventSchemaConfig, body);
  }
  patch(url15, headers, body, params, eventSchemaConfig) {
    const request = () => this.rxAxiosClient.patch(url15, body, { params, headers }).pipe(map3(({ data }) => data));
    return apiRxValidationHandler(request, url15, eventSchemaConfig, body);
  }
  post(url15, headers, body, params, config2, eventSchemaConfig) {
    const request = () => this.rxAxiosClient.post(url15, body, { params, headers, ...config2 }).pipe(map3(({ data }) => data));
    return apiRxValidationHandler(request, url15, eventSchemaConfig, body);
  }
  delete(url15, headers, params, eventSchemaConfig) {
    const request = () => this.rxAxiosClient.delete(url15, { headers, params }).pipe(map3((item) => item.data));
    return apiRxValidationHandler(request, url15, eventSchemaConfig);
  }
  getPaginatedList(url15, headers, params, options) {
    var _a, _b;
    const headersWithAuthorization = {
      ...headers,
      ...getTokenAndImpersoHeaders((_b = (_a = this.config) == null ? void 0 : _a.appendImpersonatingAs) != null ? _b : false)
    };
    const request = {
      url: buildUrl(url15, headersWithAuthorization, params),
      headers: headersWithAuthorization,
      method: "GET"
    };
    return fetchLinkedPages(this.ajaxClient, request, options);
  }
  getPostPaginatedList(url15, headers, body, params, options) {
    var _a, _b;
    const headersWithAuthorization = {
      ...headers,
      ...getTokenAndImpersoHeaders((_b = (_a = this.config) == null ? void 0 : _a.appendImpersonatingAs) != null ? _b : false)
    };
    const request = {
      url: buildUrl(url15, headersWithAuthorization, params),
      headers: headersWithAuthorization,
      body,
      method: "POST"
    };
    return fetchLinkedPages(this.ajaxClient, request, options);
  }
  download(url15, headers, options = {}, params) {
    const { method = "GET", body = {}, fileName } = options;
    const config2 = getAxiosRequestConfigForDownload(options, headers, params);
    const response$ = method === "POST" ? this.rxAxiosClient.post(url15, body, config2) : this.rxAxiosClient.get(url15, config2);
    return response$.pipe(
      map3((response) => {
        var _a, _b, _c, _d;
        const blobFileName = (_d = parseFileNameFromDisposition2((_c = (_b = (_a = response == null ? void 0 : response.data) == null ? void 0 : _a.xhr) == null ? void 0 : _b.getResponseHeader("content-disposition")) != null ? _c : "")) != null ? _d : fileName;
        return { blob: response.data, fileName: blobFileName != null ? blobFileName : "" };
      })
    );
  }
  upload(url15, headers, files, method = "POST", fileParamName = "file") {
    const data = reduce3(
      files,
      (acc, file) => {
        acc.append(fileParamName, file);
        return acc;
      },
      new FormData()
    );
    const options = { method, body: data, headers: omit4(headers, "Content-Type") };
    return (0, import_rxjs2.from)(
      fetch(buildUrl(url15, headers), options).then(async (res) => {
        if (res.ok) {
          const text = await res.text();
          return text === "" ? {} : JSON.parse(text);
        }
        throw new Error();
      })
    );
  }
  uploadFile(url15, headers, file, config2) {
    return this.rxAxiosClient.post(url15, file, { headers, ...config2 });
  }
  uploadFormData(url15, headers, payload, method = "POST") {
    const formData = new FormData();
    Object.keys(payload).forEach((key) => {
      if (payload[key] && Array.isArray(payload[key])) {
        payload[key].forEach((el) => {
          formData.append(key, el);
        });
      } else {
        formData.append(key, payload[key]);
      }
    });
    const options = { method, body: formData, headers: omit4(headers, "Content-Type") };
    return (0, import_rxjs2.from)(
      fetch(buildUrl(url15, headers), options).then(async (res) => {
        if (res.ok) {
          const text = await res.text();
          return text === "" ? {} : JSON.parse(text);
        }
        throw new Error();
      })
    );
  }
};

// src/repository/api.ts
var addEtag = (headers, etag) => ({
  ...headers,
  "If-Match": etag
});
var createRepository = (ajaxMethod = ajax) => {
  return ApiRxRepository.Crm({
    token: "",
    logger: getLoggerByEnv("ic-anywhere-vnext"),
    ajaxMethod
  });
};

// src/accounts/account.info.queries.ts
import { map as map4 } from "lodash-es";
var clientInfoQueriesKeys = {
  privateInfo: (clientId2) => ["client", "private_info", clientId2],
  info: (clientId2, properties2) => ["client", "info", clientId2, properties2],
  mifid: (accountMifidId) => ["client", "mifid", accountMifidId],
  clientLists: (params) => ["client", "clientLists", params]
};
var defaultClientProperties = [
  "bdrId",
  "clientIds",
  "coverage",
  "parent",
  "computedClientRootId",
  "country",
  "tiering",
  "tieringList",
  "mainAddress",
  "portfolio",
  "typology",
  "fund"
];
var useGetClientPrivate = (repo, clientId2, enabled = true) => {
  return useQuery({
    queryKey: clientInfoQueriesKeys.privateInfo(clientId2),
    queryFn: () => getPrivateClientById(repo, clientId2),
    enabled: !!clientId2 && enabled,
    cacheTime: fiveMinutesInMs
  });
};
var useGetClient = (repo, clientId2, enabled = true, properties2 = defaultClientProperties) => {
  return useQuery({
    queryKey: clientInfoQueriesKeys.info(clientId2, properties2),
    queryFn: () => getAccountById(repo, clientId2, properties2),
    enabled: !!clientId2 && enabled,
    cacheTime: fiveMinutesInMs
  });
};
var useGetClientsByIds = (repo, clientsId, properties2 = defaultClientProperties) => {
  return useQueries({
    queries: map4(clientsId, (id) => {
      return {
        queryKey: clientInfoQueriesKeys.info(id, properties2),
        queryFn: () => getAccountById(repo, id, properties2),
        enabled: !!id,
        cacheTime: fiveMinutesInMs
      };
    })
  });
};
var useGetClientLists = (repo, params, enabled = true) => {
  return useQuery({
    queryKey: clientInfoQueriesKeys.clientLists(params),
    queryFn: () => getClientLists(repo, params),
    enabled: !!enabled
  });
};

// src/accounts/search/account.search.api.ts
import { sanitizeSearchTerm, stringifyLists as stringifyLists2 } from "@ic-anywhere/ic-utils";

// src/accounts/search/account.search.mapper.ts
import { map as map5, pickBy } from "lodash-es";
var DEFAULT_CLIENT_API_FIELDS = [
  "clientIds",
  "country",
  "portfolio",
  "mainAddress",
  "typology",
  "customerRepresentative",
  "tieringList"
];
var mapToAccountApiParam = ({
  coveredByEmail,
  properties: properties2 = DEFAULT_CLIENT_API_FIELDS,
  pageSize = 500,
  typologyIds,
  levels,
  countryIds,
  onlyWithActivity,
  city,
  levelIds,
  listIds,
  applyInheritOnList,
  withFunds,
  displayOption = "none",
  legalOnly = false
}) => {
  const withBdrId = displayOption !== "none";
  return pickBy(
    {
      onlyWithActivity,
      coveredByEmail,
      pageSize,
      city,
      properties: !withBdrId ? properties2 : [...properties2, "bdrId"],
      typologyIds,
      levels,
      countryIds,
      listIds,
      levelIds,
      applyInheritOnList,
      withFunds,
      clientTypes: legalOnly ? "legal,prospect" : void 0
    },
    (value) => value !== void 0
  );
};
var formatAccountName2 = (name, accountLevel, country = "", bdrId = "", city = "") => {
  const accountLevelString = accountLevel ? ` (${accountLevel})` : "";
  const bdrIdString = bdrId ? `BDR ${bdrId}` : "";
  const extra = city || bdrIdString;
  const extraName = extra ? `- ${extra}` : "";
  return `${name}${accountLevelString} ${country} ${extraName}`.trim();
};
var mapToAccountWidget = (clientDto, displayOption = "none", isSuggestion = false) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C;
  const bdrCommercialId = (_b = (_a = clientDto == null ? void 0 : clientDto.clientIds) == null ? void 0 : _a.bdrCommercialId) == null ? void 0 : _b.id;
  const bdrCommercialLevel = (_d = (_c = clientDto == null ? void 0 : clientDto.clientIds) == null ? void 0 : _c.bdrCommercialId) == null ? void 0 : _d.level;
  const bdrLegalId = (_f = (_e = clientDto == null ? void 0 : clientDto.clientIds) == null ? void 0 : _e.bdrLegalId) == null ? void 0 : _f.id;
  const bdrLegalLevel = (_h = (_g = clientDto == null ? void 0 : clientDto.clientIds) == null ? void 0 : _g.bdrLegalId) == null ? void 0 : _h.level;
  const city = (_i = clientDto.mainAddress) == null ? void 0 : _i.city;
  return {
    id: clientDto == null ? void 0 : clientDto.id,
    icId: clientDto == null ? void 0 : clientDto.id,
    rctId: (_j = clientDto == null ? void 0 : clientDto.clientIds) == null ? void 0 : _j.rctId,
    siren: (_k = clientDto == null ? void 0 : clientDto.clientIds) == null ? void 0 : _k.siren,
    type: clientDto == null ? void 0 : clientDto.type,
    name: clientDto == null ? void 0 : clientDto.name,
    fullCommercialName: formatAccountName2(
      clientDto == null ? void 0 : clientDto.name,
      (_m = (_l = clientDto == null ? void 0 : clientDto.clientIds) == null ? void 0 : _l.internalId) == null ? void 0 : _m.level,
      (_n = clientDto == null ? void 0 : clientDto.country) == null ? void 0 : _n.iso3,
      displayOption === "bdr-commercial-id" ? bdrCommercialId : displayOption === "bdr-legal-id" ? bdrLegalId : "",
      city != null ? city : ""
    ),
    bdrMnemonic: (_o = clientDto == null ? void 0 : clientDto.bdrId) == null ? void 0 : _o.bdrMnemonic,
    bdrCommercialId,
    bdrCommercialLevel,
    bdrLegalId,
    bdrLegalLevel,
    countryIso3: (_p = clientDto == null ? void 0 : clientDto.country) == null ? void 0 : _p.iso3,
    countryName: (_q = clientDto == null ? void 0 : clientDto.country) == null ? void 0 : _q.country,
    parentGroup: (_s = (_r = clientDto == null ? void 0 : clientDto.clientIds) == null ? void 0 : _r.root) == null ? void 0 : _s.name,
    parentGroupId: (_u = (_t = clientDto == null ? void 0 : clientDto.clientIds) == null ? void 0 : _t.root) == null ? void 0 : _u.id,
    parentGroupLevel: (_w = (_v = clientDto == null ? void 0 : clientDto.clientIds) == null ? void 0 : _v.root) == null ? void 0 : _w.level,
    level: (_y = (_x = clientDto == null ? void 0 : clientDto.clientIds) == null ? void 0 : _x.internalId) == null ? void 0 : _y.level,
    // ic level
    typology: clientDto == null ? void 0 : clientDto.typology,
    mainAddress: clientDto == null ? void 0 : clientDto.mainAddress,
    dec: (_z = clientDto == null ? void 0 : clientDto.customerRepresentative) == null ? void 0 : _z.dec,
    dr: (_A = clientDto == null ? void 0 : clientDto.customerRepresentative) == null ? void 0 : _A.dr,
    isInMyPortfolio: (_C = (_B = clientDto == null ? void 0 : clientDto.portfolio) == null ? void 0 : _B.isInMyPortfolio) != null ? _C : false,
    isSuggestion
  };
};
var mapToListAccountWidget = (clientDtoList, displayOption, isSuggestion = false) => {
  var _a;
  return (_a = map5(clientDtoList, (clientDto) => mapToAccountWidget(clientDto, displayOption, isSuggestion))) != null ? _a : [];
};

// src/accounts/search/account.search.api.ts
var import_rxjs3 = __toESM(require_rxjs());
import { flatten as flatten2 } from "lodash-es";
var clientsUrl2 = "/2.0/clients";
var privateServicesUrl = "/api";
var searchAccountsWithParams = async (repository, term, queryParams = {}) => {
  const params = { search: sanitizeSearchTerm(term), sort: "smartSort", ...mapToAccountApiParam(queryParams) };
  const resp = await repository.get(clientsUrl2, stringifyLists2(params));
  return resp.data;
};
var searchAccountsByCriteria = (repo, headers, { clientIds, countryIds }) => {
  const pageOptions = {
    shouldFetchAllPagesAtOnce: true,
    useFromId: true
  };
  const pageCountryParams = {
    sort: "id",
    countryIds: countryIds.join(",")
  };
  if (clientIds.length) {
    const accounts$ = (0, import_rxjs3.forkJoin)(
      clientIds.flatMap(
        (clientId2) => repo.getPaginatedList(clientsUrl2, headers, { ...pageCountryParams, clientId: clientId2 }, pageOptions)
      )
    );
    return accounts$.pipe(map3((account) => flatten2(account)));
  } else {
    return repo.getPaginatedList(clientsUrl2, headers, pageCountryParams, pageOptions);
  }
};
var searchRctClients = (repo, term) => {
  return repo.get(`${privateServicesUrl}/rct-legal-entities`, { term }).then((result) => result.data.values);
};

// src/accounts/search/useBulkSearchByBrdLegalId.ts
import React2 from "react";
import { useQueries as useQueries2 } from "@tanstack/react-query";
import { compact as compact3, every as every2, findIndex, isEmpty, map as map6, some as some2 } from "lodash-es";

// ../../node_modules/.pnpm/use-deep-compare-effect@1.8.1/node_modules/use-deep-compare-effect/dist/use-deep-compare-effect.esm.js
import * as React from "react";

// ../../node_modules/.pnpm/dequal@2.0.3/node_modules/dequal/dist/index.mjs
var has = Object.prototype.hasOwnProperty;
function find3(iter, tar, key) {
  for (key of iter.keys()) {
    if (dequal(key, tar))
      return key;
  }
}
function dequal(foo, bar) {
  var ctor, len, tmp;
  if (foo === bar)
    return true;
  if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
    if (ctor === Date)
      return foo.getTime() === bar.getTime();
    if (ctor === RegExp)
      return foo.toString() === bar.toString();
    if (ctor === Array) {
      if ((len = foo.length) === bar.length) {
        while (len-- && dequal(foo[len], bar[len]))
          ;
      }
      return len === -1;
    }
    if (ctor === Set) {
      if (foo.size !== bar.size) {
        return false;
      }
      for (len of foo) {
        tmp = len;
        if (tmp && typeof tmp === "object") {
          tmp = find3(bar, tmp);
          if (!tmp)
            return false;
        }
        if (!bar.has(tmp))
          return false;
      }
      return true;
    }
    if (ctor === Map) {
      if (foo.size !== bar.size) {
        return false;
      }
      for (len of foo) {
        tmp = len[0];
        if (tmp && typeof tmp === "object") {
          tmp = find3(bar, tmp);
          if (!tmp)
            return false;
        }
        if (!dequal(len[1], bar.get(tmp))) {
          return false;
        }
      }
      return true;
    }
    if (ctor === ArrayBuffer) {
      foo = new Uint8Array(foo);
      bar = new Uint8Array(bar);
    } else if (ctor === DataView) {
      if ((len = foo.byteLength) === bar.byteLength) {
        while (len-- && foo.getInt8(len) === bar.getInt8(len))
          ;
      }
      return len === -1;
    }
    if (ArrayBuffer.isView(foo)) {
      if ((len = foo.byteLength) === bar.byteLength) {
        while (len-- && foo[len] === bar[len])
          ;
      }
      return len === -1;
    }
    if (!ctor || typeof foo === "object") {
      len = 0;
      for (ctor in foo) {
        if (has.call(foo, ctor) && ++len && !has.call(bar, ctor))
          return false;
        if (!(ctor in bar) || !dequal(foo[ctor], bar[ctor]))
          return false;
      }
      return Object.keys(bar).length === len;
    }
  }
  return foo !== foo && bar !== bar;
}

// ../../node_modules/.pnpm/use-deep-compare-effect@1.8.1/node_modules/use-deep-compare-effect/dist/use-deep-compare-effect.esm.js
function checkDeps(deps) {
  if (!deps || !deps.length) {
    throw new Error("useDeepCompareEffect should not be used with no dependencies. Use React.useEffect instead.");
  }
  if (deps.every(isPrimitive)) {
    throw new Error("useDeepCompareEffect should not be used with dependencies that are all primitive values. Use React.useEffect instead.");
  }
}
function isPrimitive(val) {
  return val == null || /^[sbn]/.test(typeof val);
}
function useDeepCompareMemoize(value) {
  var ref = React.useRef(value);
  var signalRef = React.useRef(0);
  if (!dequal(value, ref.current)) {
    ref.current = value;
    signalRef.current += 1;
  }
  return React.useMemo(function() {
    return ref.current;
  }, [signalRef.current]);
}
function useDeepCompareEffect(callback, dependencies) {
  if (true) {
    checkDeps(dependencies);
  }
  return React.useEffect(callback, useDeepCompareMemoize(dependencies));
}

// src/accounts/search/useBulkSearchByBrdLegalId.ts
var bdrSearchKey = (bdrId, queryParams) => [
  bdrId,
  "searchByBdrId",
  queryParams
];
var defaultBatchSize = 30;
var initialState = (bdrIds) => map6(bdrIds, (id) => ({
  id,
  status: "ready"
}));
var setNextBatch = (bdrHandles, batchSize) => {
  const firstReady = findIndex(bdrHandles, (x) => x.status === "ready");
  if (firstReady === -1) {
    return bdrHandles;
  }
  return bdrHandles.map(
    ({ id, status }, idx) => ({
      id,
      status: idx >= firstReady && idx < firstReady + batchSize ? "enabled" : status
    }),
    []
  );
};
var handlesReducer = (state, action) => {
  switch (action.type) {
    case "set_empty": {
      return [];
    }
    case "set_handles": {
      return action.handles;
    }
    case "set_next_batch": {
      return setNextBatch(state, action.batchSize);
    }
    case "to_done": {
      return state.map(({ id, status }) => ({
        id,
        status: id === action.handleId ? "done" : status
      }));
    }
  }
};
var useBulkSearchByBrdLegalId = (repo, queryParams = {}, batchSize = defaultBatchSize) => {
  const [bdrHandles, dispatch] = React2.useReducer(handlesReducer, []);
  const setHandleToDone = (handleId) => () => {
    dispatch({ type: "to_done", handleId });
  };
  const setBdrIds = (bdrIds) => {
    if (isEmpty(bdrIds)) {
      dispatch({ type: "set_empty" });
      return;
    }
    dispatch({ type: "set_handles", handles: initialState(bdrIds) });
  };
  useDeepCompareEffect(() => {
    if (every2(bdrHandles, (h) => h.status === "done")) {
      return;
    } else {
      dispatch({ type: "set_next_batch", batchSize });
    }
  }, [bdrHandles]);
  const currentQueries = bdrHandles.map(({ id, status }) => ({
    queryKey: bdrSearchKey(id, queryParams),
    queryFn: () => getAccountByBdrLegalId(repo, id, queryParams),
    enabled: !!id && status === "enabled",
    cacheTime: fiveMinutesInMs,
    onSettled: setHandleToDone(id)
  }));
  const queryResults = useQueries2({ queries: currentQueries });
  const isAllSuccess = !isEmpty(bdrHandles) && every2(queryResults, (r) => r.isSuccess);
  return {
    setBdrIds,
    data: isAllSuccess ? compact3(queryResults.map(({ data }) => data)) : [],
    isFetching: some2(queryResults, (r) => r.isFetching),
    isSuccess: !isEmpty(bdrHandles) && (every2(queryResults, (r) => r.isSuccess) || every2(bdrHandles, (h) => h.status === "done")),
    isError: !isEmpty(bdrHandles) && some2(queryResults, (r) => r.isError)
  };
};

// src/accounts/search/account.search.queries.ts
import { useQuery as useQuery2 } from "@tanstack/react-query";
var accountSearchKeys = {
  search: (term, queryParams) => ["account", "search", term, queryParams],
  rct: (terms) => ["rct", terms]
};
var useSearchAccountsQuery = (repo, term, queryParams = {}, enabled = false) => {
  return useQuery2({
    queryKey: accountSearchKeys.search(term, queryParams),
    queryFn: () => searchAccountsWithParams(repo, term, queryParams),
    enabled,
    cacheTime: oneMinutesInMs,
    select: (result) => {
      return mapToListAccountWidget(result, queryParams.displayOption);
    }
  });
};
var useSearchRctClients = (repo, terms, enabled) => {
  return useQuery2({
    queryKey: accountSearchKeys.rct(terms),
    enabled,
    queryFn: () => searchRctClients(repo, terms)
  });
};

// src/accounts/trees/account.trees.mapper.ts
import { isEmpty as isEmpty2, orderBy } from "lodash-es";
var levelsInOrder = ["Grp", "SubGrp", "SubGrpDiv", "LE Grp", "LE", "Sub-LE", "EC", "Sub-EC"];
var sortNode = (node) => {
  if (node && node.children) {
    node.children = sortTree(node.children);
  }
  return node;
};
var sortTree = (node) => {
  node.forEach((node2) => {
    node2.children = !isEmpty2(node2.children) ? sortTree(node2.children) : [];
  });
  return orderBy(
    node,
    [(account) => levelsInOrder.indexOf(account.level), (account) => account.name],
    ["desc", "desc"]
  );
};
var mapToOrgChartTree = (root, accountId) => ({
  root: { ...sortNode(root), contacts: root.contacts },
  accountId,
  selectedId: accountId
});
var mapToKycTree = (root, accountId) => {
  if (!root || !accountId) {
    return;
  }
  return {
    root: { ...root, ...sortNode(root) },
    accountId,
    selectedId: accountId
  };
};
var mapToKycQueryDTO = (accountId) => ({
  id: accountId,
  bdrPrimaryRole: 0,
  fundThreshold: 200,
  isKycMode: true,
  kycTreeType: 0,
  nbiActive: false,
  withEmptyNodes: true
});
var mapToOrgChartQueryDTO = (accountId) => ({
  id: accountId,
  startDate: (/* @__PURE__ */ new Date()).toISOString(),
  endDate: (/* @__PURE__ */ new Date()).toISOString()
});

// src/accounts/trees/account.trees.api.ts
var urlAccountTree = "/api/crmactivitiestree";
var urlOrgChartTree = "/api/orgchartperentityandkyctree";
var getCommercialTree = (repository, query) => repository.get(urlAccountTree, { ...query }).then(({ data }) => data);
var getOrgChartPerEntityTree = (repository, query) => repository.get(urlOrgChartTree, { ...query }, { timeout: mediumApiTimeout }).then(({ data }) => mapToOrgChartTree(data, query.id));
var getKycTree = (repository, query) => repository.get(urlOrgChartTree, { ...query }).then(({ data }) => mapToKycTree(data, query.id));
var downloadCommercialTreeExcelFile = (repository, query) => repository.download(
  `${urlAccountTree}/getcommercialtreeexcelfile`,
  {},
  { accept: OFFICE_ACCEPT_HEADERS.OFFICE_DOCUMENT, fileName: "Export Commercial Tree.xlsx" },
  { ...query }
);

// src/accounts/trees/account.trees.queries.ts
import { useQuery as useQuery3, useQueryClient } from "@tanstack/react-query";
var buildGetCommercialTreeKey = (accountId, filters) => {
  const { startDate, endDate, withEmptyNodes, withStrategic } = filters;
  return ["getCommercialTreeByAccountId", accountId, startDate, endDate, withEmptyNodes, withStrategic];
};
var buildGetCommercialTreeQuery = (repo, accountId, filters) => {
  const { startDate, endDate, withEmptyNodes, withStrategic } = filters;
  return () => getCommercialTree(repo, { id: accountId, startDate, endDate, withEmptyNodes, withStrategic });
};
var useGetCommercialTreeById = (repo, accountId, filters) => {
  return useQuery3({
    queryKey: buildGetCommercialTreeKey(accountId, filters),
    queryFn: buildGetCommercialTreeQuery(repo, accountId, filters),
    enabled: !!accountId,
    cacheTime: tenMinutesInMs
  });
};
var usePrefetchGetCommercialTreeById = (repo, accountId, filters) => {
  const client = useQueryClient();
  return () => client.prefetchQuery(
    buildGetCommercialTreeKey(accountId, filters),
    buildGetCommercialTreeQuery(repo, accountId, filters),
    {
      cacheTime: fiveMinutesInMs
    }
  ).then();
};
var useGetKycTreeById = (repo, accountId) => {
  return useQuery3({
    queryKey: ["getKycTree", accountId],
    queryFn: () => getKycTree(repo, mapToKycQueryDTO(accountId)),
    enabled: !!accountId,
    cacheTime: tenMinutesInMs
  });
};
var useGetOrgChartTreeById = (repo, accountId) => {
  return useQuery3({
    queryKey: ["getOrgChartPerEntityTree", accountId],
    queryFn: () => getOrgChartPerEntityTree(repo, mapToOrgChartQueryDTO(accountId)),
    enabled: !!accountId,
    cacheTime: tenMinutesInMs
  });
};
var useDownloadCommercialTree = (repo, accountId, filters) => {
  const { startDate, endDate, withEmptyNodes, withStrategic } = filters;
  return useQuery3({
    queryKey: ["downloadCommercialTreeExcelFile", accountId, startDate, endDate, withEmptyNodes, withStrategic],
    queryFn: () => downloadCommercialTreeExcelFile(repo, {
      id: accountId,
      startDate,
      endDate,
      withEmptyNodes,
      withStrategic
    }).then((fileBlob) => saveToFile(fileBlob)),
    enabled: false,
    cacheTime: tenMinutesInMs
  });
};

// src/accounts/coverage/account.coverage.api.ts
var clientsUrl3 = "/2.0/clients";
var portfolioUrl = "/2.0/portfolio";
var getAccountCoverage = (repository, accountId, mode = "client") => repository.get(`${clientsUrl3}/${accountId}/coverages`, { mode }).then(({ data }) => data);
var deleteAccountCoverageContact = (repository, accountId, contactId, roleKey) => repository.post(`${portfolioUrl}/do-remove-account`, {
  contactId,
  accountId,
  roleKey
});

// src/accounts/coverage/account.coverage.queries.ts
import { compact as compact4, map as map7, uniqBy } from "lodash-es";
import { useQuery as useQuery4 } from "@tanstack/react-query";
var properties = ["computedClientRootId", "bdrId", "clientIds", "country", "mainAddress"];
var buildAccountCoverageKey = (accountId, mode) => [
  "getAccountCoverage",
  accountId,
  mode
];
var buildAccountCoverageQuery = (repository, accountId, mode) => () => getAccountCoverage(repository, accountId, mode).then(
  ({ coverages }) => Promise.all(
    compact4(
      map7(
        uniqBy(coverages, "clientId"),
        ({ clientId: clientId2 }) => clientId2 && getAccountById(repository, clientId2, properties)
      )
    )
  ).then(
    (accounts) => compact4(map7(coverages, (coverage) => mapToCoverageWithAccount(map7(accounts, mapToAccount), coverage)))
  )
);
var useGetAccountCoverageQuery = (repo, accountId, mode, enabled = true) => {
  return useQuery4({
    queryKey: buildAccountCoverageKey(accountId, mode),
    queryFn: buildAccountCoverageQuery(repo, accountId, mode),
    cacheTime: fiveMinutesInMs,
    enabled: enabled && !!accountId
  });
};

// src/accounts/interactions/account.interactions.mapper.ts
import { filter as filter2, find as find4, map as map8, orderBy as orderBy2, sumBy } from "lodash-es";
var mapToChatMapInteractions = (chatMapInteractionsDTO) => {
  const result = [];
  chatMapInteractionsDTO.forEach(({ internalContact: currentContact }) => {
    if (find4(result, ({ contact }) => contact.id === currentContact.id)) {
      return;
    }
    const interactionsWithSameInternalContact = filter2(
      chatMapInteractionsDTO,
      ({ internalContact }) => (internalContact == null ? void 0 : internalContact.id) === (currentContact == null ? void 0 : currentContact.id)
    );
    const clientContacts = map8(
      orderBy2(interactionsWithSameInternalContact, ({ count }) => count.received + count.sent, "desc"),
      (interaction) => ({
        fullName: interaction.externalContact.fullName,
        jobType: interaction.externalContact.jobType,
        country: interaction.externalContact.countryIso3,
        interactionsCount: interaction.count.received + interaction.count.sent,
        id: interaction.externalContact.id,
        email: interaction.externalContact.email
      })
    );
    const interactionsCount = sumBy(clientContacts, "interactionsCount");
    result.push({
      contact: {
        fullName: currentContact.fullName,
        team: currentContact.team,
        country: currentContact.countryIso3,
        interactionsWithContactsCount: interactionsWithSameInternalContact.length || 0,
        interactionsCount,
        id: currentContact.id,
        email: currentContact.email
      },
      contactInteractions: clientContacts,
      expanded: false
    });
  });
  return orderBy2(result, ({ contact }) => contact.interactionsCount, "desc");
};

// src/accounts/interactions/account.interactions.api.ts
var accountUrl = "/2.0/accounts";
var getInteractionsByAccountId = (repository, accountId) => {
  return repository.get(`${accountUrl}/${accountId}/interactions/contacts`).then(({ data }) => mapToChatMapInteractions(data.interactions));
};

// src/accounts/interactions/account.interactions.queries.ts
import { useQuery as useQuery5 } from "@tanstack/react-query";
var interactionsAccountKeys = {
  account: (accountId) => ["interactions", "account", accountId]
};
var useGetInteractionsByAccountId = (repo, accountId) => {
  return useQuery5({
    queryKey: interactionsAccountKeys.account(accountId),
    queryFn: () => getInteractionsByAccountId(repo, accountId),
    enabled: !!accountId,
    cacheTime: fiveMinutesInMs
  });
};

// src/accounts/kyc/account.kyc.api.ts
var kycUrl = "/api/kycportfolio";
var requestKycGlobalInformation = (repository, bdrIds) => repository.post(`${kycUrl}/kycdatapost`, { bdrIds }).then((res) => mapGlobalInfo(res.data));
var requestA2dStatuses = (repository, properties2) => repository.post(`${kycUrl}/fetchauthorisationtodealstatus`, properties2).then((res) => mapToA2ds(res.data));

// src/accounts/kyc/account.kyc.queries.ts
import { useQuery as useQuery6 } from "@tanstack/react-query";
var kycQueriesKeys = {
  info: (bdrId) => ["kyc", "info", bdrId],
  a2dStatus: (bdrId, countryIso3) => ["kyc", "a2d_status", bdrId, countryIso3]
};
var useGetKycInfo = (repo, bdrId) => {
  return useQuery6({
    queryKey: kycQueriesKeys.info(bdrId),
    queryFn: () => requestKycGlobalInformation(repo, [bdrId]),
    enabled: !!bdrId,
    cacheTime: fiveMinutesInMs
  });
};
var useGetA2dStatus = (repo, bdrId, countryIso3 = "FRA") => {
  return useQuery6({
    queryKey: kycQueriesKeys.a2dStatus(bdrId, countryIso3),
    queryFn: () => requestA2dStatuses(repo, {
      bdrIds: [bdrId],
      bookingCountry: countryIso3,
      originationCountry: countryIso3
    }),
    enabled: !!bdrId,
    cacheTime: fiveMinutesInMs
  });
};

// src/accounts/mifid/account.mifid.api.ts
import { find as find5 } from "lodash-es";
var mifidUrl = "api/thirdparty/getmifidregulation";
var getSGMP = (mifidData) => find5(mifidData, (d) => d.sgEntityType === "SGPM");
var getMifid = (repo, accountMifidId) => {
  if (!accountMifidId) {
    return Promise.resolve(void 0);
  }
  const params = { entityId: accountMifidId };
  return repo.get(mifidUrl, params).then(({ data }) => {
    var _a;
    const bdrId = (_a = data == null ? void 0 : data[0]) == null ? void 0 : _a.bdrId;
    const detail = (data == null ? void 0 : data[0]) ? getSGMP(data[0].mifid) : void 0;
    if (!bdrId || !detail) {
      return void 0;
    }
    return {
      bdrId,
      ...detail
    };
  });
};

// src/accounts/mifid/account.mifid.queries.ts
import { useQuery as useQuery7 } from "@tanstack/react-query";
var useGetMifidQuery = (repo, accountMifidId, enabled = true) => {
  return useQuery7({
    queryKey: accountMifidId ? clientInfoQueriesKeys.mifid(accountMifidId) : [],
    queryFn: () => getMifid(repo, accountMifidId),
    enabled: !!accountMifidId && enabled,
    cacheTime: fiveMinutesInMs
  });
};

// src/accounts/fund/account.fund.mapper.ts
var mapLegalDMEToFundInfo = (fundInfo) => {
  var _a, _b;
  if (!((_a = fundInfo == null ? void 0 : fundInfo.legalDelegatedManagingEntity) == null ? void 0 : _a.id) || !((_b = fundInfo == null ? void 0 : fundInfo.legalDelegatedManagingEntity) == null ? void 0 : _b.name)) {
    return void 0;
  }
  const { id, name, bdrLegalId } = fundInfo.legalDelegatedManagingEntity;
  return {
    legalDelegatedManagingEntity: {
      bdrId: bdrLegalId != null ? bdrLegalId : "",
      name,
      id
    }
  };
};

// src/accounts/fund/account.fund.api.ts
var fundUrl = "/api/funds";
var requestGetFundInfo = (repository, bdrId) => repository.get(`${fundUrl}/${bdrId}`).then((res) => mapLegalDMEToFundInfo(res.data.fundInfo));

// src/accounts/fund/account.fund.queries.ts
import { useQuery as useQuery8 } from "@tanstack/react-query";
var fundQueriesKeys = {
  info: (bdrId) => ["funds", "info", bdrId]
};
var useGetFundInfoForLE = (repo, bdrId, enabled) => {
  return useQuery8({
    queryKey: fundQueriesKeys.info(bdrId),
    queryFn: () => requestGetFundInfo(repo, bdrId),
    enabled,
    cacheTime: fiveMinutesInMs
  });
};

// src/contacts/contact.mapper.ts
import { isStringEmpty as isStringEmpty6, isStringEqual as isStringEqual3 } from "@ic-anywhere/ic-utils";
import { findIndex as findIndex2, get as get3, head, isEmpty as isEmpty3, map as map9, orderBy as orderBy3, sortBy } from "lodash-es";
import { DateTime } from "luxon";
var mapToUserProfile = (contact) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  return {
    id: contact.id,
    userTeam: contact.organizationTeam ? { id: contact.organizationTeam.id, name: contact.organizationTeam.path } : void 0,
    organizationTeamId: (_b = (_a = contact.organizationTeam) == null ? void 0 : _a.id) != null ? _b : "",
    organizationTeamName: (_d = (_c = contact.organizationTeam) == null ? void 0 : _c.path) != null ? _d : "",
    userEmail: contact.mainEmail ? contact.mainEmail.email : "",
    firstName: (_e = contact == null ? void 0 : contact.firstname) != null ? _e : "",
    lastName: (_f = contact == null ? void 0 : contact.lastname) != null ? _f : "",
    phone: contact.mainPhone ? contact.mainPhone.phone : "",
    fullName: formatContactFullName((_g = contact == null ? void 0 : contact.firstname) != null ? _g : "", (_h = contact == null ? void 0 : contact.lastname) != null ? _h : ""),
    countryIso3: get3(contact, "mainAddress.countryIso3"),
    isIcUser: (_j = (_i = contact == null ? void 0 : contact.scope) == null ? void 0 : _i.isIcUser) != null ? _j : false,
    isInternal: (_l = (_k = contact == null ? void 0 : contact.scope) == null ? void 0 : _k.isInternal) != null ? _l : false
  };
};
var mapToContacts = (contacts) => map9(contacts, mapToContact);
var mapAddressDTOToAddress = ({
  street1,
  street2,
  city,
  country,
  countryIso3,
  zipCode
}) => ({
  street1,
  street2,
  city: city != null ? city : "",
  country: { name: country != null ? country : "", iso3: countryIso3 || "", iso2: "" },
  zipCode
});
var mapToContact = ({
  id,
  firstname,
  lastname,
  mainEmail,
  mainPhone,
  clientBasic,
  clientFull,
  mainAddress,
  emails,
  phones,
  addresses,
  linkedin,
  civility,
  organizationTeam,
  isActive,
  isRestricted,
  hashtags,
  portfolio,
  bernstein,
  quality
}) => ({
  id,
  type: civility == null ? void 0 : civility.type,
  firstname,
  lastname,
  fullName: formatContactFullName(firstname != null ? firstname : "", lastname != null ? lastname : ""),
  email: mainEmail ? { value: mainEmail.email } : { value: get3(emails, "[0].email") },
  phone: mainPhone ? mainPhone.phone : get3(phones, "[0].phone"),
  mainAddress: mainAddress ? mapAddressDTOToAddress(mainAddress) : void 0,
  countryIso3: mainAddress ? mainAddress.countryIso3 : void 0,
  account: clientBasic && clientFull ? getAccount(clientBasic, clientFull) : void 0,
  emails: emails ? emails.map(({ email: value }) => ({ value: !isStringEmpty6(value) ? value : "" })) : [],
  phones: phones ? phones.map(
    ({ type, phone }) => ({
      phone,
      type
    })
  ) : [],
  addresses: addresses ? addresses.map(mapAddressDTOToAddress) : [],
  linkedin,
  isInMyPortfolio: get3(portfolio, "isInMyPortfolio"),
  jobTitle: civility == null ? void 0 : civility.jobTitle,
  jobType: (civility == null ? void 0 : civility.jobType) && !isStringEqual3(civility == null ? void 0 : civility.jobType, "-") ? civility.jobType : void 0,
  organizationTeam,
  isActive,
  isRestricted,
  hashtags,
  bernstein,
  quality
});
var getContactQueryParams = (accountCoverage) => {
  var _a;
  if (!accountCoverage || isEmpty3(accountCoverage.contact) || isEmpty3(accountCoverage.contact.account)) {
    return {};
  }
  return {
    clientId: (_a = accountCoverage.contact.account) == null ? void 0 : _a.id,
    coveredByEmail: accountCoverage.contact.email,
    inherit: true
  };
};
var getAccount = (clientBasic, clientFull) => {
  var _a, _b, _c;
  if (clientFull) {
    return {
      name: clientFull.name,
      id: (_b = (_a = clientFull.internalId) == null ? void 0 : _a.id) != null ? _b : "",
      accountLevel: (_c = clientFull.internalId) == null ? void 0 : _c.level
    };
  } else if (clientBasic && clientBasic.name) {
    return { id: "", name: clientBasic.name };
  }
  return void 0;
};
var sortContactsByName = (collection) => sortBy(collection, ["lastname", "firstname"]);
var mapToContactCoverage = (coveragePage) => map9(coveragePage ? coveragePage.items : [], ({ person: { firstname, lastname, email, team, id } }) => ({
  firstname,
  lastname,
  email,
  team,
  contactId: id
}));
var mapEmployeeOfToAccount = (employee) => {
  if (!(employee == null ? void 0 : employee.id))
    return void 0;
  const { id, name, bdrLegal, bdrCommercial } = employee;
  return {
    id,
    name,
    bdrId: { bdrLegalId: bdrLegal, bdrCommercialId: bdrCommercial }
  };
};
var mapFromContactDb = ({
  id,
  givenName,
  name,
  fullName,
  emails,
  phones,
  employeeOf,
  jobTitle
}) => {
  var _a;
  if (!id) {
    return void 0;
  }
  return {
    id,
    fullName,
    firstname: givenName,
    lastname: name,
    email: emails && !isEmpty3(emails) ? { value: emails[0].value } : void 0,
    emails: emails != null ? emails : [],
    phone: (_a = head(phones)) == null ? void 0 : _a.value,
    phones: map9(phones, ({ value, type }) => ({ type, phone: value })),
    account: mapEmployeeOfToAccount(employeeOf),
    jobTitle
  };
};
var formatIndicatorDate = (indicator) => ({
  date: DateTime.fromISO(indicator.date)
});
var mapFromQualityDb = ({
  contact,
  indicators,
  emails,
  dqOwners,
  quality,
  inconsistencyReasons = []
}) => ({
  contact,
  emails,
  dqOwners,
  indicators: {
    edition: indicators.edition ? formatIndicatorDate(indicators.edition) : void 0,
    mandates: indicators.mandates,
    coverage: indicators.coverage,
    activities: indicators.activities ? formatIndicatorDate(indicators.activities) : void 0,
    emailInteractions: indicators.emailInteractions ? formatIndicatorDate(indicators.emailInteractions) : void 0,
    lastConnection: indicators.lastConnection ? formatIndicatorDate(indicators.lastConnection) : void 0,
    emailChannel: indicators.emailChannel ? {
      ...indicators.emailChannel,
      lastInteractionDate: indicators.emailChannel.lastInteractionDate ? formatIndicatorDate({ date: indicators.emailChannel.lastInteractionDate }).date : void 0
    } : { lastInteractionDate: DateTime.now(), sentCount: 0, failureCount: 0 },
    lastEmailCheck: indicators.lastEmailCheck ? formatIndicatorDate(indicators.lastEmailCheck) : void 0
  },
  quality,
  inconsistencyReasons
});
var mapFromUsageDb = ({ usage, details }, contactId) => ({
  contactId,
  usage: usage === "Yes",
  lastActivityDate: (details == null ? void 0 : details.lastActivityDate) ? DateTime.fromISO(details == null ? void 0 : details.lastActivityDate) : void 0,
  lastConnectionDate: (details == null ? void 0 : details.lastConnectionDate) ? DateTime.fromISO(details == null ? void 0 : details.lastConnectionDate) : void 0,
  mandatesCount: details == null ? void 0 : details.mandatesCount
});
var mapToChatMapInteractionsByContactId = (interactions = []) => {
  const result = [];
  interactions.forEach(({ internalContact, externalContact, count }) => {
    const { id, jobType, fullName, countryIso3: country, team, account, email } = externalContact;
    const index = findIndex2(result, ({ contact }) => contact.id === id);
    const newContactInteractions = {
      fullName: internalContact.fullName,
      team: internalContact.team,
      jobType: internalContact.jobType,
      country: internalContact.countryIso3,
      interactionsCount: count.sent + count.received,
      id: internalContact.id,
      email: internalContact.email
    };
    if (index >= 0) {
      const { contact, contactInteractions } = result[index];
      const { interactionsWithContactsCount, interactionsCount } = contact;
      result[index] = {
        ...result[index],
        contact: {
          ...contact,
          interactionsWithContactsCount: interactionsWithContactsCount + 1,
          interactionsCount: interactionsCount + count.sent + count.received
        },
        contactInteractions: orderBy3(
          [...contactInteractions, newContactInteractions],
          ({ interactionsCount: interactionsCount2 }) => interactionsCount2,
          "desc"
        )
      };
    } else {
      result.push({
        contact: {
          id,
          jobType,
          fullName,
          country,
          team,
          account,
          interactionsCount: count.sent + count.received,
          interactionsWithContactsCount: 1,
          email
        },
        contactInteractions: [newContactInteractions],
        expanded: false
      });
    }
  });
  return orderBy3(result, ({ contact }) => contact.interactionsCount, "desc");
};

// src/contacts/contact.crm.api.ts
var import_rxjs4 = __toESM(require_rxjs());
import { stringifyLists as stringifyLists3 } from "@ic-anywhere/ic-utils";
import { flatten as flatten3 } from "lodash-es";

// src/contacts/constants.ts
var defaultGetContactByIdProperties = [
  "clientFull",
  "civility",
  "mainEmail",
  "emails",
  "phones",
  "addresses",
  "visibility",
  "severity",
  "scope"
];
var defaultContactsByClientIdProperties = [
  "mainPhone",
  "emails",
  "mainEmail",
  "mainAddress",
  "civility",
  "portfolio",
  "hashtags",
  "quality"
];
var baseKey = "contacts";
var contactKeys = {
  me: [baseKey, "me"],
  meSgmc: [baseKey, "me-sgmc"],
  byId: (contactId, fields) => [baseKey, "detail", contactId, fields],
  byClientId: (contactId) => [baseKey, "detail", contactId],
  byIdSgmc: (contactId, fields) => [baseKey, "detail-sgmc", contactId, fields],
  qualityIndicators: (contactId) => [baseKey, "detail", contactId, "quality-indicators"],
  usageIndicators: (contactId) => [baseKey, "detail", contactId, "usage-indicators"],
  emailStatus: (contactId) => [baseKey, "detail", contactId, "email-status"],
  validatorInfo: (emails) => [baseKey, "detail", emails, "validator-info"],
  withAdditionalInfo: (contactId, properties2) => [
    baseKey,
    "detail",
    { contactId, properties: properties2 },
    "additional-info"
  ],
  search: [baseKey, "search"],
  searchByCriteria: ({ accountCriteria, contactCriteria }) => [
    ...contactKeys.search,
    { contactCriteria, accountCriteria }
  ],
  searchByClientId: (params, properties2) => [
    ...contactKeys.search,
    { params, properties: properties2 }
  ],
  interactions: (contactId) => [baseKey, "detail", contactId, "interactions"],
  userInteractions: (scope) => [baseKey, "detail", scope, "interactions", "user"]
};

// src/contacts/contact.crm.api.ts
var crmUrl = "/2.0/contacts";
var privateCrmUrl = "/private/0.0";
var requestMe = async (repository, properties2 = ["mainEmail", "mainAddress", "team", "scope"]) => {
  const resp = await repository.get(`${crmUrl}/me`, stringifyLists3({ properties: properties2 }));
  return { ...mapToUserProfile(resp.data), userId: resp.data.id };
};
var getContactById = (repository, contactId, properties2 = defaultGetContactByIdProperties) => repository.get(`${crmUrl}/${contactId}`, stringifyLists3({ properties: properties2 })).then((resp) => resp.data);
var getContactsByClientId = (repository, params, properties2 = defaultContactsByClientIdProperties) => repository.get(`${crmUrl}`, stringifyLists3({ ...params, properties: properties2 })).then((resp) => {
  const contactsDTO = resp.data;
  const contacts = mapToContacts(contactsDTO);
  const totalContactsCount = (contactsDTO == null ? void 0 : contactsDTO.length) > 0 && contactsDTO[0].totalItemCount ? contactsDTO[0].totalItemCount : 0;
  return { contacts, totalContactsCount };
});
var getContactsByCoveredEmail = (repository, contactQueryParams) => repository.get(`${crmUrl}`, contactQueryParams).then(({ data }) => data);
var requestContactCoverage = (repository, contactId) => repository.get(`${crmUrl}/${contactId}/coverages`).then((results) => sortContactsByName(mapToContactCoverage(results.data)));
var getHashtagsContact = (repository, contactId, properties2 = ["hashtags"]) => repository.get(`${crmUrl}/${contactId}`, stringifyLists3({ properties: properties2 })).then((res) => {
  var _a;
  return (_a = res.data.hashtags) != null ? _a : [];
});
var updateHashtagsContact = (repository, contactId, hashtags) => repository.put(`${crmUrl}/${contactId}/hashtags`, { hashtags }).then((res) => res.data);
var searchContactsByCriteria = (repo, headers, { accountIds, jobTypes, countryIds }) => {
  const searchByCriteria = (clientId2) => repo.getPaginatedList(
    crmUrl,
    headers,
    {
      sort: "id",
      clientId: clientId2,
      countryIds: countryIds.join(","),
      jobTypes: jobTypes.join(","),
      properties: [
        "mainEmail",
        "mainPhone",
        "mainAddress",
        "visibility",
        "team",
        "scope",
        "department",
        "linkedin",
        "hashtags",
        "civility"
      ].join(",")
    },
    {
      shouldFetchAllPagesAtOnce: true,
      useFromId: true
    }
  );
  return (0, import_rxjs4.forkJoin)(accountIds.map((accountId) => searchByCriteria(accountId))).pipe(
    map3((contacts) => flatten3(contacts))
  );
};
var getInteractionsByContactId = (repository, contactId) => {
  return repository.get(`${crmUrl}/${contactId}/interactions/contacts`).then(({ data }) => mapToChatMapInteractionsByContactId(data.interactions));
};
var getUserInteractions = (repository, scope) => repository.get(`${crmUrl}/interactions`, { scope }).then(({ data }) => data.interactions);
var getContactUsageIndicators = (repository, contactId) => {
  return repository.get(`${crmUrl}/${contactId}/usage-quality-indicators`).then((result) => mapFromUsageDb(result.data, contactId));
};
var importBulkBernstringContacts = (repository, file) => {
  return repository.post(
    `${privateCrmUrl}/bernstein-contacts/do-update`,
    file,
    {},
    { headers: { "Content-Type": "text/csv", accept: "text/csv" }, timeout: fiveMinutesInMs }
  );
};

// src/contacts/contact.sgmc.api.ts
import { head as head2, isEmpty as isEmpty4 } from "lodash-es";
import { stringifyLists as stringifyLists4 } from "@ic-anywhere/ic-utils";

// src/schemas/contact.schemas.ts
import { z as z2 } from "zod";

// src/schemas/common.schemas.ts
import { z } from "zod";
var IdNameNumberSchema = z.object({
  id: z.number(),
  name: z.string()
}).strict();
var StringSchema = z.string();

// src/schemas/contact.schemas.ts
var Mifid2ResearchScopeEnum = z2.enum(["In scope", "Out of scope", "Reset status"]);
var UpdateMifid2ResearchDTOSchema = z2.object({
  mifid2Research: z2.object({
    scope: Mifid2ResearchScopeEnum,
    justification: z2.object({
      id: z2.number()
    }).strict(),
    comment: z2.string()
  }).strict()
});
var Mifid2ResearchDTOSchema = z2.object({
  scope: Mifid2ResearchScopeEnum,
  justification: IdNameNumberSchema,
  comment: StringSchema
});
var putContactMifidSchemaConfig = {
  requestSchema: UpdateMifid2ResearchDTOSchema
};

// src/contacts/contact.sgmc.api.ts
var contactDbUrl = "/1.0/sg/contacts";
var baseUrl = "/1.0/sg";
var requestMeSgmc = (repository, fields = ["emails", "internalHrTeam", "organizationteam", "allowedActions"]) => {
  return repository.get(`${contactDbUrl}/_me`, stringifyLists4({ fields })).then((result) => ({ ...mapToUserProfile(result.data), userId: result.data.id }));
};
var getContactQualityIndicators = (repository, contactId) => {
  return repository.get(`${contactDbUrl}/quality-indicators`, {
    ids: contactId,
    fields: "dqowners,quality,inconsistencyReasons"
  }).then(
    (result) => !isEmpty4(head2(result.data.contactIndicators)) ? mapFromQualityDb(head2(result.data.contactIndicators)) : void 0
  );
};
var getContactEmailsStatus = (repository, contactId) => {
  return repository.get(`${contactDbUrl}/${contactId}/email-status`).then((result) => result.data.emailStatus);
};
var getValidatorInfo = (repository, emails, fields = ["internalHrTeam"]) => {
  var _a;
  const promises = (_a = emails == null ? void 0 : emails.map(async (email) => {
    var _a2, _b;
    const validatorId = (_b = (_a2 = email == null ? void 0 : email.personalEmailJustification) == null ? void 0 : _a2.validator) == null ? void 0 : _b.id;
    if (!validatorId) {
      return Promise.resolve({
        email
      });
    }
    const response = await repository.get(`${contactDbUrl}/${validatorId}`, stringifyLists4({ fields }));
    return {
      email,
      validator: response.data
    };
  })) != null ? _a : [];
  return Promise.all(promises);
};
var getContactPepSpoStatusAndEmails = (repository, id, fields = ["emails", "ispeporspo"]) => repository.get(`${contactDbUrl}/${id}`, stringifyLists4({ fields })).then((resp) => resp.data);
var getContactSgmcById = (repository, contactId, fields = ["emails", "jobTitle", "jobType", "visibility"]) => repository.get(`${contactDbUrl}/${contactId}`, stringifyLists4({ fields })).then((resp) => resp.data);
var putContactSgmc = (repository, contactId, contact) => repository.put(`${contactDbUrl}/${contactId}`, contact).then((resp) => resp.data);
var deleteContact = (repository, contactId) => repository.delete(`${contactDbUrl}/${contactId}`).then();
var getContactSgmcByIds = (repository, contactIds, onlyActive = true, fields = [
  "account",
  "jobTitle",
  "phones",
  "emails",
  "addresses",
  "igg",
  "ispeporspo",
  "socialnetworks",
  "organizationteam"
]) => repository.get(contactDbUrl, stringifyLists4({ fields, ids: contactIds, onlyActive })).then(({ data }) => data.contacts);
var putContactSgmcMifid = (repository, contactId, mifid2research) => repository.put(
  `${contactDbUrl}/${contactId}/mifid2research`,
  mifid2research,
  void 0,
  void 0,
  putContactMifidSchemaConfig
);
var deleteContactSgmcMifid = (repository, contactId) => repository.delete(`${contactDbUrl}/${contactId}/mifid2research`);
var importBulkContacts = (repository, file) => {
  return repository.post(
    `${baseUrl}/bulkcontacts`,
    file,
    {},
    { headers: { "Content-Type": "text/csv", accept: "text/csv" }, timeout: fiveMinutesInMs }
  );
};

// src/contacts/contact.mixed.api.ts
import { stringifyLists as stringifyLists5 } from "@ic-anywhere/ic-utils";
var crmUrl2 = "/2.0/contacts";
var getContactAndAdditionalInfosById = (repository, contactRepo, id, properties2 = [
  "clientBasic",
  "clientFull",
  "clientFullWithRoot",
  "civility",
  "mainEmail",
  "emails",
  "mainPhone",
  "phones",
  "mainAddress",
  "addresses",
  "visibility",
  "coverage",
  "team",
  "department",
  "linkedin",
  "bernstein"
]) => {
  return repository.get(`${crmUrl2}/${id}`, stringifyLists5({ properties: properties2 })).then((resp) => {
    return getContactPepSpoStatusAndEmails(contactRepo, id).then((result) => {
      return { ...mapToContact(resp.data), emails: result.emails, isPepOrSpo: result.isPepOrSpo };
    });
  });
};

// src/contacts/contact.queries.ts
var import_rxjs5 = __toESM(require_rxjs());
import {
  useMutation,
  useQueries as useQueries3,
  useQuery as useQuery9,
  useQueryClient as useQueryClient2
} from "@tanstack/react-query";
import { map as lmap } from "lodash-es";
var useGetContactQualityIndicatorsQuery = (repo, contactId, enabled = true) => {
  return useQuery9({
    queryKey: contactKeys.qualityIndicators(contactId),
    queryFn: () => getContactQualityIndicators(repo, contactId),
    enabled: !!contactId && enabled,
    cacheTime: tenMinutesInMs
  });
};
var useGetContactsQualityIndicatorsQuery = (repo, contactIds, enabled = true) => {
  return useQueries3({
    queries: lmap(contactIds, (contactId) => {
      return {
        queryKey: contactKeys.qualityIndicators(contactId),
        queryFn: () => getContactQualityIndicators(repo, contactId),
        enabled: !!contactId && enabled,
        cacheTime: tenMinutesInMs
      };
    })
  });
};
var useGetContactUsageIndicatorsQuery = (repo, contactId, enabled = true) => {
  return useQuery9({
    queryKey: contactKeys.usageIndicators(contactId),
    queryFn: () => getContactUsageIndicators(repo, contactId),
    enabled: !!contactId && enabled,
    cacheTime: tenMinutesInMs
  });
};
var useGetContactsUsageIndicatorsQuery = (repo, contactIds, enabled = true) => {
  return useQueries3({
    queries: lmap(contactIds, (contactId) => {
      return {
        queryKey: contactKeys.usageIndicators(contactId),
        queryFn: () => getContactUsageIndicators(repo, contactId),
        enabled: !!contactId && enabled,
        cacheTime: tenMinutesInMs
      };
    })
  });
};
var useGetContactEmailsStatusQuery = (repo, contactId) => {
  return useQuery9({
    queryKey: contactKeys.emailStatus(contactId),
    queryFn: () => getContactEmailsStatus(repo, contactId),
    enabled: !!contactId,
    cacheTime: tenMinutesInMs
  });
};
var useGetValidatorInfoQuery = (repo, emails) => {
  return useQuery9({
    queryKey: emails ? contactKeys.validatorInfo(emails) : [],
    queryFn: () => getValidatorInfo(repo, emails),
    enabled: !!emails && (emails == null ? void 0 : emails.length) > 0,
    cacheTime: tenMinutesInMs
  });
};
var useSearchContactQuery = (headers, { accountCriteria, contactCriteria }, enabled = false) => {
  const repo = createRepository();
  return useQuery9({
    queryKey: contactKeys.searchByCriteria({ accountCriteria, contactCriteria }),
    queryFn: () => {
      const accountIds$ = searchAccountsByCriteria(repo, headers, accountCriteria).pipe(
        map3((accounts) => accounts.map(({ id }) => id))
      );
      const contacts$ = accountIds$.pipe(
        mergeMap(
          (accountIds) => (accountIds == null ? void 0 : accountIds.length) ? searchContactsByCriteria(repo, headers, { ...contactCriteria, accountIds }) : (0, import_rxjs5.of)([])
        )
      );
      return contacts$.toPromise();
    },
    enabled,
    cacheTime: tenMinutesInMs
  });
};
var useGetContactByIdQuery = (repo, contactId, enabled = true, properties2 = defaultGetContactByIdProperties) => {
  return useQuery9({
    queryKey: contactId ? contactKeys.byId(contactId, properties2) : [],
    queryFn: () => getContactById(repo, contactId, properties2),
    enabled: !!contactId && enabled,
    cacheTime: twoMinutesInMs
  });
};
var useGetContactSgmcByIdQuery = (repo, contactId, enabled = true, fields = ["emails", "jobTitle", "jobType", "visibility"]) => {
  return useQuery9({
    queryKey: contactId ? contactKeys.byIdSgmc(contactId, fields) : [],
    queryFn: () => getContactSgmcById(repo, contactId, fields),
    enabled: !!contactId && enabled,
    cacheTime: twoMinutesInMs
  });
};
var useGetContactsByClientIdQuery = (repository, params, properties2) => {
  return useQuery9({
    queryKey: contactKeys.searchByClientId(params, properties2),
    queryFn: () => getContactsByClientId(repository, params, properties2),
    cacheTime: twoMinutesInMs,
    enabled: !!params.clientId
  });
};
var useDeleteContacts = (repository) => {
  const client = useQueryClient2();
  return useMutation({
    mutationFn: (payload) => Promise.all(lmap(payload, (contactId) => deleteContact(repository, contactId))),
    onSuccess: () => {
      client.invalidateQueries(contactKeys.search);
    }
  });
};
var useGetContactsByIds = (repo, contactRepo, contactsIds, properties2 = ["clientBasic", "clientFull"]) => {
  return useQueries3({
    queries: lmap(contactsIds, (id) => {
      return {
        queryKey: contactKeys.withAdditionalInfo(id),
        queryFn: () => getContactAndAdditionalInfosById(repo, contactRepo, id, properties2),
        enabled: !!id,
        cacheTime: twoMinutesInMs
      };
    })
  });
};
var useGetInteractionsByContactId = (repo, contactId) => {
  return useQuery9({
    queryKey: contactKeys.interactions(contactId),
    queryFn: () => getInteractionsByContactId(repo, contactId),
    enabled: !!contactId,
    cacheTime: fiveMinutesInMs
  });
};
var useGetUserInteractions = (repo, scope, enabled = true) => {
  return useQuery9({
    queryKey: contactKeys.userInteractions(scope),
    queryFn: () => getUserInteractions(repo, scope),
    enabled,
    cacheTime: fiveMinutesInMs
  });
};
var useRequestMeQuery = (repo, enabled, options) => {
  return useQuery9({
    queryKey: contactKeys.me,
    queryFn: () => requestMe(repo),
    onSuccess: (user) => {
      var _a;
      (_a = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a.call(options, user);
    },
    onError: (err) => {
      var _a;
      (_a = options == null ? void 0 : options.onError) == null ? void 0 : _a.call(options, err);
    },
    enabled,
    cacheTime: fiveMinutesInMs
  });
};
var useRequestMeSgmcQuery = (repo, enabled, options) => {
  return useQuery9({
    queryKey: contactKeys.meSgmc,
    queryFn: () => requestMeSgmc(repo),
    onSuccess: (user) => {
      var _a;
      (_a = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a.call(options, user);
    },
    onError: (err) => {
      var _a;
      (_a = options == null ? void 0 : options.onError) == null ? void 0 : _a.call(options, err);
    },
    enabled,
    cacheTime: twoMinutesInMs
  });
};
var useGetSgmContactByIds = (repo, contactIds, options) => {
  return useQuery9({
    queryKey: ["getContactSgmcByIds", contactIds, options],
    queryFn: () => getContactSgmcByIds(repo, contactIds, options.onlyActive, options.fields),
    enabled: options.enabled && !!contactIds,
    cacheTime: twoMinutesInMs
  });
};

// src/contacts/contact.mutations.ts
import { useMutation as useMutation2, useQueryClient as useQueryClient3 } from "@tanstack/react-query";

// src/utils/fetch.utils.ts
import { noop } from "lodash-es";
var defaultMutationOptions = {
  onSuccess: noop,
  onError: noop
};
var defaultQueryParamsOptions = {
  ...defaultMutationOptions,
  enabled: true
};

// src/contacts/contact.mutations.ts
var usePutContactSgmcMutation = (repo, contactId, { onSuccess, onError } = defaultMutationOptions) => {
  const client = useQueryClient3();
  return useMutation2({
    mutationFn: (contact) => {
      return putContactSgmc(repo, contactId, contact);
    },
    onSuccess: async () => {
      await client.invalidateQueries(contactKeys.byIdSgmc(contactId, []));
      onSuccess == null ? void 0 : onSuccess();
    },
    onError
  });
};
var usePutContactSgmcMifidMutation = (repo, contactId, { onSuccess, onError } = defaultMutationOptions) => {
  const client = useQueryClient3();
  return useMutation2({
    mutationFn: (mifid2Research) => {
      return putContactSgmcMifid(repo, contactId, mifid2Research);
    },
    onSuccess: async () => {
      await client.invalidateQueries(contactKeys.byIdSgmc(contactId, []));
      onSuccess == null ? void 0 : onSuccess();
    },
    onError
  });
};
var useDeleteContactSgmcMifidMutation = (repo, contactId, { onSuccess, onError } = defaultMutationOptions) => {
  const client = useQueryClient3();
  return useMutation2({
    mutationFn: () => deleteContactSgmcMifid(repo, contactId),
    onSuccess: async () => {
      await client.invalidateQueries(contactKeys.byIdSgmc(contactId, []));
      onSuccess == null ? void 0 : onSuccess();
    },
    onError
  });
};
var useMassUploadBernsteinContactsMutation = (repo, { onSuccess, onError } = defaultMutationOptions) => {
  return useMutation2({
    mutationFn: (file) => importBulkBernstringContacts(repo, file),
    onSuccess,
    onError
  });
};

// src/contacts/interactions/contact.interactions.queries.ts
import { useQuery as useQuery10 } from "@tanstack/react-query";

// src/contacts/interactions/contact.interactions.api.ts
var url = "/private/0.0/interactions";
var fetchOutlookContactsInteractions = (repo, messages) => {
  return repo.post(
    `${url}/do-get-details`,
    { messages }
  ).then(({ data }) => data.messages);
};

// src/contacts/interactions/contact.interactions.queries.ts
var useFetchOutlookContactsInteractions = (repo, messages, enabled = true, keepPreviousData = true, selectFn) => {
  return useQuery10({
    queryKey: ["fetchEmailContactsInteractions", repo, messages],
    queryFn: () => fetchOutlookContactsInteractions(repo, messages),
    enabled,
    select: selectFn,
    keepPreviousData
  });
};

// src/domains/domains.mapper.ts
import { first, includes as includes3, isEmpty as isEmpty5, keys as keys2, map as map10, size } from "lodash-es";
var mapToDomainNames = (domainNames) => map10(domainNames, ({ contactCount, domainName, _links, accountIdForForbidDomain }) => {
  return {
    contactCount,
    domainName,
    accountIdForForbidDomain,
    permissions: {
      authorize: includes3(keys2(_links), "add_domain_to_root"),
      forbid: includes3(keys2(_links), "remove_domain"),
      authorizeOnBusinessFunction: includes3(keys2(_links), "add_domain_to_root_with_businessfunction"),
      forbidOnBusinessFunction: includes3(keys2(_links), "remove_domain_with_businessfunction")
    }
  };
});
var mapToDomainNameDtoWithHal = (domains) => {
  return map10(domains, (domain) => {
    var _a, _b, _c;
    return {
      ...domain,
      contactCount: (_a = domain.contactCount) != null ? _a : domain.mandateCount,
      accountIdForForbidDomain: parseAccountIdFromHal((_c = (_b = domain == null ? void 0 : domain._links) == null ? void 0 : _b.remove_domain) == null ? void 0 : _c.href)
    };
  });
};
var parseAccountIdFromHal = (url15) => {
  if (isEmpty5(url15)) {
    return void 0;
  }
  const result = url15 == null ? void 0 : url15.match(/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/g);
  return size(result) > 0 ? first(result) : void 0;
};

// src/domains/domains.api.ts
var url2 = "/1.0/sg/clients";
var contactDbUrl2 = "/1.0/sg/contacts";
var getDomainsListByAccountId = (repository, accountId, inherit = true, businessFunctionId) => {
  const urlWithParams = businessFunctionId ? `${url2}/${accountId}/mandateDomains` : `${url2}/${accountId}/domains`;
  const params = businessFunctionId ? { businessFunctionId } : {};
  return repository.get(urlWithParams, {
    ...params,
    inherit,
    pageSize: 500
  }).then((response) => mapToDomainNames(mapToDomainNameDtoWithHal(response.data.domains)));
};
var updateEmailDomain = (repository, contactId, emails) => repository.put(`${contactDbUrl2}/${contactId}`, { emails }, { fields: "emails" });

// src/domains/domains.queries.ts
import { useMutation as useMutation3, useQuery as useQuery11, useQueryClient as useQueryClient4 } from "@tanstack/react-query";
import { map as map11 } from "lodash-es";
var useGetDomainsByAccountId = (repository, accountId, inherit) => {
  return useQuery11({
    queryKey: ["getDomainsListByAccountId", accountId, inherit],
    queryFn: () => getDomainsListByAccountId(repository, accountId, inherit),
    cacheTime: fiveMinutesInMs,
    enabled: !!accountId
  });
};
var useUpdateEmailDomain = (repository) => {
  const client = useQueryClient4();
  return useMutation3({
    mutationFn: (payload) => Promise.all(map11(payload, ({ contactId, emails }) => updateEmailDomain(repository, contactId, emails))),
    onSuccess: () => {
      client.invalidateQueries(["getContactsByClientId"]);
      client.invalidateQueries(["getDomainsListByAccountId"]);
    }
  });
};

// src/hashtags/hashtags.queries.ts
import {
  useMutation as useMutation4,
  useQueries as useQueries4,
  useQuery as useQuery12,
  useQueryClient as useQueryClient5
} from "@tanstack/react-query";
import { compact as compact5, forEach, map as map12, reduce as reduce4, some as some3 } from "lodash-es";
var accountHashtagsKey = (accountId) => ["getHashtagsAccount", accountId];
var contactHashtagsKey = (contactId) => ["getHashtagsContact", contactId];
var useGetHashtagsAccount = (repo, accountId) => {
  return useQuery12({
    queryKey: accountHashtagsKey(accountId),
    queryFn: () => getHashtagsAccount(repo, accountId),
    enabled: !!accountId,
    cacheTime: tenMinutesInMs
  });
};
var useUpdateHashtagsAccount = (repository) => {
  const queryClient = useQueryClient5();
  return useMutation4({
    mutationFn: ({ accountId, hashtags }) => updateHashtagsAccount(repository, accountId, hashtags),
    onSuccess: (_, { accountId }) => {
      queryClient.invalidateQueries(accountHashtagsKey(accountId));
    }
  });
};
var useGetHashtagsContact = (repo, contactId, enabled = true) => {
  return useQuery12({
    queryKey: contactHashtagsKey(contactId),
    queryFn: () => getHashtagsContact(repo, contactId),
    enabled: enabled && !!contactId,
    cacheTime: tenMinutesInMs
  });
};
var useGetHashtagsContacts = (repo, contactIds, enabled = true) => {
  const queries = contactIds.map(
    (contactId) => ({
      queryKey: contactHashtagsKey(contactId),
      queryFn: () => getHashtagsContact(repo, contactId),
      enabled: enabled && !!contactId,
      cacheTime: tenMinutesInMs
    })
  );
  const queryResults = useQueries4({ queries });
  const isFetching = some3(queryResults, (q) => q.isFetching);
  return {
    data: isFetching ? void 0 : reduce4(queryResults, (prev, curr, index) => ({ ...prev, [contactIds[index]]: curr.data }), {}),
    error: isFetching ? void 0 : compact5(queryResults.map(({ error }) => error)),
    isFetching
  };
};
var useUpdateHashtagsContact = (repository) => {
  const queryClient = useQueryClient5();
  return useMutation4({
    mutationFn: ({ contactId, hashtags }) => updateHashtagsContact(repository, contactId, hashtags),
    onSuccess: (_, { contactId }) => {
      queryClient.invalidateQueries(contactHashtagsKey(contactId));
    }
  });
};
var useUpdateHashtagsMultiContactsQuery = (repo, accountId, onSuccess, onError) => {
  const queryClient = useQueryClient5();
  return useMutation4({
    mutationFn: (contacts) => Promise.allSettled(map12(contacts, (contact) => updateHashtagsContact(repo, contact.contactId, contact.hashtags))),
    onSuccess: async (results, contacts) => {
      await queryClient.invalidateQueries(accountHashtagsKey(accountId));
      await queryClient.invalidateQueries(contactKeys.searchByClientId({ clientId: accountId }));
      forEach(contacts, async ({ contactId }) => {
        await queryClient.invalidateQueries(contactHashtagsKey(contactId));
      });
      const settledResults = map12(results, (item) => {
        var _a;
        return {
          success: item.status === "fulfilled",
          // value.id is the contactId here
          result: item.status === "fulfilled" ? item.value.id : (_a = item.reason) == null ? void 0 : _a.message
        };
      });
      if (onSuccess) {
        onSuccess(settledResults);
      }
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred";
      if (onError) {
        onError(message);
      }
    }
  });
};

// src/private/features.api.ts
import { map as map13 } from "lodash-es";
var url3 = "/private/0.0";
var requestDisabledFeatures = (repository) => {
  return repository.get(`${url3}/users/me/disabledfeaturetoggle`).then(({ data }) => map13(data.disabledFeatureToggles, ({ name }) => name));
};

// src/search/search.api.ts
import { map as map14 } from "lodash-es";

// src/search/search.mapper.ts
import { get as get4, toLower } from "lodash-es";
var mapToContactSearch = (contact) => ({
  id: contact.id,
  firstname: get4(contact, "firstname", ""),
  lastname: get4(contact, "lastname", ""),
  friendlyName: `${contact.firstname || ""} ${contact.lastname || ""}`.trim(),
  accountName: get4(contact, "clientFull.name", ""),
  accountId: get4(contact, "clientFull.internalId.id", ""),
  level: get4(contact, "clientFull.internalId.level", ""),
  countryIso: get4(contact, "mainAddress.countryIso3", ""),
  city: get4(contact, "mainAddress.city", ""),
  title: get4(contact, "civility.jobTitle", ""),
  isInMyPortfolio: get4(contact, "portfolio.isInMyPortfolio", false),
  coverage: get4(contact, "portfolio.inPortfolioCount", 0),
  organizationTeam: contact.organizationTeam
});
var mapToAccountSearch = (account) => ({
  id: account.id,
  name: account.name,
  level: get4(account, "clientIds.internalId.level", ""),
  countryIso3: get4(account, "country.iso3", ""),
  city: get4(account, "mainAddress.city", ""),
  isInMyPortfolio: get4(account, "portfolio.isInMyPortfolio", false),
  bdrLegalId: get4(account, "clientIds.bdrLegalId.id", ""),
  bdrCommercialId: get4(account, "clientIds.bdrCommercialId.id", ""),
  rctId: get4(account, "clientIds.rctId", ""),
  parentName: get4(account, "clientIds.root.name", ""),
  coverage: get4(account, "portfolio.inPortfolioCount", 0),
  isFund: isFund2(account.type)
});
var isFund2 = (type) => toLower(type) === "fund";
var mapToMixedSearchResult = ({ account, fund, contact, type }) => {
  return {
    ...type !== "contact" ? mapToMixedAccountSearch(account != null ? account : fund, type) : mapToMixedContactSearch(contact),
    type
  };
};
var mapToMixedContactSearch = (dto) => {
  const {
    id,
    firstname = "",
    lastname = "",
    fullname,
    accountName,
    accountLevelName,
    country,
    isInMyPortfolio,
    civility,
    city,
    accountId
  } = dto;
  return {
    id,
    firstname,
    lastname,
    friendlyName: fullname,
    accountName,
    accountId,
    level: accountLevelName,
    countryIso: get4(country, "iso3"),
    city,
    title: get4(civility, "jobTitle"),
    isInMyPortfolio
  };
};
var mapToMixedAccountSearch = (dto, type) => {
  const { id, name, bdrCommercialId, bdrLegalId, city, country, rctId, level, isInMyPortfolio } = dto;
  return {
    id,
    name,
    countryIso3: get4(country, "iso3"),
    city,
    isInMyPortfolio,
    bdrLegalId,
    bdrCommercialId,
    rctId,
    isFund: isFund2(type),
    level
  };
};

// src/search/search.api.ts
var contactsUrl = "/2.0/contacts";
var accountsUrl = "/2.0/clients";
var allSearchUrl = "/2.0/search";
var searchContacts = (repository, term) => {
  const params = {
    city: void 0,
    countryIds: "",
    coveredByEmail: void 0,
    jobTitle: void 0,
    jobTypes: "",
    pageSize: 8,
    properties: "clientFull,mainAddress,civility,portfolio,mainEmail",
    showRestricted: true,
    sort: "smartSort",
    search: term
  };
  const resultMapper = ({ data }) => {
    return map14(data, (contact) => ({
      ...mapToContactSearch(contact),
      type: "contact"
    }));
  };
  return repository.get(contactsUrl, params).then(resultMapper);
};
var searchAccounts = (repository, term) => {
  const params = {
    search: term,
    sort: "smartSort",
    pageSize: 8,
    properties: "clientIds,country,mainAddress,portfolio,bdrId,fund",
    typologyIds: void 0,
    levels: void 0,
    countryIds: void 0,
    listIds: void 0,
    levelIds: void 0,
    withFunds: true
  };
  return repository.get(accountsUrl, params).then(
    ({ data }) => map14(data, (account) => ({
      ...mapToAccountSearch(account),
      type: "account"
    }))
  );
};
var searchAll = (repository, term) => repository.get(allSearchUrl, {
  term,
  pageSize: 8
}).then(({ data }) => map14(data.mixedSearchResults, mapToMixedSearchResult));

// src/teams/teams.api.ts
import { compact as compact6, map as map16 } from "lodash-es";

// src/teams/teams.mapper.ts
import { each, filter as filter3, get as get5, includes as includes4, isEmpty as isEmpty6, map as map15, orderBy as orderBy4 } from "lodash-es";
import { isContainSubString } from "@ic-anywhere/ic-utils";
var mapToTeamsPermissions = (permissions) => {
  var _a, _b, _c, _d;
  return {
    permissions: (_b = (_a = permissions.permissions) == null ? void 0 : _a.map((p) => p.name)) != null ? _b : [],
    defaultVisibilityTeams: (_d = (_c = permissions.defaultVisibilityTeams) == null ? void 0 : _c.map((t) => t.id)) != null ? _d : []
  };
};
var mapToTeams = (teams) => {
  var _a;
  return (_a = map15(teams, mapToTeam)) != null ? _a : [];
};
var mapToTeam = (team) => ({
  id: team == null ? void 0 : team.id,
  name: (team == null ? void 0 : team.path) || "",
  parentId: team == null ? void 0 : team.parentOrganizationTeamId
});
var mapToTeamTree = (teams) => {
  const roots = findRootNodes(teams).map((team) => mapToRootNode(team));
  const leafs = filter3(teams, (team) => team.parentId !== null);
  return mapToTree(roots, leafs);
};
var mapToTree = (roots, leafs) => {
  each(roots, (parentTeam) => {
    parentTeam.children = orderBy4(
      (leafs != null ? leafs : []).filter((team) => team.parentId === parentTeam.id).map((node) => mapToLeafNode(node, parentTeam)),
      "name"
    );
    if (!isEmpty6(parentTeam.children)) {
      mapToTree(parentTeam.children, leafs);
    }
  });
  return orderBy4(roots, "name");
};
var findRootNodes = (nodes) => (
  //  node without parent or children with parent that does not exist on the list
  nodes.filter(
    (node) => node.parentId === null || !includes4(
      nodes.map((rootNode) => rootNode.id),
      node.parentId
    )
  )
);
var mapToRootNode = (team) => {
  var _a;
  return {
    id: (_a = team.id) != null ? _a : "",
    name: team.name || "Select all",
    path: team.fullName || team.name || "",
    expanded: true,
    selected: false,
    hidden: false,
    parent: void 0,
    sphere: !isEmpty6(team.sphere) ? team.sphere : void 0,
    children: []
  };
};
var mapToLeafNode = (team, parentTeam) => {
  var _a;
  return {
    id: (_a = team.id) != null ? _a : "",
    name: formatTeamName(team, parentTeam),
    path: team.fullName || team.name || "",
    parent: parentTeam,
    children: [],
    expanded: false,
    selected: false,
    hidden: false,
    sphere: get5(team, "sphere", void 0)
  };
};
var formatTeamName = (team, parent) => {
  const parentName = parent && parent.path ? parent.path : null;
  if (parentName !== null && isContainSubString(team.name, parentName)) {
    const teamNames = team.name.split("/");
    return teamNames.length > 0 ? teamNames[teamNames.length - 1] : team.name;
  }
  return team.name;
};

// src/teams/teams.api.ts
var urlTeamsContactDb = "/1.0/sg/teams";
var privateTeamsUrl = "/private/0.0/teams";
var getContactsByTeamId = (repository, teamId) => repository.get(`${urlTeamsContactDb}/${teamId}/contacts`).then((resp) => {
  var _a;
  return compact6(map16((_a = resp.data) == null ? void 0 : _a.contacts, (dto) => mapFromContactDb(dto)));
});
var getAllTeams = (repository, headers) => repository.getPaginatedList(
  urlTeamsContactDb,
  headers,
  { pageSize: 500 },
  { shouldFetchAllPagesAtOnce: true, iteratorField: "teams" }
);
var getTeamById = (repository, teamId) => repository.get(`${urlTeamsContactDb}/${teamId}`).then((resp) => resp.data);
var getPermissionsByTeamId = (repository, teamId) => repository.get(`${privateTeamsUrl}/${teamId}/permissions`).then((resp) => mapToTeamsPermissions(resp.data));
var getAllTeamsPermissions = (repository) => repository.get(`${privateTeamsUrl}/permissions`).then((resp) => resp.data.permissions.map((p) => p.name));
var updateAdminTeam = (repository, teamId, team) => repository.put(`${urlTeamsContactDb}/${teamId}`, team);
var updateAdminTeamPermissions = (repository, teamId, permissions) => repository.put(`${privateTeamsUrl}/${teamId}/permissions`, permissions);
var getTeamSettings = (repository, teamId) => repository.get(`${privateTeamsUrl}/${teamId}/settings`).then((resp) => resp.data);
var updateAdminTeamSettings = (repository, teamId, settings) => repository.put(`${privateTeamsUrl}/${teamId}/settings`, settings);

// src/teams/teams.queries.ts
import { useQuery as useQuery13 } from "@tanstack/react-query";
var useGetContactsByTeamId = (repo, teamId, enabled = true) => {
  return useQuery13({
    queryKey: ["getContactsByTeamId", teamId],
    queryFn: () => getContactsByTeamId(repo, teamId),
    enabled: !!teamId && enabled,
    cacheTime: tenMinutesInMs
  });
};
var useGetAllTeamsQuery = (headers, enabled = true) => {
  const repo = createRepository();
  return useQuery13({
    queryKey: ["getAllTeams"],
    queryFn: () => getAllTeams(repo, headers).toPromise(),
    enabled,
    cacheTime: tenMinutesInMs
  });
};
var useGetTeamByIdQuery = (repo, teamId, enabled = true) => {
  return useQuery13({
    queryKey: ["getTeamById", teamId],
    queryFn: () => getTeamById(repo, teamId),
    enabled,
    cacheTime: 0
  });
};
var useGetAllTeamsPermissionsQuery = (repo, enabled = true) => {
  return useQuery13({
    queryKey: ["getAllTeamsPermissions"],
    queryFn: () => getAllTeamsPermissions(repo),
    enabled,
    cacheTime: tenMinutesInMs
  });
};
var useGetPermissionsByTeamIdQuery = (repo, teamId, enabled = true) => {
  return useQuery13({
    queryKey: ["getPermissionsByTeamId", teamId],
    queryFn: () => getPermissionsByTeamId(repo, teamId),
    enabled: !!teamId && enabled,
    cacheTime: 0
  });
};
var useGetTeamSettingsQuery = (repo, teamId, enabled = true, options) => {
  return useQuery13({
    queryKey: ["getTeamSettings", teamId],
    queryFn: () => getTeamSettings(repo, teamId),
    onSuccess: (settings) => {
      var _a;
      (_a = options == null ? void 0 : options.onSuccess) == null ? void 0 : _a.call(options, settings);
    },
    onError: (err) => {
      var _a;
      (_a = options == null ? void 0 : options.onError) == null ? void 0 : _a.call(options, err);
    },
    enabled: !!teamId && enabled,
    cacheTime: 0
  });
};

// src/teams/teams.mutations.ts
import { useMutation as useMutation5, useQueryClient as useQueryClient6 } from "@tanstack/react-query";
var useUpdateTeamPermissionsMutation = (repo, onResult) => {
  return useMutation5({
    mutationFn: ({ permissions, teamId }) => {
      return updateAdminTeamPermissions(repo, teamId, permissions);
    },
    onSuccess: () => {
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};
var useUpdateTeamDescriptionMutation = (repo, onResult) => {
  return useMutation5({
    mutationFn: ({ team, teamId }) => {
      return updateAdminTeam(repo, teamId, team);
    },
    onSuccess: () => {
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};
var useUpdateTeamSettingsMutation = (repo, onResult) => {
  const queryClient = useQueryClient6();
  return useMutation5({
    mutationFn: ({ settings, teamId }) => {
      return updateAdminTeamSettings(repo, teamId, settings);
    },
    onSuccess: () => {
      onResult == null ? void 0 : onResult.onSuccess();
      queryClient.invalidateQueries(["getTeamSettings"]);
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};

// src/mandates/documents.typings.ts
var DelegationDocumentTypeEnum = /* @__PURE__ */ ((DelegationDocumentTypeEnum2) => {
  DelegationDocumentTypeEnum2["poa"] = "Power of attorney";
  DelegationDocumentTypeEnum2["signatoryCard"] = "Signatory card";
  DelegationDocumentTypeEnum2["college"] = "Group";
  return DelegationDocumentTypeEnum2;
})(DelegationDocumentTypeEnum || {});
var MandateDocumentTypeEnum = /* @__PURE__ */ ((MandateDocumentTypeEnum2) => {
  MandateDocumentTypeEnum2["indemnityLetter"] = "Indemnity letter";
  return MandateDocumentTypeEnum2;
})(MandateDocumentTypeEnum || {});
var PersonDocumentTypeEnum = /* @__PURE__ */ ((PersonDocumentTypeEnum2) => {
  PersonDocumentTypeEnum2["evidence"] = "Evidence";
  PersonDocumentTypeEnum2["specimen"] = "Specimen";
  return PersonDocumentTypeEnum2;
})(PersonDocumentTypeEnum || {});
var EvidenceTypeEnum = /* @__PURE__ */ ((EvidenceTypeEnum2) => {
  EvidenceTypeEnum2["passport"] = "Passport";
  EvidenceTypeEnum2["idCard"] = "ID Card";
  EvidenceTypeEnum2["driverLicense"] = "Driver license";
  EvidenceTypeEnum2["other"] = "Other";
  EvidenceTypeEnum2["specimen"] = "Specimen";
  return EvidenceTypeEnum2;
})(EvidenceTypeEnum || {});
var DocumentTypeEnum = {
  ...DelegationDocumentTypeEnum,
  ...MandateDocumentTypeEnum,
  ...PersonDocumentTypeEnum
};

// src/mandates/delegation.typing.ts
var DEFAULT_DELEGATION_FIELDS = ["powers", "businessFunctions"];

// src/mandates/emandate.typing.ts
var TeamReason = {
  main: "Main",
  custom: "Custom",
  implicit: "Implicit"
};

// src/mandates/businessFunction.api.ts
import { stringifyLists as stringifyLists6 } from "@ic-anywhere/ic-utils";
var url4 = "/1.0/mandates/businessfunctions";
var fetchBusinessFunctions = (repository, headers, params) => repository.getPaginatedList(url4, headers, stringifyLists6({ ...params }), {
  shouldFetchAllPagesAtOnce: true,
  iteratorField: "functions"
});
var assignBusinessFunctionToTeam = (repository, businessFunctionId, teamId) => {
  return repository.put(`${url4}/${businessFunctionId}/assignations/teams/${teamId}`, void 0).then();
};
var UnassignBusinessFunctionFromTeam = (repository, businessFunctionId, teamId) => {
  return repository.delete(`${url4}/${businessFunctionId}/assignations/teams/${teamId}`).then();
};

// src/mandates/businessFunction.queries.ts
import { useQuery as useQuery14 } from "@tanstack/react-query";

// src/mandates/businessFunction.mapper.ts
import { join as join3, map as map17, replace as replace2, sortBy as sortBy2 } from "lodash-es";
import { isStringEmpty as isStringEmpty7 } from "@ic-anywhere/ic-utils";
var mapToBusinessFunctions = (businessFunctions) => {
  if (!businessFunctions) {
    return [];
  }
  return sortBy2(map17(businessFunctions, mapToBusinessFunction), "fullTreeName");
};
var mapToBusinessFunction = ({
  id = "",
  friendlyName = "",
  isAssignable = false,
  name = "",
  parentId,
  parentName
}) => ({
  id,
  name,
  isAssignable,
  parentId,
  parentName,
  fullTreeName: friendlyName ? formatBusinessFunctionFullTreeName(friendlyName) : "",
  fullParentPath: extractParentName(friendlyName)
});
var extractParentName = (fullName) => {
  if (isStringEmpty7(fullName)) {
    return "";
  }
  const parts = fullName.split("/");
  if ((parts == null ? void 0 : parts.length) > 1) {
    parts.pop();
    return join3(parts, " / ");
  }
  return "";
};
var formatBusinessFunctionFullTreeName = (friendlyName) => {
  if (isStringEmpty7(friendlyName)) {
    return "";
  }
  return replace2(friendlyName, /\//g, " > ");
};
var formatBusinessFunction = (parent, name) => {
  const parentPart = !isStringEmpty7(parent) ? `${parent} > ` : "";
  return replace2(`${parentPart}${name}`, / > /g, "/");
};
var mapToBusinessFunctionCreateDTO = ({
  fullName = "",
  sharedWithTeam,
  sharedWith
}) => {
  return {
    name: fullName,
    shareWithTeamIds: sharedWithTeam != null ? sharedWithTeam : [],
    shareWithContactIds: sharedWith != null ? sharedWith : []
  };
};
var mapToBusinessFunctionUpdateDTO = ({
  sharedWithTeam,
  sharedWith
}) => {
  return {
    shareWithTeamIds: sharedWithTeam != null ? sharedWithTeam : [],
    shareWithContactIds: sharedWith != null ? sharedWith : []
  };
};

// src/mandates/businessFunction.queries.ts
var useGetBusinessFunctions = (headers, params, enabled = true) => {
  const repo = createRepository();
  return useQuery14({
    queryKey: ["getBusinessFunctions", params],
    queryFn: () => fetchBusinessFunctions(repo, headers, params).toPromise().then((res) => mapToBusinessFunctions(res)),
    enabled
  });
};

// src/mandates/businessFunction.mutations.ts
import { useMutation as useMutation6, useQueryClient as useQueryClient7 } from "@tanstack/react-query";
var useUpdateTeamBusinessFunctionsMutation = (repo, onResult) => {
  const queryClient = useQueryClient7();
  return useMutation6({
    mutationFn: async ({ bfToAddIds = [], bfToDeleteIds = [], teamId }) => {
      const callsToAdd = bfToAddIds.map((id) => assignBusinessFunctionToTeam(repo, id, teamId));
      const callsToDelete = bfToDeleteIds.map((id) => UnassignBusinessFunctionFromTeam(repo, id, teamId));
      return Promise.all([...callsToAdd, ...callsToDelete]);
    },
    onSuccess: () => {
      onResult == null ? void 0 : onResult.onSuccess();
      queryClient.invalidateQueries(["getBusinessFunctions"]);
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};

// src/mandates/mandates.api.ts
var mandatesUrl = "/1.0/mandates";
var getContactMandates = (repository, contactId) => repository.get(`${mandatesUrl}?contactid=${contactId}`).then(({ data }) => {
  var _a;
  return (_a = data == null ? void 0 : data.mandates) != null ? _a : [];
});

// src/mandates/mandates.queries.ts
import { useQuery as useQuery15 } from "@tanstack/react-query";
var baseKey2 = "mandates";
var madatesKeys = {
  contact: (contactId) => [baseKey2, "by-contact", contactId]
};
var useGetContactMandates = (repo, contactId) => {
  return useQuery15({
    queryKey: madatesKeys.contact(contactId),
    queryFn: () => getContactMandates(repo, contactId),
    enabled: !!contactId,
    cacheTime: twoMinutesInMs
  });
};

// src/referential/currencies/currencies.queries.ts
import { useQuery as useQuery16 } from "@tanstack/react-query";

// src/referential/currencies/currencies.mapper.ts
var mapToCurrencies = (currencies) => currencies.map(({ id }) => ({ label: id, value: id }));

// src/referential/currencies/currencies.api.ts
var baseUrl2 = "/private/0.0/referentials/currencies";
var getCurrencies = (repository) => repository.get(baseUrl2).then(({ data }) => {
  return mapToCurrencies(data.currencies);
});

// src/referential/currencies/currencies.queries.ts
var currenciesQueryKey = "CURRENCIES_QUERIES";
var useCurrenciesQuery = (repo, enabled = true) => {
  return useQuery16({
    queryKey: [currenciesQueryKey],
    queryFn: () => getCurrencies(repo),
    cacheTime: tenMinutesInMs,
    enabled
  });
};

// src/referential/countries/countries.api.ts
var baseUrl3 = "/private/0.0/referentials/countries";
var getCountries = (repository) => repository.get(`${baseUrl3}`, {
  pageSize: 500
}).then(({ data }) => data.countries);

// src/referential/countries/countries.queries.ts
import { useQuery as useQuery17 } from "@tanstack/react-query";
var useGetCountriesQuery = (repo, enabled = true) => {
  return useQuery17({
    queryKey: ["referential_countries"],
    queryFn: () => getCountries(repo),
    enabled,
    cacheTime: tenMinutesInMs
  });
};

// src/referential/typologies/typologies.api.ts
var baseUrl4 = "/private/0.0/referentials/clients/clientTypes";
var getTypologies = (repository) => repository.get(`${baseUrl4}`, {
  pageSize: 500
}).then(({ data }) => data.clientTypes);

// src/referential/typologies/typologies.queries.ts
import { useQuery as useQuery18 } from "@tanstack/react-query";
var useGetTypologiesQuery = (repo, enabled = true) => {
  return useQuery18({
    queryKey: ["referential_typologies"],
    queryFn: () => getTypologies(repo),
    enabled,
    cacheTime: tenMinutesInMs
  });
};

// src/schemas/mifid.schemas.ts
import { z as z3 } from "zod";
var mifidJustificationResponseSchema = z3.object({
  justifications: z3.array(IdNameNumberSchema)
});
var getMifidJustificationsSchemaConfig = {
  responseSchema: mifidJustificationResponseSchema
};

// src/referential/mifid/mifid.api.ts
var baseUrl5 = "/1.0/referentials/contacts/mifid2research-justifications";
var getMifidJustifications = (repository, language = "en") => repository.get(
  baseUrl5,
  void 0,
  { headers: { "accept-language": language } },
  getMifidJustificationsSchemaConfig
).then(({ data }) => data.justifications);

// src/referential/mifid/mifid.queries.ts
import { useQuery as useQuery19 } from "@tanstack/react-query";
var mifidJustifcationsKey = (language) => ["MIFID_JUSTIFICATIONS_QUERIES", language];
var useMifidJustificationsQuery = (repo, language = "en", enabled = true) => {
  return useQuery19({
    queryKey: mifidJustifcationsKey(language),
    queryFn: () => getMifidJustifications(repo, language),
    cacheTime: tenMinutesInMs,
    enabled
  });
};

// src/referential/languages/languages.api.ts
var baseUrl6 = "/1.0/referentials/languages";
var getLanguages = (repository) => repository.get(`${baseUrl6}`).then(({ data }) => data.languages);

// src/referential/languages/languages.queries.ts
import { useQuery as useQuery20 } from "@tanstack/react-query";
var useGetLanguagesQuery = (repo, enabled = true) => {
  return useQuery20({
    queryKey: ["referential_languages"],
    queryFn: () => getLanguages(repo),
    enabled,
    cacheTime: twoHoursInMs
  });
};

// src/events/events.api.ts
import { stringifyLists as stringifyLists7 } from "@ic-anywhere/ic-utils";

// src/events/events.mapper.ts
import { mapToIds, mapToIsoDateFormat, parseDate, toUtcString } from "@ic-anywhere/ic-utils";
import { compact as compact7, filter as filter4, get as get6, includes as includes5, isEmpty as isEmpty7, keys as keys3, map as map18, sortBy as sortBy3, values } from "lodash-es";
var mapToEvents = (events) => {
  return compact7(map18(events, (event) => mapToEvent(event)));
};
var mapToEvent = (event) => {
  var _a, _b, _c, _d;
  if (!event) {
    return null;
  }
  const startEvent = event.startDate ? mapToIsoDateFormat(event.startDate) : "";
  const endEvent = event.endDate ? mapToIsoDateFormat(event.endDate) : "";
  return {
    id: (_a = event.id) != null ? _a : "",
    friendlyId: event.friendlyId,
    startDate: startEvent != null ? startEvent : "",
    endDate: endEvent != null ? endEvent : "",
    category: event.category,
    name: event.name,
    typeId: event.typeId,
    status: event.status,
    country: event.country,
    description: (_b = event.description) != null ? _b : "",
    sectors: (_c = event.sectors) != null ? _c : [],
    venue: event.venue,
    frontOfficers: map18(event.frontOfficerContacts, mapToEventContact),
    eventManagers: map18(event.eventManagerContacts, mapToEventContact),
    externalSpeakers: map18(event.externalSpeakerContacts, mapToEventContact),
    internalSpeakers: map18(event.internalSpeakerContacts, mapToEventContact),
    businessContacts: map18(event.businessContacts, mapToEventContact),
    permissions: mapToEventPermission(event._links),
    webSiteUrl: event.webSiteUrl,
    resources: (_d = event.resources) != null ? _d : [],
    hashtags: event.hashtags,
    expectedParticipants: event.expectedParticipants,
    usesComhubEmailingService: !!event.usesComhubEmailingService,
    declareToGems: event.declareToGems,
    pictureLink: event.pictureLink,
    replayLink: event.replayLink
  };
};
var mapToEventContact = (contact) => ({
  ...contact,
  friendlyName: contact.jobTitle ? `${contact.friendlyName} (${contact.jobTitle})` : contact.friendlyName
});
var mapToEventPermission = (links) => {
  if (links) {
    return {
      canUpdate: hasHalLink(links, "event_update"),
      canListBudget: hasHalLink(links, "event_budget_list"),
      canListInvitation: hasHalLink(links, "event_invitation_list"),
      canListSlot: hasHalLink(links, "event_slot_list"),
      invitationTemplate: get6(links, "event_invitations_template")
    };
  }
  return void 0;
};
var hasHalLink = (links, name) => includes5(keys3(links), name);
var mapToSlots = (slots, eventVenue) => {
  return map18(
    slots,
    ({
      id,
      online,
      speakers,
      bookings,
      venueName,
      address,
      virtualLocation,
      title,
      startDate,
      endDate,
      capacity,
      type,
      addressType,
      comment,
      timeZone,
      _links
    }) => ({
      id,
      online: online != null ? online : false,
      speakers: speakers != null ? speakers : [],
      bookings: bookings != null ? bookings : [],
      venueName,
      address,
      virtualLocation,
      title: title != null ? title : "",
      startDate: parseDate(startDate, timeZone),
      endDate: parseDate(endDate, timeZone),
      capacity,
      type,
      addressType: addressType != null ? addressType : void 0,
      comment,
      timeZone,
      _links,
      venue: eventVenue
    })
  );
};
var mapSlotToView = ({
  id,
  type,
  startDate,
  endDate,
  address,
  bookings,
  venue,
  timeZone,
  capacity
}) => ({
  id,
  type,
  address: formatSlotAddress(address, venue == null ? void 0 : venue.name),
  venue,
  startDate,
  endDate,
  timeZone,
  bookedBookings: filter4(bookings, (booking) => booking.status === 1 /* BOOKED */),
  capacity
});
var COMMA_AND_SPACE = ", ";
var SPACE = " ";
var getPartOneOfAddressFormatted = (address, venueName) => {
  const { street1, street2, street3 } = address;
  const addressFormatted = {
    venueName,
    street1,
    street2,
    street3
  };
  const addressValues = compact7(values(addressFormatted));
  return isEmpty7(addressValues) ? null : addressValues.join(COMMA_AND_SPACE);
};
var getPartTwoOfAddressFormatted = (address) => {
  const { zipCode, city, country } = address;
  const addressFormatted = {
    zipCode,
    city,
    country: country.name
  };
  const addressValues = compact7(values(addressFormatted));
  return isEmpty7(addressValues) ? null : addressValues.join(SPACE);
};
var formatSlotAddress = (address, venueName) => {
  if (!address) {
    return "";
  }
  const firstPart = getPartOneOfAddressFormatted(address, venueName);
  const secondPart = getPartTwoOfAddressFormatted(address);
  return isEmpty7(firstPart) ? !isEmpty7(secondPart) ? `${secondPart}` : "" : `${firstPart}, ${secondPart}`;
};
var mapToCreateOrUpdateSlotDTO = ({
  online,
  speakers,
  address,
  addressType,
  virtualLocation,
  startDate,
  endDate,
  capacity,
  type,
  comment,
  timeZone
}) => ({
  online,
  startDate: toUtcString(startDate, void 0),
  endDate: toUtcString(endDate, void 0),
  capacity,
  type,
  address,
  virtualLocation,
  addressType,
  speakerIds: speakers ? mapToIds(speakers) : [],
  comment,
  timeZone
});
var mapToSlotTypes = (slotTypes) => sortBy3(slotTypes, "name");

// src/events/events.api.ts
var eventsUrl = "/2.0/events";
var privateEventsUrl = "/private/0.0/events";
var privateExpenseUrl = "/private/0.0/expense-approval";
var updateEventContactRelatives = (repository, eventId, contactRelatives) => {
  return repository.put(`${eventsUrl}/${eventId}/contact-relatives`, { contactRelatives });
};
var getEventContactRelatives = (repository, eventId) => {
  return repository.get(`${eventsUrl}/${eventId}/contact-relatives`).then(({ data }) => data.contactRelatives);
};
var searchEvents = (repository, searchParams) => {
  return repository.get(`${eventsUrl}`, stringifyLists7(searchParams)).then(({ data }) => data.events);
};
var getEventById = (repository, eventId) => {
  return repository.get(`${eventsUrl}/${eventId}`).then(({ data }) => data);
};
var doSendEmails = async (repo, eventId, payload) => {
  await repo.post(`${privateEventsUrl}/${eventId}/do-send-emails`, payload);
};
var getEventSlots = (repository, eventId) => {
  return repository.get(`${eventsUrl}/${eventId}/slots`).then(({ data }) => data.slots);
};
var createEvent = (repository, dto) => repository.post(eventsUrl, dto);
var updateEvent = (repository, eventId, dto) => repository.put(`${eventsUrl}/${eventId}`, dto);
var createSlot = (repository, eventId, slot) => repository.post(`${eventsUrl}/${eventId}/slots`, slot);
var updateSlot = (repository, eventId, slotId, slot) => repository.put(`${eventsUrl}/${eventId}/slots/${slotId}`, slot);
var deleteSlot = (repository, eventId, slotId) => repository.delete(`${eventsUrl}/${eventId}/slots/${slotId}`);
var requestGetEventDeclarations = (repository, eventId) => repository.get(`${eventsUrl}/${eventId}/expense-declarations`).then(({ data }) => data.expenseDeclarations);
var requestDeclareEventGems = (repository, eventId, contactId) => repository.post(`${privateExpenseUrl}/do-declare-event/${eventId}/inviter/${contactId}`, {}, void 0, {
  timeout: mediumApiTimeout
});
var requestGetEventBudgets = (repository, eventId) => repository.get(`${eventsUrl}/${eventId}/budgets`).then(({ data }) => data.budgets);
var getSlotTypes = (repository) => repository.get(`${eventsUrl}/slots/types`).then(({ data }) => mapToSlotTypes(data.types));
var getResearchCategories = (repository) => repository.get(`${eventsUrl}/research-categories`).then(({ data }) => data.researchCategories);

// src/events/events.queries.ts
import { useMutation as useMutation7, useQuery as useQuery21, useQueryClient as useQueryClient8 } from "@tanstack/react-query";
import { size as size2 } from "lodash-es";
import { lastYear } from "@ic-anywhere/ic-utils";
var eventsKeys = {
  all: ["events"],
  search: (name, searchParams) => [...eventsKeys.all, "search", name, searchParams],
  byId: (eventId) => [...eventsKeys.all, "byId", eventId],
  detail: (eventId) => [...eventsKeys.byId(eventId), "detail"],
  slots: (eventId) => [...eventsKeys.byId(eventId), "slots"],
  slotTypes: ["slotTypes"],
  declarations: (eventId) => [...eventsKeys.byId(eventId), "declarations"],
  budgets: (eventId) => [...eventsKeys.byId(eventId), "budgets"],
  contactRelatives: (eventId) => [...eventsKeys.byId(eventId), "contactRelatives"],
  researchCategories: ["researchCategories"]
};
var useGetEventContactRelatives = (repo, eventId, enabled) => {
  return useQuery21({
    queryKey: eventsKeys.contactRelatives(eventId),
    queryFn: () => getEventContactRelatives(repo, eventId),
    enabled
  });
};
var useSearchEvents = (repo, eventName, enabled = true) => {
  const searchParams = { name: eventName, startDate: lastYear().stringFormat };
  return useQuery21({
    queryKey: eventsKeys.search(eventName, searchParams),
    queryFn: () => searchEvents(repo, searchParams),
    enabled: enabled && size2(eventName) >= 2,
    cacheTime: fiveMinutesInMs
  });
};
var useGetEventById = (repo, eventId) => {
  return useQuery21({
    queryKey: eventsKeys.detail(eventId),
    queryFn: () => getEventById(repo, eventId),
    enabled: !!eventId,
    cacheTime: twoHoursInMs,
    staleTime: fiveMinutesInMs
  });
};
var useGetEventSlots = (repo, eventId) => {
  return useQuery21({
    queryKey: eventsKeys.slots(eventId),
    queryFn: () => getEventSlots(repo, eventId),
    enabled: !!eventId,
    cacheTime: tenMinutesInMs
  });
};
var useGetEventDeclarationsGems = (repo, eventId) => {
  return useQuery21({
    queryKey: eventsKeys.declarations(eventId),
    queryFn: () => requestGetEventDeclarations(repo, eventId),
    enabled: !!eventId,
    cacheTime: tenMinutesInMs
  });
};
var useDeclareEventGems = (repo, eventId, contactId, onResult) => {
  const client = useQueryClient8();
  return useMutation7({
    mutationFn: () => requestDeclareEventGems(repo, eventId, contactId),
    onSuccess: () => {
      client.invalidateQueries(eventsKeys.declarations(eventId));
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};
var useGetEventBudgets = (repo, eventId, enabled = true) => {
  return useQuery21({
    queryKey: eventsKeys.budgets(eventId),
    queryFn: () => requestGetEventBudgets(repo, eventId),
    enabled: !!eventId && enabled,
    cacheTime: 0
  });
};
var useGetSlotTypes = (repo) => {
  return useQuery21({
    queryKey: eventsKeys.slotTypes,
    queryFn: () => getSlotTypes(repo),
    enabled: true,
    cacheTime: fiveMinutesInMs
  });
};
var useGetResearchCategories = (repo, enabled = true) => {
  return useQuery21({
    queryKey: eventsKeys.researchCategories,
    queryFn: () => getResearchCategories(repo),
    enabled,
    cacheTime: fiveMinutesInMs
  });
};

// src/events/events.mutations.ts
import { useMutation as useMutation8, useQueryClient as useQueryClient9 } from "@tanstack/react-query";
var useCreateOrUpdateEventSlot = (repo, eventId, onResult) => {
  const client = useQueryClient9();
  return useMutation8({
    mutationFn: (payload) => payload.id ? updateSlot(repo, eventId, payload.id, mapToCreateOrUpdateSlotDTO(payload)) : createSlot(repo, eventId, mapToCreateOrUpdateSlotDTO(payload)),
    onSuccess: () => {
      client.invalidateQueries(eventsKeys.byId(eventId));
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};
var useUpdateEventSlot = (repo, eventId, slotId, onResult) => {
  const client = useQueryClient9();
  return useMutation8({
    mutationFn: (payload) => updateSlot(repo, eventId, slotId, payload),
    onSuccess: () => {
      client.invalidateQueries(eventsKeys.byId(eventId));
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};
var useDeleteEventSlot = (repo, eventId, onResult) => {
  const client = useQueryClient9();
  return useMutation8({
    mutationFn: (slotId) => deleteSlot(repo, eventId, slotId),
    onSuccess: () => {
      client.invalidateQueries(eventsKeys.byId(eventId));
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};
var useDoSendEmails = (repo, eventId) => {
  const client = useQueryClient9();
  return useMutation8({
    mutationFn: (payload) => doSendEmails(repo, eventId, payload),
    onSuccess: () => {
      client.invalidateQueries(eventsKeys.byId(eventId));
    }
  });
};
var useUpdateEventContactRelatives = (repo, eventId, onSuccess, onError) => {
  const client = useQueryClient9();
  return useMutation8({
    mutationFn: (payload) => updateEventContactRelatives(repo, eventId, payload),
    onSuccess: () => {
      client.invalidateQueries(eventsKeys.contactRelatives(eventId));
      onSuccess();
    },
    onError: (error) => {
      onError(error.message);
    }
  });
};

// src/events/emailTemplates/api/events.emailTemplates.api.ts
var eventsUrl2 = "/2.0/events";
var getEventEmailTemplates = (repository, eventId) => {
  return repository.get(`${eventsUrl2}/${eventId}/email-templates`).then(({ data: { emailTemplates } }) => emailTemplates);
};
var postEventEmailTemplate = (repository, eventId, template) => {
  return repository.post(`${eventsUrl2}/${eventId}/email-templates`, template).then();
};
var putEventEmailTemplate = (repository, eventId, templateId, template) => {
  return repository.put(`${eventsUrl2}/${eventId}/email-templates/${templateId}`, template).then();
};
var deleteEventEmailTemplate = (repository, eventId, templateId) => {
  return repository.delete(`${eventsUrl2}/${eventId}/email-templates/${templateId}`).then();
};

// src/events/emailTemplates/queries/events.emailTemplates.queries.ts
import { useQuery as useQuery22 } from "@tanstack/react-query";
var eventsTemplateQueriesKeys = {
  all: (eventId) => ["event", "detail", "templates", "all", eventId]
};
var useGetEventEmailTemplates = (repo, eventId, enabled = true) => {
  return useQuery22({
    queryKey: eventsTemplateQueriesKeys.all(eventId),
    queryFn: () => getEventEmailTemplates(repo, eventId),
    enabled: enabled && !!eventId,
    cacheTime: twoHoursInMs,
    staleTime: fiveMinutesInMs
  });
};

// src/events/emailTemplates/queries/events.emailTemplates.mutations.ts
import { useMutation as useMutation9, useQueryClient as useQueryClient10 } from "@tanstack/react-query";
var usePostEmailTemplateMutation = (repo, eventId, { onSuccess, onError } = defaultMutationOptions) => {
  const client = useQueryClient10();
  return useMutation9({
    mutationFn: (template) => {
      return postEventEmailTemplate(repo, eventId, template);
    },
    onSuccess: async () => {
      await client.invalidateQueries(eventsTemplateQueriesKeys.all(eventId));
      onSuccess == null ? void 0 : onSuccess();
    },
    onError
  });
};
var usePutEmailTemplateMutation = (repo, eventId, templateId, { onSuccess, onError } = defaultMutationOptions) => {
  const client = useQueryClient10();
  return useMutation9({
    mutationFn: (template) => {
      return putEventEmailTemplate(repo, eventId, templateId, template);
    },
    onSuccess: async () => {
      await client.invalidateQueries(eventsTemplateQueriesKeys.all(eventId));
      onSuccess == null ? void 0 : onSuccess();
    },
    onError
  });
};
var useDeleteEmailTemplateMutation = (repo, eventId, templateId, { onSuccess, onError } = defaultMutationOptions) => {
  const client = useQueryClient10();
  return useMutation9({
    mutationFn: () => {
      return deleteEventEmailTemplate(repo, eventId, templateId);
    },
    onSuccess: async () => {
      await client.invalidateQueries(eventsTemplateQueriesKeys.all(eventId));
      onSuccess == null ? void 0 : onSuccess();
    },
    onError
  });
};

// src/events/campaigns/api/events.campaigns.api.ts
import { map as map19 } from "lodash-es";
import { stringifyLists as stringifyLists8 } from "@ic-anywhere/ic-utils";

// src/events/campaigns/api/events.campaigns.mappers.ts
import { parseDate as parseDate2 } from "@ic-anywhere/ic-utils";
var mapCampaignFromDto = (dto) => {
  var _a;
  return {
    id: dto.id,
    status: dto.status,
    recipientCount: dto.recipientCount,
    timeZone: dto.timeZone,
    emailTemplateDetail: dto.emailTemplateDetail,
    scheduledAt: parseDate2(dto.scheduledAt, dto.timeZone),
    updatedOn: parseDate2(dto.updatedOn, dto.timeZone),
    replyToEmail: dto.replyToEmail,
    senderEmail: dto.senderEmail,
    invitees: dto.invitees,
    invitationStatus: (_a = dto.invitationCriteria) == null ? void 0 : _a.invitationStatus
  };
};

// src/events/campaigns/api/events.campaigns.api.ts
var eventsBaseUrl = "/2.0/events";
var campaignBaseUrl = (eventId) => `${eventsBaseUrl}/${eventId}/campaigns`;
var getEmailCampaigns = async (repository, eventId) => {
  var _a, _b;
  const response = await repository.get(
    campaignBaseUrl(eventId),
    stringifyLists8({
      fields: ["fullInviteeDetails"]
    })
  );
  return map19((_b = (_a = response.data) == null ? void 0 : _a.campaigns) != null ? _b : [], (item) => mapCampaignFromDto(item));
};
var createEmailCampaign = async (repo, eventId, createDto) => {
  const response = await repo.post(campaignBaseUrl(eventId), createDto);
  return response.data;
};
var updateEmailCampaign = async (repo, eventId, campaignId, updatePayload) => {
  const response = await repo.put(
    `${campaignBaseUrl(eventId)}/${campaignId}`,
    updatePayload
  );
  return response.data;
};
var deleteEmailCampaign = async (repo, eventId, campaignId) => {
  await repo.delete(`${campaignBaseUrl(eventId)}/${campaignId}`);
};

// src/events/campaigns/queries/campaigns.queries.ts
import { useMutation as useMutation10, useQuery as useQuery23, useQueryClient as useQueryClient11 } from "@tanstack/react-query";
var eventsCampaignsQueriesKeys = {
  all: (eventId) => ["event", "detail", "campaigns", "all", eventId]
};
var useGetEventEmailCampaigns = (repo, eventId, options) => {
  const { enabled = true } = options != null ? options : {};
  return useQuery23({
    queryKey: eventsCampaignsQueriesKeys.all(eventId),
    queryFn: () => getEmailCampaigns(repo, eventId),
    enabled: enabled && !!eventId
  });
};
var useCreateEmailCampaign = (repo, eventId) => {
  const client = useQueryClient11();
  return useMutation10({
    mutationFn: (payload) => createEmailCampaign(repo, eventId, payload),
    onSuccess: async () => {
      await client.invalidateQueries(eventsCampaignsQueriesKeys.all(eventId));
    }
  });
};
var useUpdateEmailCampaign = (repo, eventId, campaignId) => {
  const client = useQueryClient11();
  return useMutation10({
    mutationFn: (payload) => updateEmailCampaign(repo, eventId, campaignId, payload),
    onSuccess: async () => {
      await client.invalidateQueries(eventsCampaignsQueriesKeys.all(eventId));
    }
  });
};
var useDeleteEmailCampaign = (repo, eventId, campaignId) => {
  const client = useQueryClient11();
  return useMutation10({
    mutationFn: () => deleteEmailCampaign(repo, eventId, campaignId),
    onSuccess: async () => {
      await client.invalidateQueries(eventsCampaignsQueriesKeys.all(eventId));
    }
  });
};

// src/events/invitees/api.ts
import { stringifyLists as stringifyLists9 } from "@ic-anywhere/ic-utils";

// src/events/invitees/mapper.ts
var mapToInvitationPermission = (links) => {
  return {
    canRead: hasHalLink(links, "event_invitation_read"),
    canUpdate: hasHalLink(links, "event_invitation_update"),
    canDelete: hasHalLink(links, "event_invitation_delete")
  };
};
function mapToInvitations(invitationPage, currentPage) {
  const invitations = invitationPage._embedded.invitations.map((invitation) => {
    var _a, _b, _c, _d, _e;
    return {
      id: invitation.id,
      invitee: {
        id: (_a = invitation.invitee) == null ? void 0 : _a.id,
        friendlyName: (_b = invitation.invitee) == null ? void 0 : _b.friendlyName,
        mainEmail: (_c = invitation.invitee) == null ? void 0 : _c.mainEmail,
        inMyPortfolio: invitation.isInMyPortfolio,
        contactQuality: invitation.inviteeContactQuality
      },
      invitedBy: {
        id: (_d = invitation.invitedBy) == null ? void 0 : _d.id,
        friendlyName: (_e = invitation.invitedBy) == null ? void 0 : _e.friendlyName
      },
      account: invitation.inviteeAccount,
      comment: invitation == null ? void 0 : invitation.comment,
      status: invitation == null ? void 0 : invitation.status,
      delivery: invitation.emailDeliveryStatus,
      noShow: invitation.noShow,
      invitationPermission: mapToInvitationPermission(invitation._links)
    };
  });
  return {
    nextPage: (invitationPage == null ? void 0 : invitationPage.nextPageUri) ? currentPage + 1 : void 0,
    invitations,
    totalItems: invitationPage.totalItems,
    canCreate: hasHalLink(invitationPage._links, "event_invitation_create")
  };
}

// src/events/invitees/api.ts
var eventsUrl3 = "/2.0/events";
async function getEventInvitations(repository, eventId, params) {
  const response = await repository.get(
    `${eventsUrl3}/${eventId}/invitations`,
    stringifyLists9({
      ...params,
      fields: ["isInMyPortfolio", "emailDeliveryStatus", "inviteeContactQuality"]
    })
  );
  return mapToInvitations(response.data, params.page);
}
var deleteEventInvitation = (repository, eventId, invitationId) => repository.delete(`${eventsUrl3}/${eventId}/invitations/${invitationId}`);
var updateEventInvitation = (repository, eventId, invitationId, { invitedById, status, noShow, comment }) => {
  return repository.put(
    `${eventsUrl3}/${eventId}/invitations/${invitationId}`,
    { invitedByContactIds: [invitedById], status, noShow, comment },
    stringifyLists9({ fields: ["invitedByContactIds", "status", "comment", "noShow"] })
  );
};
var massDeleteEventInvitation = (repository, eventId, data) => {
  return repository.post(`${eventsUrl3}/${eventId}/invitations/do-delete`, data);
};

// src/events/invitees/queries.ts
import {
  useInfiniteQuery,
  useMutation as useMutation11,
  useQueryClient as useQueryClient12
} from "@tanstack/react-query";
var eventsInviteesQueriesKeys = {
  byEventId: (eventId) => ["event", eventId],
  all: (eventId, params, impersonatedUserId) => [
    ...eventsInviteesQueriesKeys.byEventId(eventId),
    "detail",
    "invitees",
    "all",
    { params },
    impersonatedUserId
  ],
  declarations: (eventId) => [...eventsInviteesQueriesKeys.byEventId(eventId), "declaration"]
};
function useGetEventInvitations(repo, eventId, params, enabled, impersonatedUserId) {
  var _a;
  return useInfiniteQuery(
    eventsInviteesQueriesKeys.all(eventId, params, `${impersonatedUserId}-${(_a = repo.config) == null ? void 0 : _a.impersonatingAs}`),
    async ({ pageParam = 0 }) => getEventInvitations(repo, eventId, {
      page: pageParam,
      pageSize: params.pageSize,
      status: params.status,
      statuses: params.statuses,
      search: params.search,
      onlyInMyPortfolio: params.onlyInMyPortfolio,
      invitedByContactIds: params.invitedByContactIds,
      onlyRecentlyAddedInvitees: params == null ? void 0 : params.onlyRecentlyAddedInvitees,
      emailTemplateId: params == null ? void 0 : params.emailTemplateId,
      sortBy: params == null ? void 0 : params.sortBy
    }),
    {
      enabled: !!eventId && enabled,
      getNextPageParam: (lastPage) => lastPage.nextPage,
      keepPreviousData: true
    }
  );
}
var useDeleteEventInvitation = (repo, eventId, invitationId, onResult) => {
  const client = useQueryClient12();
  return useMutation11({
    mutationFn: () => deleteEventInvitation(repo, eventId, invitationId),
    onSuccess: () => {
      client.invalidateQueries(eventsInviteesQueriesKeys.byEventId(eventId));
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};

// src/events/invitees/typings.ts
var InvitationStatusEnum = /* @__PURE__ */ ((InvitationStatusEnum2) => {
  InvitationStatusEnum2[InvitationStatusEnum2["Pending"] = 1] = "Pending";
  InvitationStatusEnum2[InvitationStatusEnum2["Accepted"] = 2] = "Accepted";
  InvitationStatusEnum2[InvitationStatusEnum2["RefusedNotAvailable"] = 3] = "RefusedNotAvailable";
  InvitationStatusEnum2[InvitationStatusEnum2["RefusedNotInterested"] = 4] = "RefusedNotInterested";
  return InvitationStatusEnum2;
})(InvitationStatusEnum || {});
var InvitationStatusNameEnum = /* @__PURE__ */ ((InvitationStatusNameEnum2) => {
  InvitationStatusNameEnum2["Pending"] = "Pending";
  InvitationStatusNameEnum2["Accepted"] = "Accepted";
  InvitationStatusNameEnum2["RefusedNotAvailable"] = "RefusedNotAvailable";
  InvitationStatusNameEnum2["RefusedNotInterested"] = "RefusedNotInterested";
  return InvitationStatusNameEnum2;
})(InvitationStatusNameEnum || {});
var INVITATION_STATUSES = [
  { id: 1 /* Pending */, name: "Pending" },
  { id: 2 /* Accepted */, name: "Accepted" },
  { id: 3 /* RefusedNotAvailable */, name: "Refused - Not available" },
  { id: 4 /* RefusedNotInterested */, name: "Refused - Not interested" }
];

// src/events/invitees/mutation.ts
import { useMutation as useMutation12, useQueryClient as useQueryClient13 } from "@tanstack/react-query";
var useUpdateEventInvitation = (repo, eventId, invitationId, onResult) => {
  const client = useQueryClient13();
  return useMutation12({
    mutationFn: (payload) => updateEventInvitation(repo, eventId, invitationId, payload),
    onSuccess: () => {
      client.invalidateQueries(eventsInviteesQueriesKeys.byEventId(eventId));
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};
var useMassDeleteEventInvitation = (repo, eventId, onResult) => {
  const client = useQueryClient13();
  return useMutation12({
    mutationFn: (payload) => massDeleteEventInvitation(repo, eventId, payload),
    onSuccess: () => {
      client.invalidateQueries(eventsInviteesQueriesKeys.byEventId(eventId));
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};

// src/actionPlans/actionPlans.typings.ts
var todoTaskStatuses = [
  "Abandoned",
  "Completed",
  "OnHold",
  "ToBeDone",
  "ToBeQualified",
  "ValidatedByClient"
];
var ActionPlanSeverityTypes = ["Low", "Medium", "High"];

// src/actionPlans/actionPlans.api.ts
import { stringifyLists as stringifyLists10 } from "@ic-anywhere/ic-utils";
import { omit as omit5 } from "lodash-es";

// src/actionPlans/actionPlans.mapper.ts
import { compact as compact8, first as first2, map as map22, slice, uniqBy as uniqBy2 } from "lodash-es";
import { mapToIds as mapToIds3, tagitize, untagitize } from "@ic-anywhere/ic-utils";

// src/actionPlans/tasks/tasks.queries.ts
import { useMutation as useMutation13, useQuery as useQuery25, useQueryClient as useQueryClient14 } from "@tanstack/react-query";
import { map as map21 } from "lodash-es";

// src/actionPlans/tasks/tasks.mapper.ts
import { mapToIds as mapToIds2, mapToIsoDateFormat as mapToIsoDateFormat2 } from "@ic-anywhere/ic-utils";
var mapToTaskCreateDTO = ({
  subject,
  status,
  assignedToContacts,
  startDate,
  deadline,
  revisedDeadline
}) => ({
  subject,
  status: status != null ? status : "ToBeDone",
  assignedToContactIds: assignedToContacts ? mapToIds2(assignedToContacts) : [],
  startDate: startDate && mapToIsoDateFormat2(startDate),
  deadline: deadline && mapToIsoDateFormat2(deadline),
  revisedDeadline: revisedDeadline && mapToIsoDateFormat2(revisedDeadline)
});
var mapToTask = (task) => {
  return {
    id: task.id,
    subject: task.subject,
    relatedActionPlan: task.relatedActionPlan && mapToActionPlan(task.relatedActionPlan),
    assignedToContacts: task.assignedToContacts,
    startDate: task.startDate,
    deadline: task.deadline,
    revisedDeadline: task.revisedDeadline,
    updatedOn: task.updatedOn,
    commentCount: task.commentCount,
    status: task.status,
    updatedBy: task.updatedBy,
    isRestricted: task.isRestricted,
    authorizedAction: {
      canCreateComment: task._links ? hasHalLink(task._links, "comment_create") : false,
      canDelete: task._links ? hasHalLink(task._links, "task_delete") : false,
      canEdit: task._links ? hasHalLink(task._links, "task_update") : false
    }
  };
};
var mapToTaskCommentModel = ({ id, updatedOn, updatedBy, content, _links }) => ({
  id,
  updatedOn,
  updatedBy,
  content,
  authorisation: {
    canDelete: _links ? hasHalLink(_links, "comment_delete") : false
  }
});

// src/actionPlans/tasks/tasks.api.ts
import { map as map20 } from "lodash-es";
var actionPlansUrl = "/2.0/actionplans";
var getTaskById = (repository, actionPlanId, taskId) => repository.get(`${actionPlansUrl}/${actionPlanId}/tasks/${taskId}`).then(({ data }) => data);
var getTasksAssignedTo = (repository, assignedToContactId) => repository.get(`${actionPlansUrl}/tasks`, { assignedToContactId }).then(({ data }) => map20(data.tasks, (task) => mapToTask(task)));
var getTasksByAccountId = (repository, accountId) => repository.get(`${actionPlansUrl}/tasks`, { accountId }).then(({ data }) => map20(data.tasks, (task) => mapToTask(task)));
var createTask = (repository, values4, actionPlanId) => repository.post(`${actionPlansUrl}/${actionPlanId}/tasks`, values4);
var editTask = (repository, actionPlanId, taskId, values4) => repository.put(`${actionPlansUrl}/${actionPlanId}/tasks/${taskId}`, values4);
var deleteTask = (repository, actionPlanId, taskId) => repository.delete(`${actionPlansUrl}/${actionPlanId}/tasks/${taskId}`);
var getCommentsFromTask = (repository, actionPlanId, taskId) => repository.get(`${actionPlansUrl}/${actionPlanId}/tasks/${taskId}/comments`).then(({ data }) => map20(data.comments, (comment) => mapToTaskCommentModel(comment)));
var addCommentTask = (repository, actionPlanId, taskId, comment) => repository.post(`${actionPlansUrl}/${actionPlanId}/tasks/${taskId}/comments`, { content: comment });
var deleteCommentTask = (repository, actionPlanId, taskId, commentId) => repository.delete(`${actionPlansUrl}/${actionPlanId}/tasks/${taskId}/comments/${commentId}`);

// src/actionPlans/actionPlans.queries.ts
import { useInfiniteQuery as useInfiniteQuery2, useQuery as useQuery24 } from "@tanstack/react-query";
import { isEmpty as isEmpty8, isNull, isNumber, isUndefined as isUndefined2, omitBy } from "lodash-es";
var baseKey3 = "action_plans";
var actionPlansKeys = {
  all: [baseKey3, "list"],
  byId: (actionPlanId) => [baseKey3, "byId", actionPlanId],
  searchActionPlans: [baseKey3, "search"],
  searchActionPlansWithFilters: (searchParams, accountId) => [baseKey3, "search", searchParams, accountId]
};
var cleanSearchParams = (searchParams, accountId) => omitBy({ ...searchParams, onlyLive: searchParams == null ? void 0 : searchParams.onlyLive, accountId }, (val) => isUndefined2(val) || isNull(val));
var useGetActionPlanById = (repo, actionPlanId) => {
  return useQuery24({
    queryKey: actionPlansKeys.byId(actionPlanId),
    queryFn: () => getActionPlanById(repo, actionPlanId),
    enabled: !!actionPlanId,
    cacheTime: fiveMinutesInMs
  });
};
var useGetActionPlanOrigins = (repo, enabled = true) => {
  return useQuery24({
    queryKey: ["getActionPlanOrigins"],
    queryFn: () => getActionPlanOrigins(repo),
    enabled: !!enabled,
    cacheTime: fiveMinutesInMs
  });
};
var useSearchActionPlans = (repo, params, enabled = true) => {
  const filteredParams = cleanSearchParams(params.searchParams, params.accountId);
  return useInfiniteQuery2({
    queryKey: actionPlansKeys.searchActionPlansWithFilters(params.searchParams, params.accountId),
    queryFn: ({ pageParam = 0 }) => params.isPostSearch ? postSearchActionPlansPage(repo, pageParam, 500, filteredParams) : searchActionPlansPage(repo, pageParam, 500, filteredParams, params.withTasks),
    enabled,
    cacheTime: fiveMinutesInMs,
    getNextPageParam: ({ page, nextPageUri }) => {
      return !isEmpty8(nextPageUri) && isNumber(page) ? page + 1 : void 0;
    }
  });
};

// src/actionPlans/tasks/tasks.queries.ts
var tasksActionPlanKeys = {
  all: ["taskActionPlan"],
  byId: (actionPlanId, taskId) => [...tasksActionPlanKeys.all, "byId", actionPlanId, taskId],
  assignedToId: (assignedToId) => [...tasksActionPlanKeys.all, "assignedToId", assignedToId],
  byAccountId: (accountId) => [...tasksActionPlanKeys.all, "byAccountId", accountId],
  comments: (actionPlanId, taskId) => [...tasksActionPlanKeys.all, "comments", actionPlanId, taskId]
};
var useCreateTasks = (repository, onResult) => useMutation13({
  mutationFn: (payload) => Promise.all(map21(payload.tasks, (task) => createTask(repository, mapToTaskCreateDTO(task), payload.actionPlanId))),
  onSuccess: (_, payload) => {
    onResult == null ? void 0 : onResult.onSuccess(payload.actionPlanId);
  },
  onError: (_, payload) => {
    onResult == null ? void 0 : onResult.onError(payload.actionPlanId);
  }
});
var useCreateTask = (repository, actionPlanId, onResult) => {
  const client = useQueryClient14();
  return useMutation13({
    mutationFn: (payload) => createTask(repository, mapToTaskCreateDTO(payload), actionPlanId),
    onSuccess: () => {
      onResult == null ? void 0 : onResult.onSuccess();
      client.invalidateQueries(actionPlansKeys.byId(actionPlanId));
      client.invalidateQueries(tasksActionPlanKeys.all);
    },
    onError: () => {
      onResult == null ? void 0 : onResult.onError();
    }
  });
};
var useUpdateTask = (repository, actionPlanId, taskId, onResult) => {
  const client = useQueryClient14();
  return useMutation13({
    mutationFn: (payload) => editTask(repository, actionPlanId, taskId, mapToTaskCreateDTO(payload)),
    onSuccess: () => {
      onResult == null ? void 0 : onResult.onSuccess();
      client.invalidateQueries(actionPlansKeys.byId(actionPlanId));
      client.invalidateQueries(actionPlansKeys.searchActionPlans);
      client.invalidateQueries(tasksActionPlanKeys.all);
    },
    onError: () => {
      onResult == null ? void 0 : onResult.onError();
    }
  });
};
var useDeleteTask = (repository, actionPlanId, taskId, onResult) => {
  const client = useQueryClient14();
  return useMutation13({
    mutationFn: () => deleteTask(repository, actionPlanId, taskId),
    onSuccess: () => {
      onResult == null ? void 0 : onResult.onSuccess();
      client.invalidateQueries(actionPlansKeys.byId(actionPlanId));
      client.invalidateQueries(tasksActionPlanKeys.all);
    },
    onError: () => {
      onResult == null ? void 0 : onResult.onError();
    }
  });
};
var useGetTaskById = (repository, actionPlanId, taskId) => useQuery25({
  queryKey: tasksActionPlanKeys.byId(actionPlanId, taskId),
  queryFn: () => getTaskById(repository, actionPlanId, taskId),
  enabled: !!actionPlanId && !!taskId,
  cacheTime: fiveMinutesInMs
});
var useGetTasksAssignedTo = (repository, assignedToContactId, enabled = true) => useQuery25({
  queryKey: tasksActionPlanKeys.assignedToId(assignedToContactId),
  queryFn: () => getTasksAssignedTo(repository, assignedToContactId),
  enabled: !!assignedToContactId && !!enabled,
  cacheTime: fiveMinutesInMs
});
var useGetTasksByAccountId = (repository, accountId, onResult) => useQuery25({
  queryKey: tasksActionPlanKeys.byAccountId(accountId),
  queryFn: () => getTasksByAccountId(repository, accountId),
  onError: (error) => onResult == null ? void 0 : onResult.onError(error.message || "Could not fetch Tasks"),
  enabled: !!accountId,
  cacheTime: fiveMinutesInMs
});
var useGetCommentsTask = (repository, actionPlanId, taskId) => useQuery25({
  queryKey: tasksActionPlanKeys.comments(actionPlanId, taskId),
  queryFn: () => getCommentsFromTask(repository, actionPlanId, taskId),
  enabled: !!actionPlanId && !!taskId,
  cacheTime: fiveMinutesInMs
});
var useAddCommentToTask = (repository, actionPlanId, taskId, onResult) => {
  const client = useQueryClient14();
  return useMutation13({
    mutationFn: (payload) => addCommentTask(repository, actionPlanId, taskId, payload),
    onSuccess: () => {
      onResult == null ? void 0 : onResult.onSuccess();
      client.invalidateQueries(actionPlansKeys.byId(actionPlanId));
      client.invalidateQueries(tasksActionPlanKeys.all);
    },
    onError: () => {
      onResult == null ? void 0 : onResult.onError();
    }
  });
};
var useDeleteCommentToTask = (repository, actionPlanId, taskId, onResult) => {
  const client = useQueryClient14();
  return useMutation13({
    mutationFn: (payload) => deleteCommentTask(repository, actionPlanId, taskId, payload),
    onSuccess: () => {
      onResult == null ? void 0 : onResult.onSuccess();
      client.invalidateQueries(actionPlansKeys.byId(actionPlanId));
      client.invalidateQueries(tasksActionPlanKeys.all);
    },
    onError: () => {
      onResult == null ? void 0 : onResult.onError();
    }
  });
};

// src/actionPlans/actionPlans.mapper.ts
var mapToActionPlanCreateDTO = ({
  subject,
  content,
  startDate,
  relatedToAccountIds,
  shareWithContacts,
  visibility,
  visibleToClient,
  origin,
  hashtags,
  severity
}) => ({
  subject,
  content,
  origin,
  startDate,
  relatedToAccountIds,
  shareWithContactIds: mapToIds3(shareWithContacts),
  visibility,
  visibleToClient,
  hashtags: map22(hashtags, (tag) => tagitize(tag)),
  severity
});
var mapToActionPlanFormModel = ({
  id,
  subject,
  startDate,
  relatedToAccounts,
  content,
  origin,
  visibleToClient,
  shareWithContacts,
  visibility,
  hashtags,
  severity
}) => ({
  id,
  subject,
  origin,
  visibleToClient,
  startDate: startDate != null ? startDate : "",
  relatedToAccountIds: mapToIds3(relatedToAccounts),
  content,
  shareWithContacts: shareWithContacts != null ? shareWithContacts : [],
  visibility,
  hashtags,
  severity
});
var mapToActionPlan = (actionPlan) => {
  return {
    id: actionPlan.id,
    subject: actionPlan.subject,
    content: actionPlan.content,
    visibility: actionPlan.visibility,
    visibleToClient: actionPlan.visibleToClient,
    overallStatus: actionPlan.overallStatus,
    startDate: actionPlan.startDate,
    relatedToAccounts: uniqBy2(actionPlan.relatedToAccounts, "id"),
    shareWithContacts: actionPlan.shareWithContacts,
    updatedBy: actionPlan.updatedBy,
    isRestricted: actionPlan.isRestricted,
    updatedOn: actionPlan.updatedOn,
    origin: actionPlan.origin,
    tasks: compact8(map22(actionPlan.tasks, mapToTask)),
    hashtags: map22(actionPlan.hashtags, (tag) => untagitize(tag)),
    relatedToNotes: actionPlan.relatedToNotes,
    authorizedAction: {
      canCreateTask: actionPlan._links ? hasHalLink(actionPlan._links, "task_create") : false,
      canEdit: actionPlan._links ? hasHalLink(actionPlan._links, "actionplan_update") : false,
      canDelete: actionPlan._links ? hasHalLink(actionPlan._links, "actionplan_delete") : false
    },
    severity: actionPlan.severity,
    deadline: actionPlan.deadline,
    revisedDeadline: actionPlan.revisedDeadline,
    accountRequests: actionPlan.accountRequests
  };
};
var mapToRelatedAccountsName = (accounts) => {
  var _a;
  const firtAccount = first2(accounts);
  if (!firtAccount) {
    return "";
  }
  const nbAccounts = (_a = slice(accounts, 1)) == null ? void 0 : _a.length;
  const count = nbAccounts > 0 ? `(+ ${nbAccounts}) ` : "";
  return `${firtAccount.friendlyName} ${count}`;
};

// src/actionPlans/actionPlans.api.ts
var actionPlansUrl2 = "/2.0/actionplans";
var searchActionPlansPage = async (repository, page = 0, pageSize = 500, searchParams, withTasks = false) => {
  const fields = withTasks ? { fields: "tasks" } : {};
  const searchParamsGet = omit5(searchParams, ["teamIds", "inheritOnTeams", "hashtags", "deadlineBefore", "deadlineAfter"]);
  const params = {
    page,
    pageSize,
    ...searchParamsGet,
    ...fields
  };
  return (await repository.get(`${actionPlansUrl2}`, stringifyLists10(params))).data;
};
var postPendingValidation = (repository, actionPlanId, payload) => {
  const url15 = `${actionPlansUrl2}/${actionPlanId}/request/${payload.requestId}/do-close`;
  return repository.post(url15, payload);
};
var getActionPlanOrigins = (repository) => {
  return repository.get(`${actionPlansUrl2}/origins`).then((resp) => resp.data.origins);
};
var requestAddAccountsToActionPlan = (repository, actionPlanId, payload) => {
  const url15 = `${actionPlansUrl2}/${actionPlanId}/accounts-requests`;
  return repository.post(url15, payload);
};
var postSearchActionPlansPage = async (repository, page = 0, pageSize = 500, searchParams) => {
  const searchParamsPost = searchParams.teamIds ? searchParams : { ...searchParams, teamIds: [] };
  const fields = { fields: "tasks" };
  const params = {
    page,
    pageSize,
    ...searchParamsPost,
    ...fields
  };
  return (await repository.post(`${actionPlansUrl2}/do-search`, params)).data;
};
var createActionPlan = (repository, values4) => repository.post(actionPlansUrl2, values4);
var updateActionPlan = (repository, values4, actionPlanId) => repository.put(`${actionPlansUrl2}/${actionPlanId}`, values4);
var getActionPlanById = (repository, actionPlanId) => repository.get(`${actionPlansUrl2}/${actionPlanId}`, { fields: "tasks,relatedToNotes,accountRequests" }).then(({ data }) => mapToActionPlan(data));
var deleteActionPlan = (repository, actionPlanId) => repository.delete(`${actionPlansUrl2}/${actionPlanId}`);

// src/actionPlans/actionPlans.mutations.ts
import { useMutation as useMutation14, useQueryClient as useQueryClient15 } from "@tanstack/react-query";
var useSendPendingValidation = (repo, actionPlanId, onResult) => {
  return useMutation14({
    mutationFn: (payload) => postPendingValidation(repo, actionPlanId, payload),
    onSuccess: (_, payload) => {
      onResult == null ? void 0 : onResult.onSuccess(payload.requestId, payload.status);
    },
    onError: (error, payload) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(message, payload.requestId, payload.status);
    }
  });
};
var useRequestAddAccountsToActionPlan = (repo, actionPlanId, onResult) => {
  return useMutation14({
    mutationFn: (payload) => requestAddAccountsToActionPlan(repo, actionPlanId, payload),
    onSuccess: () => {
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};
var useCreateActionPlan = (repo, userId, onResult) => {
  const client = useQueryClient15();
  return useMutation14({
    mutationFn: (payload) => createActionPlan(repo, mapToActionPlanCreateDTO(payload)),
    onSuccess: ({ data }, payload) => {
      var _a;
      client.invalidateQueries(tasksActionPlanKeys.assignedToId(userId));
      client.invalidateQueries(actionPlansKeys.searchActionPlans);
      onResult == null ? void 0 : onResult.onSuccess(data.id, (_a = payload.tasks) != null ? _a : [], !payload.id);
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};
var useUpdateActionPlan = (repo, userId, onResult) => {
  const client = useQueryClient15();
  return useMutation14({
    mutationFn: (payload) => updateActionPlan(repo, mapToActionPlanCreateDTO(payload), payload.id),
    onSuccess: ({ data }) => {
      client.invalidateQueries(actionPlansKeys.byId(data.id));
      client.invalidateQueries(tasksActionPlanKeys.assignedToId(userId));
      client.invalidateQueries(actionPlansKeys.searchActionPlans);
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};
var useDeleteActionPlan = (repo, actionPlanId, userId, onResult) => {
  const client = useQueryClient15();
  return useMutation14({
    mutationFn: () => deleteActionPlan(repo, actionPlanId),
    onSuccess: () => {
      client.invalidateQueries(actionPlansKeys.searchActionPlans);
      client.invalidateQueries(tasksActionPlanKeys.assignedToId(userId));
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};

// src/deals/deals.api.ts
import { stringifyLists as stringifyLists11 } from "@ic-anywhere/ic-utils";
var url5 = "/2.0/deals";
var privateUrl = "/private/0.0/deals";
var fetchDealTypes = (repo) => {
  return repo.get(`${url5}/types`);
};
var fetchDealsAnalytics = (repo, filters) => repo.post(`${privateUrl}/analytics`, {
  ...stringifyLists11({ ...filters }),
  hashtags: filters == null ? void 0 : filters.hashtags,
  enableNewAnalyticsMode: true
}).then(({ data }) => data);
var patchDealStatusDate = (repository, dealId, statusId, date) => repository.patch(`${url5}/${dealId}/step/${statusId}`, date);
var getDealExternalReferences = (repository) => repository.get(`${url5}/external-reference-types`);

// src/deals/deals.typings.ts
var DealKPIColor = {
  green: "#1FD69F",
  lightBlue: "#A3DEE5",
  deepBlue: "#0D50C7",
  warning: "#FF7214",
  red: "#d53229"
};

// src/deals/deals.queries.ts
import { useQuery as useQuery26 } from "@tanstack/react-query";
var useGetDealsAnalytics = (repository, filters) => {
  return useQuery26({
    queryKey: ["useGetDealsAnalytics", filters],
    queryFn: () => fetchDealsAnalytics(repository, filters),
    enabled: !!filters,
    cacheTime: fiveMinutesInMs
  });
};
var useDealTypesQuery = (repo, { enabled, onSuccess, onError } = defaultQueryParamsOptions) => {
  var _a;
  return useQuery26({
    queryKey: ["deal-types", ((_a = repo.config) == null ? void 0 : _a.impersonatingAs) || ""],
    queryFn: () => fetchDealTypes(repo).then(({ data }) => data),
    enabled,
    onSuccess,
    onError
  });
};
var useGetDealExternalReferences = (repo) => {
  return useQuery26({
    queryKey: ["getDealExternalReferences"],
    queryFn: () => getDealExternalReferences(repo).then(({ data }) => data.types),
    enabled: true,
    cacheTime: fiveMinutesInMs
  });
};

// src/deals/deals.mapper.ts
import { find as find6, isEmpty as isEmpty9 } from "lodash-es";
var convertToKAmount = (value) => {
  return value != null ? +Number(value / 1e3).toFixed(0) : null;
};
var getValueByType = (revenues, type, typeValueReturn) => {
  const revenueByType = find6(revenues, (revenue) => type === revenue.type);
  return revenueByType ? typeValueReturn === "value" ? convertToKAmount(revenueByType.value) : convertToKAmount(revenueByType.weightedValue) : null;
};
var getValueByTypeClosureTime = (closuresTime, closureTimeType) => {
  var _a;
  const closureTimeByType = find6(closuresTime, (closureTime) => closureTimeType === closureTime.type);
  return (_a = closureTimeByType == null ? void 0 : closureTimeByType.count) != null ? _a : 0;
};
var getValueByTypeCount = (typeCounts, typeCountType) => {
  var _a;
  const typeCountByType = find6(typeCounts, (typeCount) => typeCountType === typeCount.type);
  return (_a = typeCountByType == null ? void 0 : typeCountByType.count) != null ? _a : 0;
};
var mapDealAnalyticsToRevenue = ({ revenues }) => {
  if (isEmpty9(revenues)) {
    return [];
  }
  return [
    { label: "Lost", count: getValueByType(revenues, "Lost", "value"), color: DealKPIColor.red },
    {
      label: "Weighted revenue",
      count: getValueByType(revenues, "In Progress", "weightdValue"),
      color: DealKPIColor.deepBlue
    },
    { label: "Revenue", count: getValueByType(revenues, "In Progress", "value"), color: DealKPIColor.lightBlue },
    { label: "Won", count: getValueByType(revenues, "Won", "value"), color: DealKPIColor.green }
  ];
};
var mapDealAnalyticsToClosureTimeline = ({ closureTimeline }) => {
  if (isEmpty9(closureTimeline) || closureTimeline === void 0) {
    return [];
  }
  const yearDate = (/* @__PURE__ */ new Date()).getFullYear();
  return [
    { label: "Delayed", count: getValueByTypeClosureTime(closureTimeline, "Delayed"), color: DealKPIColor.warning },
    {
      label: `Q2 ${yearDate}`,
      count: getValueByTypeClosureTime(closureTimeline, `Q2 ${yearDate}`),
      color: DealKPIColor.deepBlue
    },
    {
      label: `Q3 ${yearDate}`,
      count: getValueByTypeClosureTime(closureTimeline, `Q3 ${yearDate}`),
      color: DealKPIColor.deepBlue
    },
    {
      label: `Q4 ${yearDate} & after`,
      count: getValueByTypeClosureTime(closureTimeline, `Q4 ${yearDate} & after`),
      color: DealKPIColor.deepBlue
    }
  ];
};
var mapDealAnalyticsToUpdateTimeline = (updateTimeline, type) => {
  if (isEmpty9(updateTimeline) || updateTimeline === void 0) {
    return [];
  }
  const updateTimelineLabel = type === "noUpdate" ? "never" : "last 12 months";
  return [
    {
      label: "last 14 days",
      count: getValueByTypeCount(updateTimeline, "last 14 days"),
      color: DealKPIColor.deepBlue
    },
    {
      label: "last 30 days",
      count: getValueByTypeCount(updateTimeline, "last 30 days"),
      color: DealKPIColor.deepBlue
    },
    {
      label: "last 90 days",
      count: getValueByTypeCount(updateTimeline, "last 90 days"),
      color: DealKPIColor.deepBlue
    },
    {
      label: updateTimelineLabel,
      count: getValueByTypeCount(updateTimeline, updateTimelineLabel),
      color: DealKPIColor.deepBlue
    }
  ];
};

// src/deals/deals.mutations.ts
import { useMutation as useMutation15 } from "@tanstack/react-query";
var useUpdateDealStatusDateMutation = (repo, dealId, statusId, { onSuccess, onError } = defaultMutationOptions) => {
  return useMutation15({
    mutationFn: (payload) => {
      return patchDealStatusDate(repo, dealId, statusId, payload);
    },
    onSuccess: () => {
      onSuccess == null ? void 0 : onSuccess();
    },
    onError
  });
};

// src/impersonate/impersonate.mapper.ts
import { get as get7 } from "lodash-es";
import { isStringEmpty as isStringEmpty8 } from "@ic-anywhere/ic-utils";
var mapToImpersonate = ({ id, fullName, email, organizationTeam, firstname, lastname, countryIso3 }, supervisedTeams) => {
  var _a;
  return {
    email: (_a = email == null ? void 0 : email.value) != null ? _a : "",
    userId: id,
    userTeamId: get7(organizationTeam, "id", ""),
    teamName: get7(organizationTeam, "path", ""),
    countryIso3,
    fullName: fullName != null ? fullName : "",
    firstname,
    lastname,
    userTeam: organizationTeam ? { id: organizationTeam.id, name: organizationTeam.path } : void 0,
    supervisedTeams: supervisedTeams != null ? supervisedTeams : []
  };
};
var formatTeamName2 = (team) => !isStringEmpty8(team) ? team.replace("SGCIB/", "") : null;
var mapToUsers = (contacts) => (contacts || []).map(
  ({ id, mainEmail, firstname, lastname, organizationTeam }) => ({
    userId: id,
    email: mainEmail ? mainEmail.email : null,
    fullName: formatContactFullName(firstname, lastname),
    team: organizationTeam ? formatTeamName2(organizationTeam.path) : null,
    userTeamId: organizationTeam ? organizationTeam.id : null
  })
);

// src/impersonate/impersonate.api.ts
import { stringifyLists as stringifyLists12 } from "@ic-anywhere/ic-utils";
import { join as join4 } from "lodash-es";
var url6 = "/2.0/contacts";
var getCrmContactById = async (repo, id, properties2 = []) => {
  const result = await repo.get(`${url6}/${id}`, stringifyLists12({ properties: properties2 }));
  return mapToContact(result.data);
};
var searchImpersonateAsUsersByName = async (repo, userName, properties2 = []) => {
  const result = await repo.get(`${url6}/impersonate`, {
    properties: join4(properties2, ","),
    search: userName
  });
  return mapToUsers(result.data);
};

// src/organisationTeams/organizationTeams.api.ts
import { stringifyLists as stringifyLists13 } from "@ic-anywhere/ic-utils";
var url7 = "/2.0/organizationTeams";
var requestOrganisationTeams = (repo, supervisedByContactId) => {
  return repo.getPaginatedList(url7, {}, stringifyLists13({ supervisedByContactId }), {
    iteratorField: "organizationTeams"
  }).pipe(map3(mapToTeams));
};

// src/organisationTeams/organizationTeams.mapper.ts
import { isEmpty as isEmpty10, map as map23 } from "lodash-es";
var mapToContactTeamRelationDTO = (teamId, contacts, teamRelation) => {
  if (!teamId || isEmpty10(contacts)) {
    return void 0;
  }
  return {
    contactTeamRelation: map23(contacts, (x) => ({ contactId: x, teamRelation }))
  };
};

// src/users/users.crm.api.ts
var url8 = "/private/0.0/users";
var fetchUserPermission = (repo, userContactId) => {
  return repo.get(`${url8}/${userContactId}`);
};

// src/users/users.contactDb.api.ts
var url9 = "/private/0.0/users";
var fetchContactDbPermissionsById = (repo, contactId) => {
  return repo.get(`${url9}/${contactId}`);
};

// src/hooks/useFeatureToggle.ts
import { areFeaturesActive } from "@ic-anywhere/ic-utils";
var useFeatureToggle = (disabledFeatureToggles) => {
  return (...featureName) => areFeaturesActive(disabledFeatureToggles, featureName);
};

// src/hooks/useActionsPermission.ts
import { every as every3, isEmpty as isEmpty11 } from "lodash-es";
var useActionsPermissions = (permissions) => {
  return (permissionsToCheck) => areActionsActive(permissions, permissionsToCheck);
};
var areActionsActive = (allPermissions, permissionsToCheck) => {
  if (isEmpty11(permissionsToCheck)) {
    return true;
  }
  if (allPermissions == null) {
    return false;
  }
  return every3(permissionsToCheck, (feature) => allPermissions.includes(feature));
};

// src/contactLists/contactList.mappers.ts
var mapToContactList = ({ id, name, type, shareWithContacts, shareWithTeams, teamsCount, contactsCount }, contacts = [], teams = []) => ({
  id,
  name,
  type,
  shareWithContacts,
  shareWithTeams,
  contacts,
  teams,
  teamsCount,
  contactsCount
});

// src/contactLists/contactList.api.ts
var url10 = "/2.0/contactlists";
var getContactLists = (repository, options) => repository.get(url10, { ...options }).then(({ data }) => data.customLists);
var getContactList = (repository, contactListId) => repository.get(`${url10}/${contactListId}`).then(({ data }) => data);
var createContactList = async (repo, payload) => {
  const response = await repo.post(url10, payload);
  return response.data;
};
var getContactListById = async (repo, contactListId) => {
  const response = await repo.get(`${url10}/${contactListId}`);
  return mapToContactList(response.data);
};

// src/contactLists/contactList.queries.ts
import { useMutation as useMutation16, useQuery as useQuery27 } from "@tanstack/react-query";
import { toPairs } from "lodash-es";
var useGetContactLists = (repo, options) => {
  return useQuery27({
    queryKey: ["getContactLists", ...toPairs(options)],
    queryFn: () => getContactLists(repo, options),
    enabled: true,
    cacheTime: tenMinutesInMs
  });
};
var useCreateContactList = (cmrRepo) => {
  return useMutation16({
    mutationFn: async (payload) => {
      const { id } = await createContactList(cmrRepo, payload);
      return await getContactListById(cmrRepo, id);
    }
  });
};

// src/activities/activities.api.ts
import { stringifyLists as stringifyLists14 } from "@ic-anywhere/ic-utils";
import { map as map24 } from "lodash-es";
var privateExpenseUrl2 = "/private/0.0/expense-approvals";
var DEFAULT_ACTIVITIES_PARAMS = {
  fields: "contacts,isRestricted,contentSummary,author,subType,accounts",
  types: "note,email,meeting,event,deal,actionPlan,feedback",
  pageSize: 30,
  inheritOnAccount: true,
  showCount: true,
  showRestricted: true,
  onlyLiked: false,
  countries: [],
  sort: "activityDate desc",
  participantIds: [],
  typologies: []
};
var getActivities = (repository, params = DEFAULT_ACTIVITIES_PARAMS) => {
  return repository.get("2.0/activities", stringifyLists14(params)).then((res) => {
    var _a, _b;
    return (_b = (_a = res == null ? void 0 : res.data) == null ? void 0 : _a.activities) != null ? _b : [];
  });
};
var requestDeclareGiftGems = (repository, giftId) => repository.post(`${privateExpenseUrl2}/do-declare-gift/${giftId}`, {});
var requestDeclareMeetingGems = (repository, meetingId) => repository.post(`${privateExpenseUrl2}/do-declare-meeting/${meetingId}`, {});
var getActivitiesPermissions = (repository) => {
  return repository.get("2.0/activities/actions").then((res) => {
    var _a, _b;
    return (_b = map24((_a = res == null ? void 0 : res.data) == null ? void 0 : _a.actions, ({ name }) => name)) != null ? _b : [];
  });
};

// src/activities/activities.queries.ts
import { useMutation as useMutation17, useQuery as useQuery28 } from "@tanstack/react-query";
var activitiesQueriesKeys = {
  all: (params) => ["activities", "all", { params }],
  persmission: (email) => ["activites", "permissions", email || ""]
};
var useGetLastActivitiesQuery = (repo, { enabled, onSuccess, onError } = defaultQueryParamsOptions, params = DEFAULT_ACTIVITIES_PARAMS) => {
  return useQuery28({
    queryKey: activitiesQueriesKeys.all(params),
    queryFn: () => getActivities(repo, params),
    enabled,
    onSuccess,
    onError,
    cacheTime: fiveMinutesInMs
  });
};
var useRequestDeclareGiftGems = (repo, giftId, { onSuccess, onError } = defaultMutationOptions) => {
  return useMutation17({
    mutationKey: ["requestDeclareGiftGems", giftId],
    mutationFn: () => requestDeclareGiftGems(repo, giftId),
    onSuccess,
    onError,
    cacheTime: fiveMinutesInMs
  });
};
var useRequestDeclareMeetingGems = (repo, meetingId, { onSuccess, onError } = defaultMutationOptions) => {
  return useMutation17({
    mutationFn: () => requestDeclareMeetingGems(repo, meetingId),
    mutationKey: ["requestDeclareMeetingGems", meetingId],
    onSuccess,
    onError,
    cacheTime: fiveMinutesInMs
  });
};
var useGetActivitiesPermissionsQuery = (repo, { enabled, onSuccess, onError } = defaultQueryParamsOptions) => {
  var _a;
  return useQuery28({
    queryKey: activitiesQueriesKeys.persmission((_a = repo.config) == null ? void 0 : _a.impersonatingAs),
    queryFn: () => getActivitiesPermissions(repo),
    enabled,
    onSuccess,
    onError,
    cacheTime: twelveHoursInMs
  });
};

// src/activities/activities.typings.ts
var ActivityPermissionEnum = /* @__PURE__ */ ((ActivityPermissionEnum2) => {
  ActivityPermissionEnum2["DEAL_CREATE"] = "deal_create";
  ActivityPermissionEnum2["NOTE_CREATE"] = "note_create";
  ActivityPermissionEnum2["MEETING_CREATE"] = "meeting_create";
  ActivityPermissionEnum2["GIFT_CREATE"] = "gift_create";
  ActivityPermissionEnum2["ACTIONPLAN_CREATE"] = "actionplan_create";
  ActivityPermissionEnum2["EVENT_CREATE"] = "event_create";
  ActivityPermissionEnum2["SIMPLIFIED_EVENT_CREATE"] = "simplified_event_create";
  return ActivityPermissionEnum2;
})(ActivityPermissionEnum || {});

// src/bankAccounts/bankAccounts.api.ts
import { stringifyLists as stringifyLists15 } from "@ic-anywhere/ic-utils";
var url11 = "/private/0.0/bankaccounts";
var requestBankAccounts = (repository, thirdId) => repository.get(`${url11}`, stringifyLists15({ ...thirdId })).then(
  (res) => res.data.bankAccounts.filter((a) => {
    var _a;
    return !!((_a = a.preferredAccountNumber) == null ? void 0 : _a.accountNumberValue);
  }).map((a) => a.preferredAccountNumber)
);

// src/bankAccounts/bankAccounts.queries.ts
import { useQuery as useQuery29 } from "@tanstack/react-query";
var useGetBankAccounts = (repo, thirdId, isEnabled = true) => {
  return useQuery29({
    queryKey: ["getBankAccounts", thirdId, isEnabled],
    queryFn: () => requestBankAccounts(repo, thirdId),
    enabled: isEnabled,
    cacheTime: tenMinutesInMs
  });
};

// src/feedbacks/feedbacks.api.ts
var feedbackUrl = "/2.0/service-feedbacks";
var getFeedbackById = (repository, feedbackId) => {
  return repository.get(`${feedbackUrl}/${feedbackId}`).then(({ data }) => data);
};

// src/feedbacks/feedbacks.queries.ts
import { useQuery as useQuery30 } from "@tanstack/react-query";
var feedbackHashtagsKey = (feedbackId) => ["getFeebackById", feedbackId];
var useGetFeedbackById = (repo, feedbackId) => {
  return useQuery30({
    queryKey: feedbackHashtagsKey(feedbackId),
    queryFn: () => getFeedbackById(repo, feedbackId),
    enabled: !!feedbackId,
    cacheTime: fiveMinutesInMs
  });
};

// src/topSales/topSales.api.ts
import { lastYear as lastYear2, stringifyLists as stringifyLists16 } from "@ic-anywhere/ic-utils";
import { flatten as flatten4, map as map25 } from "lodash-es";
var statisticsUrl = "2.0/statistics/activities";
var contactUrl = "2.0/contacts";
var getStatisticsActivities = (repo, accountId) => repo.get(
  statisticsUrl,
  stringifyLists16({ accountIds: [accountId], pageSize: 5, inherit: true, startDate: lastYear2().stringFormat })
).then((result) => {
  const contactIds = map25(
    result.data.aggregates,
    ({ dimensionAttributeValues }) => dimensionAttributeValues.sgParticipantId
  );
  return Promise.all(
    map25(
      contactIds,
      (contactId) => repo.get(`${contactUrl}/${contactId}`, stringifyLists16({ properties: "team" }))
    )
  ).then((res) => flatten4(map25(res, ({ data }) => data)));
});

// src/topSales/topSales.queries.ts
import { useQuery as useQuery31 } from "@tanstack/react-query";
var useGetTopSales = (repo, accountId) => useQuery31({
  queryKey: [accountId, "getTopSales"],
  queryFn: () => getStatisticsActivities(repo, accountId),
  enabled: !!accountId
});

// src/portfolio/portfolio.api.ts
var url12 = "/2.0/portfolio";
var privateUrl2 = "private/0.0/portfolio";
var addContactsToPortfolio = (repository, contactIds) => repository.post(`${privateUrl2}/contacts/do-add`, { contactIds });
var removeContactFromPortfolio = (repository, currentUser, contactId) => repository.delete(`${url12}/${currentUser}/contacts/${contactId}`);
var fetchPortfolioContactInteractions = (repository, scope) => repository.get(`${url12}/interactions`, { scope }).then(({ data }) => data.interactions);
var getAvailableRoles = (repo, userId) => {
  return repo.get(`${url12}/${userId}/clients/check`).then((response) => response.data.functionRoleList);
};

// src/portfolio/portfolio.queries.ts
import {
  useMutation as useMutation18,
  useQueries as useQueries5,
  useQuery as useQuery32,
  useQueryClient as useQueryClient16
} from "@tanstack/react-query";
import { compact as compact9, map as map26, some as some4 } from "lodash-es";
var useFetchPortfolioContactInteractions = (repository, enabled = true) => {
  const query = {
    enabled,
    cacheTime: fiveMinutesInMs
  };
  const scopes = ["onlyIgnored", "onlyKnown", "onlyUnknown"];
  const queries = useQueries5({
    queries: map26(
      scopes,
      (scope) => ({
        ...query,
        queryKey: contactKeys.userInteractions(scope),
        queryFn: () => getUserInteractions(repository, scope)
      })
    )
  });
  const isFetching = some4(queries, (query2) => query2.isFetching);
  const [onlyIgnored, onlyKnown, onlyUnknown] = queries.map((query2) => query2 == null ? void 0 : query2.data);
  const contactInteractions = compact9([
    ...map26(onlyIgnored, (interaction) => ({ ...interaction, ignored: true })),
    ...map26(onlyKnown, (interaction) => ({ ...interaction, unknown: false })),
    ...map26(onlyUnknown, (interaction) => ({ ...interaction, unknown: true }))
  ]);
  return {
    isFetching,
    data: isFetching ? void 0 : contactInteractions,
    errors: isFetching ? void 0 : map26(compact9(queries.map(({ error }) => error)), ({ message }) => message != null ? message : "An error has occured")
  };
};
var useRemoveContactsFromPortfolio = (repository, currentUserId) => {
  const client = useQueryClient16();
  return useMutation18({
    mutationFn: (payload) => Promise.all(map26(payload, (contactId) => removeContactFromPortfolio(repository, currentUserId, contactId))),
    onSuccess: () => {
      client.invalidateQueries(["getContactsByClientId"]);
    }
  });
};
var useFetchAvailableRoles = (repository, currentUserId, enabled) => {
  return useQuery32({
    queryKey: ["roles", currentUserId],
    queryFn: () => getAvailableRoles(repository, currentUserId),
    enabled
  });
};

// src/portfolio/portfolio.mutations.ts
import { useMutation as useMutation19 } from "@tanstack/react-query";
var useAddContactsToPortfolioMutation = (repo, onSuccess, onError) => {
  return useMutation19({
    mutationFn: (contactIds) => addContactsToPortfolio(repo, contactIds),
    onSuccess,
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onError(message);
    }
  });
};

// src/settings/settings.queries.ts
import { useQuery as useQuery33 } from "@tanstack/react-query";

// src/settings/settings.mapper.ts
var mapSettingsToSettingsDTO = (settings) => {
  return {
    welcomePage: settings.welcomePage,
    callPreferences: settings.phoneProtocol,
    outlookSynchronization: settings.contactSynchronization
  };
};
var mapSettingsDTOToSettings = (settingsDto) => {
  return {
    contactSynchronization: settingsDto == null ? void 0 : settingsDto.outlookSynchronization,
    phoneProtocol: settingsDto == null ? void 0 : settingsDto.callPreferences,
    welcomePage: settingsDto == null ? void 0 : settingsDto.welcomePage
  };
};

// src/settings/settings.api.ts
var meUrl = "/private/0.0/users/me";
var requestUpdatePersonalSettings = (settings, repo) => {
  return repo.put(`${meUrl}/settings`, mapSettingsToSettingsDTO(settings));
};
var fetchPersonalSettings = (repo) => repo.get(`${meUrl}/settings`).then((response) => mapSettingsDTOToSettings(response.data));

// src/settings/settings.queries.ts
var SettingsKeys = {
  fetchPersonalSettings: () => ["fetchPersonalSettingsPromise"]
};
var useFetchPersonalSettings = (repo, { onError, onSuccess, enabled = true } = defaultQueryParamsOptions) => {
  return useQuery33({
    queryKey: SettingsKeys.fetchPersonalSettings(),
    queryFn: () => fetchPersonalSettings(repo),
    onError,
    onSuccess,
    enabled
  });
};

// src/settings/settings.mutations.ts
import { useMutation as useMutation20, useQueryClient as useQueryClient17 } from "@tanstack/react-query";
var useUpdateUserSettings = (repo, { onError, onSuccess } = defaultMutationOptions) => {
  const queryClient = useQueryClient17();
  return useMutation20({
    mutationFn: (settings) => requestUpdatePersonalSettings(settings, repo),
    onSuccess: () => {
      queryClient.invalidateQueries(SettingsKeys.fetchPersonalSettings());
      onSuccess == null ? void 0 : onSuccess();
    },
    onError
  });
};

// src/settings/settings.typings.ts
var SETTINGS_PHONE_OPTIONS = [
  { label: "Click'n Dial", value: "ClicknDial" },
  { label: "Skype for business", value: "Skype" }
];
var SETTINGS_PAGE_OPTIONS = [
  { label: "Portfolio", value: "Portfolio" },
  { label: "Search", value: "Search" },
  { label: "KYC", value: "Kyc" },
  { label: "Deals in pipeline", value: "Deals" }
];

// src/contributions/contributions.api.ts
var baseUrl7 = "/private/0.0/contributions";
var getStatistics = (repository, params) => {
  return repository.post(
    `${baseUrl7}/contactinteractions/statistics`,
    params
  ).then(({ data }) => data.contributions);
};
var getStatisticCounters = (repository, params) => {
  return repository.post(`${baseUrl7}/contactinteractions/counters`, params).then(({ data }) => data);
};
var getContributions = (repository, params) => repository.post(`${baseUrl7}/do-search`, params).then(({ data }) => data.contributions);
var exportContributions = (repository, params) => repository.download(
  `${baseUrl7}/do-export`,
  {},
  {
    fileName: "Export contributions.xlsx",
    method: "POST",
    accept: OFFICE_ACCEPT_HEADERS.OFFICE_DOCUMENT,
    body: params
  },
  {}
);
var exportInteractions = (repository, params) => repository.download(
  `${baseUrl7}/contactinteractions/do-export`,
  {},
  {
    fileName: "Export interactions.xlsx",
    method: "POST",
    accept: OFFICE_ACCEPT_HEADERS.OFFICE_DOCUMENT,
    body: params
  }
);

// src/contributions/contributions.queries.ts
import { useQuery as useQuery34 } from "@tanstack/react-query";
var useGetContributions = (repository, filters, enabled = true) => {
  return useQuery34({
    queryKey: ["contributions", "list", filters],
    queryFn: () => getContributions(repository, filters),
    enabled: !!filters && enabled,
    cacheTime: fiveMinutesInMs
  });
};
var useGetStatistics = (repository, filters, enabled = true) => {
  return useQuery34({
    queryKey: ["statistics", filters],
    queryFn: () => getStatistics(repository, filters),
    enabled: !!filters && enabled
  });
};
var useGetStatisticCounters = (repository, filters, enabled = true) => {
  return useQuery34({
    queryKey: ["statisticCounter", filters],
    queryFn: () => getStatisticCounters(repository, filters),
    enabled: !!filters && enabled
  });
};
var useExportContributions = (repo, filters) => {
  return useQuery34({
    queryKey: [],
    queryFn: async () => {
      const file = await exportContributions(repo, filters);
      saveToFile(file);
      return file;
    },
    enabled: false,
    cacheTime: 0
  });
};
var useExportInteractions = (repo, filters) => {
  return useQuery34({
    queryKey: [],
    queryFn: async () => {
      const file = await exportInteractions(repo, filters);
      saveToFile(file);
      return file;
    }
  });
};

// src/contributions/contributions.mapper.ts
import { filter as filter5, groupBy, includes as includes6, map as map27, orderBy as orderBy5, partition, sum, values as values2 } from "lodash-es";
var actitivityType = ["Note", "Email", "Meeting", "Deal", "Invitation"];
var mapContributionsToDisplayBySgContactName = (data) => {
  const internalContactsGroups = groupBy(data, (d) => d.aggregates.internalContact.id);
  const contrib = map27(values2(internalContactsGroups), (contactInteractions) => {
    const { internalContact: currentContact, country, team } = contactInteractions[0].aggregates;
    const interactionsWithExternal = filter5(contactInteractions, (i) => !!i.aggregates.externalContact);
    const groupByExternal = groupBy(interactionsWithExternal, (d) => {
      var _a;
      return (_a = d.aggregates.externalContact) == null ? void 0 : _a.id;
    });
    const interactions = map27(values2(groupByExternal), (externalContactInteractions) => {
      const { externalContact: currentExternalContact } = externalContactInteractions[0].aggregates;
      const [activityInteractions, emailInteractions] = partition(
        externalContactInteractions,
        ({ aggregates }) => includes6(actitivityType, aggregates.contributionType)
      );
      return {
        contact: currentExternalContact,
        countActivities: sum(map27(activityInteractions, ({ count }) => count)),
        countOutlook: sum(map27(emailInteractions, ({ count }) => count))
      };
    });
    return {
      mainContact: currentContact,
      country: country && { name: country.name, iso3: country.codeIso3 },
      team,
      interactions
    };
  });
  return orderBy5(contrib, ({ mainContact }) => mainContact.fullName, "asc");
};
var mapContributionsToDisplayByClientContactName = (data) => {
  const interactionsWithExternal = filter5(data, (i) => !!i.aggregates.externalContact);
  const externalContactsGroups = groupBy(interactionsWithExternal, (d) => {
    var _a;
    return (_a = d.aggregates.externalContact) == null ? void 0 : _a.id;
  });
  const contrib = map27(values2(externalContactsGroups), (contactInteractions) => {
    const { externalContact: currentContact } = contactInteractions[0].aggregates;
    const groupByInternal = groupBy(contactInteractions, (d) => d.aggregates.internalContact.id);
    const interactions = map27(values2(groupByInternal), (internalContactInteractions) => {
      const { internalContact: currentInternalContact } = internalContactInteractions[0].aggregates;
      const [activityInteractions, emailInteractions] = partition(
        internalContactInteractions,
        ({ aggregates }) => includes6(actitivityType, aggregates.contributionType)
      );
      return {
        contact: currentInternalContact,
        countActivities: sum(map27(activityInteractions, ({ count }) => count)),
        countOutlook: sum(map27(emailInteractions, ({ count }) => count))
      };
    });
    return {
      mainContact: currentContact,
      interactions
    };
  });
  return orderBy5(contrib, ({ mainContact }) => mainContact.fullName, "asc");
};

// src/contributions/mockContributions.ts
var contributionsMock = [
  {
    aggregates: {
      internalContact: {
        id: "2e71ff22-b233-e611-b677-005056bd207f",
        fullName: "Asma AFFANE-DEMEURE",
        email: "asma.affane-demeure@socgen.com",
        jobTitle: "BA / AGILE MASTER"
      },
      country: {
        name: "FRANCE",
        codeIso3: "FRA"
      },
      team: {
        path: "SGCIB",
        id: "807949af-2201-e011-b580-00505684446d"
      },
      contributionType: "Note",
      externalContact: {
        id: "49d17746-fabd-4949-95c4-5d5c3316c05d",
        fullName: "Papa NOEL",
        jobType: "COMMUNICATION & MEDIA",
        jobTitle: "P\xE8re No\xEBl"
      },
      crmRole: { id: "0", name: "role" },
      businessUnit: "",
      subBusinessUnit: ""
    },
    count: 11
  },
  {
    aggregates: {
      internalContact: {
        id: "2e71ff22-b233-e611-b677-005056bd207f",
        fullName: "Asma AFFANE-DEMEURE",
        email: "asma.affane-demeure@socgen.com",
        jobTitle: "BA / AGILE MASTER"
      },
      country: {
        name: "FRANCE",
        codeIso3: "FRA"
      },
      team: {
        path: "SGCIB",
        id: "807949af-2201-e011-b580-00505684446d"
      },
      contributionType: "Meeting",
      externalContact: {
        id: "49d17-4-5d5c6c05d",
        fullName: "Poussin PIOU",
        jobType: "HR",
        jobTitle: "Yummy"
      },
      crmRole: { id: "0", name: "role" },
      businessUnit: "",
      subBusinessUnit: ""
    },
    count: 5
  },
  {
    aggregates: {
      internalContact: {
        id: "2e71ff22-b233-e611-b677-005056bd207f",
        fullName: "Asma AFFANE-DEMEURE",
        email: "asma.affane-demeure@socgen.com",
        jobTitle: "BA / AGILE MASTER"
      },
      country: {
        name: "FRANCE",
        codeIso3: "FRA"
      },
      team: {
        path: "SGCIB",
        id: "807949af-2201-e011-b580-00505684446d"
      },
      contributionType: "Note",
      crmRole: { id: "0", name: "role" },
      businessUnit: "",
      subBusinessUnit: ""
    },
    count: 2
  },
  {
    aggregates: {
      internalContact: {
        id: "d4efde9d-dd41-4c16-a7b9-8f0f95957ab4",
        fullName: "Axel DAHAN",
        email: "axel.dahan@socgen.com",
        jobTitle: "CHARGE AFF PAIEMT&CASH MANAGMT"
      },
      country: {
        name: "FRANCE",
        codeIso3: "FRA"
      },
      team: {
        path: "SGCIB/GTPS/PCM/FRA/MEP",
        id: "6964badd-6fe4-e511-be2f-0050569700b2"
      },
      contributionType: "ReceivedEmailInteraction",
      externalContact: {
        id: "0e5aa737-090c-40c1-ba74-60563c056c69",
        fullName: "Test FAURE",
        jobType: "OTHER",
        jobTitle: "zz"
      },
      crmRole: { id: "0", name: "role" },
      businessUnit: "",
      subBusinessUnit: ""
    },
    count: 5
  },
  {
    aggregates: {
      internalContact: {
        id: "d4efde9d-dd41-4c16-a7b9-8f0f95957ab4",
        fullName: "Axel DAHAN",
        email: "axel.dahan@socgen.com",
        jobTitle: "CHARGE AFF PAIEMT&CASH MANAGMT"
      },
      country: {
        name: "FRANCE",
        codeIso3: "FRA"
      },
      team: {
        path: "SGCIB/GTPS/PCM/FRA/MEP",
        id: "6964badd-6fe4-e511-be2f-0050569700b2"
      },
      contributionType: "SentEmailInteraction",
      externalContact: {
        id: "0e5aa737-090c-40c1-ba74-60563c056c69",
        fullName: "Test FAURE",
        jobType: "OTHER",
        jobTitle: "zz"
      },
      crmRole: { id: "0", name: "role" },
      businessUnit: "",
      subBusinessUnit: ""
    },
    count: 3
  },
  {
    aggregates: {
      internalContact: {
        id: "2e71ff22-b233-e611-b677-005056bd207f",
        fullName: "Asma AFFANE-DEMEURE",
        email: "asma.affane-demeure@socgen.com",
        jobTitle: "BA / AGILE MASTER"
      },
      country: {
        name: "FRANCE",
        codeIso3: "FRA"
      },
      team: {
        path: "SGCIB",
        id: "807949af-2201-e011-b580-00505684446d"
      },
      contributionType: "Meeting",
      externalContact: {
        id: "49d17746-fabd-4949-95c4-5d5c3316c05d",
        fullName: "Papa NOEL",
        jobType: "COMMUNICATION & MEDIA",
        jobTitle: "P\xE8re No\xEBl"
      },
      crmRole: { id: "0", name: "role" },
      businessUnit: "",
      subBusinessUnit: ""
    },
    count: 1
  },
  {
    aggregates: {
      internalContact: {
        id: "40567e8f-2906-e611-ae81-0026b976386e",
        fullName: "Pierre STOCKMANN",
        email: "pierre.stockmann-ext@sgcib.com",
        jobTitle: "Other"
      },
      country: {
        name: "FRANCE",
        codeIso3: "FRA"
      },
      team: {
        path: "SGCIB",
        id: "807949af-2201-e011-b580-00505684446d"
      },
      contributionType: "Invitation",
      externalContact: {
        id: "83f07dc5-0b87-4a48-ad70-e52e86b9836f",
        fullName: "Jeff NUPETEST",
        jobType: "LEGAL AND TAX",
        jobTitle: "yummy"
      },
      crmRole: { id: "0", name: "role" },
      businessUnit: "",
      subBusinessUnit: ""
    },
    count: 1
  }
];
var interactionsBySgContactNameMock = [
  {
    mainContact: {
      id: "2e71ff22-b233-e611-b677-005056bd207f",
      fullName: "Asma AFFANE-DEMEURE",
      email: "asma.affane-demeure@socgen.com",
      jobTitle: "BA / AGILE MASTER"
    },
    country: {
      name: "FRANCE",
      iso3: "FRA"
    },
    team: {
      path: "SGCIB",
      id: "807949af-2201-e011-b580-00505684446d"
    },
    interactions: [
      {
        contact: {
          id: "49d17746-fabd-4949-95c4-5d5c3316c05d",
          fullName: "Papa NOEL",
          jobType: "COMMUNICATION & MEDIA",
          jobTitle: "P\xE8re No\xEBl"
        },
        countActivities: 12,
        countOutlook: 0
      },
      {
        contact: {
          id: "49d17-4-5d5c6c05d",
          fullName: "Poussin PIOU",
          jobType: "HR",
          jobTitle: "Yummy"
        },
        countActivities: 5,
        countOutlook: 0
      }
    ]
  },
  {
    mainContact: {
      id: "d4efde9d-dd41-4c16-a7b9-8f0f95957ab4",
      fullName: "Axel DAHAN",
      email: "axel.dahan@socgen.com",
      jobTitle: "CHARGE AFF PAIEMT&CASH MANAGMT"
    },
    country: {
      name: "FRANCE",
      iso3: "FRA"
    },
    team: {
      path: "SGCIB/GTPS/PCM/FRA/MEP",
      id: "6964badd-6fe4-e511-be2f-0050569700b2"
    },
    interactions: [
      {
        contact: {
          id: "0e5aa737-090c-40c1-ba74-60563c056c69",
          fullName: "Test FAURE",
          jobType: "OTHER",
          jobTitle: "zz"
        },
        countActivities: 0,
        countOutlook: 8
      }
    ]
  },
  {
    mainContact: {
      id: "40567e8f-2906-e611-ae81-0026b976386e",
      fullName: "Pierre STOCKMANN",
      email: "pierre.stockmann-ext@sgcib.com",
      jobTitle: "Other"
    },
    country: {
      name: "FRANCE",
      iso3: "FRA"
    },
    team: {
      path: "SGCIB",
      id: "807949af-2201-e011-b580-00505684446d"
    },
    interactions: [
      {
        contact: {
          id: "83f07dc5-0b87-4a48-ad70-e52e86b9836f",
          fullName: "Jeff NUPETEST",
          jobType: "LEGAL AND TAX",
          jobTitle: "yummy"
        },
        countActivities: 1,
        countOutlook: 0
      }
    ]
  }
];
var interactionsByClientContactName = [
  {
    mainContact: {
      id: "83f07dc5-0b87-4a48-ad70-e52e86b9836f",
      fullName: "Jeff NUPETEST",
      jobType: "LEGAL AND TAX",
      jobTitle: "yummy"
    },
    interactions: [
      {
        contact: {
          id: "40567e8f-2906-e611-ae81-0026b976386e",
          fullName: "Pierre STOCKMANN",
          email: "pierre.stockmann-ext@sgcib.com",
          jobTitle: "Other"
        },
        countActivities: 1,
        countOutlook: 0
      }
    ]
  },
  {
    mainContact: {
      id: "49d17746-fabd-4949-95c4-5d5c3316c05d",
      fullName: "Papa NOEL",
      jobType: "COMMUNICATION & MEDIA",
      jobTitle: "P\xE8re No\xEBl"
    },
    interactions: [
      {
        contact: {
          id: "2e71ff22-b233-e611-b677-005056bd207f",
          fullName: "Asma AFFANE-DEMEURE",
          email: "asma.affane-demeure@socgen.com",
          jobTitle: "BA / AGILE MASTER"
        },
        countActivities: 12,
        countOutlook: 0
      }
    ]
  },
  {
    mainContact: {
      id: "49d17-4-5d5c6c05d",
      fullName: "Poussin PIOU",
      jobType: "HR",
      jobTitle: "Yummy"
    },
    interactions: [
      {
        contact: {
          id: "2e71ff22-b233-e611-b677-005056bd207f",
          fullName: "Asma AFFANE-DEMEURE",
          email: "asma.affane-demeure@socgen.com",
          jobTitle: "BA / AGILE MASTER"
        },
        countActivities: 5,
        countOutlook: 0
      }
    ]
  },
  {
    mainContact: {
      id: "0e5aa737-090c-40c1-ba74-60563c056c69",
      fullName: "Test FAURE",
      jobType: "OTHER",
      jobTitle: "zz"
    },
    interactions: [
      {
        contact: {
          id: "d4efde9d-dd41-4c16-a7b9-8f0f95957ab4",
          fullName: "Axel DAHAN",
          email: "axel.dahan@socgen.com",
          jobTitle: "CHARGE AFF PAIEMT&CASH MANAGMT"
        },
        countActivities: 0,
        countOutlook: 8
      }
    ]
  }
];

// src/graphApi/graphApi.utils.ts
import { LogLevels, logMessage, LogTypes } from "@ic-anywhere/ic-utils";
var logGraphError = (graphError) => {
  return logMessage({
    type: LogTypes.technical,
    level: LogLevels.Error,
    name: graphError.message,
    feature: "events.generateTeamsMeeting",
    description: graphError.details
  });
};
var getAuthenticationError = (details) => ({
  type: "Authentication",
  message: "An error occurred while trying to authenticate to Microsoft Office 365",
  details
});
var getGraphApiError = (details) => ({
  type: "Api",
  message: "An error occurred while trying to call the Office 365 Api",
  details: details != null ? details : ""
});

// ../../node_modules/.pnpm/@azure+msal-common@14.13.0/node_modules/@azure/msal-common/dist/logger/Logger.mjs
var LogLevel;
(function(LogLevel2) {
  LogLevel2[LogLevel2["Error"] = 0] = "Error";
  LogLevel2[LogLevel2["Warning"] = 1] = "Warning";
  LogLevel2[LogLevel2["Info"] = 2] = "Info";
  LogLevel2[LogLevel2["Verbose"] = 3] = "Verbose";
  LogLevel2[LogLevel2["Trace"] = 4] = "Trace";
})(LogLevel || (LogLevel = {}));

// src/graphApi/getMsalConfiguration.ts
import { getEnvironment as getEnvironment4 } from "@ic-anywhere/ic-utils";
var logger = getLoggerByEnv("ic-anywhere-vnext");
var env = getEnvironment4();
var isLocalEnv = () => {
  return env === "development" && new URL(window.location.href).hostname === "localhost";
};
var redirectUriDependingEnv = {
  ...SERVICE_URLS.Vnext,
  local: "https://localhost:3000/",
  development: "https://localhost:3000/",
  test: "https://localhost:3000/"
};
var clientId = env === "production" ? "e12b8332-8b2d-40c8-96b6-ad2cc2a3ed0c" : "94c16a36-9246-4031-b2e1-f795991e92eb";
var getMsalConfiguration = () => ({
  auth: {
    clientId,
    authority: "https://login.microsoftonline.com/c9a7d621-4bc4-4407-b730-f428e656aa9e",
    redirectUri: redirectUriDependingEnv[env],
    postLogoutRedirectUri: redirectUriDependingEnv[env]
  },
  cache: {
    cacheLocation: "sessionStorage",
    // This configures where your cache will be stored
    storeAuthStateInCookie: true
    // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii || !isLocalEnv()) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            logger.logError(message);
            return;
          case LogLevel.Info:
            logger.debug(message, message);
            return;
          case LogLevel.Verbose:
            logger.debug(message, message);
            return;
          case LogLevel.Warning:
            logger.logWarning(message);
            return;
        }
      },
      piiLoggingEnabled: false
    }
  }
});
var GRAPH_API_URLS = {
  myEmails: "https://graph.microsoft.com/v1.0/me/messages",
  myEmailsBySentFolder: "https://graph.microsoft.com/v1.0/me/mailFolders('SentItems')/messages",
  myEmailsByReceivedFolder: "https://graph.microsoft.com/v1.0/me/mailFolders('Inbox')/messages",
  myEvents: "https://graph.microsoft.com/v1.0/me/events",
  onlineMeetings: "https://graph.microsoft.com/v1.0/me/onlineMeetings",
  myCalendars: "https://graph.microsoft.com/v1.0/me/calendars",
  user: "https://graph.microsoft.com/v1.0/users",
  calendars: "https://graph.microsoft.com/v1.0/calendars",
  batch: "https://graph.microsoft.com/v1.0/$batch"
};

// src/graphApi/getMsalToken.ts
import { getEnvironment as getEnvironment5 } from "@ic-anywhere/ic-utils";
var meetingGraphApiRedirectUris = {
  ...SERVICE_URLS.Vnext,
  local: "https://localhost:3000/",
  test: "https://localhost:3000/",
  development: "https://localhost:3000/"
};
var msalAuthParams = {
  scopes: ["openid", "profile", "Calendars.Read.Shared", "Mail.Read.Shared"],
  redirectUri: meetingGraphApiRedirectUris[getEnvironment5()]
};
var getMsalToken = async (msalInstance) => {
  const account = msalInstance.getActiveAccount();
  if (!account) {
    throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
  }
  const response = await msalInstance.acquireTokenSilent({
    ...msalAuthParams,
    account
  });
  return response.accessToken;
};
var getMsalHeaders = async (msalInstance) => {
  const token = await getMsalToken(msalInstance);
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-type": "application/json"
  };
  return headers;
};

// src/graphApi/meetings.api.ts
var import_axios2 = __toESM(require_axios2());
import { DateTime as DateTime2 } from "luxon";
import { filter as filter6, isEmpty as isEmpty12, join as join5, map as map28, orderBy as orderBy6 } from "lodash-es";
var getFilterByDate = (filters) => {
  const fromFilter = encodeURIComponent(
    `start/dateTime ge '${DateTime2.fromISO(filters.fromDate).startOf("day").toISO()}'`
  );
  const toFilter = encodeURIComponent(
    `and start/dateTime lt '${DateTime2.fromISO(filters.toDate).startOf("day").plus({ days: 1 }).toISO()}'`
  );
  return `$filter=${fromFilter} ${toFilter}`;
};
var getMyCalendarsList = async (msalInstance) => {
  const headers = await getMsalHeaders(msalInstance);
  const select = "$select=owner,name";
  const url15 = `${GRAPH_API_URLS.myCalendars}?${select}`;
  return import_axios2.default.get(url15, { headers }).then((resp) => resp.data);
};
var getMyMeetingsList = async (msalInstance, filters, pageParam) => {
  const headers = await getMsalHeaders(msalInstance);
  const filter10 = getFilterByDate(filters);
  const select = `$select=subject,body,bodyPreview,organizer,attendees,start,end,location,lastModifiedDateTime,iCalUId,hasAttachments,isCancelled`;
  const order2 = `$orderby=start/dateTime desc`;
  const url15 = pageParam != null ? pageParam : `${GRAPH_API_URLS.myEvents}?${filter10}&${select}&${order2}&top=70`;
  return import_axios2.default.get(url15, { headers }).then((resp) => resp.data);
};
var getMeetingsListFromCalendar = async (msalInstance, calendarId, filters, pageParam) => {
  const headers = await getMsalHeaders(msalInstance);
  const filter10 = getFilterByDate(filters);
  const select = `$select=subject,body,bodyPreview,organizer,attendees,start,end,location,lastModifiedDateTime,hasAttachments,isCancelled`;
  const order2 = `$orderby=start/dateTime desc`;
  const url15 = pageParam != null ? pageParam : `${GRAPH_API_URLS.myCalendars}/${calendarId}/events?${filter10}&${select}&${order2}&top=70`;
  return import_axios2.default.get(url15, { headers }).then((resp) => resp.data);
};
var getMeetingAttachmentsById = async (msalInstance, meetingId, userMail) => {
  const headers = await getMsalHeaders(msalInstance);
  const userUrl = isEmpty12(userMail) ? `${GRAPH_API_URLS.myEvents}/${meetingId}/attachments` : `${GRAPH_API_URLS.user}/${userMail}/events/${meetingId}/attachments`;
  return import_axios2.default.get(userUrl, { headers }).then((resp) => {
    var _a, _b;
    return (_b = (_a = resp.data) == null ? void 0 : _a.value) != null ? _b : [];
  });
};
var getMeetingsByIdsBatch = async (msalInstance, meetingsIds, userMail, properties2 = [
  "subject",
  "body",
  "bodyPreview",
  "organizer",
  "attendees",
  "start",
  "end",
  "location",
  "isCancelled",
  "lastModifiedDateTime",
  "hasAttachments",
  "iCalUId"
]) => {
  const headers = await getMsalHeaders(msalInstance);
  const userUrl = isEmpty12(userMail) ? `/me/events` : `/users/${userMail}/events`;
  const requests = {
    requests: map28(meetingsIds, (meetingId, index) => ({
      id: (index + 1).toString(),
      url: `${userUrl}/${meetingId}?select=${join5(properties2, ",")}`,
      method: "GET",
      headers: { ...headers, "Retry-After": "10" }
    }))
  };
  return import_axios2.default.post(GRAPH_API_URLS.batch, requests, {
    headers: { ...headers, "Retry-After": "10" }
  }).then(
    (resp) => {
      var _a;
      return map28(
        orderBy6(
          filter6((_a = resp.data) == null ? void 0 : _a.responses, ({ status }) => status === 200),
          ({ id }) => parseInt(id)
        ),
        ({ body }) => body
      );
    }
  );
};

// src/graphApi/meetings.queries.ts
import { useInfiniteQuery as useInfiniteQuery3, useQuery as useQuery35 } from "@tanstack/react-query";

// ../../node_modules/.pnpm/@azure+msal-browser@3.18.0/node_modules/@azure/msal-browser/dist/utils/BrowserConstants.mjs
var InteractionType;
(function(InteractionType2) {
  InteractionType2["Redirect"] = "redirect";
  InteractionType2["Popup"] = "popup";
  InteractionType2["Silent"] = "silent";
  InteractionType2["None"] = "none";
})(InteractionType || (InteractionType = {}));
var InteractionStatus = {
  /**
   * Initial status before interaction occurs
   */
  Startup: "startup",
  /**
   * Status set when all login calls occuring
   */
  Login: "login",
  /**
   * Status set when logout call occuring
   */
  Logout: "logout",
  /**
   * Status set for acquireToken calls
   */
  AcquireToken: "acquireToken",
  /**
   * Status set for ssoSilent calls
   */
  SsoSilent: "ssoSilent",
  /**
   * Status set when handleRedirect in progress
   */
  HandleRedirect: "handleRedirect",
  /**
   * Status set when interaction is complete
   */
  None: "none"
};
var DB_NAME = "msal.db";
var DB_TABLE_NAME = `${DB_NAME}.keys`;
var CacheLookupPolicy = {
  /*
   * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired
   * or cannot be found the refresh token will be used to acquire a new one. Finally, if the refresh token
   * is expired acquireTokenSilent will attempt to acquire new access and refresh tokens.
   */
  Default: 0,
  /*
   * acquireTokenSilent will only look for access tokens in the cache. It will not attempt to renew access or
   * refresh tokens.
   */
  AccessToken: 1,
  /*
   * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired or
   * cannot be found, the refresh token will be used to acquire a new one. If the refresh token is expired, it
   * will not be renewed and acquireTokenSilent will fail.
   */
  AccessTokenAndRefreshToken: 2,
  /*
   * acquireTokenSilent will not attempt to retrieve access tokens from the cache and will instead attempt to
   * exchange the cached refresh token for a new access token. If the refresh token is expired, it will not be
   * renewed and acquireTokenSilent will fail.
   */
  RefreshToken: 3,
  /*
   * acquireTokenSilent will not look in the cache for the access token. It will go directly to network with the
   * cached refresh token. If the refresh token is expired an attempt will be made to renew it. This is equivalent to
   * setting "forceRefresh: true".
   */
  RefreshTokenAndNetwork: 4,
  /*
   * acquireTokenSilent will attempt to renew both access and refresh tokens. It will not look in the cache. This will
   * always fail if 3rd party cookies are blocked by the browser.
   */
  Skip: 5
};
var iFrameRenewalPolicies = [
  CacheLookupPolicy.Default,
  CacheLookupPolicy.Skip,
  CacheLookupPolicy.RefreshTokenAndNetwork
];

// src/graphApi/meetings.queries.ts
var import_rxjs6 = __toESM(require_rxjs());
import { chunk, map as map29, uniqBy as uniqBy3 } from "lodash-es";
var graphKeysMeeting = {
  baseKey: ["graph", "meetings"],
  listMyMeetings: (filters) => [graphKeysMeeting.baseKey, "my", filters],
  listMeetings: (filters, calId) => [
    graphKeysMeeting.baseKey,
    ...calId ? ["delegated", calId] : ["my"],
    filters
  ],
  listMeetingsFromCalendar: (calId) => [graphKeysMeeting.baseKey, calId],
  listMyCalendars: ["graph", "calendars", "my"],
  meetingsByIds: (meetingsIds, delegatedEmail) => [
    ...graphKeysMeeting.baseKey,
    "by_id",
    meetingsIds,
    delegatedEmail
  ],
  getMeetingAttachmentsById: (meetingsId, delegatedEmail) => [
    ...graphKeysMeeting.baseKey,
    "getMeetingAttachments",
    meetingsId,
    delegatedEmail
  ],
  getMeetingsAttachmentsById: (meetingsIds, delegatedEmail) => [
    ...graphKeysMeeting.baseKey,
    "getMeetingAttachments",
    meetingsIds,
    delegatedEmail
  ]
};
var useListMyCalendars = (msalContext, enabled = false) => {
  const { inProgress: isAuthenticating, instance } = msalContext;
  return useQuery35({
    queryKey: graphKeysMeeting.listMyCalendars,
    queryFn: () => getMyCalendarsList(instance).then((res) => res.value),
    enabled: enabled && isAuthenticating === InteractionStatus.None,
    select: (cals) => uniqBy3(cals, (cal) => cal.owner.address)
  });
};
var useListMeetings = (msalContext, filters, calendarId, enabled = false) => {
  const { inProgress: isAuthenticating, instance } = msalContext;
  return useInfiniteQuery3({
    queryKey: graphKeysMeeting.listMeetings(filters, calendarId),
    queryFn: ({ pageParam = void 0 }) => calendarId ? getMeetingsListFromCalendar(instance, calendarId, filters, pageParam) : getMyMeetingsList(instance, filters, pageParam),
    enabled: enabled && isAuthenticating === InteractionStatus.None,
    getNextPageParam: (lastPage) => {
      var _a;
      return (_a = lastPage["@odata.nextLink"]) != null ? _a : void 0;
    },
    keepPreviousData: true
  });
};
var useGetMeetingAttachmentsById = (msalContext, meetingId, delegatedEmail, enabled = false) => {
  const { inProgress: isAuthenticating, instance } = msalContext;
  return useQuery35({
    queryKey: graphKeysMeeting.getMeetingAttachmentsById(meetingId, delegatedEmail),
    queryFn: () => getMeetingAttachmentsById(instance, meetingId, delegatedEmail),
    enabled: enabled && isAuthenticating === InteractionStatus.None
  });
};
var useGetMeetingsAttachmentsById = (msalContext, meetingsIds, delegatedEmail, enabled = false) => {
  const { inProgress: isAuthenticating, instance } = msalContext;
  return useQuery35({
    queryKey: graphKeysMeeting.getMeetingsAttachmentsById(meetingsIds, delegatedEmail),
    queryFn: () => Promise.all(
      map29(
        meetingsIds,
        (id) => getMeetingAttachmentsById(instance, id, delegatedEmail).then((value) => {
          return { attachments: value, id };
        })
      )
    ),
    enabled: enabled && isAuthenticating === InteractionStatus.None
  });
};
var useGetMeetingsByIds = (msalContext, meetingsIds, delegatedEmail, enabled = false) => {
  const { inProgress: isAuthenticating, instance } = msalContext;
  const chunckedMeetingsIds = chunk(meetingsIds, 20);
  return useQuery35({
    queryKey: graphKeysMeeting.meetingsByIds(meetingsIds, delegatedEmail),
    queryFn: () => (0, import_rxjs6.from)(chunckedMeetingsIds).pipe(
      concatMap((chunkedMeetings) => (0, import_rxjs6.from)(getMeetingsByIdsBatch(instance, chunkedMeetings, delegatedEmail))),
      reduce((acc, result) => [...acc, ...result], [])
    ).toPromise(),
    enabled: enabled && isAuthenticating === InteractionStatus.None
  });
};

// src/graphApi/meetings.mutations.ts
import { useMutation as useMutation22, useQueryClient as useQueryClient19 } from "@tanstack/react-query";
import { compact as compact11, flatten as flatten5, isEmpty as isEmpty14, map as map33 } from "lodash-es";

// src/trackingOutlook/trackingOutlook.api.ts
import { formatToDateTimeInStartOrEndOfDay } from "@ic-anywhere/ic-utils";
var getFilterByDate2 = (filters) => {
  var _a, _b;
  const fromDate = (_a = formatToDateTimeInStartOrEndOfDay(filters.fromDate)) != null ? _a : "";
  const toDate = (_b = formatToDateTimeInStartOrEndOfDay(filters.toDate, false)) != null ? _b : "";
  return {
    fromDate,
    toDate
  };
};
var trackEmail = (repository, email) => {
  return repository.post("/private/0.0/emails", email);
};
var addAttachmentToMail = (repository, emailId, attachments) => {
  return repository.upload(`/2.0/emails/${emailId}/attachments`, attachments).then((resp) => resp.data);
};
var addAttachmentToMeeting = (repository, meetingId, attachments) => {
  return repository.upload(`/2.0/meetings/${meetingId}/attachments`, attachments).then((resp) => resp.data);
};
var getTrackedEmail = async (repository, body) => {
  var _a;
  const response = await repository.post(
    "/private/0.0/emails/do-search",
    body
  );
  const { data } = response;
  return (_a = data == null ? void 0 : data.emails) != null ? _a : [];
};
var createMeeting = (repository, meeting) => {
  return repository.post("/private/0.0/meetings", meeting);
};
var updateMeeting = async (repository, meeting) => {
  return repository.put(`/private/0.0/meetings/${meeting.id}`, meeting).then((response) => ({ ...response, data: meeting }));
};
var getTrackedMeeting = async (repository, startTime, endTime, participantContactId) => {
  var _a;
  const { fromDate, toDate } = getFilterByDate2({ fromDate: startTime, toDate: endTime });
  const response = await repository.post(
    "/private/0.0/meetings/do-search",
    { startTimeFrom: fromDate, startTimeTo: toDate, participantContactId }
  );
  const { data } = response;
  return (_a = data == null ? void 0 : data.meetings) != null ? _a : [];
};
var deleteMeeting = async (repository, meetingId) => {
  return repository.delete(`/private/0.0/meetings/${meetingId}`);
};

// src/trackingOutlook/trackingOutlook.queries.ts
import { useQuery as useQuery36 } from "@tanstack/react-query";
import { compact as compact10 } from "lodash-es";
var TrackingOutlookKeys = {
  trackEmails: (exchangeIds) => ["activities", "emails", "saerch_tracked", exchangeIds],
  trackMeetings: (startTime, endTime, ownerContactId) => compact10(["activities", "meetings", "saerch_tracked", startTime, endTime, ownerContactId])
};
var useGetTrackedMails = (repo, exchangeIds, enabled = false, keepPreviousData = true) => {
  return useQuery36({
    queryKey: TrackingOutlookKeys.trackEmails(exchangeIds),
    queryFn: () => getTrackedEmail(repo, { exchangeIds }),
    enabled,
    keepPreviousData
  });
};
var useGetTrackedMeetings = (repo, startTime, endTime, ownerContactId, enabled = false, keepPreviousData = true) => {
  return useQuery36({
    queryKey: TrackingOutlookKeys.trackMeetings(startTime, endTime, ownerContactId),
    queryFn: () => getTrackedMeeting(repo, startTime, endTime, ownerContactId),
    enabled,
    keepPreviousData
  });
};

// src/trackingOutlook/trackingOutlook.mutations.ts
import { useMutation as useMutation21, useQueryClient as useQueryClient18 } from "@tanstack/react-query";
import { map as map30 } from "lodash-es";
var defaultErrorMessage = "An unknown error has occurred";
var useUpdateMeeting = (repo) => {
  const queryClient = useQueryClient18();
  const mutation = useMutation21({
    mutationFn: (payload) => updateMeeting(repo, payload),
    mutationKey: ["trackingOutlookUpdateMeeting"],
    onSuccess: async () => {
      await queryClient.invalidateQueries([TrackingOutlookKeys.trackMeetings()]);
    }
  });
  const updateAllMeetings = async (meetings, onSuccess, onError) => {
    const meetingToUpdate = map30(meetings, (meeting) => mutation.mutateAsync(meeting));
    const results = await Promise.allSettled(meetingToUpdate);
    const successMeetings = results.filter((result) => {
      var _a;
      return result.status === "fulfilled" && ((_a = result == null ? void 0 : result.value) == null ? void 0 : _a.status) === 200;
    }).map((result) => result.value.data.subject);
    const errorMeetings = results.filter((result) => {
      var _a;
      return result.status === "rejected" || ((_a = result == null ? void 0 : result.value) == null ? void 0 : _a.status) !== 200;
    }).map((result, index) => ({
      subject: meetings[index].subject,
      errorMessage: result.reason.status
    }));
    onSuccess(successMeetings);
    onError(errorMeetings);
  };
  return { ...mutation, updateAllMeetings };
};
var useDeleteMeetings = (repo, onResult) => {
  const queryClient = useQueryClient18();
  return useMutation21({
    mutationFn: (meetings) => Promise.allSettled(map30(meetings, (meeting) => deleteMeeting(repo, meeting))),
    onSuccess: async (results) => {
      await queryClient.invalidateQueries([TrackingOutlookKeys.trackMeetings()]);
      const settledResults = map30(results, (item) => {
        var _a;
        return {
          success: item.status === "fulfilled",
          data: item.status === "fulfilled" ? item.value.data : (_a = item.reason) == null ? void 0 : _a.message
        };
      });
      onResult == null ? void 0 : onResult.onSuccess(settledResults);
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : defaultErrorMessage;
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};
var useAddAttachmentsToMeetingTracking = (repo, onResult) => {
  return useMutation21({
    mutationFn: ({ attachments, id }) => addAttachmentToMeeting(repo, id, attachments),
    onSuccess: async () => {
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : defaultErrorMessage;
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};
var useAddAttachmentsToEmailTracking = (repo, onResult) => {
  return useMutation21({
    mutationFn: ({ attachments, id }) => addAttachmentToMail(repo, id, attachments),
    onSuccess: async () => {
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : defaultErrorMessage;
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};

// src/graphApi/mails.queries.ts
import { useInfiniteQuery as useInfiniteQuery4, useQuery as useQuery37 } from "@tanstack/react-query";

// src/graphApi/mails.api.ts
var import_axios3 = __toESM(require_axios2());
import { formatToDateTimeInStartOrEndOfDay as formatToDateTimeInStartOrEndOfDay2 } from "@ic-anywhere/ic-utils";
import { filter as filter7, isEmpty as isEmpty13, join as join6, map as map31, orderBy as orderBy7 } from "lodash-es";
var defaultProperties = [
  "bodyPreview",
  "from",
  "toRecipients",
  "id",
  "ccRecipients",
  "bccRecipients",
  "sentDateTime",
  "receivedDateTime",
  "subject",
  "hasAttachments"
];
var order = `$orderby=receivedDateTime desc`;
var getFilterByDate3 = (filters) => {
  const fromFilter = `receivedDateTime ge ${formatToDateTimeInStartOrEndOfDay2(filters.fromDate)}`;
  const toFilter = filters.toDate ? `and receivedDateTime le ${formatToDateTimeInStartOrEndOfDay2(filters.toDate, false)}` : "";
  return `$filter=${fromFilter} ${toFilter}`;
};
var getMyEmailsList = async (msalInstance, filters, emailType, pageParam) => {
  const headers = await getMsalHeaders(msalInstance);
  const filter10 = getFilterByDate3(filters);
  const folder = emailType === "received" ? GRAPH_API_URLS.myEmailsByReceivedFolder : GRAPH_API_URLS.myEmailsBySentFolder;
  const url15 = pageParam != null ? pageParam : `${folder}?${filter10}&select=${join6(defaultProperties, ",")}&${order}&top=100`;
  return import_axios3.default.get(url15, { headers }).then((resp) => resp.data);
};
var getUserEmailsList = async (msalInstance, userMail, filters, emailsType, pageParam) => {
  const headers = await getMsalHeaders(msalInstance);
  const filter10 = getFilterByDate3(filters);
  const folder = emailsType === "received" ? `mailfolders('Inbox')` : `mailfolders('SentItems')`;
  const url15 = pageParam != null ? pageParam : `${GRAPH_API_URLS.user}/${userMail}/${folder}/messages?${filter10}&select=${join6(
    defaultProperties,
    ","
  )}&${order}&top=100`;
  return import_axios3.default.get(url15, { headers }).then((resp) => resp.data);
};
var getEmailById = async (msalInstance, mailId, userMail, properties2 = ["body"]) => {
  const headers = await getMsalHeaders(msalInstance);
  const userUrl = isEmpty13(userMail) ? `${GRAPH_API_URLS.myEmails}` : `${GRAPH_API_URLS.user}/${userMail}/messages`;
  const url15 = `${userUrl}/${mailId}?select=${join6(properties2, ",")}`;
  return import_axios3.default.get(url15, { headers }).then((resp) => resp.data);
};
var getEmailAttachmentsById = async (msalInstance, mailId, userMail) => {
  const headers = await getMsalHeaders(msalInstance);
  const userUrl = isEmpty13(userMail) ? `${GRAPH_API_URLS.myEmails}/${mailId}/attachments` : `${GRAPH_API_URLS.user}/${userMail}/messages/${mailId}/attachments`;
  return import_axios3.default.get(userUrl, { headers }).then((resp) => {
    var _a, _b;
    return (_b = (_a = resp.data) == null ? void 0 : _a.value) != null ? _b : [];
  });
};
var getEmailsByIdsBatch = async (msalInstance, mailIds, userMail, properties2 = ["body"]) => {
  const headers = await getMsalHeaders(msalInstance);
  const userUrl = isEmpty13(userMail) ? `/me/messages` : `/users/${userMail}/messages`;
  const requests = {
    requests: map31(mailIds, (mailId, index) => ({
      id: (index + 1).toString(),
      url: `${userUrl}/${mailId}?select=${join6(properties2, ",")}`,
      method: "GET",
      headers: { ...headers, "Retry-After": "10" }
    }))
  };
  return import_axios3.default.post(GRAPH_API_URLS.batch, requests, {
    headers: { ...headers, "Retry-After": "10" }
  }).then(
    (resp) => {
      var _a;
      return map31(
        orderBy7(
          filter7((_a = resp.data) == null ? void 0 : _a.responses, ({ status }) => status === 200),
          ({ id }) => parseInt(id)
        ),
        ({ body }) => body
      );
    }
  );
};

// src/graphApi/mails.queries.ts
var import_rxjs7 = __toESM(require_rxjs());
import { chunk as chunk2, map as map32 } from "lodash-es";
var graphKeysMail = {
  baseKey: ["graph", "mails"],
  listMails: (filters, delegated, emailType) => [...graphKeysMail.baseKey, ...delegated ? ["delegated", delegated] : ["my"], filters, emailType],
  emailById: (emailId, delegatedEmail) => [
    ...graphKeysMail.baseKey,
    "by_id",
    emailId,
    delegatedEmail
  ],
  emailByIds: (emailIds, delegatedEmail) => [
    ...graphKeysMail.baseKey,
    "by_id",
    emailIds,
    delegatedEmail
  ],
  getEmailAttachmentsById: (emailId, delegatedEmail) => [
    ...graphKeysMail.baseKey,
    "getEmailAttachments",
    emailId,
    delegatedEmail
  ],
  getEmailsAttachmentsById: (emailsIds, delegatedEmail) => [
    ...graphKeysMail.baseKey,
    "getEmailsAttachments",
    emailsIds,
    delegatedEmail
  ]
};
var useListOutlookMails = (msalContext, filters, delegatedEmail, emailType, enabled = false) => {
  const { inProgress: isAuthenticating, instance } = msalContext;
  return useInfiniteQuery4({
    queryKey: graphKeysMail.listMails(filters, delegatedEmail, emailType),
    queryFn: ({ pageParam = void 0 }) => {
      return delegatedEmail ? getUserEmailsList(instance, delegatedEmail, filters, emailType, pageParam) : getMyEmailsList(instance, filters, emailType, pageParam);
    },
    enabled: enabled && isAuthenticating === InteractionStatus.None,
    getNextPageParam: (lastPage) => {
      var _a;
      return (_a = lastPage["@odata.nextLink"]) != null ? _a : void 0;
    },
    keepPreviousData: true
  });
};
var useGetEmailById = (msalContext, emailId, delegatedEmail, enabled = false) => {
  const { inProgress: isAuthenticating, instance } = msalContext;
  return useQuery37({
    queryKey: graphKeysMail.emailById(emailId, delegatedEmail),
    queryFn: () => getEmailById(instance, emailId, delegatedEmail),
    enabled: enabled && isAuthenticating === InteractionStatus.None
  });
};
var useGetEmailAttachmentsById = (msalContext, emailId, delegatedEmail, enabled = false) => {
  const { inProgress: isAuthenticating, instance } = msalContext;
  return useQuery37({
    queryKey: graphKeysMail.getEmailAttachmentsById(emailId, delegatedEmail),
    queryFn: () => getEmailAttachmentsById(instance, emailId, delegatedEmail),
    enabled: enabled && isAuthenticating === InteractionStatus.None
  });
};
var useGetEmailsAttachmentsById = (msalContext, emailsIds, delegatedEmail, enabled = false) => {
  const { inProgress: isAuthenticating, instance } = msalContext;
  return useQuery37({
    queryKey: graphKeysMail.getEmailsAttachmentsById(emailsIds, delegatedEmail),
    queryFn: () => Promise.all(
      map32(
        emailsIds,
        (id) => getEmailAttachmentsById(instance, id, delegatedEmail).then((value) => {
          return { attachments: value, id };
        })
      )
    ),
    enabled: enabled && isAuthenticating === InteractionStatus.None
  });
};
var useGetEmailsByIds = (msalContext, emailsIds, delegatedEmail, enabled = false) => {
  const { inProgress: isAuthenticating, instance } = msalContext;
  const chunckedEmailsIds = chunk2(emailsIds, 20);
  return useQuery37({
    queryKey: graphKeysMail.emailByIds(emailsIds, delegatedEmail),
    queryFn: () => (0, import_rxjs7.from)(chunckedEmailsIds).pipe(
      concatMap((chunkedEmails) => (0, import_rxjs7.from)(getEmailsByIdsBatch(instance, chunkedEmails, delegatedEmail))),
      reduce((acc, result) => [...acc, ...result], [])
    ).toPromise(),
    enabled: enabled && isAuthenticating === InteractionStatus.None
  });
};

// src/graphApi/meetings.mutations.ts
var useTrackMeeting = (repo, onResult) => {
  return useMutation22({
    mutationFn: (payload) => createMeeting(repo, payload),
    onSuccess: async (resp) => {
      onResult == null ? void 0 : onResult.onSuccess(resp.data);
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(message);
    },
    onSettled: () => {
      onResult == null ? void 0 : onResult.onSettled();
    }
  });
};
var useTrackMeetings = (repo, onResult) => {
  const queryClient = useQueryClient19();
  return useMutation22({
    mutationFn: (payload) => Promise.allSettled(
      map33(payload.meetingsToTrack, (meeting) => trackMeetingAndSendAttachments(repo, meeting, payload.filesToAttach))
    ),
    onSuccess: async (res) => {
      await queryClient.invalidateQueries(graphKeysMail.baseKey);
      await queryClient.invalidateQueries(["fetchEmailContactsInteractions"]);
      await queryClient.invalidateQueries(["activities", "meetings", "saerch_tracked"]);
      const settledResults = map33(res, (item) => {
        var _a;
        return {
          success: item.status === "fulfilled",
          data: item.status === "fulfilled" ? item.value.data : (_a = item.reason) == null ? void 0 : _a.message
        };
      });
      onResult == null ? void 0 : onResult.onSuccess(settledResults);
    },
    onError: (error) => {
      var _a;
      const errorMessage = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(errorMessage);
    }
  });
};
var trackMeetingAndSendAttachments = async (repo, meetingToTrack, filesToAttach) => {
  const resp = await createMeeting(repo, meetingToTrack);
  return handleAfterMeetingTracked(resp, filesToAttach, meetingToTrack.exchangeId, repo);
};
var handleAfterMeetingTracked = (resp, filesToAttach, meetingId, repo) => {
  const goodResponseStatus = resp.status === 201 || resp.status === 202;
  if (!isEmpty14(filesToAttach) && goodResponseStatus) {
    const meetingsAttachments = flatten5(
      compact11(map33(filesToAttach, (file) => file.id === meetingId ? file.attachments : null))
    );
    if (!isEmpty14(meetingsAttachments)) {
      addAttachmentToMeeting(repo, resp.data.id, meetingsAttachments);
    }
    return resp;
  }
  return resp;
};

// src/graphApi/mails.mutation.ts
import { useMutation as useMutation23, useQueryClient as useQueryClient20 } from "@tanstack/react-query";
import { compact as compact12, flatten as flatten6, isEmpty as isEmpty15, map as map34 } from "lodash-es";
var useTrackEmail = (repo, onResult) => {
  return useMutation23({
    mutationFn: (payload) => trackEmail(repo, payload),
    onSuccess: async (resp) => {
      onResult == null ? void 0 : onResult.onSuccess(resp.data);
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(message);
    },
    onSettled: () => {
      onResult == null ? void 0 : onResult.onSettled();
    }
  });
};
var useTrackEmails = (repo, onResult) => {
  const queryClient = useQueryClient20();
  return useMutation23({
    mutationFn: (payload) => Promise.allSettled(
      map34(payload.emailsToTrack, (email) => trackEmailAndSendAttachments(repo, email, payload.filesToAttach))
    ),
    onSuccess: async (res) => {
      await queryClient.invalidateQueries(graphKeysMail.baseKey);
      await queryClient.invalidateQueries(["activities", "emails", "saerch_tracked"]);
      await queryClient.invalidateQueries(["fetchEmailContactsInteractions"]);
      const settledResults = map34(res, (item) => {
        var _a;
        return {
          success: item.status === "fulfilled",
          data: item.status === "fulfilled" ? item.value.data : (_a = item.reason) == null ? void 0 : _a.message
        };
      });
      onResult == null ? void 0 : onResult.onSuccess(settledResults);
    },
    onError: (error) => {
      var _a;
      const errorMessage = (_a = error.message) != null ? _a : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(errorMessage);
    }
  });
};
var trackEmailAndSendAttachments = async (repo, emailToTrack, filesToAttach) => {
  const resp = await trackEmail(repo, emailToTrack);
  return handleAfterEmailTracked(resp, filesToAttach, emailToTrack.exchangeId, repo);
};
var handleAfterEmailTracked = (resp, filesToAttach, emailId, repo) => {
  const goodResponseStatus = resp.status === 201 || resp.status === 202;
  if (!isEmpty15(filesToAttach) && goodResponseStatus) {
    const filestoAdd = flatten6(compact12(map34(filesToAttach, (file) => file.id === emailId ? file.attachments : null)));
    if (!isEmpty15(filestoAdd)) {
      addAttachmentToMail(repo, resp.data.id, filestoAdd);
    }
    return resp;
  }
  return resp;
};

// src/introductions/introductions.api.ts
import { stringifyLists as stringifyLists17 } from "@ic-anywhere/ic-utils";
import { compact as compact13, map as map35 } from "lodash-es";
var baseUrl8 = "/2.0/introductions";
var privateUrl3 = "/private/0.0/introductions";
var fetchIntroductions = async (repository, filters) => {
  const response = await repository.get(baseUrl8, stringifyLists17(filters));
  return response.data.introductions;
};
var fetchIntroductionById = async (repository, id) => {
  const response = await repository.get(`${baseUrl8}/${id}`);
  return response.data;
};
var fetchIntroductionListValues = async (repository) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const fetchSources = repository.get(`${baseUrl8}/sources`);
  const fetchStatuses = repository.get(`${baseUrl8}/statuses`);
  const fetchStrategyTypes = repository.get(`${baseUrl8}/strategy-types`);
  const fetchInvestmentStructure = repository.get(`${baseUrl8}/investment-structures`);
  const fetchTypes = repository.get(`${baseUrl8}/types`);
  const promises = [fetchSources, fetchStatuses, fetchStrategyTypes, fetchInvestmentStructure, fetchTypes];
  const result = await Promise.all(promises);
  return {
    sources: (_b = (_a = result[0].data) == null ? void 0 : _a.sources) != null ? _b : [],
    statuses: (_d = (_c = result[1].data) == null ? void 0 : _c.statuses) != null ? _d : [],
    strategicTypes: (_f = (_e = result[2].data) == null ? void 0 : _e.strategyTypes) != null ? _f : [],
    investmentStructure: (_h = (_g = result[3].data) == null ? void 0 : _g.investmentStructures) != null ? _h : [],
    types: (_j = (_i = result[4].data) == null ? void 0 : _i.types) != null ? _j : []
  };
};
var createCapitalIntroduction = async (repository, body) => {
  return repository.post(`${baseUrl8}`, body);
};
var updateCapitalIntroduction = async (repository, id, body) => {
  return repository.put(`${baseUrl8}/${id}`, body);
};
var fetchListStatuses = (repository) => repository.get(`${baseUrl8}/statuses`).then((result) => result.data);
var downloadIntroductionsExcelExport = (repository, filters) => repository.download(
  `${privateUrl3}/report`,
  {},
  {
    fileName: "Export Introductions.xlsx",
    method: "POST",
    accept: OFFICE_ACCEPT_HEADERS.OFFICE_DOCUMENT,
    body: filters
  },
  {}
);
var fetchAnalyticIntroduction = (repository, filters) => repository.post(`${privateUrl3}/analytics`, filters).then((result) => result.data);
var deleteIntroduction = (repository, introductionId) => repository.delete(`${baseUrl8}/${introductionId}`);
var fetchExistingProgramNames = async (repo, accountId) => {
  var _a;
  const response = await repo.get(`${baseUrl8}/programs/${accountId}`);
  return compact13(map35((_a = response.data) == null ? void 0 : _a.programs, ({ name }) => name));
};
var importIntroductions = (repo, headers, file) => repo.uploadFile(`${privateUrl3}/do-import`, { ...headers, "Content-Type": "text/csv" }, file);

// src/introductions/introductions.queries.ts
import { useMutation as useMutation24, useQuery as useQuery38, useQueryClient as useQueryClient21 } from "@tanstack/react-query";

// src/introductions/introductions.mapper.ts
import { isContainSubString as isContainSubString2, isStringEmpty as isStringEmpty9, mapToIsoDateFormat as mapToIsoDateFormat3 } from "@ic-anywhere/ic-utils";
import { filter as filter8, isEmpty as isEmpty16, join as join7, map as map36, some as some5 } from "lodash-es";
var parseNumber = (value) => {
  const parsed = parseInt(value);
  return !isNaN(parsed) ? parsed : void 0;
};
var mapInvestorsToCreateIntroductionDto = (payload) => {
  var _a, _b;
  const createIntroductionDto = mapToCreateIntroductionDto(payload);
  const otherInvestorListDto = (_b = (_a = payload.otherInvestors) == null ? void 0 : _a.map((investor) => {
    return mapToCreateIntroductionDto({
      ...payload,
      investorAccountId: investor.investorAccountId,
      investorContactIds: investor.investorContactIds
    });
  })) != null ? _b : [];
  return [createIntroductionDto, ...otherInvestorListDto];
};
var mapToCreateIntroductionDto = ({
  introductionDate,
  introductionType,
  introducerContactIds,
  investorContactIds,
  investorAccountId,
  managerContactIds,
  comments,
  investmentProgram,
  investmentStructure,
  managerAccountId,
  source,
  managerCompanyStrategies,
  status,
  tripLocationCountryIso3,
  relatedEvent
}) => ({
  introducerContactIds,
  investorCompanyContactIds: investorContactIds,
  investorCompanyAccountId: investorAccountId,
  managerCompanyContactIds: managerContactIds,
  managerCompanyAccountId: managerAccountId,
  content: comments,
  date: introductionDate,
  investmentStructure: parseNumber(investmentStructure),
  managerCompanyStrategies: map36(managerCompanyStrategies, (strategicType) => parseNumber(strategicType)),
  type: parseNumber(introductionType),
  status: parseNumber(status),
  source: parseNumber(source),
  investmentProgram,
  tripLocationCountryIso3,
  relatedEventId: relatedEvent == null ? void 0 : relatedEvent.id
});
var mapToCreateDtoFromIntroduction = ({
  date,
  type,
  content,
  investmentProgram,
  investmentStructure,
  managerCompanyAccount,
  managerCompanyContacts,
  investorCompanyAccount,
  investorCompanyContacts,
  introducerContacts,
  source,
  managerCompanyStrategies,
  status,
  relatedEvent
}) => {
  var _a, _b;
  return {
    introducerContactIds: !isEmpty16(introducerContacts) ? map36(introducerContacts, ({ id }) => id) : [],
    investorCompanyContactIds: !isEmpty16(investorCompanyContacts) ? map36(investorCompanyContacts, ({ id }) => id) : [],
    investorCompanyAccountId: (_a = investorCompanyAccount == null ? void 0 : investorCompanyAccount.id) != null ? _a : "",
    managerCompanyContactIds: !isEmpty16(managerCompanyContacts) ? map36(managerCompanyContacts, ({ id }) => id) : [],
    managerCompanyAccountId: (_b = managerCompanyAccount == null ? void 0 : managerCompanyAccount.id) != null ? _b : "",
    content,
    date,
    investmentStructure: (investmentStructure == null ? void 0 : investmentStructure.id) ? parseNumber(investmentStructure == null ? void 0 : investmentStructure.id) : void 0,
    managerCompanyStrategies: map36(managerCompanyStrategies, (start) => parseNumber(start.id)),
    type: (type == null ? void 0 : type.id) ? parseNumber(type == null ? void 0 : type.id) : void 0,
    status: (status == null ? void 0 : status.id) ? parseNumber(status == null ? void 0 : status.id) : void 0,
    source: (source == null ? void 0 : source.id) ? parseNumber(source == null ? void 0 : source.id) : void 0,
    investmentProgram,
    relatedEventId: relatedEvent == null ? void 0 : relatedEvent.id
  };
};
var mapToIntroductionFiltersDto = ({
  filterDate,
  managerAccount,
  investorAccount,
  managerContact,
  investorContact,
  introducerContact,
  status,
  type,
  strategyTypes,
  source
}) => {
  var _a, _b;
  return {
    startDate: (filterDate == null ? void 0 : filterDate.dateRange) ? mapToIsoDateFormat3((_a = filterDate.dateRange) == null ? void 0 : _a.start) : null,
    endDate: (filterDate == null ? void 0 : filterDate.dateRange) ? mapToIsoDateFormat3((_b = filterDate.dateRange) == null ? void 0 : _b.end) : null,
    managerAccount: managerAccount == null ? void 0 : managerAccount.id,
    investorAccount: investorAccount == null ? void 0 : investorAccount.id,
    managerContact: managerContact == null ? void 0 : managerContact.id,
    investorContact: investorContact == null ? void 0 : investorContact.id,
    introducer: introducerContact == null ? void 0 : introducerContact.id,
    status: status == null ? void 0 : status.id,
    type: type == null ? void 0 : type.id,
    managerCompanyStrategies: !isEmpty16(strategyTypes) ? join7(
      map36(strategyTypes, (strategyType) => strategyType == null ? void 0 : strategyType.id),
      ","
    ) : void 0,
    source: source == null ? void 0 : source.id
  };
};
var createEmptyIntroductionFormData = () => {
  return mapToCreateIntroductionForm({ date: /* @__PURE__ */ new Date() }, { mode: "Create" });
};
var mapToCreateIntroductionForm = (introduction, options) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const _introduction = (options == null ? void 0 : options.mode) === "Duplicate" ? { ...introduction, id: void 0, investorCompanyAccount: void 0, investorCompanyContacts: [] } : introduction != null ? introduction : {};
  const {
    id,
    managerCompanyAccount,
    managerCompanyContacts,
    investorCompanyAccount,
    investorCompanyContacts,
    investmentProgram,
    investmentStructure,
    introducerContacts,
    date,
    type,
    status,
    source,
    managerCompanyStrategies,
    content,
    tripLocationCountry,
    createdOn,
    lastUpdatedOn,
    relatedEvent
  } = _introduction;
  return {
    id: id != null ? id : "",
    investorAccountId: (_a = investorCompanyAccount == null ? void 0 : investorCompanyAccount.id) != null ? _a : "",
    managerAccountId: (_b = managerCompanyAccount == null ? void 0 : managerCompanyAccount.id) != null ? _b : "",
    managerContactIds: (_c = managerCompanyContacts == null ? void 0 : managerCompanyContacts.map(({ id: id2 }) => id2)) != null ? _c : [],
    investorContactIds: (_d = investorCompanyContacts == null ? void 0 : investorCompanyContacts.map(({ id: id2 }) => id2)) != null ? _d : [],
    introducerContactIds: (_e = introducerContacts == null ? void 0 : introducerContacts.map(({ id: id2 }) => id2)) != null ? _e : [],
    introductionDate: date,
    comments: content != null ? content : "",
    source: (_f = source == null ? void 0 : source.id) != null ? _f : "",
    status: (_g = status == null ? void 0 : status.id) != null ? _g : "",
    managerCompanyStrategies: map36(managerCompanyStrategies, ({ id: id2 }) => id2),
    investmentProgram: investmentProgram != null ? investmentProgram : "",
    investmentStructure: (_h = investmentStructure == null ? void 0 : investmentStructure.id) != null ? _h : "",
    introductionType: (_i = type == null ? void 0 : type.id) != null ? _i : "",
    tripLocationCountryIso3: (_j = tripLocationCountry == null ? void 0 : tripLocationCountry.iso3) != null ? _j : "",
    otherInvestors: [],
    createdOn: createdOn != null ? createdOn : null,
    lastUpdatedOn: lastUpdatedOn != null ? lastUpdatedOn : null,
    relatedEvent
  };
};
var mapToCapitalIntroducers = (contacts) => map36(contacts, ({ id, fullName, jobTitle, organisationTeam }) => ({
  id,
  friendlyName: fullName,
  fullName,
  jobTitle,
  organisationTeam
}));
var matchesSearchTerm = (searchTerm, introductionDto) => {
  const {
    managerCompanyAccount,
    investorCompanyAccount,
    introducerContacts,
    source,
    managerCompanyStrategies,
    investmentProgram,
    status
  } = introductionDto;
  return isStringEmpty9(searchTerm) || some5(
    [
      managerCompanyAccount == null ? void 0 : managerCompanyAccount.friendlyName,
      investorCompanyAccount == null ? void 0 : investorCompanyAccount.friendlyName,
      ...map36(introducerContacts, ({ fullName }) => fullName),
      source == null ? void 0 : source.name,
      ...map36(managerCompanyStrategies, ({ name }) => name),
      investmentProgram,
      status == null ? void 0 : status.name
    ],
    (item) => isContainSubString2(item, searchTerm)
  );
};
var filterBySearchTerm = (introductions, searchTerm) => filter8(introductions, (intro) => matchesSearchTerm(searchTerm, intro));

// src/introductions/introductions.queries.ts
import { isEmpty as isEmpty17, map as map37 } from "lodash-es";
import { objectToCsv } from "@ic-anywhere/ic-utils";
var introductionsKeys = {
  globalData: ["introductions", "global_data"],
  list: (filters) => [...introductionsKeys.globalData, "list", filters],
  analytics: (filters) => [...introductionsKeys.globalData, "analytics", filters],
  excel: (filters) => [...introductionsKeys.globalData, "excel_export", filters],
  detail: (id) => ["introductions", "detail", id],
  types: ["introductions", "referential", "types"],
  statuses: ["introductions", "referential", "statuses"],
  introducers: (contactIds) => ["introductions", "introducers", contactIds],
  programs: (accountId) => ["introductions", "existing_programs", accountId],
  import: ["introductions", "import"]
};
var useFetchIntroductionQuery = (repo, filters) => {
  const filtersDto = mapToIntroductionFiltersDto(filters);
  return useQuery38({
    queryKey: introductionsKeys.list(filtersDto),
    queryFn: () => fetchIntroductions(repo, { ...filtersDto, sort: "dateDesc" }),
    enabled: !!filters,
    cacheTime: fiveMinutesInMs
  });
};
var useFetchIntroductionByIdQuery = (repo, id, options) => {
  return useQuery38({
    queryKey: introductionsKeys.detail(id),
    queryFn: () => fetchIntroductionById(repo, id),
    enabled: options.enabled,
    cacheTime: fiveMinutesInMs
  });
};
var useFetchIntroductionTypesQuery = (repo, enabled) => {
  return useQuery38({
    queryKey: introductionsKeys.types,
    queryFn: () => fetchIntroductionListValues(repo),
    enabled,
    cacheTime: tenMinutesInMs,
    keepPreviousData: true
  });
};
var useCreateOrUpdateIntroductionMutation = (repo, onResult) => {
  const client = useQueryClient21();
  return useMutation24({
    mutationFn: (payload) => {
      return !payload.id ? Promise.all(
        mapInvestorsToCreateIntroductionDto(payload).map((createDto) => createCapitalIntroduction(repo, createDto))
      ) : updateCapitalIntroduction(repo, payload.id, mapToCreateIntroductionDto(payload));
    },
    onSuccess: (_, payload) => {
      client.invalidateQueries(introductionsKeys.globalData);
      !!(payload == null ? void 0 : payload.id) && client.invalidateQueries(introductionsKeys.detail(payload.id));
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      var _a, _b, _c;
      const message = (_c = (_b = (_a = error.data) == null ? void 0 : _a.UserMessage) != null ? _b : error.message) != null ? _c : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};
var useFetchIntroducerDetails = (repoCRM, repo, contactIds) => {
  return useQuery38({
    queryKey: introductionsKeys.introducers(contactIds),
    queryFn: () => Promise.all(map37(contactIds, (item) => getContactAndAdditionalInfosById(repoCRM, repo, item))),
    cacheTime: fiveMinutesInMs,
    enabled: !isEmpty17(contactIds)
  });
};
var useUpdateStatus = (repo, introductionId, onResult) => {
  const client = useQueryClient21();
  return useMutation24({
    mutationKey: ["updateStatusIntroduction", introductionId],
    mutationFn: (payload) => {
      return updateCapitalIntroduction(repo, payload.id, mapToCreateDtoFromIntroduction(payload));
    },
    onSuccess: () => {
      client.invalidateQueries(introductionsKeys.detail(introductionId));
      client.invalidateQueries(introductionsKeys.globalData);
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      var _a, _b, _c, _d;
      const message = (_d = (_c = (_b = (_a = error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.UserMessage) != null ? _c : error.message) != null ? _d : "An unknown error has occurred";
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};
var useFetchListStatuses = (repo) => {
  return useQuery38({
    queryKey: introductionsKeys.statuses,
    queryFn: () => fetchListStatuses(repo),
    enabled: true,
    cacheTime: fiveMinutesInMs
  });
};
var useDownloadReportIntroductions = (repo, filters) => {
  const filtersDto = mapToIntroductionFiltersDto(filters);
  return useQuery38({
    queryKey: introductionsKeys.excel(filtersDto),
    queryFn: () => downloadIntroductionsExcelExport(repo, filtersDto).then((file) => {
      saveToFile(file);
      return null;
    }),
    enabled: false,
    cacheTime: tenMinutesInMs
  });
};
var useFetchAnalyticIntroduction = (repo, filters) => {
  const filtersDto = mapToIntroductionFiltersDto(filters);
  return useQuery38({
    queryKey: introductionsKeys.analytics(filtersDto),
    queryFn: () => fetchAnalyticIntroduction(repo, filtersDto),
    enabled: !!filters,
    cacheTime: tenMinutesInMs
  });
};
var useDeleteIntroduction = (repo, onResult) => {
  const client = useQueryClient21();
  return useMutation24({
    mutationKey: ["deleteIntroduction"],
    mutationFn: (payload) => deleteIntroduction(repo, payload),
    onError: () => {
      onResult == null ? void 0 : onResult.onError("Error while deleting this introduction.");
    },
    onSuccess: () => {
      client.invalidateQueries(introductionsKeys.globalData);
      onResult == null ? void 0 : onResult.onSuccess();
    }
  });
};
var useFetchExistingProgramNames = (repo, accountId) => {
  return useQuery38({
    queryKey: introductionsKeys.programs(accountId),
    queryFn: () => fetchExistingProgramNames(repo, accountId),
    enabled: !!accountId,
    cacheTime: fiveMinutesInMs
  });
};
var useImportIntroductions = (headers, { onSuccess, onError }) => {
  const repo = createRepository();
  return useMutation24({
    mutationFn: (payload) => {
      const import$ = importIntroductions(repo, headers, payload).pipe(
        map3(({ status, data }) => {
          return { status, encodedUri: objectToCsv(data) };
        })
      );
      return import$.toPromise();
    },
    onSuccess: ({ status, encodedUri }) => onSuccess == null ? void 0 : onSuccess(status, encodedUri),
    onError
  });
};

// src/admin/admin.queries.ts
import { useQuery as useQuery39 } from "@tanstack/react-query";

// src/admin/admin.mapper.ts
import { compact as compact14, groupBy as groupBy2, map as map38, values as values3 } from "lodash-es";
var COVERAGE_MODE_BYID = {
  1: "Centralized",
  2: "On demand",
  5: "Activity based"
};
var mapToAdminCoverage = (adminCoverageAssociation) => {
  const businessUnitGroups = groupBy2(adminCoverageAssociation, (item) => item.businessUnit);
  return map38(values3(businessUnitGroups), (item) => {
    const coverage = map38(item, (data) => {
      return {
        id: data.id,
        isManager: data.isManager,
        role: data.role,
        functionCoverage: data.function,
        coverageMode: getCoverageMode(data.type.id)
      };
    });
    return { businessUnit: item[0].businessUnit, coverage: compact14(coverage) };
  });
};
var getCoverageMode = (id) => {
  var _a;
  return (_a = COVERAGE_MODE_BYID[id]) != null ? _a : "On demand";
};

// src/admin/admin.api.ts
var privateUrl4 = "/private/0.0";
var getAdminCoverage = (repo) => {
  return repo.get(`${privateUrl4}/coverage/roles-associations`).then(({ data }) => mapToAdminCoverage(data.rules));
};
var getAllCoverageRoles = (repo) => {
  return repo.get(`${privateUrl4}/referentials/coverage-roles`).then((value) => value.data);
};
var getAllCoverageFunctions = (repo) => {
  return repo.get(`${privateUrl4}/referentials/coverage-functions`).then((value) => value.data);
};
var addRoleInAdminCoverage = (repo, payload) => {
  return repo.post(`${privateUrl4}/coverage/roles-associations`, payload);
};
var deleteRoleInAdminCoverage = (repo, coverageId) => repo.delete(`${privateUrl4}/coverage/roles-associations/${coverageId}`);

// src/admin/admin.queries.ts
var baseKey4 = "adminCoverage";
var adminCoverageKeys = {
  base: [baseKey4],
  all: [baseKey4, "all"],
  roles: [baseKey4, "roles"],
  functions: [baseKey4, "functions"]
};
var useGetAdminCoverage = (repo, onError) => {
  return useQuery39({
    queryKey: adminCoverageKeys.all,
    queryFn: () => getAdminCoverage(repo),
    onError: () => onError == null ? void 0 : onError(),
    enabled: true
  });
};
var useGetAllCoverageRoles = (repo, onError) => {
  return useQuery39({
    queryKey: adminCoverageKeys.roles,
    queryFn: () => getAllCoverageRoles(repo),
    onError: () => onError == null ? void 0 : onError(),
    enabled: true
  });
};
var useGetAllCoverageFunctions = (repo, onError) => {
  return useQuery39({
    queryKey: adminCoverageKeys.functions,
    queryFn: () => getAllCoverageFunctions(repo),
    onError: () => onError == null ? void 0 : onError(),
    enabled: true
  });
};

// src/admin/admin.mutation.ts
import { useMutation as useMutation25, useQueryClient as useQueryClient22 } from "@tanstack/react-query";
var useAddRoleInAdminCoverage = (repo, onResult) => {
  const client = useQueryClient22();
  return useMutation25({
    mutationFn: (payload) => addRoleInAdminCoverage(repo, payload),
    onSuccess: () => {
      client.invalidateQueries(adminCoverageKeys.all);
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred while created a role.";
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};
var useDeleteRoleInAdminCoverage = (repo, onResult) => {
  const client = useQueryClient22();
  return useMutation25({
    mutationFn: (coverageId) => deleteRoleInAdminCoverage(repo, coverageId),
    onSuccess: () => {
      client.invalidateQueries(adminCoverageKeys.all);
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      var _a;
      const message = (_a = error.message) != null ? _a : "An unknown error has occurred while deleting a role";
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};

// src/mifid/constants.ts
var baseKey5 = "mifid";
var mifidKeys = {
  contact: (contactId) => [baseKey5, "contact", contactId]
};

// src/mifid/mifid.contact.api.ts
var mifidUrl2 = "/api/v1/contacts";
var getMifidContractUrlByIcId = (repository, icId) => {
  return repository.get(`${mifidUrl2}/contract-urls/${icId}`).then(({ data }) => {
    var _a;
    return (_a = data == null ? void 0 : data.uri) != null ? _a : "";
  });
};

// src/mifid/mifid.contact.queries.ts
import { useQuery as useQuery40 } from "@tanstack/react-query";
var useGetMifidContractUrlQuery = (repo, contactId, enabled = true) => {
  return useQuery40({
    queryKey: contactId ? mifidKeys.contact(contactId) : [],
    queryFn: () => getMifidContractUrlByIcId(repo, contactId != null ? contactId : ""),
    enabled: enabled && !!contactId,
    cacheTime: twoMinutesInMs
  });
};

// src/esg/esg.api.ts
import { filter as filter9 } from "lodash-es";
import { isStringEmpty as isStringEmpty10, today } from "@ic-anywhere/ic-utils";
var baseUrl9 = "/2.0/esg-details";
var cliGlobalViewUrl = "/v1/financialData";
var privateUrl5 = "/private/0.0";
var getESGHashtags = (repository) => {
  return repository.get(`${baseUrl9}/hashtags`).then((res) => {
    var _a, _b;
    return (_b = (_a = res == null ? void 0 : res.data) == null ? void 0 : _a.hashtags) != null ? _b : [];
  });
};
var getEsgDetails = (repository, accountId) => {
  return repository.get(`${baseUrl9}/${accountId}`, { fields: "lastUpdateBy, lastUpdatedOn" }).then((res) => res == null ? void 0 : res.data);
};
var patchEsgDetails = (repository, accountId, details) => {
  return repository.patch(`${baseUrl9}/${accountId}`, details).then(() => true);
};
var getEsgDocuments = (repository, accountId, documentType) => {
  return repository.get(`${baseUrl9}/${accountId}/documents`).then(
    (res) => {
      var _a;
      return filter9(
        (_a = res == null ? void 0 : res.data) == null ? void 0 : _a.esgDocuments,
        ({ type }) => !isStringEmpty10(documentType) ? documentType === type : !isStringEmpty10(type)
      );
    }
  );
};
var uploadEsgDocument = (repository, accountId, document2) => {
  return repository.uploadFormData(
    `${baseUrl9}/${accountId}/documents`,
    document2
  ).then((res) => res == null ? void 0 : res.data);
};
var deleteEsgDocument = (repository, documentId) => {
  return repository.delete(`${baseUrl9}/documents/${documentId}`);
};
var downloadEsgDocument = (repository, documentId) => repository.download(
  `${baseUrl9}/documents/${documentId}`,
  {},
  {
    method: "GET"
  }
);
var getSgResearch = (repository, bdrCommercialId) => {
  return repository.get(`${cliGlobalViewUrl}/${bdrCommercialId}/esgScore`, { date: today().stringFormat }).then((result) => {
    var _a;
    return (_a = result.data) == null ? void 0 : _a.quotes[0];
  });
};
var getEsgEvents = (repository, accountId, page) => {
  return repository.get(`${privateUrl5}/esg-events/${accountId}`, { page }).then((res) => res.data);
};

// src/esg/esg.queries.ts
import { useInfiniteQuery as useInfiniteQuery5, useQuery as useQuery41 } from "@tanstack/react-query";
import { compact as compact15 } from "lodash-es";
var ESGKeys = {
  surveyDocuments: (accountId) => compact15(["esgdocuments", "survey", accountId]),
  surveyDocumentById: (documentId) => ["esgdocument", "survey", documentId],
  download: (documentId) => ["downloadEsgDocument", documentId],
  esgDetails: (accountId) => compact15(["esgDetails", accountId]),
  esgEvents: (accountId) => compact15(["esgEvents", accountId])
};
var useGetESGHashtagsQuery = (repo, { enabled, onSuccess, onError } = defaultQueryParamsOptions) => {
  return useQuery41({
    queryKey: ["esgHashtags"],
    queryFn: () => getESGHashtags(repo),
    enabled,
    onSuccess,
    onError,
    cacheTime: twoMinutesInMs
  });
};
var useGetESGDetailsQuery = (repo, accountId, { enabled, onSuccess, onError } = defaultQueryParamsOptions) => {
  return useQuery41({
    queryKey: ESGKeys.esgDetails(accountId),
    queryFn: () => getEsgDetails(repo, accountId),
    enabled: enabled && !!accountId,
    onSuccess,
    onError,
    cacheTime: twoMinutesInMs
  });
};
var useGetESGSurveyDocumentsQuery = (repo, accountId, { enabled, onSuccess, onError } = defaultQueryParamsOptions) => {
  return useQuery41({
    queryKey: ESGKeys.surveyDocuments(accountId),
    queryFn: () => getEsgDocuments(repo, accountId, "Survey"),
    enabled: enabled && !!accountId,
    onSuccess,
    onError,
    cacheTime: twoMinutesInMs
  });
};
var useDownloadEsgDocumentQuery = (repo, document2) => {
  return useQuery41({
    queryKey: ESGKeys.download(document2 == null ? void 0 : document2.id),
    queryFn: async () => {
      const file = await downloadEsgDocument(repo, document2.id);
      saveToFile(file, document2.fileName);
      return file;
    },
    enabled: false,
    cacheTime: 0
  });
};
var useGetSGResearch = (repo, bdrCommercialId, { enabled, onSuccess, onError } = defaultQueryParamsOptions) => {
  return useQuery41({
    queryKey: ["sgResearch", bdrCommercialId],
    queryFn: () => getSgResearch(repo, bdrCommercialId),
    enabled: enabled && !!bdrCommercialId,
    onSuccess,
    onError
  });
};
var useGetESGEventsQuery = (repo, accountId, enabled = true) => {
  return useInfiniteQuery5({
    queryKey: ESGKeys.esgEvents(accountId),
    queryFn: ({ pageParam = 0 }) => getEsgEvents(repo, accountId, pageParam),
    enabled: enabled && !!accountId,
    getNextPageParam: (response) => response.nextPageUri ? response.page + 1 : void 0,
    keepPreviousData: true,
    cacheTime: twoMinutesInMs
  });
};

// src/esg/esg.mutations.ts
import { useMutation as useMutation26, useQueryClient as useQueryClient23 } from "@tanstack/react-query";
var ERROR_MESSAGE = "An unknown error has occurred";
var useDeleteEsgDocumentMutation = (repo, onResult) => {
  const client = useQueryClient23();
  return useMutation26({
    mutationFn: (documentId) => deleteEsgDocument(repo, documentId),
    onSuccess: (_, payload) => {
      client.invalidateQueries(ESGKeys.surveyDocuments());
      client.invalidateQueries(ESGKeys.surveyDocumentById(payload));
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      const message = error.message || ERROR_MESSAGE;
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};
var useUploadEsgDocumentMutation = (repo, accountId, onResult) => {
  const client = useQueryClient23();
  return useMutation26({
    mutationFn: (document2) => uploadEsgDocument(repo, accountId, document2),
    onSuccess: () => {
      client.invalidateQueries(ESGKeys.surveyDocuments(accountId));
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      const message = error.message || ERROR_MESSAGE;
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};
var useReplaceEsgDocumentMutation = (repo, accountId, onResult) => {
  const client = useQueryClient23();
  return useMutation26({
    mutationFn: ({ document: document2, documentId }) => Promise.all([deleteEsgDocument(repo, documentId), uploadEsgDocument(repo, accountId, document2)]),
    onSuccess: () => {
      client.invalidateQueries(ESGKeys.surveyDocuments(accountId));
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      const message = error.message || ERROR_MESSAGE;
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};
var usePatchEsgDetailsMutation = (repo, accountId, onResult) => {
  const client = useQueryClient23();
  return useMutation26({
    mutationFn: (values4) => patchEsgDetails(repo, accountId, values4),
    onSuccess: () => {
      client.invalidateQueries(ESGKeys.esgDetails());
      onResult == null ? void 0 : onResult.onSuccess();
    },
    onError: (error) => {
      const message = error.message || ERROR_MESSAGE;
      onResult == null ? void 0 : onResult.onError(message);
    }
  });
};

// src/bernstein/bernstein.api.ts
var privateServiceUrl = "/api/";
var url13 = "/2.0/clients";
var getUserHasBernsteinService = (repository, userEmail) => repository.get(`${privateServiceUrl}bernstein/equityresearchsubcription/${userEmail}`).then(({ data }) => data.hasBernsteinResearchAccess);
var getBernsteinLegalEntities = (repository, accountId) => repository.get(`${privateServiceUrl}bernstein/related-legal-entities/${accountId}`).then(({ data }) => data);
var getBernsteinSgStructure = (repository, accountId) => repository.get(`${privateServiceUrl}bernstein/bernstein-trees/${accountId}`).then(({ data }) => data.node);
var getIsAccountBernstein = (accountId, repo) => repo.get(`${url13}/${accountId}/bernstein-sg`).then((res) => res.data);

// src/bernstein/bernstein.queries.ts
import { useQuery as useQuery42 } from "@tanstack/react-query";
var useGetUserHasBernsteinService = (repo, userEmail, enabled = true) => useQuery42({
  queryKey: ["user_has_bernstein_service", userEmail],
  queryFn: () => getUserHasBernsteinService(repo, userEmail),
  enabled,
  cacheTime: tenMinutesInMs
});
var useGetBernsteinLegalEntities = (repo, accountId, enabled = true) => useQuery42({
  queryKey: ["berntein_legal_entities", accountId],
  queryFn: () => getBernsteinLegalEntities(repo, accountId),
  enabled,
  cacheTime: tenMinutesInMs
});
var useGetBernsteinSgStructure = (repo, accountId, enabled = true) => {
  return useQuery42({
    queryKey: ["bernstein_sg_structure", accountId],
    queryFn: () => getBernsteinSgStructure(repo, accountId),
    enabled,
    cacheTime: twoMinutesInMs
  });
};
var useGetIsAccountBernsteinQuery = (repo, accountId, enabled = false) => {
  return useQuery42({
    queryKey: ["getIsAccountBernsteinSg", accountId],
    queryFn: () => getIsAccountBernstein(accountId, repo),
    enabled: enabled && !!accountId,
    cacheTime: twoMinutesInMs
  });
};

// src/requiredActions/requiredActions.api.ts
var privateUrl6 = "/private/0.0/required-actions";
var url14 = "/api/required-actions";
var getRequiredActionsInteractions = (repo) => repo.get(`${privateUrl6}/interactions`).then((res) => res.data);
var getRequiredActionsActionPlans = (repo) => repo.get(`${privateUrl6}/actionplans`).then((res) => res.data);
var getRequiredActionsDeals = (repo) => repo.get(`${privateUrl6}/deals`).then((res) => res.data);
var getRequiredActionsPortfolio = (repo) => repo.get(`${url14}/kyc-counters`, void 0, { timeout: oneMinutesInMs }).then((res) => res.data);

// src/requiredActions/requiredActions.queries.ts
import { useQuery as useQuery43 } from "@tanstack/react-query";
var useGetRequiredActionsInteractions = (repo, enabled = true) => {
  return useQuery43({
    queryKey: ["required_actions_interactions"],
    queryFn: () => getRequiredActionsInteractions(repo),
    enabled,
    cacheTime: 0
  });
};
var useGetRequiredActionsActionPlans = (repo, enabled = true) => {
  return useQuery43({
    queryKey: ["required_actions_action_plans"],
    queryFn: () => getRequiredActionsActionPlans(repo),
    enabled,
    cacheTime: 0
  });
};
var useGetRequiredActionsDeals = (repo, enabled = true) => {
  return useQuery43({
    queryKey: ["required_actions_deals"],
    queryFn: () => getRequiredActionsDeals(repo),
    enabled,
    cacheTime: 0
  });
};
var useGetRequiredActionsPortfolio = (repo, enabled = true) => {
  return useQuery43({
    queryKey: ["required_actions_portfolio"],
    queryFn: () => getRequiredActionsPortfolio(repo),
    enabled,
    cacheTime: 0
  });
};
export {
  AccountCoverageSortField,
  AccountRoleEnum,
  ActionPlanSeverityTypes,
  ActivityPermissionEnum,
  ApiError,
  ApiRepository,
  ApiRxRepository,
  CivilityTypes,
  ClientProfileTieringListIds,
  ColorStatusNames,
  DEFAULT_ACTIVITIES_PARAMS,
  DEFAULT_CLIENT_API_FIELDS,
  DEFAULT_DELEGATION_FIELDS,
  DEFAULT_PAGE_SIZE,
  DateFilterEnum,
  DateFilterEnumExtended,
  DealKPIColor,
  DelegationDocumentTypeEnum,
  DocumentTypeEnum,
  ESGKeys,
  EventAddressType,
  EventStatusNames,
  EvidenceTypeEnum,
  GRAPH_API_URLS,
  INVITATION_STATUSES,
  IdNameNumberSchema,
  InvitationStatusEnum,
  InvitationStatusNameEnum,
  MandateDocumentTypeEnum,
  Mifid2ResearchDTOSchema,
  Mifid2ResearchScopeEnum,
  OFFICE_ACCEPT_HEADERS,
  PersonDocumentTypeEnum,
  SERVICE_URLS,
  SETTINGS_PAGE_OPTIONS,
  SETTINGS_PHONE_OPTIONS,
  SettingsKeys,
  SgRatings,
  SlotBookingStatuses,
  SlotColorStatusNames,
  SlotStatusNames,
  StringSchema,
  TeamReason,
  TrackingOutlookKeys,
  UnassignBusinessFunctionFromTeam,
  UpdateMifid2ResearchDTOSchema,
  VisibilityType,
  accountSearchKeys,
  actionPlansKeys,
  addAttachmentToMail,
  addAttachmentToMeeting,
  addCommentTask,
  addContactsToPortfolio,
  addEtag,
  addRoleInAdminCoverage,
  adminCoverageKeys,
  apiErrorHandler,
  apiRequestHandler,
  apiResponseHandler,
  apiRxValidationHandler,
  apiValidationHandler,
  assignBusinessFunctionToTeam,
  baseUrl8 as baseUrl,
  buildAccountCoverageKey,
  buildAccountCoverageQuery,
  buildUrl,
  buildUrlForEnv,
  catchApiError,
  clientInfoQueriesKeys,
  consoleLogger,
  contactDbHeader,
  contactKeys,
  contributionsMock,
  createActionPlan,
  createAxiosRequestConfig,
  createCapitalIntroduction,
  createContactList,
  createEmailCampaign,
  createEmptyIntroductionFormData,
  createEvent,
  createMeeting,
  createRepository,
  createSlot,
  createTask,
  defaultAccountProperties,
  defaultApiTimeout,
  defaultClientProperties,
  defaultContactsByClientIdProperties,
  defaultDownloadTimeout,
  defaultGetContactByIdProperties,
  defaultHeaders,
  defaultQueryClientOptions,
  deleteAccountCoverageContact,
  deleteActionPlan,
  deleteCommentTask,
  deleteContact,
  deleteContactSgmcMifid,
  deleteEmailCampaign,
  deleteEsgDocument,
  deleteEventEmailTemplate,
  deleteEventInvitation,
  deleteIntroduction,
  deleteMeeting,
  deleteRoleInAdminCoverage,
  deleteSlot,
  deleteTask,
  doSendEmails,
  downloadCommercialTreeExcelFile,
  downloadEsgDocument,
  downloadIntroductionsExcelExport,
  editTask,
  emptyGuid,
  eventsInviteesQueriesKeys,
  eventsKeys,
  eventsTemplateQueriesKeys,
  exportContributions,
  exportInteractions,
  extractParentName,
  fetchAnalyticIntroduction,
  fetchBusinessFunctions,
  fetchContactDbPermissionsById,
  fetchDealTypes,
  fetchDealsAnalytics,
  fetchExistingProgramNames,
  fetchIntroductionById,
  fetchIntroductionListValues,
  fetchIntroductions,
  fetchLinkedPages,
  fetchListStatuses,
  fetchPersonalSettings,
  fetchPortfolioContactInteractions,
  fetchUserPermission,
  filterBySearchTerm,
  fiveMinutesInMs,
  formatAccountName,
  formatBusinessFunction,
  formatBusinessFunctionFullTreeName,
  formatContactFullName,
  formatIndicatorDate,
  formatSlotAddress,
  formatTeamName2 as formatTeamName,
  fundQueriesKeys,
  get2 as get,
  getAccountByBdrLegalId,
  getAccountById,
  getAccountCompleteName,
  getAccountCoverage,
  getAccountTypology,
  getActionPlanById,
  getActionPlanOrigins,
  getActivities,
  getActivitiesPermissions,
  getAdminCoverage,
  getAllCoverageFunctions,
  getAllCoverageRoles,
  getAllTeams,
  getAllTeamsPermissions,
  getAuthenticationError,
  getAvailableRoles,
  getAxiosRequestConfigForDownload,
  getBernsteinLegalEntities,
  getBernsteinSgStructure,
  getClientLists,
  getCommentsFromTask,
  getCommercialTree,
  getContactAndAdditionalInfosById,
  getContactById,
  getContactDbHeader,
  getContactEmailsStatus,
  getContactList,
  getContactListById,
  getContactLists,
  getContactMandates,
  getContactPepSpoStatusAndEmails,
  getContactQualityIndicators,
  getContactQueryParams,
  getContactSgmcById,
  getContactSgmcByIds,
  getContactUsageIndicators,
  getContactsByClientId,
  getContactsByCoveredEmail,
  getContactsByTeamId,
  getContributions,
  getCountries,
  getCrmContactById,
  getDealExternalReferences,
  getDomainsListByAccountId,
  getESGHashtags,
  getEmailAttachmentsById,
  getEmailById,
  getEmailCampaigns,
  getEmailsByIdsBatch,
  getEsgDetails,
  getEsgDocuments,
  getEsgEvents,
  getEventById,
  getEventContactRelatives,
  getEventEmailTemplates,
  getEventInvitations,
  getEventSlots,
  getFeedbackById,
  getGraphApiError,
  getHashtagsAccount,
  getHashtagsContact,
  getHeaders,
  getInteractionsByAccountId,
  getInteractionsByContactId,
  getIsAccountBernstein,
  getKycTree,
  getLanguages,
  getLoggerByEnv,
  getMeetingAttachmentsById,
  getMeetingsByIdsBatch,
  getMeetingsListFromCalendar,
  getMifid,
  getMifidContractUrlByIcId,
  getMifidJustifications,
  getMifidJustificationsSchemaConfig,
  getMsalConfiguration,
  getMsalHeaders,
  getMsalToken,
  getMyCalendarsList,
  getMyEmailsList,
  getMyMeetingsList,
  getNextPageUri,
  getOrgChartPerEntityTree,
  getPermissionsByTeamId,
  getPrivateClientById,
  getRelatedAccount,
  getRepositoryMock,
  getRequiredActionsActionPlans,
  getRequiredActionsDeals,
  getRequiredActionsInteractions,
  getRequiredActionsPortfolio,
  getResearchCategories,
  getServiceUrl,
  getServiceUrlsByEnv,
  getSgResearch,
  getShortPathTeam,
  getSlotTypes,
  getStatisticCounters,
  getStatistics,
  getStatisticsActivities,
  getTaskById,
  getTasksAssignedTo,
  getTasksByAccountId,
  getTeamById,
  getTeamSettings,
  getTokenAndImpersoHeaders,
  getTrackedEmail,
  getTrackedMeeting,
  getTypologies,
  getUserEmailsList,
  getUserHasBernsteinService,
  getUserInteractions,
  getValidatorInfo,
  graphKeysMail,
  graphKeysMeeting,
  groupServiceUrlsByEnv,
  handleAfterEmailTracked,
  handleAfterMeetingTracked,
  hasHalLink,
  iCUrlMappingConfig,
  importBulkBernstringContacts,
  importBulkContacts,
  importIntroductions,
  interactionsAccountKeys,
  interactionsByClientContactName,
  interactionsBySgContactNameMock,
  introductionsKeys,
  isFund,
  kycQueriesKeys,
  logGraphError,
  mapAddressDTOToAddress,
  mapCampaignFromDto,
  mapContributionsToDisplayByClientContactName,
  mapContributionsToDisplayBySgContactName,
  mapDealAnalyticsToClosureTimeline,
  mapDealAnalyticsToRevenue,
  mapDealAnalyticsToUpdateTimeline,
  mapEmployeeOfToAccount,
  mapFromContactDb,
  mapFromQualityDb,
  mapFromUsageDb,
  mapGlobalInfo,
  mapInvestorsToCreateIntroductionDto,
  mapQueryResults,
  mapSlotToView,
  mapToA2ds,
  mapToAccount,
  mapToAccountApiParam,
  mapToAccountWidget,
  mapToActionPlan,
  mapToActionPlanCreateDTO,
  mapToActionPlanFormModel,
  mapToBusinessFunction,
  mapToBusinessFunctionCreateDTO,
  mapToBusinessFunctionUpdateDTO,
  mapToBusinessFunctions,
  mapToCapitalIntroducers,
  mapToChatMapInteractionsByContactId,
  mapToClientLists,
  mapToContact,
  mapToContactCoverage,
  mapToContactTeamRelationDTO,
  mapToContacts,
  mapToCoverage,
  mapToCoverageWithAccount,
  mapToCreateDtoFromIntroduction,
  mapToCreateIntroductionDto,
  mapToCreateIntroductionForm,
  mapToCreateOrUpdateSlotDTO,
  mapToDomainNameDtoWithHal,
  mapToDomainNames,
  mapToErrorMessage,
  mapToEvent,
  mapToEventContact,
  mapToEventPermission,
  mapToEvents,
  mapToFundInfo,
  mapToImpersonate,
  mapToIntroductionFiltersDto,
  mapToInvitationPermission,
  mapToInvitations,
  mapToListAccountWidget,
  mapToRelatedAccountsName,
  mapToRepositoryError,
  mapToSgRating,
  mapToSlotTypes,
  mapToSlots,
  mapToTask,
  mapToTaskCommentModel,
  mapToTaskCreateDTO,
  mapToTeam,
  mapToTeamTree,
  mapToTeams,
  mapToTeamsPermissions,
  mapToTieringLists,
  mapToTree,
  mapToTypology,
  mapToUserProfile,
  mapToUsers,
  mapZodErrorToRepositoryError,
  massDeleteEventInvitation,
  maxDownloadTimeout,
  mediumApiTimeout,
  messageByErrorStatus,
  mifidJustificationResponseSchema,
  mifidKeys,
  msalAuthParams,
  oneMinutesInMs,
  paramsSerializer,
  patchDealStatusDate,
  patchEsgDetails,
  post,
  postEventEmailTemplate,
  postPendingValidation,
  postSearchActionPlansPage,
  privateUrl3 as privateUrl,
  putContactMifidSchemaConfig,
  putContactSgmc,
  putContactSgmcMifid,
  putEventEmailTemplate,
  removeContactFromPortfolio,
  requestA2dStatuses,
  requestAccountWithId,
  requestAddAccountsToActionPlan,
  requestBankAccounts,
  requestContactCoverage,
  requestDeclareEventGems,
  requestDeclareGiftGems,
  requestDeclareMeetingGems,
  requestDisabledFeatures,
  requestGetEventBudgets,
  requestGetEventDeclarations,
  requestGetFundInfo,
  requestKycGlobalInformation,
  requestMe,
  requestMeSgmc,
  requestOrganisationTeams,
  requestUpdatePersonalSettings,
  saveToFile,
  searchAccounts,
  searchAccountsByCriteria,
  searchAccountsWithParams,
  searchActionPlansPage,
  searchAll,
  searchContacts,
  searchContactsByCriteria,
  searchEvents,
  searchImpersonateAsUsersByName,
  searchRctClients,
  setNextBatch,
  shortApiTimeout,
  slotLocations,
  slotParticipantStatus,
  sortContactsByName,
  tasksActionPlanKeys,
  tenMinutesInMs,
  timeoutErrorMessage,
  todoTaskStatuses,
  trackEmail,
  tryParseJsonField,
  twelveHoursInMs,
  twoHoursInMs,
  twoMinutesInMs,
  updateActionPlan,
  updateAdminTeam,
  updateAdminTeamPermissions,
  updateAdminTeamSettings,
  updateCapitalIntroduction,
  updateEmailCampaign,
  updateEmailDomain,
  updateEvent,
  updateEventContactRelatives,
  updateEventInvitation,
  updateHashtagsAccount,
  updateHashtagsContact,
  updateMeeting,
  updateSlot,
  uploadEsgDocument,
  url9 as url,
  useActionsPermissions,
  useAddAttachmentsToEmailTracking,
  useAddAttachmentsToMeetingTracking,
  useAddCommentToTask,
  useAddContactsToPortfolioMutation,
  useAddRoleInAdminCoverage,
  useBulkSearchByBrdLegalId,
  useCreateActionPlan,
  useCreateContactList,
  useCreateEmailCampaign,
  useCreateOrUpdateEventSlot,
  useCreateOrUpdateIntroductionMutation,
  useCreateTask,
  useCreateTasks,
  useCurrenciesQuery,
  useDealTypesQuery,
  useDeclareEventGems,
  useDeleteActionPlan,
  useDeleteCommentToTask,
  useDeleteContactSgmcMifidMutation,
  useDeleteContacts,
  useDeleteEmailCampaign,
  useDeleteEmailTemplateMutation,
  useDeleteEsgDocumentMutation,
  useDeleteEventInvitation,
  useDeleteEventSlot,
  useDeleteIntroduction,
  useDeleteMeetings,
  useDeleteRoleInAdminCoverage,
  useDeleteTask,
  useDoSendEmails,
  useDownloadCommercialTree,
  useDownloadEsgDocumentQuery,
  useDownloadReportIntroductions,
  useExportContributions,
  useExportInteractions,
  useFeatureToggle,
  useFetchAnalyticIntroduction,
  useFetchAvailableRoles,
  useFetchExistingProgramNames,
  useFetchIntroducerDetails,
  useFetchIntroductionByIdQuery,
  useFetchIntroductionQuery,
  useFetchIntroductionTypesQuery,
  useFetchListStatuses,
  useFetchOutlookContactsInteractions,
  useFetchPersonalSettings,
  useFetchPortfolioContactInteractions,
  useGetA2dStatus,
  useGetAccountCoverageQuery,
  useGetActionPlanById,
  useGetActionPlanOrigins,
  useGetActivitiesPermissionsQuery,
  useGetAdminCoverage,
  useGetAllCoverageFunctions,
  useGetAllCoverageRoles,
  useGetAllTeamsPermissionsQuery,
  useGetAllTeamsQuery,
  useGetBankAccounts,
  useGetBernsteinLegalEntities,
  useGetBernsteinSgStructure,
  useGetBusinessFunctions,
  useGetClient,
  useGetClientLists,
  useGetClientPrivate,
  useGetClientsByIds,
  useGetCommentsTask,
  useGetCommercialTreeById,
  useGetContactByIdQuery,
  useGetContactEmailsStatusQuery,
  useGetContactLists,
  useGetContactMandates,
  useGetContactQualityIndicatorsQuery,
  useGetContactSgmcByIdQuery,
  useGetContactUsageIndicatorsQuery,
  useGetContactsByClientIdQuery,
  useGetContactsByIds,
  useGetContactsByTeamId,
  useGetContactsQualityIndicatorsQuery,
  useGetContactsUsageIndicatorsQuery,
  useGetContributions,
  useGetCountriesQuery,
  useGetDealExternalReferences,
  useGetDealsAnalytics,
  useGetDomainsByAccountId,
  useGetESGDetailsQuery,
  useGetESGEventsQuery,
  useGetESGHashtagsQuery,
  useGetESGSurveyDocumentsQuery,
  useGetEmailAttachmentsById,
  useGetEmailById,
  useGetEmailsAttachmentsById,
  useGetEmailsByIds,
  useGetEventBudgets,
  useGetEventById,
  useGetEventContactRelatives,
  useGetEventDeclarationsGems,
  useGetEventEmailCampaigns,
  useGetEventEmailTemplates,
  useGetEventInvitations,
  useGetEventSlots,
  useGetFeedbackById,
  useGetFundInfoForLE,
  useGetHashtagsAccount,
  useGetHashtagsContact,
  useGetHashtagsContacts,
  useGetInteractionsByAccountId,
  useGetInteractionsByContactId,
  useGetIsAccountBernsteinQuery,
  useGetKycInfo,
  useGetKycTreeById,
  useGetLanguagesQuery,
  useGetLastActivitiesQuery,
  useGetMeetingAttachmentsById,
  useGetMeetingsAttachmentsById,
  useGetMeetingsByIds,
  useGetMifidContractUrlQuery,
  useGetMifidQuery,
  useGetOrgChartTreeById,
  useGetPermissionsByTeamIdQuery,
  useGetRequiredActionsActionPlans,
  useGetRequiredActionsDeals,
  useGetRequiredActionsInteractions,
  useGetRequiredActionsPortfolio,
  useGetResearchCategories,
  useGetSGResearch,
  useGetSgmContactByIds,
  useGetSlotTypes,
  useGetStatisticCounters,
  useGetStatistics,
  useGetTaskById,
  useGetTasksAssignedTo,
  useGetTasksByAccountId,
  useGetTeamByIdQuery,
  useGetTeamSettingsQuery,
  useGetTopSales,
  useGetTrackedMails,
  useGetTrackedMeetings,
  useGetTypologiesQuery,
  useGetUserHasBernsteinService,
  useGetUserInteractions,
  useGetValidatorInfoQuery,
  useImportIntroductions,
  useListMeetings,
  useListMyCalendars,
  useListOutlookMails,
  useMassDeleteEventInvitation,
  useMassUploadBernsteinContactsMutation,
  useMifidJustificationsQuery,
  usePatchEsgDetailsMutation,
  usePostEmailTemplateMutation,
  usePrefetchGetCommercialTreeById,
  usePutContactSgmcMifidMutation,
  usePutContactSgmcMutation,
  usePutEmailTemplateMutation,
  useRemoveContactsFromPortfolio,
  useReplaceEsgDocumentMutation,
  useRequestAddAccountsToActionPlan,
  useRequestDeclareGiftGems,
  useRequestDeclareMeetingGems,
  useRequestMeQuery,
  useRequestMeSgmcQuery,
  useSearchAccountsQuery,
  useSearchActionPlans,
  useSearchContactQuery,
  useSearchEvents,
  useSearchRctClients,
  useSendPendingValidation,
  useTrackEmail,
  useTrackEmails,
  useTrackMeeting,
  useTrackMeetings,
  useUpdateActionPlan,
  useUpdateDealStatusDateMutation,
  useUpdateEmailCampaign,
  useUpdateEmailDomain,
  useUpdateEventContactRelatives,
  useUpdateEventInvitation,
  useUpdateEventSlot,
  useUpdateHashtagsAccount,
  useUpdateHashtagsContact,
  useUpdateHashtagsMultiContactsQuery,
  useUpdateMeeting,
  useUpdateStatus,
  useUpdateTask,
  useUpdateTeamBusinessFunctionsMutation,
  useUpdateTeamDescriptionMutation,
  useUpdateTeamPermissionsMutation,
  useUpdateTeamSettingsMutation,
  useUpdateUserSettings,
  useUploadEsgDocumentMutation,
  webLibLogger
};
/*! Bundled license information:

is-buffer/index.js:
  (*!
   * Determine if an object is a Buffer
   *
   * @author   Feross Aboukhadijeh <https://feross.org>
   * @license  MIT
   *)

axios-mock-adapter/src/is_blob.js:
  (*!
   * MIT License
   *
   * Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (https://sindresorhus.com)
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
   * documentation files (the "Software"), to deal in the Software without restriction, including without limitation the
   * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit
   * persons to whom the Software is furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the
   * Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
   * WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
   * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
   * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
   *)

@azure/msal-common/dist/logger/Logger.mjs:
  (*! @azure/msal-common v14.13.0 2024-07-01 *)

@azure/msal-common/dist/index.mjs:
  (*! @azure/msal-common v14.13.0 2024-07-01 *)

@azure/msal-browser/dist/utils/BrowserConstants.mjs:
  (*! @azure/msal-browser v3.18.0 2024-07-01 *)

@azure/msal-browser/dist/index.mjs:
  (*! @azure/msal-browser v3.18.0 2024-07-01 *)
*/
